import { Component, OnInit, OnDestroy, ViewChild, ElementRef, ChangeDetectorRef, AfterViewInit, DoCheck } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { RouterLink, RouterModule, ActivatedRoute, Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SortPipe } from '../_helpers/sort.pipe';
import { HelpsectionComponent } from '../helpsection/helpsection.component';
import { LazyLoadImgDirective } from '../_helpers/lazy-load-img.directive';
import { CommonService } from '../_service/common.service';
import { appConfig, int, intUrl, localUrl, opeUrl, share, baseUrl, dev, newShare, shareLan, intLan, re7ShareUrl, shareUrl, online, pdf, guideLink, guidecompanyLink, pdf1, OktaProd, OktaUat, opewafUrl,opeNewwafUrl } from '../app.config';
import { PagerService } from '../_service/pager-service';
import { Observable, of, Subject, forkJoin, firstValueFrom } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, switchMap, takeUntil } from 'rxjs/operators';
import { utils, writeFile, WorkSheet, WorkBook } from 'xlsx';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SupplierService } from '../_service/supplier.service';
import { SitesService } from '../_service/sites.service';
import { ContactsService } from '../_service/contacts.service';
import { CountryService } from '../_service/country.service';
import { ArcaService } from '../_service/arca.service';
import { K2Service } from '../_service/K2.service';
import { AddressService } from '../_service/address.service';
import { DocumentsService } from '../_service/documents.service';
import { BlankstatusService } from '../_service/blankstatus.service';
import { SustainService } from '../_service/sustain.service';
import { BrowserTitleService } from '../_service/browser-title.service';

interface Doc { fileName: string; fileType: string; documentPayingCompany: string }
const NEGATIVE_ONE = -1;
const ZERO = 0;
const ONE = 1;
const TWO = 2;
const THREE = 3;
const FOUR = 4;
const FIVE = 5;
const SIX = 6;
const SEVEN = 7;
const EIGHT = 8;
const NINE = 9;
const TEN = 10;
const TWENTY = 20;
const HOURS_PER_DAY = 24;
const THIRTY = 30;
const FIFTY = 50;
const SIXTY = 60;
const ONE_HUNDRED = 100;
const ONE_HUNDRED_TEN = 110;
const ONE_HUNDRED_SEVENTY = 170;
const THREE_HUNDRED = 300;
const FOUR_HUNDRED = 400;
const FOUR_HUNDRED_FOUR = 404;
const FIVE_HUNDRED = 500;
const FIVE_HUNDRED_FIFTY = 550;
const ONE_THOUSAND = 1000;
const TWO_THOUSAND = 2000;
const THREE_THOUSAND = 3000;
const FOUR_THOUSAND = 4000;
const EIGHT_THOUSAND = 8000;
const WORKFLOW_PAGE_HEIGHT_OFFSET = 120;
const WORKFLOW_PAGE_HEIGHT_FALLBACK = 290;
const REAL_ESTATE_ASSET_IDENTIFIERS_PATH = 'real-estate-asset-identifiers/';

@Component({
    selector: 'app-company-details',
    templateUrl: './company-details.component.html',
    styleUrls: ['./company-details.component.css'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterLink,
        RouterModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
        MatSelectModule,
        MatOptionModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        MatSnackBarModule,
        MatProgressBarModule,
        NgxPaginationModule,
        NgSelectModule,
        NgbModule,
        NgxMatSelectSearchModule,
        SortPipe,
        LazyLoadImgDirective,
        HelpsectionComponent
    ]
})
export class CompanyDetailsComponent implements OnInit, OnDestroy, AfterViewInit, DoCheck {
  readonly ngUnsubscribe = new Subject();
  userQuestionUpdate = new Subject<string>();
  userQuestionUpdateCode = new Subject<string>();
  pComp_Code = "";
  pComp_Name = "";
  userQuestionUpdate2 = new UntypedFormControl();
  userQuestionUpdate3 = new UntypedFormControl();
  delayGrpAllianceId = new UntypedFormControl;
  delayGrpShortName = new UntypedFormControl();
  Config: any;
  loading = false;
  companyExist = true;
  companyID: any;
  companyBasicInfo: any;
  PayingInfo: any = [];
  dataForPayCmpState: any = [];
  PayingLoading = true;
  alcorStatusLoading = false;
  alcorStatusData: any[] = [];
  alcorStatusError = '';
  GroupAssign: any;
  CompanyIdentiTypes: any;
  CompanyIdentiLoading = true;
  SiteDispLoading = true;
  SitesInfo: any = [];
  arcaSrchnoresults = false;
  CompanyDoc: any = '';
  companyAlias: any;
  companyAliasAll: any;
  TaxIdentifierKeys: any;
  TaxIdentifiLoading = true;
  public companyNameModelval: any = '';
  public companyNameModelExistsval: any = '';
  public companyNameModelvalerror = false;
  saveDatas: any = "Save";
  computeDatas: any = "Compute";
  computeDataButtonShow = false;
  guobvdIDcpy = false;
  GroupLoadin = true;
  GroupNameAll: any = [];
  GroupNameAllId: any = [];
  changeGroupAllianceId: any = [];
  changeGroupShortName: any = [];
  GroupAllToName: any = [];
  GroupShrtToName: any = [];
  GroupCatptins: any = [];
  GroupingTypeAll: any = [];
  GrpNameModel = "";
  groupAllianceIdModel = "";
  groupShortNameModel = "";
  GrpingTypeModel = "";
  computeGTOPWarningText = "GTOP already exists for this supplier!";
  GrpNameError = false;
  GrpingTypeError = false;
  GrpAllianceError = false;
  GrpShortNameError = false;
  TaxIdentifierType: any;
  TaxTypeIdnetifierModel = "";
  NewIdnetifierValue = "";
  IdnetifierValueError = false;
  IdnetifierTypeError = false;
  compAliasType: any;
  CmpAlliasTypeModel = "";
  NewCmpAlliasValue = "";
  CmpAlliasTypeError = false;
  CmpAlliasValueError = false;
  CompanyStatusAll: any = [];
  cmpStausModel = "";
  CmpStaError = false;
  SelectedcmpStaus = "";
  mdmSynchroRowId: any = [];
  MDMSynchroModeValue = '';
  public MDMSynchroMode = false;
  CompanyIdRole: any = [];
  CompanyIdRoleDetails: any = [];
  CompanyContacts: any = [];
  CompanyContactsLoading = true;
  ContactsFlag = false;
  SitesFlag = false;
  PersonDetails: any = [];
  PersonDetailsCompSent2Req: any = [];
  allKamSaleRoles: any = [];
  personuserId: any = [];
  removeDatas: any = "Remove";
  remvoeContactModelval: any = '';
  CmpConEmailexistsError = false;
  EditAliasObj: any = [];
  EditAliasModel = "";
  EditCmpAlliasValueError = false;
  arrApprovalStatus: any = [];
  arrApprovalScopes: any = [];
  payingCompanyCodeModelval: any = '';
  payingCompanyCodeModelvalLabel: any = '';
  payingCompanyCodeModelvalerror = false;
  payingCompanyCodes: any = [];
  payingCompanyCodeids: any = [];
  EditTIObj: any = [];
  EditTIModel = "";
  EditTIValueError = false;
  showCancelOrange = false;
  supplierCategoryLoading = true;
  public dataForCatAuth: any[] = [];
  supplierCategoryVals: any[] = [];
  catAuthLoading = false;
  disableCatAuthState = false;
  EditCategoryError = false;
  isAfterSales = false;
  isPrototype = false;
  isTooling = false;
  isMassProd = false;
  isOutProd = false;
  isMassOutProd = false;
  isStandardSupplier = true;
  isIndustrialPartner = false;
  isB2BPartner = false;
  row_id: any[] = [];
  companyAllianceIdentifier: any;
  reloadPage = false;
  categoryValues: any[] = [];
  isPrototypeEnabled = false;
  isPrototypeLocked = false;
  newId = '';
  PersonRoleSelectOp: any = [];
  CmpConField = ['CmpConFname', 'CmpConLname', 'CmpConRole', 'CmpConEmail'];
  CmpConFname = "";
  CmpConLname = "";
  CmpConRole = "";
  personRowId = "";
  NewPersonRowId = "";
  updPersonId = "";
  AllPersonIdArr: any = "";
  Editrow_id_cmpContactcs = "";
  upd_usersRow_id = "";
  editingAlias: any;
  activeValue: any[] = [];
  public CmpConEmailExists: any = '';
  public isReadOnly = false;
  public selectedPayingCmpValue = "failed";
  dataForGroupingState: any[] = [];
  editCmpConFname = '';
  editCmpConLname = '';
  editCmpConCellphone = '';
  editCmpConPhone = '';
  cellPhoneEdit = false;
  fixedPhoneEdit = false;
  pdfLink = '';
  public senReqPayCompcodeMOdel = "";
  public editShortName = '';
  public EditShortNameValueError = false;
  public cmpConRoleexists = false;
  public PayListAutoLists: any = [];
  public PayCodeListAutoLists: any = [];
  public colorStatus = { "archived": "#CB4B32", "active": "#5CBA63", "draft": "#5CBA63", "validated": "#5CBA63", 'pending_validation': '#B7783C', 'pending': '#B7783C', 'greenfield': '#FFBD69', 'brownfield': '#FFBD69', "destroyed": "#CB4B32", "built": "#5CBA63", "waiting for approval": "#B7783C", "created": "#B7783C", "identified": "#D8C4A0", "inactive": "#FFBD69" }
  public colors = { "": "#D8C4A0", "approved": "#5CBA63", "identified": "#D8C4A0", "pending": "#B7783C", "registered": "#66D8D0", "archived": "#CB4B32", "waiting for approval": "#B7783C", "prospect": "#4B9BF5", "inactive": "#FFBD69" }
  public colorsGroup = { "": "#D8C4A0", "active": "#5CBA63", "validated": "#5CBA63", "inactive": "#FFBD69", "pending": "#B7783C", "pending_validation": "#B7783C", "archived": "#CB4B32", "blocked": "#D8C4A0", "waiting for approval": "#B7783C", "identified": "#D8C4A0", "draft": 'yellow' }
  public colorForWorkflow = { "In progress": "#B7783C", "Need more info": "#66D8D0", "Approved": "#5CBA63", "Refused": "#CB4B32", "inactive": "#FFBD69", "pending": "#B7783C", "waiting for approval": "#B7783C" }
  public qualifierColors = {
    "P05": "#2E2ECA",
    "P06": "#244F35",
    "P07": "#978B7F",
    "P08": "#632717",
    "P09": "#4613A5",
    "P11": "#CB4B32",
    "P13": "#66D8D0",
    "P14": "#5CBA63",
    "P18": "#000000",
    "P19": "#B7783C",
    "B2b": "#000000"
  }
  public qualifierTypesText = {
    P05: "Manufacturing",
    P06: "Invoicing",
    P07: "Picking",
    P08: "Customer",
    P09: "Quality Return",
    P11: "Ordering",
    P13: "Grouping",
    P14: "Main Entrance",
    P18: "Headquarters",
    P19: "Supply Chain EDI",
    B2b: "B2B Partner"
  };
  public sortedQualifiers = {
    "P14": "P14",
    "B2b": "B2bn",
    "P18": "P18",
    "P11": "P11",
    "P05": "P05",
    "P13": "P13",
    "P19": "P19",
    "P07": "P07",
    "P09": "P09",
    "P06": "P06",
    "P08": "P08",
    "P100": "assets/sites/icons/P101.png",
  };
  beRowID: any = [];
  SiteRowID: any = [];
  SiteDe_BvdID_Stat: any = [];
  Site_City_Country: any = [];
  public Site_hrefTo_Cid: any = [];
  site_qualifiers: any = [];
  public businessEntityId: any;
  public envHide: any = "";
  public CmpConRoleError: any;
  public CmpConRoleSelected: any;
  public CmpConFnameError: any;
  public CmpConLnameError: any;
  public CmpConIpn: any;
  public CmpConIpnError: any;
  public CmpConEmail: any;
  public CmpConEmailError: any;
  public CmpConCellphone: any;
  public CmpConCellphoneError: any;
  public CmpConCellphoneError2: any;
  public CmpConPhone: any;
  public CmpConPhoneError: any;
  public CmpConPhoneError2: any;
  public groupName: any;
  public cmpRolechanged = false;
  public addSiteNameError = false;
  public addSiteNameModel: any = "";
  public selectedSiteName: any = "failed";
  public addSiteCaptains: any = [];
  public addSiteNameAll: any[] = [];
  public addSiteCompany: any[] = [];
  public sitesRowId: any;
  public cityName: any;
  public dataForTaxState: any[] = [];
  public taxStateLoading = false;
  public addSiteBvdIdError = false;
  public addSiteBvdIdModel: any = "";
  public arcasearchModel: any = "";
  public companysearchModel: any = "";
  public dataForCmpyAlias: any[] = [];
  public roleVariableHide = false;
  public companyShortName = '';
  public companyShortRowId = '';
  public aliasDoesNotExist = false;
  public aliasTextDisp = '';
  public disableSaveBtnAlias = true;
  public newCpyId = '';
  public disableSaveBtnAliaCpy = true;
  public changeGroupModal = 'default';
  public changeGroupButtonText = 'Cancel';
  public chgGroupTextDisp = '';
  public CpyStatusHolder = '';
  public popSiteRowId: any[] = [];
  public shortNameSiteArray: any[] = [];
  public disableInputForMDM = false;
  public EditCmpAlliasRegExError = false;
  public newCpyAliasRegExError = false;
  public newCpyAlcorRegExError = false;
  public EditCmpAlliasRegExNumError = false;
  public senReqPayCompMOdel = "";
  public senReqKamSaleContMOdel = "";
  public senReqSamMOdel = "";
  public senReqBuyerAssiMOdel = "";
  public senReqNotesMOdel = "";
  public senReqPayCompMOdelError = false;
  public senReqKamSaleContMOdelError = false;
  public senReqSamMOdelError = false;
  public bvdIdData: any[] = [];
  public EditBvdIdValueError = false;
  public EditBvdIdModel = '';
  public bvdIdValExists = false;
  public bvdFatalError = false;
  public bvdIdTextHolder = '';
  public bvdIdObj: any;
  public checkArray: any[] = [];
  public senReqSiteModelError = false;
  public senReqAddSiteModelError = false;
  public updateSiteData: any[] = [];
  public addSiteDataArray: any[] = [];
  public noHqExists = '';
  public selectedSiteAsHQ = '';
  public payingCpyData: any[] = [];
  public assignedPayingCmp :any[]=[];
  public filteredPayingCpyCount = ZERO;
  public selectedPayingGrouping = '';
  public assignedPayingSelections: { [key: string]: boolean } = {};
  public assignedPayingPendingSwitches: { [key: string]: boolean } = {};
  public payingCpyLoading = false;
  public siteAssnBusinessData: any[] = [];
  public siteBusinessEntityHQ = '';
  public siteBusinessEntityExist = true;
  public businessIdForBvd = '';
  public bvdIdRowIdForDuplicate = '';
  public aliasAccToRowId = [];
  public showSwitch = false;
  public taxIdentifierRowName = [];
  public switchBtnText = 'Switch to GTOP';
  public superUserShow: any = false;
  public maxCpyNameLength = '60';
  public prodHide = false;
  public superAdminAllProfiles: any = false;
  public siteIdenTypeDetails: any = [];
  public cpyShortNameTypes: any = [];
  public ArcFirstName: any = "";
  data: any = [];
  resetArca = false;
  arcaSrchWait = false;
  ArcIpn: any = "";
  ArcLastName: any = "";
  resetComp = false;
  compSrchWait = false;
  public showCancelOk = 'Close';
  public showBuyerProfile: any = true;
  public alcorValueWithApos: string[] = [];
  public alcorValueWithAposActive: string[] = []; // Track only active ALCOR codes (without endDate)
  public alcorValueCpy: any = [];
  public realEstateAlcorData: any = [];
  public lookForSiteLoading = false;
  public noLookForSiteData = false;
  public lookForSitesInputValue = '';
  public selectedInputValLook: any = [];
  public lookForSitesLinkIdArr: any = [];
  public realEstateNewData: any = [];
  public gotAlcorRealLookData = false;
  public siteAssignmentData: any = [];
  public siteRowsOnAlcorVals: any = [];
  public siteIdentifierOnAlcor: any = [];
  public disableBtnInitiateLinkLook = false;
  public alcorValSiteIds: any = [];
  public alcorAssignmentAval: any = [];
  public progressForInitiateLink = ZERO;
  public showReloadBtnLook = true;
  public counterForReloadButton = ZERO;
  public showDelBtnForNoSite = true;
  public siteQualiferMainEntranceData: any = [];
  public shortNameArrayValues: any = [];
  public alcorNameValsOnAlcorVal: any = [];
  public editRaftNameForAlcor = '';
  public alcorNameRegExError = false;
  public warningForArchiveCpyText = '';
  public hideInQuaNProd = false;
  public showForConsult = false;
  showForSupplier = false;
  public alcorRequestCompanyNames: any = [];
  public alcorRequestStatusReports: any = {};
  public alcorRequestStatusMapping = {
    'AC': 'TO COMPLETE',
    'ACFC': 'WAIT FOR CORRECT BT',
    'AV': 'TO VALIDATE',
    'DF': 'FINALIZED',
    'RCFC': 'REJECT BY CFC',
    'RT': 'TECHNICAL REJECT',
    'VCFC': 'VALIDATED BY CFC'
  };
  public selectedAlcorRequest: any = null;
  public showAlcorRequestPopup = false;
  public alcorRequestType = '';
  public selectedPayingCompanyForAlcor = '';
  public selectedPayingCompaniesForAlcor: string[] = [];
  public pendingPayingCompanies: any[] = [];
  public isStep2 = false;
  public isAlcorRequestLoading = false;
  public isAlcorRequestComplete = false;
  public selectedPayingCompanyDetails: any = null;
  public alcorBlindTasksResponse: any[] = [];
  public selectedDocuments: any[] = [];
  counter = '';
  autoShortname = true;
  Alcordata: any;
  AlcordataDetails: any;
  businessentity: any;
  alcorAddress: any;
  alcorTaxValue = [];
  alcorTaxName = [];
  sirenValue =  '';
  siretValue = '';
  vatValur: any;
  alcorEndDate = '';
  alcorStartDate = '';
  requestedType = '';
  AlcorRequestdata: {
    mdmAskForRequestId: string; requestType: string; alcorCode: string; payingCompanyCode: string; companyIdentifier: any; siteIdentifier: any; name: any; shortName: string; street: string; street2: any; postalBox: string; zipCode: any; city: any; region: string; country: any; telephone: string; businessLanguage: string; duns: any; vatId: any;
    headQuarterLanguage: string; effectiveDate: any;

    "expiration Date": string; sirenNumber: string; siretNumber: string; taxationType: string; taxationValue: string; reason: string; documents: { fileName: string; fileType: string; documentPayingCompany: string; }[];
  }[] = [];
  public companyNameModelvalRegExError = false;
  public EditShortNameValueRegExError = false;
  public loadingForCompanyDocuments = true;
  public selectedDocPreview = '';
  public showPreview = false;
  public lookForSitesAssignRows: any = [];
  warningForHQ = '';
  disableCheckHQ = false;
  public disableSetAsHQ = false;
  public documentTypeModel = '';
  public documentNameModel = '';
  uploadDocNameError = false;
  uploadDocTypeError = false;
  fileToUpload: File | null = null;
  fileContent: any;
  uploadDocError = false;
  disableUploadBtn = false;
  selectFileError = false;
  fileSizeError = false;
  public groupingStateLoading = false;
  cpyAliasLoading = false;
  public comp_modelEmail = true;
  public comp_modelFname = false;
  public comp_modelLname = false;
  public comp_modelCellphone = false;
  public comp_modelPhone = false;
  public comp_modelRole = false;
  public disableEmail = false;
  public comp_modelLabelName = false;
  public comp_modelIpn = false;
  public comp_ShowSave = false;
  public comp_ShowNext = true;
  public compModelName = "";
  public compModelIpn = "";
  sharePointURL = '';
  disableGroupLinkBtn = false;
  saveIdenClicked = false;
  disableAddSiteAdmin = false;
  disableUpdateCpyNameBtn = false;
  disableChangeCpyStatus = false;
  disableCpyShortNameUpdate = false;
  disableEditTaxIdens = false;
  disableEditCpyAlias = false;
  siteAssignmentGet = '';
  siteCreation = '';
  acpCreation = '';
  businessECreation = '';
  bvdAssoCreation = '';
  siteAssignCreation = '';
  siteNameUCreation = '';
  finalSiteCreation = '';
  validationSuccess = false;
  public Editcontact_rowId = "";
  disablePayingStatusBtn = false;
  payingCpyStatus = '';
  payingCpyStatusError = false;
  payingCpyOptions: any[] = [];
  activePayingCpyRowId: any;
  accessPointIdOnAddress: any = []
  acpAddressDetOnRows: any = [];
  isaRoleFor_Uid: any = [];
  ipnOnPersonIds: any = [];
  showUidDisable = false;
  disableContactRoleEdit = false;
  showSendMail = false;
  mailContent = '';
  mailBody = '';
  sendMailTo = '';
  isEnvQua = false;
  isEnvInt = false;
  addDocPayingCpy = '';
  boolForPayingCpySelect = false;
  roleIsManager = false;
  personIpn: any = [];
  specificCpyLink: string = '';
  public mailBodyContent = `<p>Hello,</p><p>You have been designed by an Alliance Renault-Nissan buyer to complete several information that will allow you to begin business with the Renault Group.For that please access the following page ${this.specificCpyLink} and update the missing data listed on the top of the page. For any help please contact <u>isa@renault.com</u></p><p>Regards,</p><p> Supplier Admin</p>`;
  public sendRequestError = false;
  public selectedSendRequest = '';
  public accHomoRequestSelected = false;
  public siteUpdRequestSelected = false;
  public siteAddRequestSelected = false;
  public addPayCmpRequestSelected = false;
  public disableSendReqBtn = true;
  warningForSendReq = 'Sorry, a workflow is already in progress';
  showAddSiteBtn = false;
  hQBvdIdHolder: any;
  addSiteBvdIdData: any[] = [];
  showAddSiteLoading = false;
  selectedPayingCpyVal = '';
  selectedPayingCpyVals: string[] = [];
  selectedPayingCompanies: any[] = [];
  selectedAddPayingCpyVal = '';
  SitesInfoBvd: any = [];
  tempVarCounList: any = [];
  countrySelList: any[] = [];
  CountryNameKeyId: any = [];
  CaptCountry: any = [];
  qualifierChangetoPending: any = [];
  public newCategoryAssignment = '6';
  public newCategoryName = 'SUPPLIER SITE'
  arrBasedOnVal: any = [];
  cpyAlcorToRaft: any = [];
  varIsMergingSite = '2';
  CityNameKeyId: any = [];
  selectedCountry = '';
  siteCityModel = '';
  CaptCity: any;
  siteCountryModel = '';
  selectedBvdId: any[] = [];
  disableImportSite = false;
  disableCheckbox = false;
  sharePointUrlNative = '';
  public documentStatusModel = '';
  documentId: any;
  uploadDocMessage = 'Upload Error';
  selectedCustomCountry = '';
  changedRoleId: any;
  showAddSiteProcessing = true;
  documentFileName = '';
  currentDocumentType = '';
  showDocsDelete = true;
  buyerNameSelected: any;
  siteRaftCodeValOnRowId: any = [];
  siteIdentifierForRaft: any = [];
  workFlowDetails: any = [];
  clientCompanyLegalName: any;
  companyIdentifierKeyName: any;
  catAuthvalue: any;
  openData = true;
  openRole = false;
  addSiteCurrentStatus = 'loading...';
  pageHeight: number = ZERO;
  Uid: any;
  pagedTotalItem: number = ZERO;
  public colors2 = [
    { status: "DELETED", color: "#CB4B32" },
    { status: "PENDING_VALIDATION", color: "##B7783C" },
    { status: "Need more info", color: "#66D8D0" },
    { status: "DRAFT", color: "yellow" },
    { status: "Approved", color: "#5CBA63" },
    { status: "Archived", color: "#CB4B32" },
    { status: "Updating...", color: "white" },
    { status: "Blocked", color: "#CB4B32" },
    { status: "Refused", color: "#CB4B32" },
    { status: "Active", color: "#5CBA63" },
    { status: "Registered", color: "#66D8D0" },
    { status: "Prospect", color: "#4B9BF5" },
    { status: "Identified", color: "#D8C4A0" },
    { status: "", color: "white" },
    { status: "Pending", color: "#B7783C" },
    { status: "Waiting for approval", color: "#B7783C" },
    { status: "Created", color: "#B7783C" },
    { status: "In progress", color: "#B7783C" }
  ];
  public statusOrder = ["Active", "Pending", "Created", "Archived"];
  public siteWorkflowStatusOrder = ["NotStarted", "WaitingForSupplier", "WaitingForRenault", "Completed"];
  public statusOrderWorkFlow = ["In progress", "Need more info", "Approved", "Refused"];
  public FiltercheckStatus = ["Active_status", "Pending_status", "Created_status", "Archived_status"];
  public FiltercheckSiteWorkflowStatus = ["NotStarted_siteWf", "WaitingForSupplier_siteWf", "WaitingForRenault_siteWf", "Completed_siteWf"];
  public Active_status = false; public Pending_status = false; public Created_status = false; public Archived_status = false;
  public NotStarted_siteWf = false; public WaitingForSupplier_siteWf = false; public WaitingForRenault_siteWf = false; public Completed_siteWf = false;
  public showFilterStatus = false;
  public showFilterSiteWorkflowStatus = false;
  public showFilterStatusWorkFlow = false;
  tempCompanySection: any = [];
  paginationForStatus = false;
  filteredCompanies: any = [];
  filteredWorkFlow: any = [];
  public siteRowIdFilter: any = [];
  public siteStatus: any = [];
  pager: any = {};
  workflowFolioFromK2Isa: any = '';
  workflowReqIdFromK2Isa: any = '';
  workflowValidationLoading = false;
  wkfValNotesModel: any = '';
  confirmationOption = false;
  documentsReviewOption = false;
  public tempBvdId = '';
  public sitebvidid: any = '';
  public BPNLValue: any = '';
  public DUNSValue: any = '';
  showArchivedBvdId = false;
  public editIdValueModel = '';
  public editIdModelError = false;
  disableSaveBtn = false;
  public bvdidloading = false;
  public statusText = '';
  public noSiteAssn = true;
  public disableInPortfolioSwitch = false;
  inPortfolioLoading = true;
  bvdInPortfolioSet: any;
  public countValue: any = '';
  public statusFiltered = false;
  public statusFilteredSiteStatus = false;
  public statusFilteredSiteWorkflow = false;
  public statusFilteredWorkFlow = false;
  wkfRejNotesModel: any = '';
  wkfInfoNotesModel: any = '';
  public rejectWorkflowNotesError = false;
  public maxRecorePage = FIFTY;
  public FiltercheckStatusWorkFlow = ["Inprogress_status", "Needmoreinfo_status", "Approved_status", "Refused_status"];
  public Approved_status = false; public Refused_status = false; public Inprogress_status = false;
  public Needmoreinfo_status = false;
  tempWorkflow: any = [];
  public siteRowIdFilterWorkFlow: any = [];
  public workflowStatus: any = [];
  workFlowVisibility = false;
  showBoxDowncompany = false;
  showBoxDownGroup = false;
  showBoxDownworkflow = false;
  showBoxDownSite = false;
  public customLoadingTemplate: any;
  public customLoadingTemplate2: any;
  disablerefresh = false;
  isoutMassProd = false;
  requestForNotesHistory: any = [];
  public siteUpdatePayingComp = false;
  payingSiteData: any[] = [];
  public RowupArray1: any[] = [];
  senReqUpdatePayingModelError = false;
  showBoxDownForAllSec = true;
  bvdidNumber: any = '';
  valArchived = false;
  @ViewChild('inputUpload') inputUpload!: ElementRef;
  @ViewChild('inputGenUpload') inputGenUpload!: ElementRef;
  myFileInput!: ElementRef;
  groupId: any;
  groupAlias: any[] = [];
  siteSaerCodeValOnRowId: any = [];
  MailNameModel = '';
  differenceinDays = '';
  guide = '';
  guideCompanyUrl = '';
  valTiArc: any;
  groupAssignToCpy = '';
  orbisBvdDataLoading = true;
  dataloading = false;
  orbisBvdData: any[] = [];
  siteIdTemp: any;
  rowID: any;
  public ISAdata: any[] = [];
  grpAllianceIdForGR: any;
  groupbvdIDcpy: any;
  inPortfolioLoading1 = true;
  public countValue1: any = '';
  bvdInPortfolioSet1: any;
  bvdloading = true;
  GenericCompanyDoc: any = '';
  Http_URL = '';
  loadingForGenericDocuments = true
  fileToUpload1: any;
  genDoc = false;
  show = false;
  GuobvdIDcpy: any;
  activityA: any[] = [];
  activityB: any[] = [];
  activityC: any[] = [];
  activityD: any[] = [];
  optActivityA: { value: any, checked: boolean }[] = [];
  optActivityB: { value: any, checked: boolean }[] = [];
  optActivityC: { value: any, checked: boolean }[] = [];
  optActivityD: { value: any, checked: boolean }[] = [];
  Avalue: any = [];
  Cvalue: any = [];
  Bvalue: any = [];
  Dvalue: any = [];
  desc: any = '';
  string1: any;
  string2: any;
  string3: any;
  string4: any;
  oldvalue: any = [];
  activityLoad = false;
  activityLoaded = false;
  sitesData = true;
  validatingWorkflow = false;
  groupNameDrop = false;
  groupIdDrop = false;
  groupShortNameDrop = false;
  showForSupplierwithIPN = false;
  get bothBopNbopConflict(): boolean {
    return this.Bvalue.includes('B#BOP') && this.Bvalue.includes('B#NBOP');
  }
  public categoryOption = ['After Sales only', 'Materials', 'Transport']
  public companyWorkflowStatusModel = '';
  public disableCompanyWorkflowStatusBtn = false;
  public companyWorkflowStatusOptions = ['NotStarted', 'WaitingForSupplier', 'WaitingForRenault', 'Completed'];
  public workflowStatusColors = {
    'NotStarted': '#D8C4A0',
    'WaitingForSupplier': '#B7783C',
    'WaitingForRenault': '#B7783C',
    'Completed': '#5CBA63'
  };
  statusDisplay: any;
  dateDisplay: any;
  grpDate: any;
  tempDuns = '';
  showArchivedDUNSId = false;
  showArchivedBPNId = false;
  tempBpn = '';
  TypePopup = '';
  routerLink: any;
  showArchivedId = false;
  DocTypeError = false;
  noGuo = false;
  companyBvdIdNotFound = false;
  guoBvdIdNotFound = false;
  testing: any;
  IsaBvD: any;
  autoLoadGrpName = false;
  autoLoadGrpId = false;
  autoLoadGrpSrtName = false;
  autoLoadSiteName = false;
  noDisplay = true;
  nameNotFoundTemplate = false;
  @ViewChild('ChangeGrp') changeGrpModal!: ElementRef;
  BpnDate: any = '';
  retriveButton = false;
  requestButton = false;
  requested = '';
  key = 'name';
  reverse = false;
  groupingData: any[] = [];
  companyIdentifierData: any[] = [];
  taxData: any[] = [];
  payingData: any[] = [];
  rows: any;
  paying: any;
  identifying: any;
  taxing: any;
  CpyData: any[] = [];
  cpyData: any[] = [];
  uniqueGroupingValues: any[] = [];
  history = false;
  siteC2bCodeValOnRowId: any = [];
  groupPager: any = {};
  payPager: any = {};
  idenPager: any = {};
  taxPager: any = {};
  cmpPager: any = {};
  load: any;
  histPager: any = {};
  viewSupplier: any;
  payingCompanyCodeids1: any = [];
  siteLatamCodeValOnRowId: any = [];
  representingCompany: any;
  siteRnaiplCodeValOnRowId: any = [];
  oldIdentifier = '';
  oldName = '';
  oldId = '';
  isEnvOpe = false;
  CmpConEmailFormatError = false;
  endDateisPresent = false;
  endDateistrue = false;
  ipnnotpresent = false;
  archived: any = [];
  orbisStatusCode = '';
  orbisDate = '';
  latestOrbisStatus: any;
  TextForCompleteUpload: any='';
  blankUpdateCompleted:any;
  TableData: Object[] = [];
  approverEdit = false;
  sendMailToApprover: any;
  prospectSelected = false;
  reqType: any;
  checkboxSelect = false;
  payingCmprowId: any;
  payingCmpCode: any;
  payingCmpName: any;
  entityId: any = [];
  roleLoad = true;
  showPayingCompanyBlock = false;
  showActivityBlock = true;
  showACompanyIdentifier = true;
  showTaxIdentifier = false;
  showCompanyContacts = false;
  showDocumentsForAccounting = false;
  showGenericDocuments = false;
  activityLength = ZERO;
  historyLoading = false;
  siteGroupsecMaxpage: any;
  completedWkf = false;
  selectedDocumentsDetails: any[] = [];
  selectedDocumentsByCompanyDetails = {};
  urls = '';
  yesterDay = "";
  AlcorReqStart = "";
  approverEmail: any;
  currentModalDetail: any;
  updatedWorkflowStatus = 'WaitingForSupplier';
  constructor(readonly commonService: CommonService, readonly supplierService: SupplierService, readonly siteService: SitesService, readonly k2Service: K2Service, readonly countryService: CountryService, readonly addressService: AddressService, readonly arcaServices: ArcaService, readonly contactService: ContactsService, readonly route: ActivatedRoute, readonly documentService: DocumentsService, readonly pagerService: PagerService, readonly router: Router, readonly blankUpdate: BlankstatusService, readonly sustainService: SustainService, readonly cdr: ChangeDetectorRef, readonly http: HttpClient, readonly browserTitleService: BrowserTitleService) {
    this.Config = appConfig;
    this.companyID = route.snapshot.params['row_id'];
    this.groupId = route.snapshot.params['groupId'];
    this.userQuestionUpdate.pipe(debounceTime(FOUR_HUNDRED), distinctUntilChanged()).subscribe(value => {
      this.PayingCmpListKeyup(value);
    });
    this.userQuestionUpdateCode.pipe(debounceTime(FOUR_HUNDRED), distinctUntilChanged()).subscribe(value => {
      this.PayingCmpListKeyupCode(value);
    });
    this.userQuestionUpdate2.valueChanges.pipe(debounceTime(FIVE_HUNDRED), distinctUntilChanged()).subscribe(value => {
      this.GrpNameModel = value
      if(!this.groupIdDrop && !this.groupShortNameDrop){
        this.LoadGrp(value)
      }
    }); this.delayGrpAllianceId.valueChanges.pipe(debounceTime(FIVE_HUNDRED), distinctUntilChanged()).subscribe(value => {
      this.groupAllianceIdModel = value
      if(!this.groupNameDrop && !this.groupShortNameDrop){
        this.LoadGrpAllianceId(value);
      }
    });
    this.delayGrpShortName.valueChanges.pipe(debounceTime(FIVE_HUNDRED), distinctUntilChanged()).subscribe(value => {
      this.groupShortNameModel = value
      if(!this.groupNameDrop && !this.groupIdDrop){
        this.LoadGrpShortName(value);
      }
    });
    this.userQuestionUpdate3.valueChanges.pipe(debounceTime(FOUR_HUNDRED), distinctUntilChanged()).subscribe(value => {
      this.addSiteNameModel = value;
      this.addSiteNameError = false;
      this.selectedSiteName = value
      this.loadSites(value)
    });
  }
  ngOnInit() {
    this.companyBasicInfo = "";
    this.Uid = this.commonService.fromApp_UserIPN ? this.commonService.fromApp_UserIPN.toLowerCase() : '';
    this.getCompanyDetails();
    this.guide = guideLink
    this.guideCompanyUrl = guidecompanyLink;
    this.Http_URL = this.commonService.getDocument()
    this.blankUpdate.TextForCompleteUpload$.subscribe(message => {
      this.TextForCompleteUpload = message;
    });
    this.blankUpdate.uploadCompleted$.subscribe(status => {
      this.blankUpdateCompleted = status;
    })
    this.blankUpdate.ExportFile$.subscribe(exportfiledata => {
      this.TableData = exportfiledata
    })
    this.handleInitialFragmentScrolling();
    this.AlcorReqStart = this.commonService.getTodayDate().replaceAll(/-/g, '')
    console.info("AlcorReqStart", this.AlcorReqStart)
    const d = new Date();
    d.setDate(d.getDate() - ONE);
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + ONE).padStart(TWO, '0');
    const dd = String(d.getDate()).padStart(TWO, '0');
    this.yesterDay = `${yyyy}${mm}${dd}`
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.route.fragment.subscribe(fragment => {
        if (fragment) {
          this.scrollToFragment(fragment, ZERO);
        }
      });
    }, ONE_THOUSAND);
    globalThis.addEventListener('hashchange', () => {
      const hash = globalThis.location.hash.substring(ONE);
      if (hash) {
        this.scrollToFragment(hash, ZERO);
      }
    });
    const currentHash = globalThis.location.hash.substring(ONE);
    if (currentHash) {
      setTimeout(() => {
        this.scrollToFragment(currentHash, ZERO);
      }, THREE_THOUSAND);
    }
  }
  ngDoCheck() {
    this.getRoles();
  }
  getRoles() {
    const RoleByService = this.commonService.splitAndRolesAssign();
    this.checkAllProfilesAndEnv(RoleByService);
  }

  navigateToHome() {
    if (this.showForSupplier) {
      this.router.navigate(['/company']);
    } else {
      if (this.companyBasicInfo?.companyStatusCode?.toLowerCase() === 'pending') {
        return;
      } else {
        const targetGroupId = this.groupId || this.GroupAssign?.groupId;
        if (targetGroupId) {
          this.router.navigate(['/supplier-group-details', targetGroupId]);
        }
      }
    }
  }
  private updateProfileFlags(profile: any): void {
    this.showSendMail = profile['userIpn'] == 'z027793';
    this.showBuyerProfile = profile['buyer'] != 'yes';
    this.roleVariableHide = profile['role'] == 'admin' || profile['role'].includes('admin');
    this.superUserShow = profile['superAdmin'] == 'yes';
    this.superAdminAllProfiles = profile['superAdminAllProfiles'] == 'yes';
    this.showForConsult = !(profile['role'] == 'consult' || profile['role'].includes('consult'));
    this.showForSupplier = profile['role'] != 'supplier';
    this.pdfLink = profile['role'] == 'supplier' ? pdf : pdf1;
    this.showForSupplierwithIPN = profile['role'] == 'supplier' && profile['userIpn'] && String(profile['userIpn']).trim() !== '';
    this.roleIsManager = profile['role'] == 'manager';
  }

  private updateEnvironmentFlags(profile: any): void {
    const environment = profile['env'];
    this.envHide = !['qua', 're7', 'ope'].includes(environment);
    this.isEnvQua = environment == 'qua';
    this.isEnvInt = environment == 'int';
    this.hideInQuaNProd = environment == 'qua' || environment == 'ope';
    this.isEnvOpe = environment == 'ope';
    this.prodHide = this.isEnvOpe;
    const sharePointBaseUrl = this.isEnvOpe ? shareUrl : re7ShareUrl;
    this.sharePointURL = `${sharePointBaseUrl}_api/`;
    this.sharePointUrlNative = sharePointBaseUrl;
  }

  checkAllProfilesAndEnv(RoleByService: any = {}) {
    const profile = RoleByService;
    if (profile['userAccess'] == undefined || profile['userAccess'].includes('Deined')) {
      this.showSendMail = profile['userIpn'] == 'z027793';
      return;
    }
    this.updateProfileFlags(profile);
    this.updateEnvironmentFlags(profile);
  }
  PayingCmpListKeyup(event: any) {
    if (event.length >= THREE) {
      this.getPayingCompanies(event);
    } else {
      this.PayListAutoLists = "";
      this.PayListAutoLists = [];
    }
  }
  PayingCmpListKeyupCode(event: any) {
    if (event.length >= THREE) {
      this.getPayingCompaniesCode(event);
    } else {
      this.PayCodeListAutoLists = "";
      this.PayCodeListAutoLists = [];
    }
  }
  /* Start Root Functions. To add New functions, add below end of Root Function */
  getCompanyDetails() {
    this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies/${this.companyID}`).subscribe((data: any) => {
      if (data['errors'] == undefined) {
        this.companyBasicInfo = data;
        this.companyNameModelval = data['legalName'];
        this.companyNameModelExistsval = data['legalName'];
        this.browserTitleService.setCompanyName(this.companyNameModelval);
        const date = data['startDate'].replaceAll(/-/g, '')
        this.viewSupplier = data['allianceIdentifier'].substring(TWO) + date + this.companyID
        this.alcorStartDate = data['startDate']
        this.alcorEndDate = data['endDate']
        this.dateDisplay = data['companyStatusCode'] ? (data['companyStatusCode'].toLowerCase() === 'archived' ? data['endDate'] : data['startDate']) : data['startDate'];
        if (!this.showBuyerProfile || !this.showForConsult || this.roleIsManager) {
          this.showDocsDelete = false;
        }
        if (this.roleVariableHide || !this.showForSupplier) {
          this.showDocsDelete = true;
        }
        this.getPayingDetails();
        this.loadBvdIdCpy(this.tempBvdId);
        this.getCompanyDocumentDetails();
        this.getSupplierCategoryDetails();
        this.getMDMSynchroMode();
        this.workflowDetailsfn();
        this.getGenericDocumentDetails();
      }
      else {
        this.companyExist = false;
        console.info('data_error', data['errors'][ZERO].errorMessage);
      }
    }, error => {
      this.companyExist = false;
      console.info('data_error', error.status);
    });
  }
  getMDMSynchroMode() {
    this.MDMSynchroModeValue = '';
    this.mdmSynchroRowId = [];
    this.supplierService.getCompanyNames(`${this.Config.ApiSupplierUrl}company-names?companyNameTypeName=MDM SYNCHRO MODE&companyId=${this.companyID}`).subscribe((datas: any) => {
      if (datas['company-names'].length > ZERO) {
        for (const element of datas['company-names']) {
          this.MDMSynchroModeValue = element.value;
          this.mdmSynchroRowId.push(element.row_id);
        }
      }
    });
  }
  getShortNameDetails(page: number = ONE, _subscribeData: any[] = []) {
    this.supplierService.getCompanyNames(`${this.Config.ApiSupplierUrl}company-names?companyId=${this.companyID}&_page=${page}`).subscribe((data: any) => {
      if (data['company-names'].length > ZERO) {
        for (const element of data['company-names']) {
          if (element.companyNameTypeName == "SHORT NAME") {
            this.companyShortName = element.value;
            this.companyShortRowId = element.row_id;
          }
        }
      }
    });
  }
  editActivity() {
    this.optActivityA = []
    this.optActivityB = []
    this.optActivityC = []
    this.optActivityD = []
    const optA: any[] = [];
    const optB: any[] = [];
    const optC: any[] = [];
    const optD: any[] = [];
    var types: any[]
    this.activityLoaded = false
    this.supplierService.getCompanyNameTypes(`${this.Config.ApiSupplierUrl}company-name-types?name=SUPPLIER%20ACTIVITY`).subscribe((data: any) => {
      for (const nameType of data['company-name-types']) {
        nameType.description = nameType.description.replaceAll('<p>', '')
        nameType.description = nameType.description.replaceAll('</p>', '')
        const separators = ['<br>', '<br />'];
        const regex = new RegExp(separators.join('|'), 'g');
        types = nameType.description.split(regex);
      }
      for (let datas of types) {
        if (datas.includes("A#")) {
          datas = datas.replaceAll("A#", '')
          optA.push(datas)
        }
        if (datas.includes("B#")) {
          datas = datas.replaceAll("B#", '')
          optB.push(datas)
        }
        if (datas.includes("C#")) {
          datas = datas.replaceAll("C#", '')
          optC.push(datas)
        }
        if (datas.includes("D#")) {
          datas = datas.replaceAll("D#", '')
          optD.push(datas)
        }
      }
    })
    setTimeout(() => {
      for (const data of optA) {
        if (this.activityA.includes(data)) {
          this.optActivityA.push({ value: data, checked: true })
          this.Avalue.push(`A#${data}`)
        } else {
          this.optActivityA.push({ value: data, checked: false })
        }
      }
      for (const data of optB) {
        if (this.activityB.includes(data)) {
          this.optActivityB.push({ value: data, checked: true })
          this.Bvalue.push(`B#${data}`)
        } else {
          this.optActivityB.push({ value: data, checked: false })
        }
      }
      for (const data of optC) {
        if (this.activityC.includes(data)) {
          this.optActivityC.push({ value: data, checked: true })
          this.Cvalue.push(`C#${data}`)
        } else {
          this.optActivityC.push({ value: data, checked: false })
        }
      }
      for (const data of optD) {
        if (this.activityD.includes(data)) {
          this.optActivityD.push({ value: data, checked: true })
          this.Dvalue.push(`D#${data}`)
        } else {
          this.optActivityD.push({ value: data, checked: false })
        }
      }
      this.activityLoaded = true
    }, THREE_THOUSAND)
  }
  activitySave(value: any, name: string) {
    const activityValue = `${name == 'bRadio' ? 'B' : name.toUpperCase()}#${value.target.value}`;
    if (name == 'bRadio') {
      this.Bvalue = this.Bvalue.filter((x: any) => x !== 'B#BOP' && x !== 'B#NBOP');
      this.Bvalue.push(activityValue);
    } else {
      this.updateActivityValues(name, activityValue, value.target.checked);
    }
    this.desc = [...this.Avalue, ...this.Bvalue, ...this.Cvalue, ...this.Dvalue]
  }
  private updateActivityValues(name: string, activityValue: string, checked: boolean): void {
    const values = { a: this.Avalue, b: this.Bvalue, c: this.Cvalue, d: this.Dvalue }[name];
    if (!values) {
      return;
    }
    if (checked) {
      values.push(activityValue);
    } else {
      const index = values.indexOf(activityValue);
      if (index !== NEGATIVE_ONE) {
        values.splice(index, ONE);
      }
    }
  }

  isSingleBopOrNbopSelected(): boolean {
    const hasBop = this.Bvalue.indexOf('B#BOP') !== NEGATIVE_ONE;
    const hasNbop = this.Bvalue.indexOf('B#NBOP') !== NEGATIVE_ONE;
    return (hasBop ? ONE : ZERO) + (hasNbop ? ONE : ZERO) === ONE;
  }
  
  actvity() {
    if (!this.isSingleBopOrNbopSelected()) {
      return;
    }
    const changes = this.getActivityChanges();
    this.createActivities(changes.newActivity);
    this.removeActivities(changes.remove);
    this.activityLoad = false
    document.getElementById('closeEditActivity').click();
    setTimeout(() => {
      this.getactivity()
    }, FOUR_THOUSAND)
  }
  private getActivityChanges(): { remove: any[]; newActivity: any[] } {
    const add: any[] = [];
    const newActivity: any[] = [];
    for (const activity of this.desc) {
      add.push(activity);
      if (this.oldvalue.findIndex((x: any) => x == activity) == NEGATIVE_ONE) {
        newActivity.push(activity);
      }
    }
    const remove = Array.isArray(this.desc) && this.desc.length > ZERO
      ? this.oldvalue.filter((activity: any) => add.findIndex((x: any) => x == activity) == NEGATIVE_ONE)
      : [];
    return { remove, newActivity };
  }
  private createActivities(activities: any[]): void {
    for (const value of activities) {
      const datas = {
        "companyAllianceIdentifier": this.companyAllianceIdentifier, "companyNameTypeName": "SUPPLIER ACTIVITY",
        "companyId": this.companyID, "endDate": "", "companyNameTypeId": "6", value,
        "startDate": this.commonService.getTodayDate()
      };
      this.supplierService.CreateCompanyNames(`${this.Config.ApiSupplierUrl}company-names`, datas).subscribe((_data: any) => { });
    }
  }
  private removeActivities(activities: any[]): void {
    for (const value of activities) {
      this.supplierService.getCompanyNames(`${this.Config.ApiSupplierUrl}company-names?companyNameTypeName=SUPPLIER%20ACTIVITY&value=${value.replaceAll('#', "%23")}&companyAllianceIdentifier=${this.companyAllianceIdentifier}`).subscribe((data: any) => {
        for (const id of data['company-names']) {
          this.supplierService.deleteCompanyName(`${this.Config.ApiSupplierUrl}company-names/${id.row_id}`).subscribe((_data: any) => { });
        }
      });
    }
  }
  getactivity() {
    this.activityA = []
    this.activityB = []
    this.activityC = []
    this.activityD = []
    this.activityLoad = false
    this.oldvalue = []
    this.supplierService.getCompanyNames(`${this.Config.ApiSupplierUrl}company-names?companyNameTypeName=SUPPLIER%20ACTIVITY&companyAllianceIdentifier=${this.companyAllianceIdentifier}`).subscribe((data: any) => {
      if (data['company-names'].length != ZERO) {
        for (const datas of data['company-names']) {
          this.activityLoad = true
          this.oldvalue.push(datas.value)
          if (datas.value.includes("A#")) {
            datas.value = datas.value.replaceAll("A#", '')
            this.activityA.push(datas.value)
          }
          if (datas.value.includes("B#")) {
            datas.value = datas.value.replaceAll("B#", '')
            this.activityB.push(datas.value)
          }
          if (datas.value.includes("C#")) {
            datas.value = datas.value.replaceAll("C#", '')
            this.activityC.push(datas.value)
          }
          if (datas.value.includes("D#")) {
            datas.value = datas.value.replaceAll("D#", '')
            this.activityD.push(datas.value)
          }
        }
        this.activityLength = this.activityA.length + this.activityB.length + this.activityC.length + this.activityD.length
      }
      else {
        this.activityLoad = true;
        this.activityLength = ZERO;
      }
    })
  }
  downloadUploadLogFile() {
    const element = document.getElementById('excelTableLog');
    const ws: WorkSheet = utils.table_to_sheet(element);
    const wb: WorkBook = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Update To PENDING');
    writeFile(wb, 'UpdatedDetails.xlsx');
  }
  getPayingDetails(contine = "Yes", page: number = ONE, subscribeData: any[] = []) {
    this.paying;
    this.supplierService.getCompanyApprovals(`${this.Config.ApiSupplierUrl}company-approvals?companiesId=${this.companyID}&_page=${page}`).subscribe((data: any) => {
      this.handlePayingDetailsResponse(data, contine, page, subscribeData);
    });
  }
  private handlePayingDetailsResponse(data: any, contine: string, page: number, subscribeData: any[]): void {
    this.payingData = [];
    const hasApprovals = data['company-approvals'].length > ZERO;
    if (hasApprovals) {
      this.collectPayingDetails(data['company-approvals'], subscribeData);
      this.continuePayingDetailsIfNeeded(data, contine, page, subscribeData);
    }
    if (contine != "No" && data['maxPage'] == page) {
      this.getGroupAssignments();
      this.PayingLoading = false;
    }
    this.updatePayingPager(page);
  }
  private collectPayingDetails(approvals: any[], subscribeData: any[]): void {
    for (const element of approvals) {
      if (this.roleVariableHide || element.approvalModificationStatus.toLowerCase() != 'archived') { subscribeData.push(element); }
      this.payingData.push(element);
    }
  }
  private continuePayingDetailsIfNeeded(data: any, contine: string, page: number, subscribeData: any[]): void {
    if (data['maxPage'] > ONE && data['maxPage'] != page) {
      this.getPayingDetails(contine, page + ONE, subscribeData);
      return;
    }
    if (data['maxPage'] != page) { return; }
    this.PayingInfo = subscribeData.sort((a: any, b: any) => a.clientCompanyCode.localeCompare(b.clientCompanyCode));
    this.PayingLoading = false;
    this.activeValue = [...subscribeData];
  }
  private updatePayingPager(page: number): void {
    this.payPager = this.pagerService.getPager(this.payingData.length, page, TEN);
    this.dataForPayCmpState = this.payingData.slice(this.payPager.startIndex, this.payPager.endIndex + ONE);
    this.paying = this.payingData.length > TEN ? false : true;
  }
  payingCompanyTable(page: number) {
    this.payPager = this.pagerService.getPager(this.payingData.length, page, TEN);
    this.dataForPayCmpState = this.payingData.slice(this.payPager.startIndex, this.payPager.endIndex + ONE)
  }
  checkAlcorStatus() {
    this.alcorStatusLoading = true;
    this.alcorStatusData = [];
    this.alcorStatusError = '';
    
    if (!this.companyAliasAll || !this.companyAliasAll['ALCOR'] || this.companyAliasAll['ALCOR'].length === ZERO) {
      this.alcorStatusError = 'No ALCOR code found for this company.';
      this.alcorStatusLoading = false;
      return;
    }
    
    const alcorCodes = this.companyAliasAll['ALCOR'];
    
    setTimeout(() => {
      // Create an array of observables for each ALCOR code
      const alcorRequests: Observable<any>[] = alcorCodes.map((alcorCodeObj: any) => {
        const alcorCode = alcorCodeObj.val;
        const isAlcorArchived = alcorCodeObj.archived || false;
        const paddedAlcorCode = alcorCode.toString().padStart(TEN, '0');
        
        return this.supplierService.getVendorInfo(
          `${this.Config.ApiVendorUrl}vendors-info-all?vendorCode=${paddedAlcorCode}`
        ).pipe(
          map((response: any) => {
            return this.processAlcorResponse(response, alcorCode, isAlcorArchived, paddedAlcorCode);
          }),
          // Handle errors for individual requests
          map((result: any) => result, (error: any) => {
            console.info(`Error fetching ALCOR status for ${paddedAlcorCode}:`, error);
            const statusFromError = error.error && error.error.statusCode;
            const statusFromHeaders = error.headers && error.headers.status;
            const statusCode = error.status || statusFromError || statusFromHeaders;
            
            if (statusCode === FOUR_HUNDRED || statusCode === FOUR_HUNDRED_FOUR || !statusCode || Object.keys(error).length === ZERO) {
              return {
                alcorCode: alcorCodeObj.val,
                isAlcorArchived,
                isAlcorGlobalClean: true,
                payingCompanies: [],
                warningMessage: `The vendor code ${paddedAlcorCode} is unknown from ALCOR.`
              };
            } else {
              return {
                alcorCode: alcorCodeObj.val,
                isAlcorArchived,
                isAlcorGlobalClean: true,
                payingCompanies: [],
                warningMessage: `Failed to retrieve ALCOR status. Status: ${(statusCode || 'Unknown')}`
              };
            }
          })
        );
      });
      
      // Execute all requests in parallel
      forkJoin(alcorRequests).subscribe(
        (results: any) => {
          this.alcorStatusData = results;
          this.alcorStatusLoading = false;
        },
        error => {
          console.info('Error in forkJoin:', error);
          this.alcorStatusError = 'Failed to retrieve ALCOR status for one or more codes.';
          this.alcorStatusLoading = false;
        }
      );
    }, THREE_HUNDRED);
  }
  
  private getAlcorCompanyStatus(companyCodeData: any): string {
    const hasBlockingStatus = companyCodeData.cocodepostblock || companyCodeData.cocodedeletionflag || companyCodeData.cocodedeletionblock;
    const hasBlockingPost = companyCodeData.cocodepostblock && companyCodeData.cocodepostblock !== '';
    const hasBlockingDeletion = companyCodeData.cocodedeletionflag && companyCodeData.cocodedeletionflag !== '';
    const hasBlockingBlock = companyCodeData.cocodedeletionblock && companyCodeData.cocodedeletionblock !== '';
    const hasBlockingValue = hasBlockingPost || hasBlockingDeletion || hasBlockingBlock;
    return hasBlockingStatus && hasBlockingValue ? 'blocked' : 'clean';
  }
  private getIsaCompanyStatus(approvalModificationStatus: string): string {
    switch (approvalModificationStatus) {
    case 'VALIDATED':
      return 'VALIDATED';
    case 'ARCHIVED':
      return 'ARCHIVED';
    case 'PENDING_VALIDATION':
      return 'PENDING_VALIDATION';
    default:
      return '';
    }
  }
  processAlcorResponse(response: any, alcorCode: string, isAlcorArchived: boolean, paddedAlcorCode: string) {
    if (!response || (Array.isArray(response) && response.length === ZERO)) {
      return this.getUnknownAlcorResponse(alcorCode, isAlcorArchived, paddedAlcorCode);
    }
    const alcorData = Array.isArray(response) ? response[ZERO] : response;
    const alcorPayingCompaniesMap = this.getAlcorPayingCompaniesMap(alcorData);
    const allPayingCompaniesMap = this.mergePayingCompanyMaps(alcorPayingCompaniesMap);
    const payingCompanies = Array.from(allPayingCompaniesMap.values());
    payingCompanies.sort((a, b) => a.companyCode.localeCompare(b.companyCode));
    return {
      alcorCode,
      isAlcorArchived,
      isAlcorGlobalClean: this.isAlcorGlobalClean(alcorData),
      payingCompanies,
      warningMessage: ''
    };
  }
  private getUnknownAlcorResponse(alcorCode: string, isAlcorArchived: boolean, paddedAlcorCode: string): any {
    return { alcorCode, isAlcorArchived, isAlcorGlobalClean: true, payingCompanies: [], warningMessage: `The vendor code ${paddedAlcorCode} is unknown from ALCOR.` };
  }
  private isAlcorGlobalClean(alcorData: any): boolean {
    const postingBlockClear = !alcorData.globalPostingBlock || alcorData.globalPostingBlock === '';
    const purchBlockClear = !alcorData.globalPurchBlock || alcorData.globalPurchBlock === '';
    const deletionBlockClear = !alcorData.globalDeletionBlock || alcorData.globalDeletionBlock === '';
    const blockFunctionClear = !alcorData.blockFunction || alcorData.blockFunction === '';
    return postingBlockClear && purchBlockClear && deletionBlockClear && blockFunctionClear;
  }
  private getAlcorPayingCompaniesMap(alcorData: any): Map<any, any> {
    const payingCompanies = new Map();
    if (alcorData.companyCode && Array.isArray(alcorData.companyCode)) {
      for (const companyCodeData of alcorData.companyCode) {
        payingCompanies.set(companyCodeData.companycode, this.getAlcorCompanyStatus(companyCodeData));
      }
    }
    return payingCompanies;
  }
  private mergePayingCompanyMaps(alcorPayingCompaniesMap: Map<any, any>): Map<any, any> {
    const allPayingCompaniesMap = new Map();
    if (this.PayingInfo && Array.isArray(this.PayingInfo)) {
      for (const payingInfo of this.PayingInfo) {
        const companyCode = payingInfo.clientCompanyCode;
        allPayingCompaniesMap.set(companyCode, {
          companyCode, companyName: payingInfo.clientCompanyLegalName || '',
          isaStatus: this.getIsaCompanyStatus(payingInfo.approvalModificationStatus),
          alcorStatus: alcorPayingCompaniesMap.get(companyCode) || ''
        });
      }
    }
    for (const [companyCode, alcorStatus] of alcorPayingCompaniesMap) {
      if (!allPayingCompaniesMap.has(companyCode)) {
        allPayingCompaniesMap.set(companyCode, { companyCode, companyName: '', isaStatus: '', alcorStatus });
      }
    }
    return allPayingCompaniesMap;
  }
  getGroupAssignments(contine = "Yes", page: number = ONE, subscribeData: any[] = []) {
    this.GroupAssign = [];
    this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?apoStatus=ACTIVE&status=VALIDATED&companyId=${this.companyID}&_page=${page}`).subscribe((data: any) => {
      this.handleGroupAssignmentsResponse(data, contine, page, subscribeData);
    }, _error => {
      this.GroupLoadin = false;
      this.TaxIdentifiLoading = false;
      this.CompanyIdentiLoading = false;
    });
  }
  private handleGroupAssignmentsResponse(data: any, contine: string, page: number, subscribeData: any[]): void {
    subscribeData.push(...data['group-assignments']);
    if (data['maxPage'] > ONE && data['maxPage'] != page) {
      this.getGroupAssignments(contine, page + ONE, subscribeData);
      return;
    }
    if (data['maxPage'] != page) { return; }
    data['group-assignments'].forEach((element: any, index: number) => this.processGroupAssignment(element, index, data['group-assignments'].length));
    this.GroupLoadin = false;
    if (contine != 'No') { this.loadGroupAssignmentDetails(); }
  }
  private processGroupAssignment(element: any, index: number, assignmentCount: number): void {
    if (element.groupTypeCode.toLowerCase() == 'apo') { element.groupTypeCode = 'RGP'; }
    if (element.apoStatus.toLowerCase() == 'active') {
      this.GroupAssign = element;
      this.GroupAssign['apoStatus2'] = element.groupStatus.toLowerCase();
      this.statusDisplay = element.groupStatus;
    }
    const isActive = element.apoStatus.toLowerCase() == 'active';
    if (isActive && element.groupId != '' && index + ONE == assignmentCount) { this.loadGroupAssignment(element); }
    if (!isActive) { this.loadGroupAssignment(element); }
    this.getGroupAliasByRowid(this.groupId);
  }
  private loadGroupAssignment(element: any): void {
    this.supplierService.getGroups(`${this.Config.ApiSupplierUrl}groups/${element.groupId}`).subscribe((data: any) => {
      this.representingCompany = data.representingCompanyId;
      if (element.apoStatus.toLowerCase() == 'active') {
        this.GroupAssign['GroupCategory'] = data.groupTypeCode;
        this.grpDate = data['modificationStatus'].toLowerCase() == 'archived' ? data['endDate'] : data['startDate'];
      }
    });
  }
  private loadGroupAssignmentDetails(): void {
    this.getShortNameDetails();
    this.getCompanyIdentifierTypes();
    this.getbvd();
    this.getactivity();
  }
  getCompanyIdentifierTypes(page: number = ONE, subscribeData: any[] = []) {
    this.supplierService.getCompanyIdentifierKeys(`${this.Config.ApiSupplierUrl}company-identifier-keys?_page=${page}`).subscribe((data: any) => {
      this.CompanyIdentiTypes = [];
      this.TaxIdentifierKeys = [];
      this.TaxIdentifierType = [];
      this.compAliasType = [];
      for (const element of data['company-identifier-keys']) {
        subscribeData.push(element);
      }
      if (data['maxPage'] > ONE && data['maxPage'] != page) {
        this.getCompanyIdentifierTypes(page + ONE, subscribeData);
        return;
      }
      if (data['maxPage'] != page) { return; }
      for (const element of subscribeData) {
        if (element.type.toLowerCase() == "oth") {
          this.CompanyIdentiTypes.push(element.name);
          this.compAliasType.push(element);
          this.aliasAccToRowId[element.name.toLowerCase()] = element.row_id;
        }
        if (element.type.toLowerCase() == "tax") {
          this.TaxIdentifierKeys.push(element.name);
          this.TaxIdentifierType.push(element);
          this.taxIdentifierRowName[element.name.toLowerCase()] = element.row_id;
        }
      }
      console.info("this.CompanyIdentiTypes", this.CompanyIdentiTypes)
      this.CompanyIdnentifiers();
      this.TaxIdentifiLoading = false;
      this.CompanyIdentiLoading = false;
    }, _error => {
      this.TaxIdentifiLoading = false;
      this.CompanyIdentiLoading = false;
    });
  }
  private getCompanyIdentifierDisplayData(element: any): any {
    const identifierType = element.companyIdentifierKeyName.toLowerCase();
    const isArchived = element.endDate != '';
    const showSwitch = identifierType != 'alcor';
    this.updateAlcorIdentifierValues(element, identifierType, isArchived);
    if (this.roleVariableHide) {
      return this.getRoleHiddenIdentifierDisplayData(element, identifierType, isArchived, showSwitch);
    }
    return isArchived ? '' : this.createIdentifierDisplayData(element, showSwitch, false);
  }
  private updateAlcorIdentifierValues(element: any, identifierType: string, isArchived: boolean): void {
    if (identifierType != 'alcor') { return; }
    if (isArchived) { this.archived.push(element.endDate); }
    const value = `'${element.value}'`;
    if (this.alcorValueWithApos.indexOf(value) == NEGATIVE_ONE) { this.alcorValueWithApos.push(value); }
    if (!isArchived && this.alcorValueWithAposActive.indexOf(value) == NEGATIVE_ONE) { this.alcorValueWithAposActive.push(value); }
    this.alcorValueCpy.push(element.value);
  }
  private getRoleHiddenIdentifierDisplayData(element: any, identifierType: string, isArchived: boolean, showSwitch: boolean): any {
    if (isArchived && (identifierType == 'mdm' || identifierType == 'gtop')) {
      return { 'val': element.value, 'key': element.row_id, 'disableInput': true, 'showSwitch': showSwitch, 'endDate': element.endDate, 'archived': true, 'iden': element.companyIdentifierKeyName };
    }
    return this.createIdentifierDisplayData(element, showSwitch, isArchived);
  }
  private createIdentifierDisplayData(element: any, showSwitch: boolean, isArchived: boolean): any {
    return { 'val': element.value, 'key': element.row_id, 'disableInput': true, 'showSwitch': showSwitch, 'endDate': element.endDate, 'archived': isArchived };
  }
  CompanyIdnentifiers(callby = "sss", page: number = ONE, loopC = "cont") {
    this.supplierService.getCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers?linkedCompanyId=${this.companyID}&_page=${page}`).subscribe((data: any) => {
      this.handleCompanyIdentifiersResponse(data, callby, page, loopC);
    });
  }
  private handleCompanyIdentifiersResponse(data: any, callby: string, page: number, loopC: string): void {
    this.resetCompanyIdentifierCollections(loopC);
    this.scheduleCompanyIdentifierDisplays(data['company-identifiers']);
    let nextPage = ONE;
    if (data['maxPage'] > ONE && loopC != 'stop') { nextPage = this.loadCompanyIdentifierPages(data['maxPage']); }
    this.finishCompanyIdentifierLoad(callby, loopC, nextPage);
  }
  private resetCompanyIdentifierCollections(loopC: string): void {
    if (loopC == 'cont' || loopC == 'no' || loopC == 'reload') {
      this.companyAlias = [];
      this.companyAliasAll = [];
    }
    this.alcorValueCpy = [];
    this.alcorValueWithAposActive = [];
  }
  private scheduleCompanyIdentifierDisplays(elements: any[]): void {
    for (const element of elements) {
      if (!this.companyAliasAll[element.companyIdentifierKeyName]) { this.companyAliasAll[element.companyIdentifierKeyName] = []; }
      const displayData = this.getCompanyIdentifierDisplayData(element);
      setTimeout(() => {
        if (displayData != '') { this.companyAliasAll[element.companyIdentifierKeyName].push(displayData); }
      }, TWO_THOUSAND);
    }
  }
  private loadCompanyIdentifierPages(maxPage: number): number {
    let page: number;
    for (page = TWO; page <= maxPage; page++) { this.CompanyIdnentifiers('', page, 'stop'); }
    return page;
  }
  private finishCompanyIdentifierLoad(callby: string, loopC: string, nextPage: number): void {
    if (nextPage <= ONE && callby == 'two') {
      this.companyAliasAll = [];
      this.CompanyIdnentifiers('', ONE, 'no');
    }
    if (loopC == 'reload') {
      this.getAlcorNameVals();
      this.getAlcorRequestCompanyNames();
    }
    if (loopC == 'cont') {
      this.companyRoles();
      this.getAlcorNameVals();
      this.getAlcorRequestCompanyNames();
      this.getSiteIdenTypes();
      this.getCpyShortNameTypes();
      this.getGroupApprovalStatus();
    }
    if (loopC == 'no') { this.getAlcorRequestCompanyNames(); }
  }
  companyRoles(page = ONE, loopCRole = "yes") {
    this.contactService.getSupplierCompanyRoles(`${this.Config.ApinewContactsUrl}supplierCompanyRoles?personSupplierCompany=CtcSupplierCompanyService:${this.companyID}&personRoleStatus=VALIDATED&_page=${page}`).subscribe((data: any) => {
      this.handleCompanyRolesResponse(data, loopCRole, page);
    }, _error => {
      this.CompanyIdentiLoading = false;
      this.ContactsFlag = true;
    });
  }
  private handleCompanyRolesResponse(data: any, loopCRole: string, page: number): void {
    this.resetCompanyRolesIfNeeded(loopCRole);
    if (data['supplierCompanyRoles'].length == ZERO) {
      this.CompanyIdentiLoading = false;
      this.ContactsFlag = true;
      return;
    }
    this.showCompanyContacts = true;
    for (const element of data['supplierCompanyRoles']) { this.processCompanyRole(element); }
    this.loadMoreCompanyRoles(data, page, loopCRole);
    this.finishCompanyRolesLoad();
  }
  private resetCompanyRolesIfNeeded(loopCRole: string): void {
    if (loopCRole == 'yes') {
      this.CompanyIdRole = [];
      this.CompanyContacts = [];
      this.AllPersonIdArr = [];
    }
  }
  private processCompanyRole(element: any): void {
    if (!element.personSupplierCompany) { return; }
    const companyParts = typeof element.personSupplierCompany === 'string'
      ? element.personSupplierCompany.split(':')
      : element.personSupplierCompany.href.split('/');
    if (this.companyID != companyParts[ONE] || element.personRoleStatus.toLowerCase() != 'validated') { return; }
    if (this.CompanyIdRole.indexOf(companyParts[ONE]) == NEGATIVE_ONE) {
      this.CompanyIdRole.push(companyParts[ONE]);
      this.CompanyIdRoleDetails[companyParts[ONE]] = [];
    }
    this.CompanyIdRoleDetails[companyParts[ONE]].push(element);
    if (this.AllPersonIdArr.indexOf(element.personRowId) == NEGATIVE_ONE && element.personRowId != '') { this.AllPersonIdArr.push(element.personRowId); }
  }
  private loadMoreCompanyRoles(data: any, page: number, loopCRole: string): void {
    if (data['maxPage'] > ONE && loopCRole != 'stop') {
      for (let nextPage = TWO; nextPage <= data['maxPage']; nextPage++) { this.companyRoles(nextPage, 'stop'); }
    }
  }
  private finishCompanyRolesLoad(): void {
    this.CompanyContactsLoading = false;
    if (this.CompanyIdRoleDetails[this.companyID] == undefined) {
      this.ContactsFlag = true;
      return;
    }
    this.CompanyContacts = this.CompanyIdRoleDetails[this.companyID];
    if (this.AllPersonIdArr.length > ZERO) { this.PersonAddresses(); }
    else { this.ContactsFlag = true; }
  }
  PersonAddresses(page: number = ONE, subscribeData: any[] = []) {
    this.contactService.getPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses?personRowId=in(${this.AllPersonIdArr})&_page=${page}`).subscribe((data: any) => {
      if (data['personAddresses'].length > ZERO) {
        subscribeData.push(...data['personAddresses']);
        if (data['maxPage'] == undefined) {
          this.processPersonAddresses(subscribeData, 'addressSummary');
          return;
        }
        if (data['maxPage'] > ONE && data['maxPage'] != page) {
          this.PersonAddresses(page + ONE, subscribeData);
          return;
        }
        if (data['maxPage'] == page) {
          this.processPersonAddresses(subscribeData, 'summary');
          this.getPersonsIpns(this.AllPersonIdArr);
        }
      }
    });
    this.ContactsFlag = true;
  }
  private processPersonAddresses(addresses: any[], summaryProperty: 'addressSummary' | 'summary'): void {
    for (const address of addresses) {
      if (this.AllPersonIdArr.includes(address.personRowId) == ONE) { this.processPersonAddress(address, summaryProperty); }
    }
  }
  private processPersonAddress(address: any, summaryProperty: 'addressSummary' | 'summary'): void {
    const summary = address[summaryProperty];
    if (address.addressType.toLowerCase() == 'email') {
      this.PersonDetails[`${address.personRowId}_email`] = summary;
      this.PersonDetails[`${address.personRowId}_addIDEmail`] = address.addressId;
      return;
    }
    if (address.addressType.toLowerCase() != 'telephone') { return; }
    const parts = summary.split('*');
    if (parts.length <= ONE || parts[ONE].trim() == undefined) { return; }
    const phoneType = parts[ONE].trim().toLowerCase();
    if (phoneType == 'p') { this.setPersonPhoneDetails(address, parts[ZERO], 'p'); }
    if (phoneType == 'f') { this.setPersonPhoneDetails(address, parts[ZERO], 'f'); }
  }
  private setPersonPhoneDetails(address: any, value: string, phoneType: string): void {
    this.PersonDetails[`${address.personRowId}_${phoneType}`] = value;
    this.PersonDetails[`${address.personRowId}_addID${phoneType}`] = address.addressId;
  }
  private triggerRoleUserLoadIfNeeded(): void {
    if (this.roleLoad) {
      this.roleLoad = false;
      this.getKamsaleroleuser();
    }
  }

  private updatePersonIpnData(users: any[]): void {
    for (const e of users) {
      this.ipnnotpresent = !!e.endDate;
      this.personIpn[e.personRowId] = e;
    }
  }

  private hasMoreUserPages(data: any, page: number): boolean {
    return data['maxPage'] > ONE && data['maxPage'] != page;
  }

  getPersonsIpns(AllPersonIdArr: any[], page = ONE) {
    if (AllPersonIdArr.length === ZERO) {
      return;
    }

    this.contactService.getUsers(`${this.Config.ApinewContactsUrl}users?personRowId=in(${AllPersonIdArr})&_page=${page}`).subscribe((data: any) => {
      const users = data['users'] || [];
      if (users.length === ZERO) {
        this.triggerRoleUserLoadIfNeeded();
        return;
      }

      this.updatePersonIpnData(users);
      if (this.hasMoreUserPages(data, page)) {
        this.getPersonsIpns(AllPersonIdArr, page + ONE);
        return;
      }

      this.triggerRoleUserLoadIfNeeded();
    });
  }

  private isSupplierCategoryType(companyNameTypeName: string): boolean {
    return ["SUPPLIER CATEGORY", "SUPPLIER AUTHORIZATION", "SUPPLIER TYPE"].includes(companyNameTypeName);
  }

  private processSupplierCategoryPagination(data: any, page: number, supplierCategoryValues: any[]): void {
    if (data['maxPage'] > ONE && data['maxPage'] != page) {
      this.getSupplierCategoryDetails(page + ONE, supplierCategoryValues);
      return;
    }

    if (data['maxPage'] == page) {
      this.supplierCategoryVals = supplierCategoryValues;
      this.supplierCategoryLoading = false;
      this.catAuthLoading = false;
    }
  }

  getSupplierCategoryDetails(page = ONE, supplierCategoryValues: any[] = []) {
    this.catAuthLoading = true;
    this.supplierService.getCompanyNames(`${this.Config.ApiSupplierUrl}company-names?companyId=${this.companyID}&_page=${page}`).subscribe((data: any) => {
      this.dataForCatAuth = [];
      if (data['company-names'].length > ZERO) {
        for (const element1 of data['company-names']) {
          this.companyAllianceIdentifier = element1.companyAllianceIdentifier;
          const isSupplierType = this.isSupplierCategoryType(element1.companyNameTypeName);
          if (isSupplierType && element1.endDate == '') {
            supplierCategoryValues.push(element1.value);
          }
          if (isSupplierType) {
            this.dataForCatAuth.push(element1);
            this.row_id[element1.value] = element1.row_id;
          }
        }
        this.processSupplierCategoryPagination(data, page, supplierCategoryValues);
      }
    }, _error => {
      this.catAuthLoading = false;
    });
  }
  /* End ###################### Root Files Loaded Here */
  padLeft(text: string, padChar: string, size: number): string {
    return (String(padChar).repeat(size) + text).substr((size * NEGATIVE_ONE), size);
  }
  updateComputeNewGtop() {
    this.showCancelOrange = false;
    this.computeDatas = 'Compute';
    if (typeof this.companyAliasAll['GTOP'] != 'undefined') {
      this.computeDataButtonShow = false;
      this.computeGTOPWarningText = 'GTOP already exists for this supplier!';
    }
    else if (typeof this.companyAliasAll['MDM'] == 'undefined' && typeof this.companyAliasAll['GTOP'] == 'undefined') {
      this.computeDataButtonShow = false;
      this.computeGTOPWarningText = '    GTOP unavailable for this supplier !'
    }
    else {
      this.computeDataButtonShow = true;
      this.showCancelOrange = true;
      this.computeGTOPWarningText = 'Compute new GTOP for this supplier!';
    }
  }
  saveComputeNewGtop() {
    this.computeDatas = "Compute...";
    const NuGtop = this.companyAliasAll['MDM'][ZERO].val;
    const NewGTOP = this.padLeft(NuGtop, '0', FOUR);
    const datas = { linkedCompanyId: this.companyID, companyIdentifierKeyName: "GTOP", companyIdentifierTypeId: "2", value: NewGTOP, startDate: this.commonService.getTodayDate() };
    this.supplierService.createCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers`, datas).subscribe((_dataGApprovals: any) => {
      this.CompanyIdnentifiers('', ONE, 'no');
      document.getElementById("closeCNGBtn").click();
      this.computeDatas = "Compute";
    });
  }
  resetCompanyValue() {
    this.NewCmpAlliasValue = "";
    this.CmpAlliasValueError = true;
    this.disableSaveBtnAliaCpy = true;
    this.newCpyAliasRegExError = false;
    this.newCpyAlcorRegExError = false;
  }
  resetCompanyAlias(val='') {
    if (val == 'name') {
      this.editRaftNameForAlcor = '';
    } else {
      this.EditAliasModel = "";
      this.EditCmpAlliasRegExError = false;
      this.EditCmpAlliasRegExNumError = false;
      this.EditCmpAlliasValueError = true;
    }
  }
  resetTaxidentif() {
    this.NewIdnetifierValue = ""
    this.IdnetifierValueError = true;
    this.disableSaveBtnAlias = true;
  }
  resetSelectedFields() {
    this.companyNameModelval = '';
    this.companyNameModelvalerror = true;
    this.companyNameModelvalRegExError = false;
  }
  /* End Root Functions. To add New functions, add below here */
  /* Start - Add Tax Identifiers */
  LoadTaxType() {
    this.saveDatas = 'Save';
    this.NewIdnetifierValue = "";
    this.TaxTypeIdnetifierModel = "";
    this.IdnetifierTypeError = false;
    this.IdnetifierValueError = false;
    this.disableSaveBtnAlias = true;
    this.saveIdenClicked = false;
  }
  changeTaxType(event: any) {
    this.TaxTypeIdnetifierModel = event.target.value;
    if (this.TaxTypeIdnetifierModel.trim() != "" && this.TaxTypeIdnetifierModel != undefined) {
      this.IdnetifierTypeError = false;
    }
    if (this.TaxTypeIdnetifierModel.trim() != "" && this.TaxTypeIdnetifierModel != undefined && this.NewIdnetifierValue.trim() != '' && this.NewIdnetifierValue != undefined) {
      this.disableSaveBtnAlias = false;
    }
    if (this.taxIdentifierRowName['european vat number'] == this.TaxTypeIdnetifierModel) {
      document.getElementById('addTaxIdenInput')?.setAttribute('maxLength', '20');
    } else {
      if (document.getElementById('addTaxIdenInput')) {
        document.getElementById('addTaxIdenInput')?.removeAttribute('maxLength');
      }
    }
  }
  emptyCheck() {
    if ((this.NewIdnetifierValue).trim() == '') {
      this.IdnetifierValueError = true;
      this.disableSaveBtnAlias = true;
    } else {
      this.IdnetifierValueError = false;
    }
    if (this.TaxTypeIdnetifierModel.trim() != "" && this.TaxTypeIdnetifierModel != undefined && this.NewIdnetifierValue.trim() != '' && this.NewIdnetifierValue != undefined) {
      this.disableSaveBtnAlias = false;
    }
  }
  AddTaxIdentifiers() {
    if (this.TaxTypeIdnetifierModel.trim() != "" && this.TaxTypeIdnetifierModel != undefined && this.NewIdnetifierValue.trim() != '' && this.NewIdnetifierValue != undefined) {
      this.saveDatas = "Saving...";
      const datas1 = {
        linkedCompanyId: this.companyID,
        companyIdentifierTypeId: this.TaxTypeIdnetifierModel,
        value: this.NewIdnetifierValue,
        startDate: this.commonService.getTodayDate(),
        companyIdentifierKeyName: ""
      };
      this.supplierService.createCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers`, datas1).subscribe((_data: any) => {
        this.CompanyIdnentifiers('', ONE, 'no');
        document.getElementById("closeAddTax").click();
        document.getElementById('closeAliasEditModal').click();
        this.saveDatas = "Save";
      });
    } else {
      if (this.TaxTypeIdnetifierModel.trim() == "" || this.TaxTypeIdnetifierModel == undefined) {
        this.IdnetifierTypeError = true;
      } else {
        this.IdnetifierTypeError = false;
      }
      if (this.NewIdnetifierValue.trim() == "" || this.NewIdnetifierValue == undefined) {
        this.IdnetifierValueError = true;
      } else {
        this.IdnetifierValueError = false;
      }
    }
  }
  /* End - Add Tax Identifiers */
  /* Start - Change Company Status */
  private shouldIncludeStatus(statusCode: string, currentStatusId: number): boolean {
    if (currentStatusId === ONE) {
      return this.shouldIncludeStatusForApproved(statusCode);
    }
    if (currentStatusId === FOUR) {
      return statusCode === 'Identified';
    }
    return this.shouldIncludeStatusForApproved(statusCode);
  }

  private shouldIncludeStatusForApproved(statusCode: string): boolean {
    if (this.alcorValueWithApos.length === ZERO) {
      return statusCode !== 'Approved';
    }
    if (this.archived.length > ZERO && this.archived !== undefined) {
      return statusCode !== 'Approved';
    }
    return true;
  }

  FetchExistStatus(params: string) {
    this.saveDatas = 'Save';
    this.CmpStaError = false;
    this.CompanyStatusAll = [];
    this.CpyStatusHolder = params;
    this.disableChangeCpyStatus = false;
    this.MDMSynchroMode = false;
    this.supplierService.getCompanySatus(`${this.Config.ApiSupplierUrl}company-status`).subscribe((data: any) => {
      console.info("alcor", this.alcorValueWithApos, "archived", this.archived.length)
      console.info("this.companyBasicInfo['companyStatusId']", this.companyBasicInfo['companyStatusId'])
      const currentStatusId = this.companyBasicInfo['companyStatusId'];
      for (const element10 of data['company-status']) {
        if (element10['row_id'] !== currentStatusId && this.shouldIncludeStatus(element10['code'], currentStatusId)) {
          this.CompanyStatusAll.push(element10);
        }
      }
    });
    this.getMDMSynchroMode();
    this.cmpStausModel = "";
  }
  changecmpStaus(selectedValue: any) {
    this.cmpStausModel = selectedValue;
    if (this.cmpStausModel && this.cmpStausModel.trim() !== "") {
      this.CmpStaError = false;
    }
    const CmpTmp = this.cmpStausModel.split("===");
    if (CmpTmp[ONE] === 'Registered') {
      this.MDMSynchroMode = true;
    } else {
      this.MDMSynchroMode = false;
    }
  }
  private hasActiveAlcorAlias(): boolean {
    if (!this.companyAliasAll['ALCOR'] || this.companyAliasAll['ALCOR'].length <= ZERO) {
      return false;
    }
    return this.companyAliasAll['ALCOR'].some((element: any) => element.endDate == '');
  }
  private hasActiveSite(): boolean {
    for (const element of this.SitesInfo) {
      if (element.site) {
        const siteIdTemp = element.site.href.split('/');
        if (element.businessEntityId != this.siteBusinessEntityHQ && element.status != 'ARCHIVED' && this.Site_City_Country[siteIdTemp[ONE]]['activeStatus'] != 'ARCHIVED') {
          return true;
        }
      }
    }
    return false;
  }
  private updateArchivedCompany(datas2: any) {
    this.supplierService.getGroups(`${this.Config.ApiSupplierUrl}groups?representingCompanyId=${this.companyID}`).subscribe(data => {
      if (data['groups'].length > ZERO) {
        data['groups'].every((elementGrp: any) => elementGrp.modificationStatus == 'ARCHIVED');
      }
      this.supplierService.UpdateCompany(`${this.Config.ApiSupplierUrl}companies/${this.companyID}`, datas2).subscribe((updateResult: any) => {
        document.getElementById("closeCmpStatus").click();
        this.companyBasicInfo['companyStatusCode'] = updateResult.companyStatusCode;
        this.companyBasicInfo['companyStatusId'] = updateResult.companyStatusId;
        this.saveDatas = "Save";
        const constSetEnd = { endDate: this.commonService.getTodayDate() }
        if (this.companyAliasAll['GTOP']) {
          for (const [index, ele] of this.companyAliasAll['GTOP'].entries()) {
            this.supplierService.updateCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers/${ele.key}`, constSetEnd).subscribe(_data12 => {
              if (!this.companyAliasAll['MDM'] && index + ONE == this.companyAliasAll['GTOP'].length) {
                this.CompanyIdnentifiers('', ONE, 'no');
              }
            });
          }
        }
        if (this.companyAliasAll['MDM']) {
          for (const [index, ele] of this.companyAliasAll['MDM'].entries()) {
            this.supplierService.updateCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers/${ele.key}`, constSetEnd).subscribe(_data12 => {
              if (index + ONE == this.companyAliasAll['MDM'].length) {
                this.CompanyIdnentifiers('', ONE, 'no');
              }
            });
          }
        }
        if (this.CpyStatusHolder == 'Registered' && this.mdmSynchroRowId.length > ZERO) {
          for (const element of this.mdmSynchroRowId) {
            this.supplierService.deleteCompanyName(`${this.Config.ApiSupplierUrl}company-names/${element}`).subscribe((_data: any) => { });
          }
        }
      });
    });
  }
  private saveArchivedCompanyStatus(datas2: any) {
    if (this.hasActiveAlcorAlias()) {
      this.warningForArchiveCpyText = 'Prior to archive a Company, please archive all its ALCOR codes.';
      document.getElementById('btnForWarningArchiveCpy').click();
      this.saveDatas = 'Save';
      return;
    }
    if (this.hasActiveSite()) {
      this.warningForArchiveCpyText = 'Prior to archive a Company, please archive or move all its Sites.';
      document.getElementById('btnForWarningArchiveCpy').click();
      this.saveDatas = 'Save';
      return;
    }
    this.updateArchivedCompany(datas2);
  }
  private saveApprovedCompanyStatus(datas2: any) {
    if (this.mdmSynchroRowId.length > ZERO) {
      for (const element of this.mdmSynchroRowId) {
        this.supplierService.deleteCompanyName(`${this.Config.ApiSupplierUrl}company-names/${element}`).subscribe((_data: any) => { });
      }
    }
    if (!this.hasActiveAlcorAlias()) {
      this.supplierService.UpdateCompany(`${this.Config.ApiSupplierUrl}companies/${this.companyID}`, datas2).subscribe((data: any) => {
        console.info('companyStatus', data)
        this.companyBasicInfo['companyStatusCode'] = data.companyStatusCode;
        this.companyBasicInfo['companyStatusId'] = data.companyStatusId;
        this.saveDatas = "Save";
      });
      return;
    }
    this.warningForArchiveCpyText = 'This company can not be Approved because all ALCOR codes are Archived';
    document.getElementById('btnForWarningArchiveCpy').click();
    document.getElementById("closeCmpStatus").click();
    this.reloadPage = true;
    this.saveDatas = 'Save';
  }
  SaveNewCmpStatus() {
    if (this.cmpStausModel == undefined || this.cmpStausModel.trim() == "") {
      this.CmpStaError = true;
      return;
    }
    console.info('group status', this.GroupAssign);
    this.disableChangeCpyStatus = true;
    this.CmpStaError = false;
    this.saveDatas = "Saving...";
    const status = this.cmpStausModel.split("===");
    const datas2 = this.getCompanyStatusPayload(status);
    if (status[ONE] == 'Archived') {
      this.saveArchivedCompanyStatus({ ...datas2, endDate: this.commonService.getTodayDate() });
    } else if (status[ONE] == 'Approved' && this.CpyStatusHolder == 'Registered') {
      this.saveApprovedCompanyStatus(datas2);
    } else {
      this.saveStandardCompanyStatus(datas2);
    }
  }
  private getCompanyStatusPayload(status: string[]): any {
    return this.CpyStatusHolder == 'Archived'
      ? { companyStatusId: status[ZERO], companyStatusCode: status[ONE], endDate: '' }
      : { companyStatusId: status[ZERO], companyStatusCode: status[ONE] };
  }
  private saveStandardCompanyStatus(datas2: any): void {
    if (this.CpyStatusHolder == 'Registered') {
      for (const element of this.mdmSynchroRowId) {
        this.supplierService.deleteCompanyName(`${this.Config.ApiSupplierUrl}company-names/${element}`).subscribe((_data: any) => { });
      }
    }
    this.supplierService.UpdateCompany(`${this.Config.ApiSupplierUrl}companies/${this.companyID}`, datas2).subscribe((data: any) => {
      document.getElementById("closeCmpStatus").click();
      this.companyBasicInfo['companyStatusCode'] = data.companyStatusCode;
      this.companyBasicInfo['companyStatusId'] = data.companyStatusId;
      this.saveDatas = "Save";
    });
  }
  /* End - Change Company Status */
  /* Start ***** Add Company Alias */
  LoadCmpAlias() {
    this.saveDatas = 'Save';
    this.CmpAlliasTypeModel = "1";
    this.TaxTypeIdnetifierModel = "1";
    this.NewCmpAlliasValue = "";
    this.CmpAlliasTypeError = false;
    this.CmpAlliasValueError = false;
    this.disableSaveBtnAliaCpy = true;
    this.newCpyAliasRegExError = false;
    this.newCpyAlcorRegExError = false;
    this.saveIdenClicked = false;
    document.getElementById('newCpyAliasValId').removeAttribute('maxLength');
  }
  changeCmpAllias(event: any, type) {
    if (type == 'bvdId' || type == 'dup') {
      this.handleDuplicateBvdAlias();
      return;
    }
    this.TaxTypeIdnetifierModel = event.target.value;
    this.updateAliasSaveState(type, this.NewCmpAlliasValue);
  }
  private updateAliasSaveState(type: any, value: string): void {
    this.clearAliasTypeErrorIfValid();
    const typeIds = this.aliasAccToRowId;
    const hasRequiredValue = this.hasAliasTypeAndValue(value);
    const isShortAlias = type == typeIds['gtop'] || type == typeIds['mdm'];
    const isValid = this.isValidAliasValue(type, value, isShortAlias);
    this.disableSaveBtnAliaCpy = !hasRequiredValue || !isValid;
    this.updateAliasInputLength(type, value, isShortAlias);
  }
  private clearAliasTypeErrorIfValid(): void {
    if (this.TaxTypeIdnetifierModel.trim() != "" && this.TaxTypeIdnetifierModel != undefined) { this.CmpAlliasTypeError = false; }
  }
  private hasAliasTypeAndValue(value: string): boolean {
    return this.TaxTypeIdnetifierModel.trim() != "" && this.TaxTypeIdnetifierModel != undefined && value.trim() != '';
  }
  private isValidAliasValue(type: any, value: string, isShortAlias: boolean): boolean {
    const isAlphaNumericShort = /^[a-zA-Z0-9]+$/.test(value) && isShortAlias;
    const isAlcorNumeric = type == this.aliasAccToRowId['alcor'] && /^[0-9]+$/.test(value);
    return isAlphaNumericShort || isAlcorNumeric || type == this.aliasAccToRowId['duns'];
  }
  private updateAliasInputLength(type: any, value: string, isShortAlias: boolean): void {
    const input = document.getElementById('newCpyAliasValId');
    if (isShortAlias) {
      this.disableSaveBtnAliaCpy = value.length > FOUR;
      input.setAttribute('maxLength', '4');
      return;
    }
    if (type == this.aliasAccToRowId['alcor']) {
      input.setAttribute('maxLength', '6');
      return;
    }
    input.removeAttribute('maxLength');
  }
  private handleDuplicateBvdAlias(): void {
    if (this.bvdIdValExists) {
      document.getElementById('bvdIdAlreadyExists').click();
      this.bvdIdTextHolder = "This company already has a BVD ID, if needed please update it.";
      this.CmpAlliasTypeModel = 'dup';
    }
  }
  test() {
    console.info('test')
  }
  CmpEmptyCheck(_e) {
    if (this.CmpAlliasTypeModel == 'bvdId') {
      this.CmpAlliasValueError = this.NewCmpAlliasValue.trim().length == ZERO;
      this.disableSaveBtnAliaCpy = !this.CmpAlliasValueError;
      return;
    }
    this.validateCompanyAliasValue(this.CmpAlliasTypeModel);
  }
  private validateCompanyAliasValue(rowId: any): void {
    const value = this.NewCmpAlliasValue;
    if (value.trim() == '') {
      this.resetEmptyAliasValidation();
      return;
    }
    this.setNewAliasFormatErrors(rowId, value);
    if (!this.hasAliasTypeAndValue(value)) { return this.disableAliasSave(); }
    this.disableSaveBtnAliaCpy = this.isAliasSaveDisabled(rowId, value);
  }
  private resetEmptyAliasValidation(): void {
    this.CmpAlliasValueError = true;
    this.disableSaveBtnAliaCpy = true;
    this.newCpyAliasRegExError = false;
    this.newCpyAlcorRegExError = false;
  }
  private setNewAliasFormatErrors(rowId: any, value: string): void {
    const isGtopOrMdm = rowId == this.aliasAccToRowId['gtop'] || rowId == this.aliasAccToRowId['mdm'];
    if (isGtopOrMdm) { this.newCpyAliasRegExError = !/^[a-zA-Z0-9]+$/.test(value); }
    if (rowId == this.aliasAccToRowId['alcor']) { this.newCpyAlcorRegExError = !(/^[0-9]+$/.test(value) && value.length == SIX); }
    this.disableSaveBtnAliaCpy = false;
    this.CmpAlliasValueError = false;
  }
  private disableAliasSave(): void {
    this.disableSaveBtnAliaCpy = true;
  }
  private isAliasSaveDisabled(rowId: any, value: string): boolean {
    if (rowId == this.aliasAccToRowId['gtop'] || rowId == this.aliasAccToRowId['mdm']) { return !(/^[a-zA-Z0-9]+$/.test(value) && value.length <= FOUR); }
    if (rowId == this.aliasAccToRowId['alcor']) { return !/^[0-9]+$/.test(value); }
    return false;
  }
  AddCmpAllias(onSuccess?: () => void) {
    if (this.CmpAlliasTypeModel.trim() != "" && this.CmpAlliasTypeModel != undefined && this.NewCmpAlliasValue.trim() != '' && this.NewCmpAlliasValue != undefined) {
      this.saveDatas = "Saving...";
      /*date*/
      const today = new Date();
      const dd = String(today.getDate()).padStart(TWO, '0');
      const mm = String(today.getMonth() + ONE).padStart(TWO, '0');
      const yyyy = today.getFullYear();
      const todayDate = `${yyyy}-${mm}-${dd}`;
      /*date*/
      const datas3 = {
        linkedCompanyId: this.companyID,
        companyIdentifierTypeId: this.CmpAlliasTypeModel,
        value: this.NewCmpAlliasValue,
        startDate: todayDate,
        companyIdentifierKeyName: ""
      };
      this.supplierService.createCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers`, datas3).subscribe((_data: any) => {
        this.CompanyIdnentifiers('', ONE, 'reload');
        document.getElementById("closeAddCmpAlias").click();
        document.getElementById('closeAliasEditModal').click();
        this.saveDatas = "Save";
        const isAlcorAlias = String(this.CmpAlliasTypeModel) === String((this.aliasAccToRowId as any)['alcor']);
        if (isAlcorAlias) {
          this.runPostAlcorStatusTransitions();
        }
        if (onSuccess) {
          onSuccess();
        }
      });
    } else {
      if (this.CmpAlliasTypeModel.trim() == "" || this.CmpAlliasTypeModel == undefined) {
        this.CmpAlliasTypeError = true;
      } else {
        this.CmpAlliasTypeError = false;
      }
      if (this.NewCmpAlliasValue.trim() == "" || this.NewCmpAlliasValue == undefined) {
        this.CmpAlliasValueError = true;
      } else {
        this.CmpAlliasValueError = false;
      }
    }
  }

  private runPostAlcorStatusTransitions() {
    const updateHeadQuarterWorkflowStatus = () => {
      const headQuarterBusinessEntityId = this.siteBusinessEntityHQ;
      const headQuarterSiteId = headQuarterBusinessEntityId ? this.Site_hrefTo_Cid[headQuarterBusinessEntityId] : '';
      console.info(headQuarterBusinessEntityId, this.Site_City_Country[headQuarterSiteId]);

      if (!headQuarterSiteId || !this.Site_City_Country || !this.Site_City_Country[headQuarterSiteId]) {
        return;
      }

      if (this.Site_City_Country[headQuarterSiteId]['workflowStatus'] !== 'WaitingForRenault') {
        return;
      }
      this.siteService.getAccessPoints(`${this.Config.ApiSitesUrl}access-points?siteIdentifier=${this.Site_City_Country[headQuarterSiteId]['identifier']}&activeStatus=PENDING`).subscribe(acpdata =>{
        if(acpdata['access-points'].length == ZERO){
        this.siteService
        .updateSite(`${this.Config.ApiSitesUrl}sites/${headQuarterSiteId}`, { workflowStatus: 'Completed' })
        .subscribe(() => {
          this.Site_City_Country[headQuarterSiteId]['workflowStatus'] = 'Completed';
        });
      }
      })
    };

    const updateCompanyWorkflowStatus = () => {
      if (!this.companyBasicInfo || this.companyBasicInfo['workflowStatus'] !== 'WaitingForRenault') {
        updateHeadQuarterWorkflowStatus();
        return;
      }

      this.supplierService
        .UpdateCompany(`${this.Config.ApiSupplierUrl}companies/${this.companyID}`, { workflowStatus: 'Completed' })
        .subscribe(() => {
          this.companyBasicInfo['workflowStatus'] = 'Completed';
          updateHeadQuarterWorkflowStatus();
        }, () => {
          updateHeadQuarterWorkflowStatus();
        });
    };

    if (!this.companyBasicInfo || !this.companyBasicInfo['companyStatusCode'] || (this.companyBasicInfo['companyStatusCode'].toLowerCase() !== 'identified' && this.companyBasicInfo['companyStatusCode'].toLowerCase() !== 'prospect')) {
      updateCompanyWorkflowStatus();
      return;
    }

    this.supplierService.getCompanySatus(`${this.Config.ApiSupplierUrl}company-status`).subscribe((dataStatus: any) => {
      const approvedStatus = (dataStatus?.['company-status'] ?? []).find(
        (status: any) => status?.code?.toLowerCase() === 'approved'
      );

      if (!approvedStatus) {
        updateCompanyWorkflowStatus();
        return;
      }

      const payload = {
        companyStatusId: approvedStatus.row_id,
        companyStatusCode: approvedStatus.code
      };

      this.supplierService.UpdateCompany(`${this.Config.ApiSupplierUrl}companies/${this.companyID}`, payload).subscribe((updatedCompany: any) => {
        this.companyBasicInfo['companyStatusCode'] = updatedCompany?.companyStatusCode ?? approvedStatus.code;
        this.companyBasicInfo['companyStatusId'] = updatedCompany?.companyStatusId ?? approvedStatus.row_id;
        updateCompanyWorkflowStatus();
      }, () => {
        updateCompanyWorkflowStatus();
      });
    }, () => {
      updateCompanyWorkflowStatus();
    });
  }
  /* End ***** Add Company Alias */
  /* Start ***** Change Group */
  LoadGrp(valFrmUsr) {
    this.autoLoadGrpName = true
    this.saveDatas = 'Save';
    this.GroupNameAll = [];
    this.GroupCatptins = [];
    this.GroupAllToName = [];
    this.GroupNameAllId = [];
    if (valFrmUsr.length >= TWO) {
      this.supplierService.getGroups(`${this.Config.ApiSupplierUrl}groups?name=*${encodeURIComponent(valFrmUsr)}*&_page=1&_pagesize=10`).subscribe((data: any) => {
        if (data['count'] >= ONE) {
          for (const element of data['groups']) {
            this.GroupNameAll[element.row_id] = element.name;
            this.GroupNameAllId[element.name] = element.row_id;
            this.GroupAllToName[element.name] = element.allianceIdentifier;
            this.GroupCatptins.push(element.name);
            this.autoLoadGrpName = false
          }
        } else {
          this.autoLoadGrpName = false
        }
      });
    } else {
      this.autoLoadGrpName = false
      this.GroupNameAll = [];
      this.GroupCatptins = [];
      this.GroupAllToName = [];
      this.GroupNameAllId = [];
    }
  }
  LoadGrpAllianceId(valFrmUsr) {
    this.autoLoadGrpId = true
    this.saveDatas = 'Save';
    this.changeGroupAllianceId = [];
    this.GroupCatptins = [];
    this.GroupAllToName = [];
    this.GroupNameAllId = [];
    if (valFrmUsr.length >= FOUR) {
      this.supplierService.getGroups(`${this.Config.ApiSupplierUrl}groups?allianceIdentifier=*${valFrmUsr}*&_page=1&_pagesize=10`).subscribe((data: any) => {
        if (data['count'] >= ONE) {
          for (const element of data['groups']) {
            this.GroupAllToName[element.allianceIdentifier] = element.name;
            this.GroupNameAllId[element.name] = element.row_id;
            this.changeGroupAllianceId.push(element.allianceIdentifier);
            this.autoLoadGrpId = false
          }
        } else {
          this.autoLoadGrpId = false
        }
      });
    } else {
      this.autoLoadGrpId = false
    }
  }
  LoadGrpShortName(valFrmUsr) {
    if (!this.autoShortname) { return; }
    this.autoLoadGrpSrtName = true;
    this.saveDatas = 'Save';
    this.GroupAllToName = [];
    this.changeGroupShortName = [];
    this.GroupShrtToName = [];
    this.GroupNameAllId = [];
    if (valFrmUsr.length < TWO) { this.autoLoadGrpSrtName = false; return; }
    this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?value=*${valFrmUsr}*&groupIdentifierKeyName=MDM GROUP&_page=1&_pagesize=10`).subscribe(data => {
      this.autoLoadGrpSrtName = false;
      if (data['count'] < ONE) { return; }
      for (const element of data['group-identifiers']) {
        this.GroupAllToName[element.value] = element.groupAllianceIdentifier;
        this.GroupShrtToName[element.value] = element.groupName;
        this.GroupNameAllId[element.groupName] = element.groupId;
        this.changeGroupShortName.push(element.value);
      }
    });
  }
  LoadGrpingType() {
    this.GrpNameModel = "";
    this.GroupNameAll = "";
    this.groupAllianceIdModel = "";
    this.groupShortNameModel = "";
    this.GroupNameAll = [];
    this.GroupAllToName = "";
    this.GroupShrtToName = "";
    this.GroupAllToName = [];
    this.GroupShrtToName = [];
    this.GroupCatptins = [];
    this.changeGroupAllianceId = [];
    this.GroupNameAllId = [];
    this.changeGroupShortName = [];
    this.autoShortname = true;
    this.GrpNameError = false;
    this.GrpingTypeError = false;
    this.GrpingTypeModel = '2';
    this.autoLoadGrpName = false
    this.autoLoadGrpId = false
    this.autoLoadGrpSrtName = false
    this.changeGroupModal = 'default';
    this.disableGroupLinkBtn = false;
    this.groupNameDrop = false;
    this.groupIdDrop = false;
    this.groupShortNameDrop = false;
    this.userQuestionUpdate2.setValue('')
    this.delayGrpAllianceId.setValue('')
    this.delayGrpShortName.setValue('')
    if (this.GroupingTypeAll.length == ZERO) {
      this.supplierService.getGroupAssignmentTypes(`${this.Config.ApiSupplierUrl}group-assignment-types`).subscribe((data: any) => {
        for (const element of data['group-assignment-types']) {
          if (element.groupAssignementTypeCode.toLowerCase() == 'apo') {
            element.groupAssignementTypeCode = 'RGP'
          }
        }
        this.GroupingTypeAll = data['group-assignment-types'];
      });
    }
  }
  changeGrpingType(event: any) {
    this.GrpingTypeModel = event.value;
    if (this.GrpingTypeModel.trim() != "" && this.GrpingTypeModel != undefined) {
      this.GrpingTypeError = false;
    }
  }
  UpdateCmpGrp() {
    console.info(this.GrpingTypeModel);
    if (this.GrpNameModel == undefined || this.GrpingTypeModel == undefined || this.GrpNameModel == "" || this.GrpingTypeModel == '') {
      this.setGroupValidationErrors();
      return false;
    }
    this.saveGroupAssignment();
  }
  private saveGroupAssignment(): void {
      this.disableGroupLinkBtn = true;
      const GTM = this.GroupNameAllId[this.GrpNameModel];
      let representingCompanyChange: boolean;
      /*date*/
      const today = new Date();
      const dd = String(today.getDate()).padStart(TWO, '0');
      const mm = String(today.getMonth() + ONE).padStart(TWO, '0');
      const yyyy = today.getFullYear();
      const todayDate = `${yyyy}-${mm}-${dd}`;
      /*date*/
      const datas5 = {
        "companyId": this.companyID,
        "groupTypeCode": "",
        "groupId": GTM,
        "apoStatus": "ACTIVE",
        "validityStartDate": todayDate,
        "groupTypeId": this.GrpingTypeModel,
        "status": "VALIDATED"
      };
      this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?groupId=${GTM}&companyId=${this.companyID}&_page=1`).subscribe(data0 => {
        if (data0['pageCount'] == ZERO) {
          representingCompanyChange = this.prepareNewGroupAssignment(datas5);
          this.createGroupAssignment(datas5, representingCompanyChange);
          return;
        }
        this.processExistingGroupAssignments(data0['group-assignments']);
      });
  }
  private prepareNewGroupAssignment(datas5: any): boolean {
    this.changeGroupModal = 'default';
    console.info('hh', this.companyID, 'kk', this.representingCompany)
    if (this.companyID != this.representingCompany) {
      return false;
    }
    const removeRep = {
      representingCompanyId: '',
      representingCompanyAllianceIdentifier: ''
    }
    this.supplierService.UpdateGroups(`${this.Config.ApiSupplierUrl}groups/${this.GroupAssign.groupId}`, removeRep).subscribe(data => {
      this.oldName = data['name']
      this.oldIdentifier = data['allianceIdentifier']
      this.oldId = data['row_id']
    });
    return true;
  }
  private createGroupAssignment(datas5: any, representingCompanyChange: boolean): void {
    this.supplierService.CreateGroupAssignment(`${this.Config.ApiSupplierUrl}group-assignments`, datas5).subscribe((_data: any) => {
      this.getGroupAssignments('No');
      if (representingCompanyChange) {
        this.changeGroupModal = 'change1';
        return;
      }
      document.getElementById("closeChangeGrp").click();
      this.saveDatas = "Save";
      this.disableGroupLinkBtn = false;
    });
  }
  private processExistingGroupAssignments(assignments: any[]): void {
    this.changeGroupModal = 'change';
    for (const assignment of assignments) {
      this.processGroupAssignmentChange(assignment);
    }
  }
  private processGroupAssignmentChange(assignment: any): void {
    const isActive = assignment.validityEndDate == '';
    const sameType = assignment.groupTypeId == this.GrpingTypeModel;
    if (isActive && sameType) {
      this.chgGroupTextDisp = '<img src="assets/images/warning.png" class="img-btn mr-2" alt=""> The Company is already associated to the Group';
      this.changeGroupButtonText = 'Cancel';
      return;
    }
    if (isActive) {
      this.updateActiveGroupAssignment(assignment);
      return;
    }
    this.updateArchivedGroupAssignment(assignment, sameType);
  }
  private updateActiveGroupAssignment(assignment: any): void {
    this.chgGroupTextDisp = '<img src="assets/images/warning.png" class="img-btn mr-2" alt=""> Grouping Type as been updated';
    this.changeGroupButtonText = 'OK';
    const update = { 'groupTypeId': this.GrpingTypeModel }
    this.supplierService.updateGroupAssignment(`${this.Config.ApiSupplierUrl}group-assignments/${assignment.row_id}`, update).subscribe(_data0 => {
      this.getGroupAssignments('No');
    });
  }
  private updateArchivedGroupAssignment(assignment: any, sameType: boolean): void {
    this.chgGroupTextDisp = sameType
      ? '<img src="assets/images/warning.png" class="img-btn mr-2" alt=""> The link has been unarchived'
      : '<img src="assets/images/warning.png" class="img-btn mr-2" alt=""> The link has been unarchived and Grouping Type as been updated';
    this.changeGroupButtonText = 'OK';
    const update = sameType
      ? { 'validityEndDate': '', 'apoStatus': 'ACTIVE', 'status': 'VALIDATED' }
      : { 'validityEndDate': '', 'groupTypeId': this.GrpingTypeModel, 'apoStatus': 'ACTIVE', 'status': 'VALIDATED' };
    const archive = { 'validityEndDate': this.commonService.getTodayDate(), 'apoStatus': 'ARCHIVED', 'status': 'ARCHIVED' };
    this.supplierService.updateGroupAssignment(`${this.Config.ApiSupplierUrl}group-assignments/${this.GroupAssign['row_id']}`, archive).subscribe(_data8 => {
      this.supplierService.updateGroupAssignment(`${this.Config.ApiSupplierUrl}group-assignments/${assignment.row_id}`, update).subscribe(_data3 => {
        this.getGroupAssignments('No');
      });
    });
  }
  private setGroupValidationErrors(): void {
    this.GrpNameError = this.GrpNameModel == undefined || this.GrpNameModel.trim() == "";
    this.GrpAllianceError = this.groupAllianceIdModel == undefined || this.groupAllianceIdModel.trim() == "";
    this.GrpShortNameError = this.groupShortNameModel == undefined || this.groupShortNameModel.trim() == "";
    this.GrpingTypeError = this.GrpingTypeModel == undefined || this.GrpingTypeModel == "";
  }
  /* End ***** Change Group */
  updateCompanyExistsName() {
    this.saveDatas = 'Save';
    this.companyNameModelval = this.companyNameModelExistsval;
    this.companyNameModelvalerror = false;
    this.companyNameModelvalRegExError = false;
    this.disableUpdateCpyNameBtn = false;
  }
  checkvalidateField() {
    // intentional noop
  }
  updateCompanyName() {
    if (this.companyNameModelval != '' && this.companyNameModelval != undefined && !this.companyNameModelvalRegExError) {
      this.disableUpdateCpyNameBtn = true;
      const siteRowIds = [];
      for (const ele of this.SitesInfo) {
        if (ele.status == "VALIDATED") {
          const split = ele.site.href.split('/');
          siteRowIds.push(split[ONE]);
        }
      }
      this.saveDatas = "Save...";
      this.companyNameModelvalerror = false;
      const datas = { legalName: this.companyNameModelval };
      this.supplierService.UpdateCompany(`${this.Config.ApiSupplierUrl}companies/${this.companyID}`, datas).subscribe((data: any) => {
        this.companyBasicInfo = data;
        this.companyNameModelExistsval = this.companyNameModelval;
        this.browserTitleService.setCompanyName(this.companyNameModelval);
        document.getElementById("closeCBtn").click();
        this.saveDatas = "Save";
        if (siteRowIds.length > ZERO) {
          const constLabel = { label: this.companyNameModelval };
          for (const element1 of siteRowIds) {
            this.updateSiteNameAfterRename(element1, constLabel);
          }
          this.siteService.getRealEstateAssetAssignments(`${this.Config.ApiSitesUrl}real-estate-asset-assignments?realEstateAssetId=in(${siteRowIds})`).subscribe(data12 => {
            this.updateLegalEntitiesForSites(data12);
          });
        }
        setTimeout(function () {
          this.loadBvdIdCpy('reload');
        }.bind(this), siteRowIds.length * THREE_HUNDRED);
      });
    } else {
      if (!this.companyNameModelvalRegExError) {
        this.companyNameModelvalerror = true;
      }
    }
  }
  private updateSiteNameAfterRename(siteRowId: string, constLabel: any): void {
    if (this.Site_City_Country[siteRowId]) {
      const constNameUP = { name: `${this.companyNameModelval} ${this.Site_City_Country[siteRowId].cityName}` };
      this.siteService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.Site_City_Country[siteRowId].rowId}`, constNameUP).subscribe(_data2 => { });
    }
    if (this.siteQualiferMainEntranceData.length > ZERO && this.siteQualiferMainEntranceData[siteRowId]) {
      this.siteService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${this.siteQualiferMainEntranceData[siteRowId].rowId}`, constLabel).subscribe(_data12 => { });
    }
  }
  private updateLegalEntitiesForSites(data12: any): void {
    if (data12['real-estate-asset-assignments'].length <= ZERO) { return; }
    const updateLegal = { corporateName: this.companyNameModelval };
    for (const element of data12['real-estate-asset-assignments']) {
      if (element.legalEntityId != '') {
        this.siteService.updateLegalEntity(`${this.Config.ApiSitesUrl}legal-entities/${element.legalEntityId}`, updateLegal).subscribe(_data13 => { });
      }
    }
  }
  /** Edit Company Alias */
  EditAlias(AliaType, AliaVal, AliaKey, bool, bool1, arc1) {
    this.saveDatas = 'Save';
    this.EditCmpAlliasValueError = false;
    this.editingAlias = AliaType;
    this.disableEditCpyAlias = false;
    this.EditAliasObj = "";
    this.EditAliasObj = { "AliasType": AliaType, "AliasKey": AliaKey, "AliasVal": AliaVal }
    this.EditAliasModel = AliaVal;
    this.disableInputForMDM = bool;
    this.showSwitch = bool1;
    this.valArchived = arc1;
    console.info("valArchived", this.valArchived)
    this.EditCmpAlliasRegExError = false;
    this.EditCmpAlliasRegExNumError = false;
    if (AliaType == 'ALCOR') {
      if (this.alcorNameValsOnAlcorVal[AliaVal]) {
        this.editRaftNameForAlcor = this.alcorNameValsOnAlcorVal[AliaVal][ZERO]['businessIdentifierName'];
      }
      this.disableInputForMDM = false;
    } else {
      this.editRaftNameForAlcor = '';
    }
    if (AliaType == 'GTOP') {
      this.switchBtnText = 'Switch to MDM'
    } else if (AliaType == 'MDM') {
      this.switchBtnText = 'Switch to GTOP'
    } else {
    }
    document.getElementById('editAliasModelId').removeAttribute('maxLength');
    if (AliaType == 'GTOP' || AliaType == 'MDM') {
      document.getElementById('editAliasModelId').setAttribute('maxLength', '4');
    } else if (AliaType == 'ALCOR') {
      document.getElementById('editAliasModelId').setAttribute('maxLength', '6');
    } else {
    }
  }
  EditAliasEmptyCheck(_e) {
    const type = this.EditAliasObj.AliasType;
    if ((this.EditAliasModel).trim() == '') {
      this.EditCmpAlliasValueError = true;
      this.EditCmpAlliasRegExError = false;
      return;
    }
    if (type == 'DUNS') {
      this.EditCmpAlliasValueError = false;
      this.EditCmpAlliasRegExError = false;
      this.EditCmpAlliasRegExNumError = false;
      return;
    }
    this.setAliasFormatErrors(type, this.EditAliasModel);
    this.EditCmpAlliasValueError = false;
  }
  private setAliasFormatErrors(type: string, value: string): void {
    const isAlphaNumeric = /^[a-zA-Z0-9]+$/.test(value);
    const isNumeric = /^[0-9]+$/.test(value);
    this.EditCmpAlliasRegExError = type != 'ALCOR' && !(isAlphaNumeric && (type == 'GTOP' || type == 'MDM'));
    this.EditCmpAlliasRegExNumError = type == 'ALCOR' ? !isNumeric : type != 'MDM' && type != 'GTOP';
  }
  EditSaveCmpAllias(editValue) {
    if (editValue == 'ALCOR') {
      this.saveAlcorAliasName();
      return;
    }
    if (this.isEditableAliasValid()) {
      this.saveEditableAlias();
      return;
    }
    this.setEditableAliasErrors();
  }
  private isEditableAliasValid(): boolean {
    const value = this.EditAliasModel;
    const type = this.EditAliasObj.AliasType;
    const alphaNumeric = /^[a-zA-Z0-9]+$/.test(value);
    const numeric = /^[0-9]+$/.test(value);
    const isAlphaNumericMdmGtop = alphaNumeric && (type == 'MDM' || type == 'GTOP');
    const isNumericAlcor = numeric && type == 'ALCOR';
    const isValidType = isAlphaNumericMdmGtop || isNumericAlcor || type == 'DUNS';
    return value != undefined && value.trim() != '' && isValidType;
  }
  private saveEditableAlias(): void {
    this.saveDatas = "Saving...";
    this.disableEditCpyAlias = true;
    const datas9 = { value: this.EditAliasModel };
    this.supplierService.updateCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers/${this.EditAliasObj.AliasKey}`, datas9).subscribe((_data: any) => {
      this.updateAliasSiteIdentifiers();
      document.getElementById("closeEditCmpAlias").click();
      this.CompanyIdnentifiers('', ONE, 'no');
      this.saveDatas = "Save";
    });
  }
  private updateAliasSiteIdentifiers(): void {
    this.siteService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?businessIdentifierValue=${this.EditAliasModel}&_page=1`).subscribe(data0 => {
      if (data0['pageCount'] == ZERO) {
        const shortNameVal = this.companyShortName === '' ? this.companyBasicInfo['legalName'].slice(ZERO, SIX) : this.companyShortName.trim();
        for (const ele of this.SiteRowID) {
          const const3 = {
            'sourceSystemId': '2', 'businessIdentifierId': this.siteIdenTypeDetails['RAFT_ACCOUNT'],
            'effectiveDate': this.commonService.getTodayDate(), 'businessIdentifierValue': this.EditAliasModel,
            'businessIdentifierName': shortNameVal, 'realEstateAssetId': ele
          };
          this.siteService.createRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers`, const3).subscribe(_data1 => { });
        }
      } else {
        for (const ele1 of data0['real-estate-asset-identifiers']) {
          this.siteService.updateRealEstateAssetIdentifier(this.Config.ApiSitesUrl + REAL_ESTATE_ASSET_IDENTIFIERS_PATH + ele1.rowId, { 'endDate': '' }).subscribe(_data5 => { });
        }
      }
    });
  }
  private setEditableAliasErrors(): void {
    if (this.EditAliasModel.trim() == '') {
      this.EditCmpAlliasValueError = true;
      return;
    }
    if (!/^[0-9]+$/.test(this.EditAliasModel) && this.EditAliasObj.AliasType == 'ALCOR') {
      this.EditCmpAlliasRegExNumError = true;
    } else {
      this.EditCmpAlliasRegExError = true;
    }
  }
  private saveAlcorAliasName(): void {
    if (this.alcorNameRegExError || this.editRaftNameForAlcor == '' || this.editRaftNameForAlcor == undefined) {
      return;
    }
    this.saveDatas = "Saving...";
    const updateRaftName = { businessIdentifierName: this.editRaftNameForAlcor };
    const existingNames = this.alcorNameValsOnAlcorVal[this.EditAliasModel];
    if (existingNames) {
      for (const [index, element] of existingNames.entries()) {
        this.siteService.updateRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers/${element['rowId']}`, updateRaftName).subscribe(_data123 => {
          if (index + ONE == existingNames.length) {
            this.finishAliasSave();
          }
        });
      }
      return;
    }
    for (const [index, ele] of this.SiteRowID.entries()) {
      const newUpdateName = {
        'sourceSystemId': '2', 'businessIdentifierId': this.siteIdenTypeDetails['RAFT_ACCOUNT'],
        'effectiveDate': this.commonService.getTodayDate(), 'businessIdentifierValue': this.EditAliasModel,
        'businessIdentifierName': this.editRaftNameForAlcor, 'realEstateAssetId': ele
      };
      this.siteService.createRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers`, newUpdateName).subscribe(_data1 => {
        if (index + ONE == this.SiteRowID.length) {
          this.finishAliasSave();
        }
      });
    }
  }
  private finishAliasSave(): void {
    document.getElementById("closeEditCmpAlias").click();
    this.CompanyIdnentifiers('', ONE, 'no');
    this.saveDatas = "Save";
  }
  /** Edit Company Alias */
  /** Add/Edit Company Contact */
  addcompanycontact_emailnext() {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(this.CmpConEmail)) { this.CmpConEmailFormatError = true; return; }
    if (this.CmpConEmailexistsError) { return; }
    this.CmpConEmailFormatError = false;
    this.disableEmail = true;
    this.contactService.getPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses?summary=${this.CmpConEmail}`).subscribe((data: any) => {
      if (data['personAddresses'].length <= ZERO) {
        this.applyContactModelState(false, false, true, true, true, true);
        this.getPersonRoleType();
        return;
      }
      this.compModelName = `${data['personAddresses'][ZERO]["personFirstName"]} ${data['personAddresses'][ZERO]["personLastName"]}`;
      this.CmpConFname = data['personAddresses'][ZERO]["personFirstName"];
      this.CmpConLname = data['personAddresses'][ZERO]["personLastName"];
      this.personRowId = data['personAddresses'][ZERO]["personRowId"];
      this.contactService.getUsers(`${this.Config.ApinewContactsUrl}users?personRowId=${data['personAddresses'][ZERO].personRowId}`).subscribe((usrdata: any) => {
        this.applyEmailNextContactModel(usrdata);
      }, _err => {
        this.applyContactModelState(true, false, true, false, false, false);
        this.getPersonRoleType();
      });
    });
  }
  private applyEmailNextContactModel(usrdata: any): void {
    const ipnExists = usrdata.users.length > ZERO;
    if (ipnExists) { this.compModelIpn = usrdata["users"][ZERO].loginId; }
    this.applyContactModelState(true, ipnExists, true, false, false, false);
    this.getPersonRoleType(ipnExists ? "notkamsales" : "");
  }
  private applyContactModelState(labelName: boolean, ipn: boolean, role: boolean, fname: boolean, lname: boolean, phone: boolean): void {
    this.comp_modelLabelName = labelName;
    this.comp_modelIpn = ipn;
    this.comp_modelRole = role;
    this.comp_modelFname = fname;
    this.comp_modelLname = lname;
    this.comp_modelCellphone = phone;
    this.comp_modelPhone = phone;
    this.comp_ShowNext = false;
    this.comp_ShowSave = true;
  }
  AddEditCmpContact(from = '', type, rowIdd = null) {
    this.Editcontact_rowId = "";
    this.saveDatas = 'Save';
    this.personRowId = "";
    this.updPersonId = "";
    this.isReadOnly = false;
    this["CmpConIpn"] = "";
    this["CmpConCellphone"] = "";
    this["CmpConPhone"] = "";
    this.CmpConRoleSelected = "";
    this.Editrow_id_cmpContactcs = "";
    this.disableEmail = false;
    this.cmpConRoleexists = false;
    this.roleLoad = from == 'fromWorkflow' ? true : false
    if (type == "load") {
      this.prepareContactLoad();
      this.resetContactFields();
      this.getPersonRoleType();
    } else if (type == "add") {
      this.resetContactFields();
      this.getPersonRoleType();
    } else if (type == "edit") {
      this.loadContactForEdit(rowIdd);
    } else {
    }
  }
  private resetContactFields(): void {
    for (const element2 of this.CmpConField) {
      this[element2] = "";
      this[`${element2}Error`] = false;
      if (element2 == "CmpConCellphone" || element2 == "CmpConPhone") {
        this[`${element2}Error2`] = false;
      }
    }
  }
  private prepareContactLoad(): void {
    this.comp_ShowNext = true;
    this.comp_ShowSave = false;
    this.CmpConEmailexistsError = false;
    this.comp_modelEmail = true;
    this.comp_modelLabelName = false;
    this.comp_modelIpn = false;
    this.comp_modelFname = false;
    this.comp_modelLname = false;
    this.comp_modelCellphone = false;
    this.comp_modelPhone = false;
    this.comp_modelRole = false;
  }
  private loadContactForEdit(rowIdd): void {
    console.info("Person Details", this.PersonDetails);
    this.disableContactRoleEdit = false;
    this.Editcontact_rowId = rowIdd;
    this.fixedPhoneEdit = false;
    this.cellPhoneEdit = false;
    this.changedRoleId = rowIdd;
    const contact = this.CompanyContacts.find(element => element.rowId == rowIdd);
    if (contact) {
      this.populateContactEditFields(contact);
    }
  }
  private populateContactEditFields(element): void {
    console.info('contact', element);
    this.disableContactRoleEdit = ['KAM', 'SAL', 'ADF', 'SAD'].indexOf(element.roleTypeCode) != NEGATIVE_ONE;
    this.personRowId = element.personRowId;
    this.upd_usersRow_id = "";
    this.Editrow_id_cmpContactcs = element.row_id;
    this["CmpConFname"] = element.personFirstName;
    this["CmpConLname"] = element.personLastName;
    this["CmpConRole"] = element.roleTypeId;
    this.CmpConRoleSelected = element.roleTypeCode;
    this["CmpConIpn"] = "";
    this["CmpConEmail"] = this.PersonDetails[`${element.personRowId}_email`] ? this.PersonDetails[`${element.personRowId}_email`] : '';
    this["CmpConPhone"] = this.PersonDetails[`${element.personRowId}_f`] ? this.PersonDetails[`${element.personRowId}_f`].trim() : '';
    this["CmpConCellphone"] = this.PersonDetails[`${element.personRowId}_p`] ? this.PersonDetails[`${element.personRowId}_p`].trim() : '';
    this.personUserscompcontact(this.personRowId, "No");
  }
  getPersonRoleType(kamFilter = "", page = ONE) {
    if (page == ONE) {
      this.PersonRoleSelectOp = [];
    }
    const role = kamFilter
    this.contactService.getPersonRoleTypes(`${this.Config.ApinewContactsUrl}personRoleTypes?categoryCode=Company%20Contact&_page=${page}`).subscribe((data: any) => {
      this.processPersonRoleTypes(data, kamFilter);
      if (data['maxPage'] > ONE && data['maxPage'] != page) {
        this.getPersonRoleType(role, page + ONE);
      }
    });
    console.info(this.CmpConRole)
  }
  private processPersonRoleTypes(data: any, kamFilter: string): void {
    if (data['personRoleTypes'].length == ZERO) {
      return;
    }
    for (const element of data['personRoleTypes']) {
      if (element.categoryCode.toLowerCase() == "company contact") {
        this.processPersonRoleType(element, kamFilter);
      }
    }
  }
  private processPersonRoleType(element: any, kamFilter: string): void {
    if (!this.showForSupplier) {
      this.cmpConstRole(element);
      return;
    }
    this.processSupplierRoleType(element, kamFilter);
  }
  private processSupplierRoleType(element: any, kamFilter: string): void {
    const roleTypeCode = element.roleTypeCode.toLowerCase();
    if (kamFilter == "KamSales") {
      this.processKamSalesRole(element, roleTypeCode);
      return;
    }
    if (kamFilter == "notkamsales") {
      if (!['kam', 'adf', 'sad'].includes(roleTypeCode)) {
        this.addPersonRoleOption(element);
      }
      return;
    }
    if (this["CmpConIpn"] != "") {
      this.cmpConstRole(element);
      return;
    }
    this.addPersonRoleOption(element);
  }
  private processKamSalesRole(element: any, roleTypeCode: string): void {
    if (roleTypeCode == "kam" || roleTypeCode == "sales contact") {
      this.addPersonRoleOption(element);
    }
  }
  private addPersonRoleOption(element: any): void {
    this.PersonRoleSelectOp.push({ "row_id": element.rowId, "code": element.roleTypeCode, "label": element.roleTypeLabel });
  }
  resetCmpContact(fieEld) {
    if (fieEld === 'Email') {
      if (!this.disableEmail) {
        this[`CmpCon${fieEld}`] = "";
      }
    } else {
      this[`CmpCon${fieEld}`] = "";
      if (fieEld != "Ipn" && fieEld != "Cellphone" && fieEld != "Phone") {
        this[`CmpCon${fieEld}`] = "";
        this[`CmpCon${fieEld}Error2`] = false;
        this[`CmpCon${fieEld}Error`] = true;
        if (fieEld == "Fname" || fieEld == "Lname") {
          this["CmpConIpn"] = "";
          this["CmpConPhone"] = "";
          this["CmpConCellphone"] = "";
        }
      }
      if (fieEld == "Cellphone" || fieEld == "Phone") {
        this[`CmpCon${fieEld}`] = "";
        this[`CmpCon${fieEld}Error2`] = false;
        this[`CmpCon${fieEld}Error`] = true;
      } else {
        this[`CmpCon${fieEld}Error`] = false;
      }
    }
  }
  CmpCntemptyCheck(fieEld) {
    if (fieEld == "Ipn") {
      return;
    }
    this.validateContactField(fieEld);
  }
  private validateContactField(field: string): void {
    const value = this[`CmpCon${field}`];
    const isPhone = field == "Cellphone" || field == "Phone";
    this[`CmpCon${field}Error`] = value.trim() == '';
    if (isPhone && !this[`CmpCon${field}Error`]) {
      this[`CmpCon${field}Error2`] = !value.match(/^[ 0-9\+]*$/gm);
      this[`CmpCon${field}Error`] = !this[`CmpCon${field}Error2`];
    }
  }
  focusOutFunctionEmail() {
    this.CmpConEmailexistsError = false;
  }
  focusOutFunction() {
    this["CmpConIpn"] = "";
    this["CmpConEmail"] = "";
    this["CmpConPhone"] = "";
    this["CmpConCellphone"] = "";
    this.CmpConEmailExists = '';
    this.personRowId = "";
    if (this["CmpConFname"] == undefined || this["CmpConLname"] == undefined || this["CmpConFname"].trim() == "" || this["CmpConLname"].trim() == "") { this.isReadOnly = false; return; }
    this.contactService.getPersons(`${this.Config.ApinewContactsUrl}persons?_page=1&firstName=${this["CmpConFname"].trim()}&lastName=${this["CmpConLname"]}`).subscribe((data: any) => {
      for (const element of data['persons']) {
        if (element.personFirstName.toLowerCase() != this["CmpConFname"].toLowerCase() || element.personLastName.toLowerCase() != this["CmpConLname"].toLowerCase()) { this.isReadOnly = false; } else {
          this.personRowId = element.rowId;
          this.personUsers(element.rowId);
          return false;
        }
      }
    });
  }
  personUsers(RowID, next = "Yes") {
    this.contactService.getUsers(`${this.Config.ApinewContactsUrl}users?personId=${this.personRowId}`).subscribe((data: any) => {
      if (data['users'].length > ZERO && data['users'][ZERO]['loginType'].toLowerCase() == "renault_ipn") {
        this.personRowId = data['users'][ZERO]['personRowId'];
        this["CmpConIpnError"] = false;
        this["CmpConIpn"] = data['users'][ZERO]['loginId'];
        this.upd_usersRow_id = data['users'][ZERO]['rowId'];
      }
      if (next == "Yes") {
        this.personAddresses(RowID);
      } else {
        if (data['users'].length > ZERO && data['users'][ZERO]['loginType'].toLowerCase() == "renault_ipn") {
          this.personRowId = data['users'][ZERO]['personRowId'];
        } else {
          this["CmpConIpn"] = "";
        }
      }
    }, _err => {
      this["CmpConIpn"] = "";
    });
  }
  cmpConstRole(element) {
    const role = this.CmpConRoleSelected.toLowerCase();
    const excludedRoles = {
      kam: ['sal', 'adf', 'sad'], adf: ['kam', 'sal', 'sad'], sal: ['kam', 'adf', 'sad'],
      sad: ['kam', 'adf', 'sal'], default: ['kam', 'sal', 'adf', 'sad']
    }[role] || ['kam', 'sal', 'adf', 'sad'];
    if (!excludedRoles.includes(element.roleTypeCode.toLowerCase()) &&
      !(role == 'kam' && element.roleTypeLabel.toLowerCase() == 'sal')) {
      this.PersonRoleSelectOp.push({ "row_id": element.rowId, "code": element.roleTypeCode, "label": element.roleTypeLabel });
    }
  }
  personUserscompcontact(RowID, next = "Yes") {
    if (this.personRowId == '') { return; }
    this.contactService.getPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses?personRowId=${this.personRowId}`).subscribe((data: any) => {
      if (data['personAddresses'].length <= ZERO) { return; }
      this.contactService.getUsers(`${this.Config.ApinewContactsUrl}users?personRowId=${data['personAddresses'][ZERO].personRowId}`).subscribe((usrdata: any) => {
        this.applyContactUserData(usrdata, RowID, next);
      }, _err => { this["CmpConIpn"] = ""; });
    });
  }
  private applyContactUserData(usrdata: any, RowID: any, next: string): void {
    if (usrdata.users.length == ZERO) { this.endDateisPresent = false; }
    if (usrdata.users.length > ZERO && usrdata['users'][ZERO]['loginType'].toLowerCase() == "renault_ipn") {
      console.info('IPn', usrdata);
      this.compModelIpn = usrdata["users"][ZERO].loginId;
      this["CmpConIpnError"] = false;
      this["CmpConIpn"] = usrdata["users"][ZERO].loginId;
      const user = usrdata["users"][ZERO];
      this.endDateisPresent = !!(user['loginId'] && user.endDate == '');
      this.personRowId = user['personRowId'];
      this.upd_usersRow_id = usrdata['users'][ZERO]['rowId'];
      this.getPersonRoleType();
    }
    if (next == "Yes") {
      this.personAddresses(RowID);
    } else {
      if (usrdata['users'].length > ZERO && usrdata['users'][ZERO]['loginType'].toLowerCase() == "renault_ipn") {
        this.personRowId = usrdata['users'][ZERO]['personRowId'];
      } else {
        this["CmpConIpn"] = "";
        this.getPersonRoleType();
      }
    }
  }
  personAddresses(RowID) {
    this.contactService.getPersonAddresses(`${this.Config.ApinewContactsUrl}persons/${RowID}/personAddresses`).subscribe((data: any) => {
      for (const element of data['personAddresses']) {
        this.applyPersonAddress(element);
      }
    });
  }
  private applyPersonAddress(element: any): void {
    if (element.addressType.toLowerCase() == "email") {
      this["CmpConEmailError"] = false;
      this["CmpConEmail"] = element.addressSummary;
      this.CmpConEmailExists = element.addressSummary;
      this.isReadOnly = element.addressSummary != '';
      return;
    }
    if (element.addressType.toLowerCase() != "telephone") { return; }
    const cpSplit = element.addressSummary.split('*');
    if (cpSplit.length <= ONE) { return; }
    if (cpSplit[ONE].toLowerCase().trim() == "f") { this["CmpConPhoneError"] = false; this["CmpConPhone"] = cpSplit[ZERO].trim(); }
    if (cpSplit[ONE].toLowerCase().trim() == "p") { this["CmpConCellphoneError"] = false; this["CmpConCellphone"] = cpSplit[ZERO].trim(); }
  }
  CmpCntRoleSelected(event: any) {
    this.CmpConRole = event.value;
    this.cmpConRoleexists = false;
    this.cmpRolechanged = false;
    if (this.CmpConRole != undefined && this.CmpConRole != "") {
      for (const element of this.CompanyContacts) {
        if ((this.PersonDetails[`${element.personRowId}_email`] ? this.PersonDetails[`${element.personRowId}_email`] : '') == this.CmpConEmail && element.typeRowId == this.CmpConRole) {
          this.cmpRolechanged = true;
          this.cmpConRoleexists = true;
          this["CmpConRoleError"] = false;
        }
        else {
          this.cmpRolechanged = true;
          this["CmpConRoleError"] = false;
        }
      }
    }
    else {
      this["CmpConRoleError"] = true;
    }
  }
  AddEditSaveCmpCnt(SaveType) {
    if (!this.validateCompanyContactFields(SaveType)) {
      return false;
    }
    if (SaveType == 'add' && !this.cmpConRoleexists) {
      this.addCompanyContact();
    } else if (SaveType == 'edit') {
      this.editCompanyContact();
    } else if (SaveType == 'next') {
      this.addcompanycontact_emailnext();
    } else {
    }
  }

  private validateCompanyContactFields(saveType): boolean {
    for (const field of this.CmpConField) {
      const shouldValidate = (saveType === 'next' && field === 'CmpConEmail') || (saveType === 'add' && field !== 'CmpConEmail');
      if (shouldValidate) {
        if (this[field] == undefined || this[field].trim() == '') {
          this[`${field}Error`] = true;
          return false;
        }
        this[`${field}Error`] = false;
      }
    }
    return true;
  }

  private createContactPerson(): void {
    const personData = {
      personFirstName: this['CmpConFname'],
      personLastName: this['CmpConLname']
    };
    this.contactService.createPersons(`${this.Config.ApinewContactsUrl}persons`, personData).subscribe((data: any) => {
      this.personRowId = data.rowId;
      if (data.rowId != '') {
        this.newPersonId(data.rowId);
      }
    });
  }

  private addCompanyContact(): void {
    if (this.personRowId == '') {
      this.createContactPerson();
      return;
    }
    const roleData = {
      roleTypeId: this['CmpConRole'],
      personRowId: this.personRowId,
      personSupplierCompany: `CtcSupplierCompanyService:${this.companyID}`,
      personRoleStatus: 'VALIDATED',
      startDate: this.commonService.getTodayDate()
    };
    this.contactService.getSupplierCompanyRoles(`${this.Config.ApinewContactsUrl}supplierCompanyRoles?personRowId=${this.personRowId}&roleTypeId=${this['CmpConRole']}&supplierCompanyIdentifier=${this.companyBasicInfo['allianceIdentifier']}`).subscribe((data: any) => {
      this.cmpConRoleexists = data['supplierCompanyRoles'].length > ZERO;
      if (!this.cmpConRoleexists) {
        this.contactService.createSupplierCompanyRoles(`${this.Config.ApinewContactsUrl}supplierCompanyRoles`, roleData).subscribe((_data: any) => {
          this.companyRoles();
          document.getElementById('closeCmpContacts1')?.click();
        });
      }
    });
  }

  private editCompanyContact(): void {
    let proceedToCreate = true;
    for (const contact of this.CompanyContacts) {
      if (contact.typeRowId == this['CmpConRole'] && contact.personRowId == this.personRowId) {
        proceedToCreate = false;
        document.getElementById('closeEditCmpConRole').click();
        document.getElementById('btnForOpenRoleExistsWarning').click();
      }
      document.getElementById('closeContactAndRole').click();
    }
    if (!proceedToCreate) {
      return;
    }
    if (this.personRowId == '') {
      this.newPersonId(this.personRowId, 'updNewIPN');
      return;
    }
    this.updateContactRole();
    const userData = { loginId: this['CmpConIpn'] };
    this.contactService.updateUsers(`${this.Config.ApinewContactsUrl}users/${this.upd_usersRow_id}`, userData).subscribe((_data: any) => {
      this.updateEmail();
    });
  }

  private updateContactRole(): void {
    if (this.cmpRolechanged && this.changedRoleId != '') {
      const typeCode = this.PersonRoleSelectOp.find(role => role.row_id == this['CmpConRole'])?.code || '';
      const roleData = { roleTypeId: this['CmpConRole'], personTypeCode: typeCode };
      this.contactService.updateSupplierCompanyRoles(`${this.Config.ApinewContactsUrl}supplierCompanyRoles/${this.changedRoleId}`, roleData).subscribe(_data => {
        this.companyRoles();
      });
      return;
    }
    const roleData = {
      roleTypeId: this['CmpConRole'],
      personRowId: this.personRowId,
      personSupplierCompany: `CtcSupplierCompanyService:${this.companyID}`,
      personRoleStatus: 'VALIDATED'
    };
    this.contactService.createSupplierCompanyRoles(`${this.Config.ApinewContactsUrl}supplierCompanyRoles`, roleData).subscribe((_data: any) => {
      this.companyRoles();
    }, err => console.info(err));
  }
  updateEmail() {
    const add_ID = this.PersonDetails[`${this.personRowId}_addIDEmail`];
    if (add_ID == undefined) {
      console.info("Email Undefined");
      this.updateFphone();
    } else {
      const datas21 = {
        email: this["CmpConEmail"]
      };
      this.contactService.updateEmailAddresses(`${this.Config.ApinewContactsUrl}emailAddresses/${add_ID}`, datas21).subscribe((_data: any) => {
        this.updateFphone();
      });
    }
  }
  updateFphone() {
    if (this["CmpConPhone"] != undefined && this["CmpConPhone"].trim() != "") {
      const add_IDf = this.PersonDetails[`${this.personRowId}_addIDf`];
      if (add_IDf == undefined) {
        this.newFixedphoneCreate("UpdateFphone");
      } else {
        const datas22 = {
          phoneNumber: this["CmpConPhone"]
        };
        this.contactService.updateTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${add_IDf}`, datas22).subscribe((_data: any) => {
          this.updateCphone();
        });
      }
    } else {
      this.updateCphone();
    }
  }
  updateCphone() {
    if (this["CmpConCellphone"] != undefined && this["CmpConCellphone"].trim() != "") {
      const add_IDc = this.PersonDetails[`${this.personRowId}_addIDp`];
      if (add_IDc == undefined) {
        this.newCellphoneCreate("UpdateCphone");
        document.getElementById("closeEditCmpConRole").click();
      } else {
        const datas23 = {
          phoneNumber: this["CmpConCellphone"]
        };
        this.contactService.updateTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${add_IDc}`, datas23).subscribe((_data: any) => {
          this.PersonAddresses();
          document.getElementById("closeEditCmpConRole").click();
        });
      }
    } else {
      this.PersonAddresses();
      document.getElementById("closeEditCmpConRole").click();
    }
  }
  newPersonId(_personRowID, Next = "Yes") {
    if (this["CmpConIpn"] != undefined && this["CmpConIpn"].trim() != "") {
      const datas11 = {
        loginId: this["CmpConIpn"],
        loginType: "RENAULT_IPN",
        personRowId: this.personRowId
      };
      this.contactService.createUsers(`${this.Config.ApinewContactsUrl}users`, datas11).subscribe((_data: any) => {
        if (Next == "Yes") {
          this.newFixedphoneCreate();
        } else if (Next == "updNewIPN") {
          this.updateEmail();
        } else {
        }
      });
    } else {
      this.newEmailCreate();
    }
  }
  newEmailCreate(Next = "Yes") {
    const datas12 = {
      email: this["CmpConEmail"]
    };
    this.contactService.createEmailAddress(`${this.Config.ApinewContactsUrl}emailAddresses`, datas12).subscribe((data: any) => {
      if (Next == "Yes") {
        this.linkEmailtoAddresses(data.rowId);
      }
    });
  }
  linkEmailtoAddresses(email_rowID) {
    const datas13 = {
      personRowId: this.personRowId,
      addressId: email_rowID
    };
    this.contactService.createPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses`, datas13).subscribe((_data: any) => {
      this.newFixedphoneCreate();
    });
  }
  newFixedphoneCreate(Next = "Yes") {
    if (this["CmpConPhone"] != undefined && this["CmpConPhone"].trim() != "") {
      const datas14 = {
        phoneType: "F",
        phoneNumber: this["CmpConPhone"]
      };
      this.contactService.createTelephoneAddress(`${this.Config.ApinewContactsUrl}telephoneAddresses`, datas14).subscribe((data: any) => {
        if (Next == "Yes") {
          this.linkFixedphonetoAddresses(data.rowId);
        } else if (Next == "UpdateFphone") {
          this.linkFixedphonetoAddresses(data.rowId, "GotoUpdatephone");
        } else {
        }
      });
    } else {
      this.newCellphoneCreate();
    }
  }
  linkFixedphonetoAddresses(Fphone_rowID, Next = "Yes") {
    const datas15 = {
      personRowId: this.personRowId,
      addressId: Fphone_rowID
    };
    this.contactService.createPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses`, datas15).subscribe((data: any) => {
      if (Next == "Yes") {
        this.newCellphoneCreate();
      } else if (Next == "GotoUpdatephone") {
        this.PersonDetails[`${this.personRowId}_addIDf`] = data.addressId;
        this.PersonDetails[`${this.personRowId}_f`] = this["CmpConPhone"];
        this.updateFphone();
      } else {
      }
    });
  }
  newCellphoneCreate(Next = "Yes") {
    if (this["CmpConCellphone"] != undefined && this["CmpConCellphone"].trim() != "") {
      const datas16 = {
        phoneType: "P",
        phoneNumber: this["CmpConCellphone"]
      };
      this.contactService.createTelephoneAddress(`${this.Config.ApinewContactsUrl}telephoneAddresses`, datas16).subscribe((data: any) => {
        if (Next == "Yes") {
          this.linkcellphonetoAddresses(data.rowId);
        } else if (Next == "UpdateCphone") {
          this.linkcellphonetoAddresses(data.rowId, "GotoUpdatephone");
        } else {
        }
      });
    } else {
      this.personToAllLinkAddresses();
    }
  }
  linkcellphonetoAddresses(Cellphone_rowID, Next = "Yes") {
    const datas17 = {
      personRowId: this.personRowId,
      addressId: Cellphone_rowID
    };
    this.contactService.createPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses`, datas17).subscribe((data: any) => {
      if (Next == "Yes") {
        this.personToAllLinkAddresses();
      } else if (Next == "GotoUpdatephone") {
        this.PersonDetails[`${this.personRowId}_addIDp`] = data.addressId;
        this.PersonDetails[`${this.personRowId}_p`] = this["CmpConCellphone"];
        this.updateCphone();
      } else {
      }
    });
  }
  personToAllLinkAddresses() {
    if (this.personRowId != "") {
      const datas18 = {
        roleTypeId: this["CmpConRole"],
        personRowId: this.personRowId,
        personSupplierCompany: `CtcSupplierCompanyService:${this.companyID}`,
        personRoleStatus: "VALIDATED",
        startDate: this.commonService.getTodayDate()
      };
      this.contactService.createSupplierCompanyRoles(`${this.Config.ApinewContactsUrl}supplierCompanyRoles`, datas18).subscribe((_data: any) => {
        this.companyRoles();
        document.getElementById("closeCmpContacts1").click();
      });
    }
  }
  conInfoDel() {
    this.contactService.deletePersons(`${this.Config.ApinewContactsUrl}persons/${this.personRowId}`).subscribe((_data: any) => {
      this.contactService.deleteEmailAddresses(`${this.Config.ApinewContactsUrl}emailAddresses/${this.PersonDetails[this.personRowId + '_addIDEmail']}`).subscribe(_data => { });
      if (this.PersonDetails[`${this.personRowId}_addIDf`] != undefined && this.PersonDetails[`${this.personRowId}_addIDf`] != '') {
        this.contactService.deleteTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${this.PersonDetails[this.personRowId + '_addIDf']}`).subscribe(_data => { });
      }
      if (this.PersonDetails[`${this.personRowId}_addIDp`] != undefined && this.PersonDetails[`${this.personRowId}_addIDp`] != '') {
        this.contactService.deleteTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${this.PersonDetails[this.personRowId + '_addIDp']}`).subscribe(_data => { });
      }
      this.companyRoles();
      document.getElementById("DeleteContact").click();
      document.getElementById("closeEditCmpConRole").click();
      document.getElementById("closeContactDetails").click();
      document.getElementById("closeContactAndRole").click();
    });
  }
  delContact() {
    if (this.personRowId != "") {
      this.contactService.deleteSupplierCompanyRoles(`${this.Config.ApinewContactsUrl}supplierCompanyRoles/${this.Editcontact_rowId}`).subscribe(_data => {
        if (this.upd_usersRow_id != undefined && this.upd_usersRow_id != '') {
          this.contactService.deleteusers(`${this.Config.ApinewContactsUrl}users/${this.upd_usersRow_id}`).subscribe(_data => {
            this.conInfoDel()
          });
        } else {
          this.conInfoDel()
        }
      })
    }
  }
  checkEmailChanged() {
    this.CmpConEmailFormatError = false;
    if (this.CmpConEmailExists != '' && this["CmpConEmail"] == this.CmpConEmailExists) {
      this.isReadOnly = true;
    } else {
      if (this.CmpConEmailExists != '') {
        this["CmpConIpn"] = "";
        this["CmpConPhone"] = "";
        this["CmpConCellphone"] = "";
      }
      this.isReadOnly = false;
    }
  }
  /** Add/Edit Company Contact */
  delRole() {
    if (this.personRowId != "") {
      this.contactService.deleteSupplierCompanyRoles(`${this.Config.ApinewContactsUrl}supplierCompanyRoles/${this.Editcontact_rowId}`).subscribe(_data => { });
      setTimeout(() => {
        this.companyRoles()
      }, TWO_THOUSAND)
      document.getElementById("ccompanyContactRemoveModalPopup").click();
      document.getElementById("EditCmpConRole").click();
      document.getElementById("closeCCBtn").click();
      document.getElementById("closeContactAndRole").click();
    }
  }
  /** Edit Contact Details starts here */
  setEditConDetails(type) {
    this.editCmpConFname = this["CmpConFname"];
    this.editCmpConLname = this["CmpConLname"];
    this.editCmpConCellphone = this["CmpConCellphone"];
    this.editCmpConPhone = this["CmpConPhone"];
    this['CmpConFnameError'] = false;
    this['CmpConLnameError'] = false;
    this['CmpConCellphoneError'] = false;
    this['CmpConCellphoneError2'] = false;
    this['CmpConPhoneError'] = false;
    this['CmpConPhoneError2'] = false;
    if (type == 'cellPhone') {
      this.cellPhoneEdit = true;
    } else {
      this.cellPhoneEdit = false;
    } if (type == 'fixedPhone') {
      this.fixedPhoneEdit = true;
    } else {
      this.fixedPhoneEdit = false;
    }
  }
  editCmpConDetails(type) {
    if (type == 'name') {
      const datas = {
        personFirstName: this.editCmpConFname,
        personLastName: this.editCmpConLname
      };
      this.contactService.updatePersons(`${this.Config.ApinewContactsUrl}persons/${this.personRowId}`, datas).subscribe((data: any) => {
        document.getElementById('closeEditCmpConNameDetails').click();
        this.companyRoles();
        this["CmpConFname"] = data.personFirstName;
        this["CmpConLname"] = data.personLastName;
      });
    } else if (type == 'phone' && !this.CmpConPhoneError2 && !this.CmpConPhoneError
        && !this.CmpConCellphoneError && !this.CmpConCellphoneError2) {
      this.updateFphone();
      this.fixedPhoneEdit = false;
      this.cellPhoneEdit = false;
    } else {
    }
  }
  resetCmpEditContact(field) {
    if (field == 'Fname' || field == 'Lname') {
      this[`editCmpCon${field}`] = '';
      this[`CmpCon${field}Error`] = true;
    } else {
      this[`CmpCon${field}Error`] = false;
    }
  }
  CmpEditCntemptyCheck(fieEld) {
    if (fieEld == 'Fname' || fieEld == 'Lname') {
      if ((this[`editCmpCon${fieEld}`]).trim() == '') {
        this[`CmpCon${fieEld}Error`] = true;
      } else {
        this[`CmpCon${fieEld}Error`] = false;
      }
    }
  }
  toggleCmpConEdit() {
    this["CmpConCellphone"] = this.editCmpConCellphone;
    this["CmpConPhone"] = this.editCmpConPhone;
    this.fixedPhoneEdit = false;
    this.cellPhoneEdit = false;
  }
  /** Edit Contact Details ends here */
  /** Add Paying company by admin start here */
  getGroupApprovalStatus(page = ONE, subscribeData = []) {
    this.supplierService.getApprovalStatus(`${this.Config.ApiSupplierUrl}approval-status?_page=${page}`).subscribe((data: any) => {
      for (let i = ZERO; i < data['approval-status'].length; i++) {
        this.arrApprovalStatus[data['approval-status'][i]['code']] = data['approval-status'][i]['row_id'];
      }
      if (data['maxPage'] > ONE && data['maxPage'] != page) {
        this.getGroupApprovalStatus(page + ONE, subscribeData);
      } else if (data['maxPage'] == page) {
        this.getGroupApprovalScopes();
      } else {
      }
    }, error => {
      console.info('data_error', error.status);
    });
  }
  getGroupApprovalScopes(page = ONE, subscribeData = []) {
    this.arrApprovalScopes = [];
    this.supplierService.getApprovalScopes(`${this.Config.ApiSupplierUrl}approval-scopes?_page=${page}`).subscribe((data: any) => {
      for (let i = ZERO; i < data['approval-scopes'].length; i++) {
        this.arrApprovalScopes[data['approval-scopes'][i]['code']] = data['approval-scopes'][i]['row_id'];
      }
      if (data['maxPage'] > ONE && data['maxPage'] != page) {
        this.getGroupApprovalScopes(page + ONE, subscribeData);
      } else if (data['maxPage'] == page) {
        // page loaded - no additional action needed
      } else {
      }
    }, error => {
      console.info('data_error', error.status);
    });
  }
  trimSpaces(stringsVal: any) {
    let s = stringsVal.replaceAll(/(^\s*)|(\s*$)/gi, "");
    s = s.replaceAll(/[ ]{2,}/gi, " ");
    s = s.replace(/\n /, "\n");
    return s;
  }
  clearFields(resetparam: any) {
    switch (resetparam) {
    case "payingCompanyCodeModelvalLabel": this.payingCompanyCodeModelvalLabel = ''; break;
    case "GrpNameModel": this.userQuestionUpdate2.setValue(''); break;
    case "groupAllianceIdModel": this.delayGrpAllianceId.setValue(''); break;
    case "groupShortNameModel": this.delayGrpShortName.setValue(''); break;
    default: break;
    }
  }
  getPayingCompaniesCode(valueFrmuser = "") {
    this.supplierService.get(`${this.Config.ApiSupplierUrl}paying-company?code=*${valueFrmuser}*&_page=1`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: any) => {
      this.PayCodeListAutoLists = "";
      this.PayCodeListAutoLists = [];
      if (data['paying-company'] && data['paying-company'] != null) {
        for (let i = ZERO; i < data['paying-company'].length; i++) {
          this.payingCompanyCodes[i] = data['paying-company'][i];
          this.payingCompanyCodeids[this.trimSpaces(data['paying-company'][i]['legalName'])] = data['paying-company'][i]['row_id'];
          this.PayCodeListAutoLists.push(this.trimSpaces(data['paying-company'][i]['code']));
        }
      }
    }, error => {
      this.getPayingCompaniesCode();
      console.info('data_error', error);
    });
  }
  getPayingCompanies(valueFrmuser = "") {
    this.supplierService.get(`${this.Config.ApiSupplierUrl}paying-company?legalName=*${valueFrmuser}*&_page=1`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: any) => {
      this.PayListAutoLists = "";
      this.PayListAutoLists = [];
      if (data['paying-company'] && data['paying-company'] != null) {
        for (let i = ZERO; i < data['paying-company'].length; i++) {
          this.payingCompanyCodes[i] = data['paying-company'][i];
          this.payingCompanyCodeids[this.trimSpaces(data['paying-company'][i]['legalName'])] = data['paying-company'][i]['row_id'];
          this.PayListAutoLists.push(this.trimSpaces(data['paying-company'][i]['legalName']));
        }
      }
    }, error => {
      this.getPayingCompanies();
      console.info('data_error', error);
    });
  }
  onPayingCompanycodeSelect(selected) {
    if (selected) {
      this.selectedPayingCmpValue = selected;
      this.payingCompanyCodeModelvalerror = false;
      const selarr = this.selectedPayingCmpValue.split('-');
      const comp_Id = this.payingCompanyCodes.find(x => x.code == selected.originalObject)
      this.selectedPayingCmpValue = comp_Id.legalName;
      this.senReqPayCompMOdel = comp_Id.legalName;
      this.pComp_Name = `${comp_Id.code}-${comp_Id.legalName}`
    } else {
      this.selectedPayingCmpValue = "failed";
      this.payingCompanyCodeModelvalerror = true;
    }
  }
  getKamsaleroleuser(page = ONE, pushedData = [], checkexist = [], userIds = [], accumulatedRoles = []) {
    this.PersonRoleSelectOp = page == ONE ? [] : this.PersonRoleSelectOp;
    this.contactService.getSupplierCompanyRoles(`${this.Config.ApinewContactsUrl}supplierCompanyRoles?personSupplierCompany=CtcSupplierCompanyService:${this.companyID}&personRoleStatus=VALIDATED&_page=${page}`).subscribe((data: any) => {
      const currentRoles = data['supplierCompanyRoles'];
      this.processKamSaleRoles(currentRoles, pushedData, checkexist, userIds);
      accumulatedRoles.push(...this.filterKamSaleRoles(currentRoles));
      if (data['maxPage'] > ONE && data['maxPage'] != page) {
        this.getKamsaleroleuser(page + ONE, pushedData, checkexist, userIds, accumulatedRoles);
      } else {
        this.allKamSaleRoles = accumulatedRoles;
        this.PersonDetailsCompSent2Req = accumulatedRoles;
      }
      if (pushedData.length > ZERO) {
        this.PersonRoleSelectOp = pushedData;
      }
      this.getUserIds(userIds);
    });
  }
  private processKamSaleRoles(roles: any[], pushedData: any[], checkexist: any[], userIds: any[]): void {
    this.PersonDetailsCompSent2Req.push(this.filterKamSaleRoles(roles));
    for (const element of roles) {
      if (userIds.indexOf(element.personRowId) == NEGATIVE_ONE && element.personRowId != '') {
        userIds.push(element.personRowId);
      }
      this.addKamSaleRole(element, pushedData, checkexist);
    }
  }
  private addKamSaleRole(element: any, pushedData: any[], checkexist: any[]): void {
    const personRowidexist = checkexist.indexOf(element.personRowId);
    const isKamOrSale = element.roleTypeCode.toLowerCase() == 'kam' || element.roleTypeCode.toLowerCase() == 'sal';
    if (personRowidexist == NEGATIVE_ONE && isKamOrSale) {
      checkexist.push(element.personRowId);
      pushedData.push(`${element.personFirstName} ${element.personLastName}`);
    }
  }
  private filterKamSaleRoles(roles: any[]): any[] {
    return roles.filter(role => role.roleTypeCode.toLowerCase().includes('kam') || role.roleTypeCode.toLowerCase().includes('sal'));
  }
  getUserIds(personIds) {
    console.info('in gets', personIds);
    if (personIds.length > ZERO) {
      this.contactService.getUsers(`${this.Config.ApinewContactsUrl}users?personRowId=in(${personIds})`).subscribe(data => {
        this.personuserId = data['users'];
        // Re-apply filter now that personuserId is populated (in case it was empty when request type was selected)
        const filterableTypes = ['add paying company', 'site update', 'Add site', 'Update bank details'];
        if (filterableTypes.includes(this.selectedSendRequest)) {
          this.PersonDetailsCompSent2Req = this.filterRequestPersons();
        }
        if (data['users'].length > ZERO) {
          for (const e of data['users']) {
            this.ipnOnPersonIds[e.personRowId] = e;
            console.info('user', this.ipnOnPersonIds)
          }
        }
      });
    }
  }
  onPayingCompanySelect(selected) {
    if (selected) {
      this.selectedPayingCmpValue = selected;
      this.payingCompanyCodeModelvalerror = false;
      const selarr = this.selectedPayingCmpValue.split('-');
      const comp_get = this.payingCompanyCodes.find(x => x.legalName == selected)
      this.selectedPayingCmpValue = comp_get.legalName;
      this.senReqPayCompcodeMOdel = comp_get.code;
      this.pComp_Name = `${comp_get.code}-${comp_get.legalName}`
    } else {
      this.selectedPayingCmpValue = "failed";
      this.payingCompanyCodeModelvalerror = true;
    }
  }
  onGrpSelect(selected) {
    if (selected) {
      this.GrpNameError = false;
      this.delayGrpAllianceId.setValue(this.GroupAllToName[selected]);
      this.getShortNameFromGrp(this.GroupAllToName[selected]);
      this.groupNameDrop = true
    } else {
      this.GrpNameError = true;
    }
  }
  onIdentivalueSelectUpdateAlliance(selected) {
    if (
      selected != undefined &&
      selected != null &&
      selected != undefined
    ) {
      this.userQuestionUpdate2.setValue(this.GroupAllToName[selected]);
      this.getShortNameFromGrp(selected);
      this.GrpNameError = false;
      this.groupIdDrop = true;
    }
  }
  onIdentivalueSelect(selected) {
    if (
      selected != undefined &&
      selected != null &&
      selected != undefined
    ) {
      this.groupAllianceIdModel = this.GroupAllToName[selected];
      this.delayGrpAllianceId.setValue(this.GroupAllToName[selected])
      this.userQuestionUpdate2.setValue(this.GroupShrtToName[selected])
      this.GrpNameModel = this.GroupShrtToName[selected];
      this.GrpNameError = false;
      this.groupShortNameDrop = true;
    }
  }
  getShortNameFromGrp(valFrmUsr) {
    this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?groupAllianceIdentifier=${valFrmUsr}&groupIdentifierKeyName=MDM GROUP&_page=1&_pagesize=10`).subscribe(data => {
      if (data['group-identifiers'].length > ZERO) {
        this.groupShortNameModel = data['group-identifiers'][ZERO].value;
        this.delayGrpShortName.setValue(data['group-identifiers'][ZERO].value)
        this.autoShortname = false;
      }
    });
  }
  updatePayingCompanyToGroup() {
    const updates = this.buildAssignedPayingCompanyUpdates();
    const newPayingCompaniesToAdd = this.getNewPayingCompaniesToAdd();

    if (updates.length == ZERO && newPayingCompaniesToAdd.length == ZERO) {
      this.getPayingDetails('No');
      document.getElementById('closePCBtn')?.click();
      this.saveDatas = 'Save';
      this.payingCompanyCodeModelvalerror = false;
      return;
    }

    this.saveDatas = 'Save...';
    this.payingCompanyCodeModelvalerror = false;

    if (newPayingCompaniesToAdd.length == ZERO) {
      forkJoin(updates).subscribe(() => {
        this.handlePayingCompanySaveSuccess();
      }, () => {
        this.saveDatas = 'Save';
      });
      return;
    }

    this.supplierService.getApprovalScopes(`${this.Config.ApiSupplierUrl}approval-scopes`).subscribe((scopeData: any) => {
      const inPanelScope = scopeData['approval-scopes']
        ? scopeData['approval-scopes'].find((scope: any) => (scope.code || '').toLowerCase() == 'in panel')
        : null;
      const inPanelScopeId = inPanelScope?.row_id ?? '';

      if (!inPanelScopeId) {
        this.saveDatas = 'Save';
        return;
      }

      const createOps = this.buildNewPayingCompanyCreateOperations(inPanelScopeId, newPayingCompaniesToAdd);
      const allOperations = [...updates, ...createOps];

      if (allOperations.length == ZERO) {
        this.handlePayingCompanySaveSuccess();
        return;
      }

      forkJoin(allOperations).subscribe(() => {
        this.handlePayingCompanySaveSuccess();
      }, () => {
        this.saveDatas = 'Save';
      });
    }, () => {
      this.saveDatas = 'Save';
    });
  }

  private handlePayingCompanySaveSuccess() {
    this.getPayingDetails('No');
    document.getElementById('closePCBtn')?.click();
    this.saveDatas = 'Save';
  }

  private getNewPayingCompaniesToAdd(): any[] {
    if (!this.selectedPayingCompanies || !Array.isArray(this.selectedPayingCompanies)) {
      return [];
    }

    const assignedCodes = new Set(
      (this.PayingInfo || [])
        .filter((assigned: any) => assigned && assigned.clientCompanyCode)
        .map((assigned: any) => assigned.clientCompanyCode)
    );

    return this.selectedPayingCompanies.filter((company: any) => company && company.code && !assignedCodes.has(company.code));
  }

  private buildNewPayingCompanyCreateOperations(scopeId: string, companiesToAdd: any[]): Observable<unknown>[] {
    const createOps: Observable<unknown>[] = [];

    for (const company of companiesToAdd) {
      const clientCompanyId = this.payingCompanyCodeids1[this.trimSpaces(company.code)];
      if (clientCompanyId) {
        const payload = {
          scopeId,
          clientCompanyId,
          companiesId: this.companyID,
          approvalModificationStatus: 'VALIDATED',
          statusId: this.arrApprovalStatus['Approved'],
          type: 'COMPANY',
          validityStartDate: this.commonService.getTodayDate(),
          validityEndDate: ''
        };
        createOps.push(this.supplierService.createCompanyApprovals(`${this.Config.ApiSupplierUrl}company-approvals`, payload));
      }
    }

    return createOps;
  }

  private buildAssignedPayingCompanyUpdates(): Observable<unknown>[] {
    if (!this.PayingInfo || !Array.isArray(this.PayingInfo)) {
      return [];
    }

    const updates: Observable<unknown>[] = [];

    for (const assigned of this.PayingInfo) {
      if (assigned?.row_id) {
        const payload = this.getAssignedPayingCompanyStatusPayload(assigned);
        if (payload) {
          updates.push(
            this.supplierService.updateCompanyApprovals(
              `${this.Config.ApiSupplierUrl}company-approvals/${assigned.row_id}`,
              payload
            )
          );
        }
      }
    }

    return updates;
  }

  private getAssignedPayingCompanyStatusPayload(assigned: any): any {
    const status = assigned?.approvalModificationStatus ? assigned.approvalModificationStatus.toLowerCase() : '';
    const isChecked = this.isAssignedChecked(assigned);
    const key = this.getAssignedPayingKey(assigned);
    const switchedToPending = Boolean(key && this.assignedPayingPendingSwitches[key]);

    if (isChecked && status == 'archived') { return this.getValidatedPayingCompanyPayload(); }
    if (isChecked && switchedToPending) { return this.getPendingPayingCompanyPayload(); }
    if (!isChecked && this.isActivePayingCompanyStatus(status)) { return this.getArchivedPayingCompanyPayload(); }
    return null;
  }
  private getValidatedPayingCompanyPayload(): any {
    return { approvalModificationStatus: 'VALIDATED', statusId: this.arrApprovalStatus['Approved'], validityStartDate: this.commonService.getTodayDate(), validityEndDate: '' };
  }
  private getPendingPayingCompanyPayload(): any {
    return { approvalModificationStatus: 'PENDING_VALIDATION', statusId: this.arrApprovalStatus['To be validated'] };
  }
  private isActivePayingCompanyStatus(status: string): boolean {
    return ['active', 'validated', 'pending', 'pending_validation'].includes(status);
  }
  private getArchivedPayingCompanyPayload(): any {
    return { approvalModificationStatus: 'ARCHIVED', statusId: this.arrApprovalStatus['Archived'], validityEndDate: this.commonService.getTodayDate() };
  }
  updatePCExistsName() {
    this.saveDatas = 'Save';
    this.payingCompanyCodeModelval = '';
    this.payingCompanyCodeModelvalLabel = ''
    this.payingCompanyCodeModelvalerror = false;
    this.pComp_Name = '';
    this.selectedPayingCpyVals = [];
    this.selectedPayingCompanies = [];
    this.selectedPayingCpyVal = '';
    this.senReqPayCompMOdel = '';
    this.senReqPayCompcodeMOdel = '';
  }

  clearPayingCompanyPopupSelections() {
    this.selectedPayingCpyVals = [];
    this.selectedPayingCompanies = [];
    this.selectedPayingCpyVal = '';
    this.pComp_Name = '';
    this.selectedPayingCmpValue = 'failed';
    this.payingCompanyCodeModelvalerror = false;
    this.resetAssignedPayingSelections();
  }

  openPayingCompanyPopup() {
    this.updatePCExistsName();
    this.selectedPayingGrouping = '';
    this.resetAssignedPayingSelections();
    this.loadPayingDatabase();
    this.getPayingDetails('No');
  }

  resetAssignedPayingSelections() {
    this.assignedPayingSelections = {};
    this.assignedPayingPendingSwitches = {};
  }

  getAssignedPayingKey(assigned: any): string {
    return assigned?.row_id || assigned?.clientCompanyCode || '';
  }

  isAssignedArchived(assigned: any): boolean {
    return (assigned?.approvalModificationStatus ? assigned.approvalModificationStatus.toLowerCase() : '') == 'archived';
  }

  isAssignedActive(assigned: any): boolean {
    const status = assigned?.approvalModificationStatus ? assigned.approvalModificationStatus.toLowerCase() : '';
    return status == 'active' || status == 'validated';
  }

  isAssignedPending(assigned: any): boolean {
    const status = assigned?.approvalModificationStatus ? assigned.approvalModificationStatus.toLowerCase() : '';
    return status == 'pending' || status == 'pending_validation';
  }

  canSwitchAssignedToPending(assigned: any): boolean {
    return this.isAssignedChecked(assigned) && this.isAssignedActive(assigned) && !!assigned?.row_id;
  }

  canSwitchAssignedToActive(assigned: any): boolean {
    return this.isAssignedChecked(assigned) && this.isAssignedPending(assigned) && !!assigned?.row_id;
  }

  switchAssignedToPending(assigned: any) {
    if (!this.canSwitchAssignedToPending(assigned)) {
      return;
    }

    const rowId = assigned.row_id;
    const key = this.getAssignedPayingKey(assigned);
    if (key) {
      this.assignedPayingSelections[key] = true;
    }

    const payload = {
      approvalModificationStatus: 'PENDING_VALIDATION',
      statusId: this.arrApprovalStatus['To be validated']
    };

    this.supplierService.updateCompanyApprovals(`${this.Config.ApiSupplierUrl}company-approvals/${rowId}`, payload)
      .subscribe(() => {
        assigned.approvalModificationStatus = 'PENDING_VALIDATION';
        if (key) {
          delete this.assignedPayingPendingSwitches[key];
        }
      });
  }

  switchAssignedToActive(assigned: any) {
    if (!this.canSwitchAssignedToActive(assigned)) {
      return;
    }

    const rowId = assigned.row_id;
    const payload = {
      approvalModificationStatus: 'VALIDATED',
      statusId: this.arrApprovalStatus['Approved'],
      validityStartDate: this.commonService.getTodayDate(),
      validityEndDate: ''
    };

    this.supplierService.updateCompanyApprovals(`${this.Config.ApiSupplierUrl}company-approvals/${rowId}`, payload)
      .subscribe(() => {
        assigned.approvalModificationStatus = 'VALIDATED';
      });
  }

  isAssignedChecked(assigned: any): boolean {
    const key = this.getAssignedPayingKey(assigned);
    if (!key) {
      return !this.isAssignedArchived(assigned);
    }
    if (this.assignedPayingSelections[key] !== undefined) {
      return this.assignedPayingSelections[key];
    }
    return !this.isAssignedArchived(assigned);
  }

  onAssignedCheckedChange(assigned: any, checked: boolean) {
    const key = this.getAssignedPayingKey(assigned);
    if (!key) {
      return;
    }
    this.assignedPayingSelections[key] = checked;
    if (!checked) {
      delete this.assignedPayingPendingSwitches[key];
    }
  }

  getSelectableAssignedCount(): number {
    if (!this.PayingInfo || !Array.isArray(this.PayingInfo)) {
      return ZERO;
    }
    return this.PayingInfo.length;
  }

  isAllAssignedSelected(): boolean {
    const selectable = this.getSelectableAssignedCount();
    if (selectable == ZERO) {
      return false;
    }
    const selectedCount = this.PayingInfo
      .filter((assigned: any) => {
        return this.isAssignedChecked(assigned);
      }).length;
    return selectedCount == selectable;
  }

  isAssignedPartiallySelected(): boolean {
    const selectable = this.getSelectableAssignedCount();
    if (selectable == ZERO) {
      return false;
    }
    const checkedCount = this.PayingInfo
      .filter((assigned: any) => {
        return this.isAssignedChecked(assigned);
      }).length;
    return checkedCount > ZERO && checkedCount < selectable;
  }

  toggleAllAssigned(checked: boolean) {
    if (!this.PayingInfo || !Array.isArray(this.PayingInfo)) {
      return;
    }
    for (const assigned of this.PayingInfo) {
      const key = this.getAssignedPayingKey(assigned);
      if (key) {
        this.assignedPayingSelections[key] = checked;
        if (!checked) {
          delete this.assignedPayingPendingSwitches[key];
        }
      }
    }
  }
  /** Add Paying company by admin start here */
  /** Edit Tax Identifier start here */
  EditTI(TIType, TIVal, TIKey, TiArc) {
    this.saveDatas = 'Save';
    this.EditTIValueError = false;
    this.disableEditTaxIdens = false;
    this.EditTIObj = "";
    this.EditTIObj = { TIType, TIKey, TIVal }
    this.EditTIModel = TIVal;
    this.saveDatas = "Save";
    this.valTiArc = TiArc
    if (TIType.toLowerCase() == 'european vat number') {
      document.getElementById('inputTaxIden').setAttribute('maxLength', '20');
    } else {
      document.getElementById('inputTaxIden').removeAttribute('maxLength');
    }
  }
  EditTIEmptyCheck() {
    if ((this.EditTIModel).trim() == '') {
      this.EditTIValueError = true;
    } else {
      this.EditTIValueError = false;
    }
  }
  resetEditTIValue() {
    this.EditTIModel = "";
    this.EditTIValueError = true;
  }
  EditSaveTI() {
    if (this.EditTIModel != undefined && this.EditTIModel.trim() != "") {
      this.saveDatas = "Saving...";
      this.disableEditTaxIdens = true;
      const datas9 = {
        value: this.EditTIModel
      };
      this.supplierService.updateCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers/${this.EditTIObj.TIKey}`, datas9).subscribe((_data: any) => {
        this.CompanyIdnentifiers('', ONE, 'no');
        this.saveDatas = "Save";
        document.getElementById("closeEditTI").click();
      });
    } else {
      this.EditTIValueError = true;
    }
  }
  /** Edit Tax Identifier End here */
  /** Remove Role for this group start here */
  removeCompanyContactExists(rowId: any) {
    this.removeDatas = 'Remove';
    this.remvoeContactModelval = rowId;
  }
  ArchiveCompanyContactDetails(rowid) {
    const datas = { endDate: this.commonService.getTodayDate(), personRoleStatus: "ARCHIVED" };
    this.contactService.updateSupplierCompanyRoles(`${this.Config.ApinewContactsUrl}supplierCompanyRoles/${rowid}`, datas).subscribe((_data: any) => {
    });
  }
  removeCompanyContactDetails() {
    if (this.remvoeContactModelval != '' && this.remvoeContactModelval != undefined) {
      this.removeDatas = "Remove...";
      const datas = { endDate: this.commonService.getTodayDate(), status: "ARCHIVED" };
      this.contactService.deleteSupplierCompanyRoles(`${this.Config.ApinewContactsUrl}supplierCompanyRoles/${this.remvoeContactModelval}`).subscribe((_data: any) => {
        this.CompanyContacts = [];
        this.companyRoles();
        document.getElementById("closeCCBtn").click();
        this.removeDatas = "Remove";
      });
    }
  }
  /** Remove Role for this Group end here */
  ngOnDestroy() {
    this.ngUnsubscribe.next(undefined);
    this.ngUnsubscribe.complete();
  }
  getCompanyIdentifiersForArchive() {
    const tempSiteRowId = [];
    for (const e of this.SiteRowID) { tempSiteRowId.push(e) }
    let proceedToArchive = true;
    let idenVal = '';
    if (this.EditAliasObj.AliasType == 'ALCOR') {
      if (this.EditAliasObj.AliasVal.length == SIX) {
        idenVal = this.EditAliasObj.AliasVal;
      } else if (this.EditAliasObj.AliasVal.length < SIX) {
        idenVal = `0${this.EditAliasObj.AliasVal}`;
      } else {
      }
      this.siteService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierValue=${idenVal}*&identifierTypeName=RAFT_CODE`).subscribe(data01 => {
        if (data01['access-point-identifiers'].length <= ZERO) { this.proxyForgetCompanyIdentifiersForArchive(tempSiteRowId); return; }
        for (const elementNew of data01['access-point-identifiers']) {
          if (elementNew.endDate == '') { proceedToArchive = false; }
        }
        if (proceedToArchive) { this.proxyForgetCompanyIdentifiersForArchive(tempSiteRowId); }
        else { document.getElementById("closeConfirmArchive").click(); document.getElementById('btnForWarningNoArchiveAlcor').click(); }
      });
    } else {
      this.proxyForgetCompanyIdentifiersForArchive(tempSiteRowId);
    }
  }
  proxyForgetCompanyIdentifiersForArchive(tempSiteRowId) {
    const datas5 = { "endDate": this.commonService.getTodayDate() };
    this.supplierService.updateCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers/${this.EditAliasObj.AliasKey}`, datas5).subscribe(data => {
      if (this.EditAliasObj.AliasType == 'ALCOR') {
        this.siteService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?businessIdentifierValue=${data['value']}&_page=1`).subscribe(data1 => {
          this.applyRaftAccountArchiveUpdate(data1, tempSiteRowId, data['value']);
        });
      }
      document.getElementById("closeConfirmArchive").click();
      document.getElementById("closeArchiveAlias").click();
      this.CompanyIdnentifiers('', ONE, 'no');
    });
  }
  private applyRaftAccountArchiveUpdate(data1: any, tempSiteRowId: any[], value: string): void {
    if (data1['pageCount'] == ZERO) { this.createRaftAccAndArchive(tempSiteRowId, value); return; }
    const constEndDate = { "endDate": this.commonService.getTodayDate() };
    for (let i = ZERO; i < data1['pageCount']; i++) {
      const item = data1['real-estate-asset-identifiers'][i];
      if (item['identifierType'] === 'RAFT_ACCOUNT' && this.SiteRowID.indexOf(item['realEstateAssetId']) !== NEGATIVE_ONE) {
        tempSiteRowId.splice(this.SiteRowID.indexOf(item['realEstateAssetId']), ONE);
        this.siteService.updateRealEstateAssetIdentifier(this.Config.ApiSitesUrl + REAL_ESTATE_ASSET_IDENTIFIERS_PATH + item['rowId'], constEndDate).subscribe(_data2 => { });
      }
    }
    if (tempSiteRowId.length != ZERO) { this.createRaftAccAndArchive(tempSiteRowId, value); }
  }
  getCompanyIdentifiersForUnArchive() {
    const tempSiteRowId = [];
    for (const e of this.SiteRowID) { tempSiteRowId.push(e) }
    if (this.EditAliasObj.AliasType == 'ALCOR') {
      this.proxyForgetCompanyIdentifiersForunArchive(tempSiteRowId);
    } else {
      this.proxyForgetCompanyIdentifiersForunArchive(tempSiteRowId);
    }
  }
  proxyForgetCompanyIdentifiersForunArchive(tempSiteRowId) {
    const datas5 = { "endDate": '' };
    this.supplierService.updateCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers/${this.EditAliasObj.AliasKey}`, datas5).subscribe(data => {
      if (this.EditAliasObj.AliasType == 'ALCOR') {
        this.siteService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?businessIdentifierValue=${data['value']}&_page=1`).subscribe(data1 => {
          this.applyRaftAccountUnarchiveUpdate(data1, tempSiteRowId);
        });
      }
      document.getElementById("closeConfirmArchive").click();
      document.getElementById("closeArchiveAlias").click();
      this.CompanyIdnentifiers('', ONE, 'no');
    });
  }
  private applyRaftAccountUnarchiveUpdate(data1: any, tempSiteRowId: any[]): void {
    if (data1['pageCount'] == ZERO) { return; }
    const constEndDate = { "endDate": '' };
    for (let i = ZERO; i < data1['pageCount']; i++) {
      const item = data1['real-estate-asset-identifiers'][i];
      if (item['identifierType'] === 'RAFT_ACCOUNT' && this.SiteRowID.indexOf(item['realEstateAssetId']) !== NEGATIVE_ONE) {
        tempSiteRowId.splice(this.SiteRowID.indexOf(item['realEstateAssetId']), ONE);
        this.siteService.updateRealEstateAssetIdentifier(this.Config.ApiSitesUrl + REAL_ESTATE_ASSET_IDENTIFIERS_PATH + item['rowId'], constEndDate).subscribe(_data2 => { });
      }
    }
  }
  createRaftAccAndArchive(arr, value) {
    for (const ele of arr) {
      const const1 = {
        "sourceSystemId": "2",
        "businessIdentifierId": this.siteIdenTypeDetails['RAFT_ACCOUNT'],
        "effectiveDate": this.commonService.getTodayDate(),
        "businessIdentifierValue": value,
        "realEstateAssetId": ele,
        "endDate": this.commonService.getTodayDate()
      }
      this.siteService.createRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers`, const1).subscribe(_data1 => {
      });
    }
  }
  showGroupingState(page = ONE, forCtrl = "start") {
    this.rows;
    this.groupingData = []
    this.groupingStateLoading = true;
    this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?_page=${page}&companyId=${this.companyID}`).subscribe(data1 => {
      if (forCtrl == "start") {
        this.dataForGroupingState = [];
      }
      for (const element of data1['group-assignments']) {
        this.groupingData.push(element);
      }
      if (data1['maxPage'] > ONE && forCtrl != "stop") {
        for (let x = TWO; x <= data1['maxPage']; x++) {
          this.showGroupingState(x, 'stop');
        }
      }
      if (data1['maxPage'] == page) {
        this.groupingStateLoading = false;
      }
      this.groupPager = this.pagerService.getPager(this.groupingData.length, page, TEN);
      this.dataForGroupingState = this.groupingData.slice(this.groupPager.startIndex, this.groupPager.endIndex + ONE)
      this.rows = this.groupingData.length > TEN ? false : true
    }, _error => {
      this.groupingStateLoading = false;
    });
  }
  groupingTable(page) {
    this.groupPager = this.pagerService.getPager(this.groupingData.length, page, TEN);
    this.dataForGroupingState = this.groupingData.slice(this.groupPager.startIndex, this.groupPager.endIndex + ONE)
  }
  blankStatusUpdate() {
    document.getElementById("btnForblankupdate").click();
    document.getElementById("closeblankStatusUpdate").click();
    const companyStatus = this.companyBasicInfo?.companyStatusCode?.toLowerCase();
    this.blankUpdate.CompanyBlankStatusUpdate(this.companyID);
  }
  /* Start --> US-420 [Company Details] Display Sites */
  getSiteDetails(page, curr_page = ONE, subscribeData = []) {
    this.Site_hrefTo_Cid = [];
    const bvdf = '';
    this.SitesFlag = false;
    this.SiteDispLoading = true;
    this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?businessEntityCompanyId=${this.companyID}&_page=${curr_page}`).subscribe((data: any) => {
      this.handleSiteDetailsResponse(data, page, curr_page, subscribeData);
    }, error => {
      this.companyExist = false;
      console.info('data_error', error.status);
    });
  }
  private handleSiteDetailsResponse(data: any, page: number, currPage: number, subscribeData: any[]): void {
    this.siteGroupsecMaxpage = data['maxPage'];
    if (data['site-assignments'].length > ZERO) {
      this.appendSiteAssignments(data['site-assignments'], subscribeData);
      if (data['maxPage'] > ONE && data['maxPage'] != currPage) {
        this.getSiteDetails(page, currPage + ONE, subscribeData);
      } else if (data['maxPage'] == currPage) {
        this.finalizeSiteAssignments(subscribeData);
      } else {
      }
    }
    if (data['maxPage'] == currPage) {
      this.finishSiteDetails(page);
    }
  }
  private appendSiteAssignments(assignments: any[], subscribeData: any[]): void {
    for (const element of assignments) {
      if (element['status'] != 'ARCHIVED') {
        subscribeData.push(element);
      }
      this.markSiteAssignmentsForFiltering(subscribeData);
    }
  }
  private markSiteAssignmentsForFiltering(assignments: any[]): void {
    for (const assignment of assignments) {
      assignment['filterTrue'] = true;
    }
  }
  private finalizeSiteAssignments(assignments: any[]): void {
    for (const element of assignments) {
      this.prepareSiteAssignment(element);
      this.removeExistingSiteAssignment(element);
      this.addSiteAssignmentToDisplay(element);
    }
  }
  private prepareSiteAssignment(element: any): void {
    if (!element.site.href) {
      return;
    }
    const siteRowId = element.site.href.split("/");
    if (this.SiteRowID.indexOf(siteRowId[ONE]) == NEGATIVE_ONE) {
      this.SiteRowID.push(siteRowId[ONE]);
    }
    this.Site_hrefTo_Cid[element.businessEntityId] = siteRowId[ONE];
    if (this.beRowID.indexOf(element.businessEntityId) == NEGATIVE_ONE) {
      this.beRowID.push(element.businessEntityId);
    }
    element['showRow'] = element.status != 'ARCHIVED';
    element['toggleRow'] = false;
  }
  private removeExistingSiteAssignment(element: any): void {
    for (const [index, existing] of this.SitesInfo.entries()) {
      if (existing.businessEntityId == element.businessEntityId) {
        this.SitesInfo.splice(index, ONE);
      }
    }
  }
  private addSiteAssignmentToDisplay(element: any): void {
    if (element.businessEntityId == this.siteBusinessEntityHQ) {
      element['showAsHQ'] = true;
      this.businessIdForBvd = element.businessEntityId;
      this.Alcordata = element.reaIdentifier;
      this.businessentity = element.businessEntityId;
      console.info('hq ele', element);
      this.SitesInfo.unshift(element);
      return;
    }
    element['showAsHQ'] = false;
    this.SitesInfo.push(element);
  }
  private finishSiteDetails(page: number): void {
    this.pager = this.pagerService.getPager(this.SitesInfo.length, page, FIFTY);
    if (this.beRowID.length > ZERO) {
      this.JoinBusniessEntity();
    } else {
      this.joincityCountry();
    }
    this.SitesFlag = true;
  }
  JoinBusniessEntity(page = ONE, subscribeData = []) {
    this.siteBusinessEntityExist = true;
    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&businessEntityId=in(${this.beRowID})&_page=${page}`).subscribe(
      (data: any) => {
        if (data['business-entity-identifiers'].length > ZERO) {
          this.processBusinessEntityIdentifiers(data['business-entity-identifiers']);
          if (data['maxPage'] > ONE && data['maxPage'] != page) {
            this.JoinBusniessEntity(page + ONE, subscribeData);
          }
        }
        if (data['maxPage'] == page) {
          this.joincityCountry();
        }
      });
  }
  private processBusinessEntityIdentifiers(identifiers: any[]): void {
    for (const identifier of identifiers) {
      const isBvdId = identifier.businessEntityIdentifierTypeName.toLowerCase() == "bvd id";
      if (isBvdId && identifier.endDate == '') {
        this.processActiveBusinessEntityIdentifier(identifier);
      } else if (isBvdId) {
        this.processArchivedBusinessEntityIdentifier(identifier);
      } else {
      }
    }
  }
  private processActiveBusinessEntityIdentifier(identifier: any): void {
    if (this.siteBusinessEntityHQ == identifier.businessEntityId) {
      this.showAddSiteBtn = true;
      this.hQBvdIdHolder = identifier.value;
    }
    this.SiteDe_BvdID_Stat[identifier.businessEntityId] = identifier;
    this.SiteDe_BvdID_Stat[identifier.businessEntityId]['exist'] = true;
  }
  private processArchivedBusinessEntityIdentifier(identifier: any): void {
    if (this.SiteDe_BvdID_Stat[identifier.businessEntityId] == undefined) {
      this.SiteDe_BvdID_Stat[identifier.businessEntityId] = [];
    }
    this.SiteDe_BvdID_Stat[identifier.businessEntityId]['exist'] = false;
  }
  joincityCountry(page = ONE, loop = 'start') {
    if (this.SiteRowID.length <= ZERO) { this.SiteDispLoading = false; return; }
    if (loop == 'start') { this.Site_City_Country = []; this.siteIdentifierForRaft = []; }
    this.siteService.getSites(`${this.Config.ApiSitesUrl}sites?rowId=in(${this.SiteRowID})&_page=${page}`).subscribe((data: any) => {
      if (data['sites'].length <= ZERO) { this.SiteDispLoading = false; this.sitesData = false; return; }
      this.processSiteLocationData(data['sites']);
      if (data['maxPage'] > ONE && data['maxPage'] != page) { this.joincityCountry(page + ONE, 'continue'); }
      else if (data['maxPage'] == page) { this.completeSiteLocationLoad(); }
    });
  }
  private processSiteLocationData(sites: any[]): void {
    for (const site of sites) {
      this.Site_City_Country[site.rowId] = site;
      this.siteIdentifierForRaft.push(`'${site.identifier}'`);
      this.siteRowIdFilter.push(site.rowId);
      site['filterTrue'] = true;
      if (this.siteStatus[site.rowId] == undefined) {
        this.siteStatus[site.rowId] = [];
      }
      if (this.siteStatus[site.rowId]) {
        this.siteStatus[site.rowId] = [site.activeStatus]
      }
    }
  }
  private completeSiteLocationLoad(): void {
    console.info('sites data>>', this.Site_City_Country);
    for (const element of Object.values(this.Site_City_Country)) {
      if (element?.['identifier'] == this.Alcordata) {
        this.AlcordataDetails = element
        console.info('this.AlcordataDetails', element);
      }
    }
    this.JoinQualifiers();
  }
  JoinQualifiers(page = ONE, subscribeData = [], loop = 'start', mainEntranceIds = [], mainAccessIdOnSiteId: any = []) {
    const temp = '';
    const temp1 = [];
    if (this.SiteRowID.length > ZERO) {
      if (loop == 'start') {
        this.site_qualifiers = [];
        this.siteQualiferMainEntranceData = [];
        this.accessPointIdOnAddress = [];
        this.acpAddressDetOnRows = [];
      }
      this.siteService.getAccessPoints(`${this.Config.ApiSitesUrl}access-points?realEstateAssetId=in(${this.SiteRowID})&_page=${page}`).subscribe(
        (data: any) => this.handleJoinQualifiersResponse(data, page, subscribeData, mainEntranceIds, mainAccessIdOnSiteId));
    } else {
      this.SiteDispLoading = false;
    }
  }
  private handleJoinQualifiersResponse(data: any, page: number, subscribeData: any[], mainEntranceIds: any[], mainAccessIdOnSiteId: any): void {
    if (data['access-points'].length == ZERO) {
      this.SiteDispLoading = false;
      return;
    }
    for (const element of data['access-points']) {
      this.processJoinQualifier(element, mainEntranceIds, mainAccessIdOnSiteId);
    }
    if (data['maxPage'] > ONE && data['maxPage'] != page) {
      this.JoinQualifiers(page + ONE, subscribeData, 'continue', mainEntranceIds, mainAccessIdOnSiteId);
    } else if (data['maxPage'] == page) {
      this.finishJoinQualifiers(mainEntranceIds, mainAccessIdOnSiteId);
    } else {
    }
  }
  private processJoinQualifier(element: any, mainEntranceIds: any[], mainAccessIdOnSiteId: any): void {
    if (element.type == 'P18') { element.type = 'B2b'; }
    if (element.type == 'P14') { this.addMainEntranceQualifier(element, mainEntranceIds, mainAccessIdOnSiteId); }
    if (element.endDate == '' && element.activeStatus != 'ARCHIVED' && element.irnAuthor != 'IRN-70907') {
      const qualifierSet = this.site_qualifiers[element.realEstateAssetId] ||= [];
      qualifierSet[element.type] = (qualifierSet[element.type] || ZERO) + ONE;
    }
    for (const site of this.SitesInfo) {
      if (site.reaIdentifier == element.siteIdentifier && element.type == 'P14') { site.effectiveDate = element.effectiveDate; }
    }
  }
  private addMainEntranceQualifier(element: any, mainEntranceIds: any[], mainAccessIdOnSiteId: any): void {
    this.siteQualiferMainEntranceData[element.realEstateAssetId] = element;
    if (mainEntranceIds.indexOf(element.rowId) == NEGATIVE_ONE) {
      mainEntranceIds.push(element.rowId);
      mainAccessIdOnSiteId[element.rowId] = element.realEstateAssetId;
    }
  }
  private finishJoinQualifiers(mainEntranceIds: any[], mainAccessIdOnSiteId: any): void {
    this.getMainEntranceIds(mainEntranceIds, mainAccessIdOnSiteId);
    this.getSiteRaftCodes(this.siteIdentifierForRaft);
    this.getSiteSaerCodes(this.siteIdentifierForRaft);
    this.getSiteC2bCodes(this.siteIdentifierForRaft);
    this.getSiteLatamCodes(this.siteIdentifierForRaft);
    this.getSiteRnaiplCodes(this.siteIdentifierForRaft);
    this.SiteDispLoading = false;
    console.info('qualifiers', this.site_qualifiers);
    this.SitesInfo = this.SitesInfo.sort((a, b) => +new Date(b.effectiveDate) - +new Date(a.effectiveDate));
    const headquarters = this.SitesInfo.find(element => element.showAsHQ);
    const otherSites = this.SitesInfo.filter(element => !element.showAsHQ);
    this.SitesInfo = headquarters ? [headquarters, ...otherSites] : otherSites;
    console.info("sitesinfo mainentrance", this.SitesInfo);
    this.pagedTotalItem = this.SitesInfo.length;
    this.tempCompanySection = [...this.SitesInfo];
    this.SitesInfo = this.SitesInfo.slice(this.pager.startIndex, this.pager.endIndex + ONE);
  }
  returnZero() {
    return ZERO;
  }
  /* End --> US-420 [Company Details] Display Sites */
  addSite2Cmp() {
    this.userQuestionUpdate3.setValue('')
    this.addSiteNameError = false;
    this.addSiteBvdIdError = false;
    this.addSiteNameModel = "";
    this.addSiteBvdIdModel = "";
    this.selectedSiteName = "failed";
    this.disableAddSiteAdmin = false;
  }
  loadSites(valFrmUsr) {
    this.autoLoadSiteName = true;
    this.addSiteCaptains = [];
    this.addSiteNameAll = [];
    this.addSiteNameError = false;
    if (valFrmUsr == '' || valFrmUsr.length < TWO) { this.autoLoadSiteName = false; return; }
    this.siteService.getSites(`${this.Config.ApiSitesUrl}sites?name=*${valFrmUsr}*&activeStatus=ACTIVE&_page=1&_pagesize=20`).subscribe((data: any) => {
      this.autoLoadSiteName = false;
      if (data['count'] < ONE) { return; }
      for (const element of data['sites']) {
        const ss = [];
        this.addSiteCaptains.push(element.name);
        ss['sites_row_id'] = element.rowId;
        ss['city_name'] = element.cityName;
        this.addSiteNameAll[element.name] = ss;
      }
    });
  }
  onSiteCmpSelect(selected) {
    if (selected) {
      this.addSiteCompany = [];
      this.selectedSiteName = selected;
      this.addSiteNameError = false;
    } else {
      this.selectedSiteName = "failed";
      this.addSiteNameError = true;
    }
  }
  resetAutocomplete() {
    console.info('POPUP IS CLOSED')
  }
  resetaddSite2cmp(fieEld) {
    if (fieEld == "addSiteNameModel") {
      this.userQuestionUpdate3.setValue('')
      this.addSiteNameModel = "";
      this.addSiteNameError = true;
    }
    if (fieEld == "BvdId") {
      this.addSiteBvdIdModel = "";
      this.addSiteBvdIdError = true;
    }
  }
  BvdIdEmptyCheck(fieEld) {
    if (fieEld == "BvdId") {
      if (this.addSiteBvdIdModel.trim() == '') {
        this.addSiteBvdIdError = true;
      } else {
        this.addSiteBvdIdError = false;
      }
    }
  }
  SaveAddSite2Cmp() {
    this.saveDatas = "Saving...";
    if (this.addSiteBvdIdModel.trim() != "" && this.selectedSiteName != "failed") {
      document.getElementById('btnSiteStepsLog').click();
      this.disableAddSiteAdmin = true;
      this.validationSuccess = true;
      this.siteAssignmentGet = 'loading';
      this.acpCreation = 'loading';
      this.businessECreation = 'loading';
      this.bvdAssoCreation = 'loading';
      this.siteAssignCreation = 'loading';
      this.siteNameUCreation = 'loading';
      this.finalSiteCreation = 'loading';
      console.info(ONE, this.addSiteNameAll[this.selectedSiteName]['sites_row_id']);
      let sC = this.addSiteNameAll[this.selectedSiteName]['sites_row_id'];
      this.sitesRowId = this.addSiteNameAll[this.selectedSiteName]['sites_row_id'];
      this.cityName = this.addSiteNameAll[this.selectedSiteName]['city_name'];
      this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?status=VALIDATED&site=SupSiteService:${sC}&_page=1`).subscribe(
        (data: any) => {
          this.siteAssignmentGet = 'success';
          console.info("test", data);
          if (data['count'] > ZERO) {
            console.info('case 1');
            sC = data['site-assignments'][ZERO]['rowId'];
            this.disableAddSiteAdmin = false;
            this.saveDatas = "Save";
          } else {
            console.info('case 2');
            this.case2addToSiteCmp(sC);
          }
        }, _error => {
          this.disableAddSiteAdmin = false;
          this.saveDatas = "Save";
          this.siteAssignmentGet = 'error';
          this.siteAssignCreation = 'error';
          this.bvdAssoCreation = 'error';
          this.businessECreation = 'error';
          this.acpCreation = 'error';
          this.siteNameUCreation = 'error';
          this.finalSiteCreation = 'error';
        });
    } else {
      if (this.addSiteBvdIdModel.trim() == "")
        { this.addSiteBvdIdError = true; }
      if (this.selectedSiteName == "failed")
        { this.addSiteNameError = true; }
      this.saveDatas = "Save";
    }
  }
  case1addToSiteCmp(sites_row_Id) {
    const datas2 = {
      status: "ARCHIVED"
    };
    this.supplierService.updateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments/${sites_row_Id}`, datas2).subscribe((_data: any) => {
      const datas = {
        endDate: this.commonService.getTodayDate()
      };
      this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.SiteDe_BvdID_Stat[this.beRowID]['row_id']}`, datas).subscribe((data: any) => {
        console.info("check ", data);
      });
    });
  }
  case2addToSiteCmp(sites_row_Id, page = ONE) {
    this.siteService.getAccessPoints(`${this.Config.ApiSitesUrl}access-points?realEstateAssetId=${sites_row_Id}&_page=${page}`).subscribe(
      (data: any) => {
        this.acpCreation = 'success';
        const datas2 = {
          activeStatus: "PENDING"
        };
        console.info(TWO, data);
        for (const element of data['access-points']) {
          this.siteService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${element.rowId}`, datas2).subscribe((data: any) => {
            console.info(THREE, data);
          });
        }
        if (data['maxPage'] > ONE && data['maxPage'] != page) {
          this.case2addToSiteCmp(sites_row_Id, page + ONE);
        }
        if (data['maxPage'] == page) {
          setTimeout(function () {
            this.callAddSiteCase2();
          }.bind(this), TWO_THOUSAND);
        }
      }, _error => {
        this.acpCreation = 'error';
        this.siteAssignCreation = 'error';
        this.bvdAssoCreation = 'error';
        this.businessECreation = 'error';
        this.siteNameUCreation = 'error';
        this.finalSiteCreation = 'error';
      });
  }
  callAddSiteCase2() {
    const datas = { modificationStatus: "VALIDATED", companyId: this.companyID, isHQ: "N" };
    this.supplierService.CreateBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities`, datas).subscribe((data: any) => {
      this.businessECreation = 'success';
      console.info(FOUR, data);
      this.businessEntityId = data['row_id'];
      this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifier-types?name=BVD ID&_page=1`).subscribe((beidTypeData: any) => {
        console.info(FIVE, beidTypeData);
        const row_id_BVDID = beidTypeData['business-entity-identifier-types'][ZERO]['row_id'];
        const datas_N = { businessEntityId: this.businessEntityId, businessEntityIdentifierTypeId: row_id_BVDID, value: this.addSiteBvdIdModel, startDate: this.commonService.getTodayDate() };
        this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`, datas_N).subscribe((createdBeid: any) => {
          this.bvdAssoCreation = 'success';
          console.info(SIX, createdBeid);
          const datas_1 = { site: `SupSiteService:${this.sitesRowId}`, validityStartDate: this.commonService.getTodayDate(), businessEntityId: this.businessEntityId, businessEntityCompanyId: this.companyID, status: "VALIDATED" };
          this.supplierService.CreateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments`, datas_1).subscribe((_data: any) => {
            this.siteAssignCreation = 'success';
            console.info("created 7");
            const datas_2 = { name: `${this.companyNameModelval}, ${this.cityName}` };
            this.siteService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.sitesRowId}`, datas_2).subscribe((_data: any) => {
              console.info("created final");
              this.siteNameUCreation = 'success';
              this.finalSiteCreation = 'success';
              const closeButton = document.getElementById("closeCmpSites");
              if (closeButton && closeButton instanceof HTMLElement) {
                closeButton.click();
              }
              setTimeout(() => {
                this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                  this.router.navigate(['/company-details', this.companyID]);
                });
              }, ONE_THOUSAND)
            }, _error => {
              this.siteNameUCreation = 'error';
            });
          }, _error => {
            this.siteAssignCreation = 'error';
          });
        }, _error => {
          this.bvdAssoCreation = 'error';
        });
      });
    }, _error => {
      this.siteAssignCreation = 'error';
      this.bvdAssoCreation = 'error';
      this.businessECreation = 'error';
      this.siteNameUCreation = 'error';
      this.finalSiteCreation = 'error';
    });
  }
  archiveTaxIdentifier() {
    const rowid = this.EditTIObj['TIKey'];
    const const1 = {
      endDate: this.commonService.getTodayDate()
    }
    this.supplierService.updateCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers/${rowid}`, const1).subscribe(_data => {
      document.getElementById('closeConfirmArchiveForTI').click();
      document.getElementById('closeEditTI').click();
      this.CompanyIdnentifiers('', ONE, 'no');
    })
  }
  unarchiveTaxIdentifier() {
    const rowid = this.EditTIObj['TIKey'];
    const const1 = {
      endDate: ''
    }
    this.supplierService.updateCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers/${rowid}`, const1).subscribe(_data => {
      document.getElementById('closeConfirmunArchiveForTI').click();
      document.getElementById('closeUnEditTi').click();
      document.getElementById('closeEditTI').click();
      this.CompanyIdnentifiers('', ONE, 'no');
    })
  }
  showTaxState(loop = 'start', page = ONE) {
    this.taxing;
    if (loop == 'start') {
      this.taxData = [];
      this.taxStateLoading = true;
    }
    this.supplierService.getCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers?linkedCompanyId=${this.companyID}&_page=${page}`).subscribe((data: any) => {
      if (data['company-identifiers']) {
        for (const ele of data['company-identifiers']) {
          if (this.TaxIdentifierKeys.indexOf(ele.companyIdentifierKeyName) != NEGATIVE_ONE) {
            this.taxData.push(ele);
          }
        }
      }
      if (data['maxPage'] > ONE && loop != 'stop') {
        for (let i = TWO; i <= data['maxPage']; i++) {
          this.showTaxState('stop', i)
        }
      }
      if (data['maxPage'] == page) {
        this.taxStateLoading = false;
      }
      this.taxPager = this.pagerService.getPager(this.taxData.length, page, TEN);
      this.dataForTaxState = this.taxData.slice(this.taxPager.startIndex, this.taxPager.endIndex + ONE)
      this.taxing = this.taxData.length > TEN ? false : true
    }, _error => {
      this.taxStateLoading = false;
    });
  }
  taxTable(page) {
    this.taxPager = this.pagerService.getPager(this.taxData.length, page, TEN);
    this.dataForTaxState = this.taxData.slice(this.taxPager.startIndex, this.taxPager.endIndex + ONE)
  }
  loadCmpyAliasState(loop = 'start', page = ONE) {
    this.identifying;
    this.companyIdentifierData = []
    this.cpyAliasLoading = true;
    this.supplierService.getCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers?linkedCompanyId=${this.companyID}&_page=${page}`).subscribe((data: any) => {
      if (loop == 'start') {
        this.dataForCmpyAlias = [];
      }
      if (data['company-identifiers']) {
        this.appendCompanyIdentifiers(data['company-identifiers']);
      }
      if (data['maxPage'] > ONE && loop != 'stop') {
        for (let i = TWO; i <= data['maxPage']; i++) {
          this.loadCmpyAliasState('stop', i)
        }
      }
      if (data['maxPage'] == page) {
        this.cpyAliasLoading = false;
      }
      this.idenPager = this.pagerService.getPager(this.companyIdentifierData.length, page, TEN);
      this.dataForCmpyAlias = this.companyIdentifierData.slice(this.idenPager.startIndex, this.idenPager.endIndex + ONE)
      this.identifying = this.companyIdentifierData.length > TEN ? false : true
    }, _error => {
      this.cpyAliasLoading = false;
    });
  }
  private appendCompanyIdentifiers(identifiers: any[]): void {
    for (const identifier of identifiers) {
      for (const identifierType of this.CompanyIdentiTypes) {
        if (identifier.companyIdentifierKeyName.indexOf(identifierType) != NEGATIVE_ONE) {
          this.companyIdentifierData.push(identifier)
        }
      }
    }
  }
  companyIdentifierTable(page) {
    this.idenPager = this.pagerService.getPager(this.companyIdentifierData.length, page, TEN);
    this.dataForCmpyAlias = this.companyIdentifierData.slice(this.idenPager.startIndex, this.idenPager.endIndex + ONE)
  }
  loadShortName(page = ONE, loop = 'start') {
    if (loop == 'start') {
      this.disableCpyShortNameUpdate = false;
      this.editShortName = this.companyShortName.split(' ').join('');
      this.shortNameSiteArray = [];
      this.EditShortNameValueError = false;
      this.EditShortNameValueRegExError = false;
    }
    if (this.SiteRowID.length <= ZERO) { this.shortNameSiteArray = []; this.popSiteRowId = []; return; }
    this.siteService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?realEstateAssetId=in(${this.SiteRowID})&_page=${page}`).subscribe(data0 => {
      this.applyShortNameSiteIdentifiers(data0, page);
    });
  }
  private applyShortNameSiteIdentifiers(data0: any, page: number): void {
    if (data0['pageCount'] <= ZERO) { this.popSiteRowId = []; }
    else {
      for (const element of data0['real-estate-asset-identifiers']) {
        if (this.SiteRowID.indexOf(element.realEstateAssetId) == NEGATIVE_ONE) {
          this.popSiteRowId.push(element.realEstateAssetId);
        } else {
          const kim = { 'rowId': element.rowId, 'siteId': element.realEstateAssetId };
          if (this.shortNameSiteArray.indexOf(kim) == NEGATIVE_ONE) { this.shortNameSiteArray.push(kim); }
        }
      }
    }
    if (data0['maxPage'] > ONE && data0['maxPage'] != page) { this.loadShortName(page + ONE, 'continue'); }
    else if (data0['maxPage'] == page) { console.info('pop row', this.popSiteRowId); console.info('short array', this.shortNameSiteArray); }
  }
  loadShortName2(page = ONE) {
    this.siteService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?businessIdentifierValue=in(${this.alcorValueWithApos})&_page=${page}`).subscribe(data0 => {
      if (data0['real-estate-asset-identifiers'].length > ZERO) {
        for (const element of data0['real-estate-asset-identifiers']) {
          const kim = { 'rowId': element.rowId, 'siteId': element.realEstateAssetId }
          if (this.shortNameSiteArray.indexOf(kim) == NEGATIVE_ONE) {
            this.shortNameSiteArray.push(kim);
          }
        }
        if (data0['maxPage'] > ONE && data0['maxPage'] != page) {
          this.loadShortName2(page + ONE);
        } else if (data0['maxPage'] == page) {
          console.info('short name id>>', this.shortNameSiteArray);
        } else {
        }
      }
    });
  }
  resetEditShortName() {
    this.editShortName = '';
    this.EditShortNameValueError = false;
    this.EditShortNameValueRegExError = false;
  }
  EditShortName() {
    if (!this.isShortNameValid()) {
      this.EditShortNameValueError = this.editShortName == '';
      this.EditShortNameValueRegExError = !this.EditShortNameValueError;
      return;
    }
    if (this.companyShortRowId != '' && this.companyShortName != '') {
      this.updateExistingShortName();
    } else if (this.companyShortRowId === '' && this.companyShortName === '') {
      this.createShortName();
    } else {
    }
  }
  private isShortNameValid(): boolean {
    const lengthAndContent = this.editShortName.length <= TEN && this.editShortName != '' && !this.EditShortNameValueRegExError;
    const hasExistingName = this.companyShortRowId != '' && this.companyShortName != '';
    const hasNoName = this.companyShortRowId === '' && this.companyShortName === '';
    return lengthAndContent && (hasExistingName || hasNoName);
  }
  private updateExistingShortName(): void {
    this.disableCpyShortNameUpdate = true;
    this.editShortName = this.editShortName.split(' ').join('').padEnd(TEN);
    this.supplierService.updateCompanyNames(`${this.Config.ApiSupplierUrl}company-names/${this.companyShortRowId}`, { "value": this.editShortName }).subscribe(_data => {
      this.refreshShortNameDetails();
    });
    document.getElementById('closeEditShortName').click();
  }
  private createShortName(): void {
    this.editShortName = this.editShortName.trim();
    const datas3 = { companyId: this.companyID, companyNameTypeId: this.cpyShortNameTypes['SHORT NAME'], "value": this.editShortName, startDate: this.commonService.getTodayDate() };
    this.supplierService.CreateCompanyNames(`${this.Config.ApiSupplierUrl}company-names`, datas3).subscribe((_data: any) => {
      this.refreshShortNameDetails();
    });
    document.getElementById('closeEditShortName').click();
  }
  private refreshShortNameDetails(): void {
    this.getShortNameDetails();
    this.setShortNameForSites();
    this.getactivity();
  }
  setShortNameForSites() {
    if (this.shortNameSiteArray.length > ZERO) {
      console.info(this.shortNameSiteArray);
      this.setShortNameForManySites(this.shortNameSiteArray, ZERO, 'start', this.shortNameSiteArray.length);
    }
    if (this.popSiteRowId.length > ZERO) {
      for (const ele of this.popSiteRowId) {
        const const2 = {
          "sourceSystemId": "2",
          "businessIdentifierId": this.siteIdenTypeDetails['SHORT_NAME'],
          "effectiveDate": this.commonService.getTodayDate(),
          "realEstateAssetId": ele,
          "businessIdentifierValue": this.editShortName
        }
        this.siteService.createRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers`, const2).subscribe(_data1 => {
        });
      }
    }
  }
  setShortNameForManySites(_arrayOfVals, index, _position, maxLength) {
    if (index + ONE <= maxLength) {
      const const1 = {
        "businessIdentifierName": this.editShortName
      }
    }
  }
  checkForValidation(paramval) {
    if (paramval == 'addtaxidentifier') {
      this.checkIfTaxIdentifierExists('taxid');
    }
    if (paramval == 'addcpyalias') {
      if (this.CmpAlliasTypeModel == 'bvdId') {
        this.saveNewBvdIdValue();
      } else {
        this.checkIfTaxIdentifierExists('cpyalias');
      }
    }
  }
  private validateIdentifierLength(vals: string, searchVal: string, identifierType: any): boolean {
    if (vals == 'taxid' && this.taxIdentifierRowName['european vat number'] == identifierType && searchVal.length > TWENTY) {
      this.aliasTextDisp = 'Character Limit for this identifier is 20!';
      return false;
    }
    if (vals != 'cpyalias') {
      return true;
    }
    if (identifierType == this.aliasAccToRowId['mdm'] || identifierType == this.aliasAccToRowId['gtop']) {
      if (searchVal.trim().length > FOUR) {
        this.aliasTextDisp = 'Character Limit for this alias is 4';
        return false;
      }
      return true;
    }
    if (identifierType == this.aliasAccToRowId['alcor'] && searchVal.trim().length != SIX) {
      this.aliasTextDisp = 'Character length requirement for this alias is 6';
      return false;
    }
    return true;
  }
  private showIdentifierValidationErrors(vals: string): void {
    const type = vals == 'taxid' ? this.TaxTypeIdnetifierModel : this.CmpAlliasTypeModel;
    const value = vals == 'taxid' ? this.NewIdnetifierValue : this.NewCmpAlliasValue;
    if (vals == 'taxid') {
      this.IdnetifierTypeError = type == undefined || type.trim() == '';
      this.IdnetifierValueError = value == undefined || value.trim() == '';
      return;
    }
    this.CmpAlliasTypeError = type == undefined || type.trim() == '';
    this.CmpAlliasValueError = value == undefined || value.trim() == '';
  }
  checkIfTaxIdentifierExists(vals) {
    if (!this.saveIdenClicked) {
      const url = globalThis.location.href.split('/company-details')[ZERO];
      this.showCancelOk = 'Close';
      this.aliasTextDisp = 'Loading.....';
      this.saveIdenClicked = true;
      const searchVal = vals == 'taxid' ? this.NewIdnetifierValue : this.NewCmpAlliasValue;
      const taxtypemodel = vals == 'taxid' ? this.TaxTypeIdnetifierModel : this.CmpAlliasTypeModel;
      const lengthCheckForType = this.validateIdentifierLength(vals, searchVal, taxtypemodel);
      if (!lengthCheckForType) {
        this.saveIdenClicked = false;
      }
      const searchValValid = searchVal != undefined && searchVal.trim() != '';
      const typeModelValid = taxtypemodel.trim() != "" && taxtypemodel != undefined;
      if (searchValValid && typeModelValid && lengthCheckForType) {
        this.supplierService.getCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers?companyIdentifierKeyName=ALCOR&value=${searchVal}`).subscribe(
          data => this.handleTaxIdentifierResponse(data, vals, taxtypemodel, url),
          () => this.closeIdentifierModals());
      }
      this.showIdentifierValidationErrors(vals);
    }
  }
  private closeIdentifierModals(): void {
    document.getElementById('closeAddTax').click();
    document.getElementById('closeAddCmpAlias').click();
  }
  private closeIdentifierModalByType(vals: string): void {
    if (vals == 'taxid') { document.getElementById('closeAddTax').click(); }
    else if (vals == 'cpyalias') { document.getElementById('closeAddCmpAlias').click(); }
  }
  private handleTaxIdentifierResponse(data: any, vals: string, taxtypemodel: string, url: string): void {
    const identifiers = data['company-identifiers'];
    if (!identifiers || identifiers.length == ZERO) {
      this.handleMissingTaxIdentifier(vals, taxtypemodel);
      return;
    }
    const identifier = identifiers[ZERO];
    this.newCpyId = identifier['linkedCompanyId'];
    if (identifier['endDate'] === '' && identifier['linkedCompanyId'] === this.companyID) {
      this.handleCurrentTaxIdentifier(vals);
    } else if (identifier['endDate'] !== '' && identifier['linkedCompanyId'] === this.companyID) {
      this.handleArchivedTaxIdentifier(identifier, vals, taxtypemodel);
    } else if (identifier['endDate'] === '') {
      this.handleActiveExternalTaxIdentifier(identifier, url, vals);
    } else {
      this.handleArchivedExternalTaxIdentifier(identifier, url, taxtypemodel, vals);
    }
  }
  private handleMissingTaxIdentifier(vals: string, taxtypemodel: string): void {
    document.getElementById('closeAliasEditModal').click();
    if (vals == 'taxid') {
      document.getElementById('closeAddTax').click();
      this.aliasTextDisp = "Adding TaxIdentifier to the Company...";
      setTimeout(() => this.AddTaxIdentifiers(), ONE_HUNDRED);
    } else if (vals == 'cpyalias') {
      document.getElementById('closeAddCmpAlias').click();
      this.aliasTextDisp = "Adding CompanyAlias to the Company...";
      this.AddCmpAllias(() => { if (taxtypemodel == this.aliasAccToRowId['alcor']) { this.addAlcorToSiteRaft(); } });
      console.info(taxtypemodel);
    } else {
    }
  }
  private handleCurrentTaxIdentifier(vals: string): void {
    document.getElementById('closeAddCmpAlias').click();
    this.aliasTextDisp = '<img src="assets/images/warning.png" class="img-btn mr-2" alt=""> The Identifier is already associated to the Company';
    this.closeIdentifierModalByType(vals);
  }
  private handleArchivedTaxIdentifier(identifier: any, vals: string, taxtypemodel: string): void {
    this.aliasTextDisp = '<img src="assets/images/warning.png" class="img-btn mr-2" alt=""> The Identifier has been unarchived';
    if (taxtypemodel == this.aliasAccToRowId['alcor']) { this.addAlcorToSiteRaft(); }
    this.supplierService.updateCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers/${identifier['row_id']}`, { endDate: '' }).subscribe(() => {
      this.CompanyIdnentifiers('', ONE, 'no');
      if (taxtypemodel == this.aliasAccToRowId['alcor']) { this.runPostAlcorStatusTransitions(); }
    });
    this.closeIdentifierModalByType(vals);
  }
  private handleActiveExternalTaxIdentifier(identifier: any, url: string, vals: string): void {
    this.closeIdentifierModalByType(vals);
    this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies/${identifier['linkedCompanyId']}`).subscribe(data => {
      this.aliasTextDisp = `<img src="assets/images/warning.png" class="img-btn mr-2" alt=""> <span class="font-weight-bold"> The Identifier is already associated to the Company : <a class="label-darkblue" href="${url}/company-details/${this.newCpyId}" target="_blank">${data['legalName']}<span>`;
    });
  }
  private handleArchivedExternalTaxIdentifier(identifier: any, url: string, taxtypemodel: string, vals: string): void {
    this.closeIdentifierModalByType(vals);
    this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies/${identifier['linkedCompanyId']}`).subscribe(data => {
      this.showCancelOk = 'OK';
      this.aliasTextDisp = `<span class="font-weight-bold"><u>Information:</u> The Identifier was associated to the Company : <a class="label-darkblue" href="${url}/company-details/${this.newCpyId}" target="_blank">${data['legalName']}<span>`;
      if (taxtypemodel == this.aliasAccToRowId['alcor']) { this.addAlcorToSiteRaft(); }
      this.supplierService.updateCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers/${identifier['row_id']}`, { linkedCompanyId: this.companyID, companyIdentifierTypeId: taxtypemodel, endDate: '' }).subscribe(() => {
        this.CompanyIdnentifiers('', ONE, 'no');
        if (taxtypemodel == this.aliasAccToRowId['alcor']) { this.runPostAlcorStatusTransitions(); }
      });
    });
  }
  addAlcorToSiteRaft() {
    this.siteService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?businessIdentifierValue=${this.NewCmpAlliasValue}&_page=1`).subscribe(data0 => {
      if (data0['pageCount'] == ZERO) {
        const shortNameH = this.companyShortName != '' ? this.companyShortName.trim() : this.companyBasicInfo['legalName'].slice(ZERO, SIX);
        for (const element of this.SiteRowID) {
          const const1 = {
            "sourceSystemId": "2",
            "businessIdentifierId": this.siteIdenTypeDetails['RAFT_ACCOUNT'],
            "effectiveDate": this.commonService.getTodayDate(),
            "businessIdentifierValue": this.NewCmpAlliasValue,
            "businessIdentifierName": shortNameH,
            "realEstateAssetId": element
          }
          this.siteService.createRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers`, const1).subscribe(_data1 => {
            this.runPostAlcorStatusTransitions();
          });
        }
      } else {
        const tempRowId = [];
        const const2 = { "endDate": "" }
        for (let i = ZERO; i < data0['pageCount']; i++) {
          this.siteService.updateRealEstateAssetIdentifier(this.Config.ApiSitesUrl + REAL_ESTATE_ASSET_IDENTIFIERS_PATH + data0['real-estate-asset-identifiers'][i]['rowId'], const2).subscribe(_data2 => {
            tempRowId.push(data0['real-estate-asset-identifiers'][i]['rowId']);
          });
        }
        const shortNameH = this.companyShortName != '' ? this.companyShortName.trim() : this.companyBasicInfo['legalName'].slice(ZERO, SIX);
        for (const ele of this.SiteRowID) {
          if (tempRowId.indexOf(ele) != NEGATIVE_ONE) {
            const const12 =
            {
              "sourceSystemId": "2",
              "businessIdentifierId": this.siteIdenTypeDetails['RAFT_ACCOUNT'],
              "effectiveDate": this.commonService.getTodayDate(),
              "businessIdentifierValue": this.NewCmpAlliasValue,
              "businessIdentifierName": shortNameH,
              "realEstateAssetId": ele
            }
            this.siteService.createRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers`, const12).subscribe(_data1 => {
            });
          }
        }
      }
    });
  }
  loadCatAuthState() {
    this.disableCatAuthState = false;
    this.EditCategoryError = false;
    console.info("this.supplierCategoryVals", this.supplierCategoryVals)
    const stateSetters = {
      'Tooling via SAER': () => this.isTooling = true,
      'Prototype': () => this.isPrototype = true,
      'After Sales only': () => this.isAfterSales = true,
      'Mass Prod / Materials / After Sales': () => this.isMassProd = true,
      'Industrial Partner': () => this.isIndustrialPartner = true,
      'B2B Partner': () => this.isB2BPartner = true,
      'Out of Production only': () => this.isOutProd = true,
      'Mass Prod / Materials / After Sales / Out of Production': () => this.isoutMassProd = true
    };
    for (const element of this.supplierCategoryVals) {
      stateSetters[element]?.();
    }
  }
  private saveCategoryState(rowKey: string, checked: boolean, value: string, companyNameTypeName: string) {
    let datas;
    if (this.row_id[rowKey]) {
      datas = checked ? { "startDate": this.commonService.getTodayDate(), "endDate": '' } : { "endDate": this.commonService.getTodayDate() };
      this.supplierService.updateCompanyNames(`${this.Config.ApiSupplierUrl}company-names/${this.row_id[rowKey]}`, datas).subscribe((_data: any) => {
        this.reloadCatAuth();
      });
    } else if (checked) {
      datas = {
        companyNameTypeName,
        "startDate": this.commonService.getTodayDate(),
        "endDate": '',
        "companyId": this.companyID,
        "companyNameTypeId": this.cpyShortNameTypes[companyNameTypeName],
        value,
        "companyAllianceIdentifier": this.companyAllianceIdentifier
      };
      this.supplierService.CreateCompanyNames(`${this.Config.ApiSupplierUrl}company-names`, datas).subscribe((_data: any) => {
        this.reloadCatAuth();
      });
    } else {
    }
  }
  EditCatAuthState() {
    this.EditCategoryError = false;
    this.saveDatas = "Save...";
    const controls = this.getCategoryControls();
    if (!controls.AfterSales.checked && !controls.MassProd.checked && !controls.OutProd.checked && !controls.MassoutProd.checked) {
      this.EditCategoryError = true;
      return;
    }
    this.saveCategorySelections(controls);
    this.clearStandardSupplier(controls.StandardSupplier.checked);
    this.saveDatas = "Save";
    document.getElementById('closeEditCatAuth').click();
  }
  private getCategoryControls(): { AfterSales: HTMLInputElement; MassProd: HTMLInputElement; OutProd: HTMLInputElement; MassoutProd: HTMLInputElement; IndustrialPartner: HTMLInputElement; B2BPartner: HTMLInputElement; StandardSupplier: HTMLInputElement } {
    return {
      AfterSales: document.getElementById('AfterSales') as HTMLInputElement,
      MassProd: document.getElementById('MassProd') as HTMLInputElement,
      OutProd: document.getElementById('OUtofProd') as HTMLInputElement,
      MassoutProd: document.getElementById('MassoutProd') as HTMLInputElement,
      IndustrialPartner: document.getElementById('IndustrialPartner') as HTMLInputElement,
      B2BPartner: document.getElementById('B2BPartner') as HTMLInputElement,
      StandardSupplier: document.getElementById('StandardSupplier') as HTMLInputElement
    };
  }
  private saveCategorySelections(controls: any): void {
    this.saveCategoryState('After Sales only', controls.AfterSales.checked, 'After Sales only', 'SUPPLIER CATEGORY');
    this.saveCategoryState('Mass Prod / Materials / After Sales', controls.MassProd.checked, 'Mass Prod / Materials / After Sales', 'SUPPLIER CATEGORY');
    this.saveCategoryState('Mass Prod / Materials / After Sales / Out of Production', controls.MassoutProd.checked, 'Mass Prod / Materials / After Sales / Out of Production', 'SUPPLIER CATEGORY');
    this.saveCategoryState('Out of Production only', controls.OutProd.checked, 'Out of Production only', 'SUPPLIER CATEGORY');
    this.saveCategoryState('Prototype', this.isPrototype, 'Prototype', 'SUPPLIER AUTHORIZATION');
    this.saveCategoryState('Industrial Partner', controls.IndustrialPartner.checked, 'Industrial Partner', 'SUPPLIER TYPE');
    this.saveCategoryState('B2B Partner', controls.B2BPartner.checked, 'B2B Partner', 'SUPPLIER TYPE');
  }
  private clearStandardSupplier(standardSupplierChecked: boolean): void {
    if (!standardSupplierChecked) {
      return;
    }
    const rowId = this.row_id['B2B Partner'] || this.row_id['Industrial Partner'];
    if (rowId) {
      this.supplierService.updateCompanyNames(`${this.Config.ApiSupplierUrl}company-names/${rowId}`, { "endDate": this.commonService.getTodayDate() }).subscribe((_data: any) => this.reloadCatAuth());
    }
  }
  reloadCatAuth() {
    this.supplierCategoryLoading = true;
    this.supplierCategoryVals = [];
    this.getSupplierCategoryDetails(ONE, this.supplierCategoryVals);
  }
  getCategoryValues(page = ONE, categoryVals = []) {
    this.supplierService.getCompanyNames(`${this.Config.ApiSupplierUrl}company-names?companyId=${this.companyID}&_page=${page}`).subscribe((data: any) => {
      if (data['company-names'].length > ZERO) {
        for (const element1 of data['company-names']) {
          if ((element1.companyNameTypeName == "SUPPLIER CATEGORY" || element1.companyNameTypeName == "SUPPLIER AUTHORIZATION" || element1.companyNameTypeName == "SUPPLIER TYPE") && element1.endDate == '') {
            categoryVals.push(element1.value);
          }
        }
        if (data['maxPage'] > ONE && data['maxPage'] != page) {
          this.getCategoryValues(page + ONE, categoryVals);
        } else if (data['maxPage'] == page) {
          this.categoryValues = categoryVals;
        } else {
        }
      }
    });
  }
  checked(item) {
    if (this.categoryValues.indexOf(item) != NEGATIVE_ONE) {
      return true;
    }
  }
  onChange(item) {
    if (item.target.checked) {
      this.categoryValues.push(item.target.value);
    } else {
      this.categoryValues = this.categoryValues.filter(x => x != item.target.value)
    }
    console.info(this.categoryValues)
  }
  /************************* SEND REQUEST TO SUPPLIER START **********************************/
  CheckSendReqSupplier() {
    let openReqSupplier = true;
    if (this.companyBasicInfo.workflowStatus.toLowerCase() == 'WaitingForRenault' || this.companyBasicInfo.workflowStatus.toLowerCase() == 'WaitingForSupplier') {
      openReqSupplier = false;
    }
    if (openReqSupplier) {
      this.selectedPayingCmpValue = "failed"
      this.senReqPayCompMOdel = "";
      this.senReqPayCompcodeMOdel = "";
      this.pComp_Name = "";
      this.senReqPayCompMOdelError = false;
      this.payingCompanyCodeModelvalerror = false;
      this.senReqKamSaleContMOdel = "";
      this.senReqKamSaleContMOdelError = false;
      this.senReqSamMOdel = "";
      this.senReqSamMOdelError = false;
      this.senReqBuyerAssiMOdel = "";
      this.senReqNotesMOdel = "";
      this.selectedSendRequest = '';
      this.accHomoRequestSelected = false;
      this.siteUpdRequestSelected = false;
      this.siteAddRequestSelected = false;
      this.addPayCmpRequestSelected = false;
      this.siteUpdatePayingComp = false;
      this.disableSendReqBtn = true;
      this.selectedPayingCpyVal = '';
      this.checkArray = [];
      this.RowupArray1 = [];
      this.senReqSiteModelError = false;
      this.senReqAddSiteModelError = false;
      this.senReqUpdatePayingModelError = false;
      this.prospectSelected = false;
      this.getKamsaleroleuser();
      this.getPersonRoleType("KamSales");
      this.getCategoryValues();
      this.getUpdateSitesData();
      this.addSiteChkHQBvd();
      this.getPayingSitesData();
      document.getElementById('btnForOpenSendReqToSupp').click();
    } else {
      document.getElementById('btnForOpenWarningSendReq').click();
    }
    /*if(this.PersonRoleSelectOp.length>0) {
      console.info("if",this.PersonRoleSelectOp);
    } else {
      this.getPersonRoleType("KamSales");
      console.info("else",this.PersonRoleSelectOp);
    }
    this.kamSalesFilterType(); */
  }
  getUpdateSitesData(page = ONE, subscribeData = []) {
    this.updateSiteData = [];
    this.siteService.getSites(`${this.Config.ApiSitesUrl}sites?rowId=in(${this.SiteRowID})&_page=${page}`).subscribe((data: any) => {
      if (data['sites'].length > ZERO) {
        for (const element of data['sites']) {
          subscribeData.push(element);
        }
        if (data['maxPage'] > ONE && data['maxPage'] != page) {
          this.getUpdateSitesData(page + ONE, subscribeData);
        } else if (data['maxPage'] == page) {
          this.prepareUpdateSiteData(subscribeData);
        } else {
        }
      }
    });
  }
  private prepareUpdateSiteData(sites: any[]): void {
    for (const site of sites) {
      this.prepareUpdateSite(site);
      this.updateSiteData.push(site);
      this.updateSiteData = this.updateSiteData.sort((a, b) => (+new Date(b.effectiveDateMain) - +new Date(a.effectiveDateMain)));
    }
  }
  private prepareUpdateSite(site: any): void {
    const isPendingOrCreated = ['pending', 'created'].includes(site.activeStatus.toLowerCase());
    site['disableCheckBox'] = isPendingOrCreated;
    for (const existingSite of this.SitesInfo) {
      if (existingSite.reaIdentifier == site.identifier) {
        site.effectiveDateMain = existingSite.effectiveDate;
      }
    }
  }
  getPayingSitesData(page = ONE, subscribeData = []) {
    this.payingSiteData = [];
    this.supplierService.getCompanyApprovals(`${this.Config.ApiSupplierUrl}company-approvals?companiesId=${this.companyID}&_page=${page}`).subscribe((data: any) => {
      if (data['company-approvals'].length <= ZERO) { return; }
      for (const element of data['company-approvals']) { subscribeData.push(element); }
      if (data['maxPage'] > ONE && data['maxPage'] != page) { this.getPayingSitesData(page + ONE, subscribeData); return; }
      if (data['maxPage'] == page) { this.applyPayingSiteData(subscribeData); }
    });
  }
  private applyPayingSiteData(items: any[]): void {
    for (const element of items) {
      element['disableCheckBox'] = element['approvalModificationStatus'] == 'PENDING_VALIDATION';
      if (element['approvalModificationStatus'] == 'PENDING_VALIDATION' || element['approvalModificationStatus'] == 'VALIDATED') {
        this.payingSiteData.push(element);
      }
    }
  }
  kamSalesFilterType() {
    this.contactService.getPersonRoleTypesbyId(`${this.Config.ApinewContactsUrl}person-role-types/5`).subscribe((data: any) => {
      console.info(data);
    });
  }
  PayingCompanyList() {
    this.supplierService.getPayingCompany(`${this.Config.ApiSupplierUrl}paying-company&_page=1`).subscribe(data => {
      console.info(data);
    });
  }
  resetCompanySearch(fieEld) {
    if (fieEld == "name") {
      this.senReqPayCompMOdel = "";
      this.senReqPayCompMOdelError = true;
    }
    else if (fieEld == "code") {
      this.senReqPayCompcodeMOdel = "";
    } else {
    }
  }
  resetSendReqToSupp(fieEld) {
    const resetters = {
      senReqPayCompMOdel: () => { this.senReqPayCompMOdel = ""; this.senReqPayCompMOdelError = true; },
      senReqPayCompCodeMOdel: () => { this.senReqPayCompcodeMOdel = ""; },
      senReqKamSaleContMOdel: () => { this.senReqKamSaleContMOdel = ""; this.senReqKamSaleContMOdelError = true; },
      senReqSamMOdel: () => { this.senReqSamMOdel = ""; this.senReqSamMOdelError = true; },
      senReqBuyerAssiMOdel: () => { this.senReqBuyerAssiMOdel = ""; },
      senReqNotesMOdel: () => { this.senReqNotesMOdel = ""; }
    };
    resetters[fieEld]?.();
  }
  assignSendRequestToSupplier() {
    const compUrl = baseUrl
    console.info('currentURL', compUrl);
    if (compUrl == intUrl || compUrl == `${intUrl}/` || compUrl == `${localUrl}/` || compUrl == localUrl) {
      this.sendRequestSupplier();
    } else {
      this.sendRequestSupplier2();
    }
  }
  sendRequestSupplier2() {
    if (this.isSupplier2CompanyRequest()) {
      this.sendSupplier2CompanyRequest();
      return;
    }
    if (this.isSupplier2SiteRequest()) {
      this.sendSupplier2SiteRequest();
      return;
    }
    this.setSupplier2ValidationErrors();
  }
  private isSupplier2CompanyRequest(): boolean {
    const payingValid = !this.payingCompanyCodeModelvalerror && this.selectedPayingCmpValue != "failed";
    const requestValid = this.senReqKamSaleContMOdel != "" && this.senReqSamMOdel.trim() != "" && this.selectedSendRequest != '' && !this.sendRequestError;
    return payingValid && requestValid && (this.accHomoRequestSelected || this.addPayCmpRequestSelected);
  }
  private isSupplier2SiteRequest(): boolean {
    const baseRequestValid = this.senReqKamSaleContMOdel != "" && this.senReqSamMOdel.trim() != "" && this.selectedSendRequest != '';
    const siteCheckValid = !this.sendRequestError && this.checkArray.length > ZERO && this.siteUpdRequestSelected;
    return baseRequestValid && siteCheckValid;
  }
  private sendSupplier2CompanyRequest(): void {
      console.info("true");
      this.senReqSamMOdelError = false;
      this.disableSendReqBtn = true;
      const SuppName = this.companyBasicInfo['legalName'];
      const AllianId = this.companyBasicInfo['allianceIdentifier'];
      const SuppUrl = `'${globalThis.location}'`;
      let v1Ipn: string;
      const v2Ipn = 'v033684';
      const v3Ipn = this.commonService.fromApp_UserIPN;
      const temps = this.senReqSamMOdel.trim().split('-');
      const v4Ipn = this.senReqBuyerAssiMOdel;
      const v5Ipn = temps[ZERO];
      const v6Ipn = "v033684";
      const reqType = "New Company";
      const desc = this.senReqNotesMOdel;
      const perarr: any = [];
      const v7Ipn = 'a027700';
      const v8Ipn = '';
      const v9Ipn = '';
      const v10Ipn = '';
      let shouldSendMail = false;
      const sendMailTo = this.PersonDetails[`${this.senReqKamSaleContMOdel}_email`];
      const category = this.categoryValues;
      perarr.push(this.senReqKamSaleContMOdel);
      this.contactService.getUsers(`${this.Config.ApinewContactsUrl}users?personRowId=${this.senReqKamSaleContMOdel}`).subscribe((data: any) => {
        v1Ipn = this.getSupplierContactIpn(data, perarr);
        if (v1Ipn == '') {
          v1Ipn = v6Ipn;
          shouldSendMail = true;
        }
        this.openSupplier2CompanyRequest(SuppName, AllianId, SuppUrl, v1Ipn, v2Ipn, v3Ipn, v4Ipn, v5Ipn, v6Ipn, v7Ipn, v8Ipn, v9Ipn, v10Ipn, reqType, desc);
        if (shouldSendMail) { this.sendSupplier2InvitationMail(sendMailTo, desc); }
        document.getElementById("closesendReqtoSupp1").click();
        console.info('person', this.PersonDetailsCompSent2Req)
        this.completeSupplier2CompanyRequest();
        this.saveDatas = "Save";
        document.getElementById('closeEditCatAuth').click();
      });
  }
  private getSupplierContactIpn(data: any, contactIds: any[]): string {
    let ipn = '';
    for (const element of data['users']) {
      if (contactIds.includes(element.personRowId)) { ipn = element.loginId; }
    }
    return ipn;
  }
  private openSupplier2CompanyRequest(supplierName: string, allianceId: string, supplierUrl: string, v1Ipn: string, v2Ipn: string, v3Ipn: string, v4Ipn: string, v5Ipn: string, v6Ipn: string, v7Ipn: string, v8Ipn: string, v9Ipn: string, v10Ipn: string, requestType: string, description: string): void {
    const requestUrl = baseUrl == opeUrl || baseUrl == opewafUrl || baseUrl == opeNewwafUrl ? newShare : int;
    globalThis.open(`${requestUrl}Request?SupplierName=${supplierName}&AllianceID=${allianceId}&SupplierDetail=${supplierUrl}&V1IPN=${v1Ipn}&V2IPN=${v2Ipn}&V3IPN=${v3Ipn}&V4IPN=${v4Ipn}&V5IPN=${v5Ipn}&V6IPN=${v6Ipn}&V7IPN=${v7Ipn}&V8IPN=${v8Ipn}&V9IPN=${v9Ipn}&V10IPN=${v10Ipn}&RequestType=${requestType}&Description=${description}`);
  }
  private sendSupplier2InvitationMail(sendMailTo: string, description: string): void {
    this.mailBodyContent = this.buildSupplierRegistrationMail(sendMailTo, description);
    this.sendMailFn(sendMailTo, 'ISA access for your referencement in the Renault Group', this.mailBodyContent);
  }
  private buildSupplierRegistrationMail(sendMailTo: string, description: string): string {
    const baseUrl1 = baseUrl;
    const okta = baseUrl1 == opeUrl || baseUrl1 == opewafUrl || baseUrl1 == opeNewwafUrl ? OktaProd : OktaUat;
    return `<p>Dear Supplier,</p><p>A Renault buyer has identified your company and would like to invite you to register in order to establish a business relationship with the Renault Group.</p><p>To complete your registration, please follow the three steps below.</p><p><strong>Step 1 &ndash; Create your OKTA account</strong></p><p>If you do not yet have an IPN, create your OKTA account using your email address (<em>${sendMailTo}</em>) via this link: <a href="${okta}" target="_blank">${okta}</a></p><p><strong>Step 2 &ndash; Log into ISA</strong></p><p>Once your account is created, log in to the ISA application (Interface for Supplier Administration): <a href="${baseUrl1}" target="_blank">${baseUrl1}</a></p><p><strong>Step 3 &ndash; Complete your registration</strong></p><ol><li>In the <strong>Documents</strong> section, upload a blank invoice and your bank account details.</li><li>In the <strong>Sites</strong> section, assign the appropriate qualifiers to each of your locations.</li><li>Once all required information has been completed:<ul><li>Click <strong>&quot;Send to Buyer&quot;</strong> if you do not have an IPN; <strong>or</strong></li><li>Validate the workflow on the <strong>Company</strong> page if you already have an IPN.</li></ul></li></ol><p>This will submit your registration for review.</p><p><em>Buyer comment: ${description}</em></p><p><strong>Need help?</strong> A user guide is available here: <a href="${guidecompanyLink}" target="_blank">${guidecompanyLink}</a></p><p>For any question or assistance during this process, please contact: <a href="mailto:isa@renault.com">isa@renault.com</a></p><p>Thank you in advance for your prompt attention to this request. We look forward to starting our collaboration.</p><p><strong>Best regards,</strong></p><p>Supplier Repository Team</p><p>Renault Group</p>`;
  }
  private completeSupplier2CompanyRequest(): void {
    this.supplierService.UpdateCompany(`${this.Config.ApiSupplierUrl}companies/${this.companyID}`, { companyStatusCode: "Pending", companyStatusId: "5" }).subscribe(_data => { });
    if (this.accHomoRequestSelected) {
      for (const element of this.SitesInfo) {
        if (element.site) {
          const siteId = element.site.href.split('/')[ONE];
          this.siteService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.Site_City_Country[siteId]['rowId']}`, { activeStatus: "PENDING" }).subscribe(_data => { });
        }
      }
    }
    this.supplierService.getApprovalScopes(`${this.Config.ApiSupplierUrl}approval-scopes`).subscribe(() => this.checkPayingCompanyStatus());
    const activities = [['After Sales only', 'B#AFTER-SALES-ONLY'], ['Materials', 'B#MATERIALS'], ['Transport', 'B#TRANSPORT'], ['Prototype', 'C#PROTOTYPE']];
    activities.filter(([category]) => this.categoryValues.includes(category) && (category != 'Materials' || this.row_id['Materials'])).forEach(([category, value]) => {
      const payload = { companyNameTypeName: category == 'Prototype' ? 'SUPPLIER ACTIVITYN' : 'SUPPLIER ACTIVITY', startDate: this.commonService.getTodayDate(), endDate: '', companyId: this.companyID, companyNameTypeId: this.cpyShortNameTypes['SUPPLIER ACTIVITY'], value, companyAllianceIdentifier: this.companyAllianceIdentifier };
      this.supplierService.CreateCompanyNames(`${this.Config.ApiSupplierUrl}company-names`, payload).subscribe((_data: any) => this.reloadCatAuth());
    });
  }
  private sendSupplier2SiteRequest(): void {
      this.senReqSamMOdelError = false;
      this.disableSendReqBtn = true;
      const SuppName = this.companyBasicInfo['legalName'];
      const AllianId = this.companyBasicInfo['allianceIdentifier'];
      const SuppUrl = `'${globalThis.location}'`;
      let v1Ipn = '';
      const v2Ipn = 'v033684';
      const v3Ipn = this.commonService.fromApp_UserIPN;
      const temps = this.senReqSamMOdel.trim().split('-');
      const v4Ipn = this.senReqBuyerAssiMOdel;
      const v5Ipn = temps[ZERO];
      const v6Ipn = "v033684";
      const reqType = "New Company";
      const desc = this.senReqNotesMOdel;
      const perarr: any = [];
      const v7Ipn = 'a027700';
      const v8Ipn = '';
      const v9Ipn = '';
      const v10Ipn = '';
      let shouldSendMail = false;
      const sendMailTo = this.PersonDetails[`${this.senReqKamSaleContMOdel}_email`];
      perarr.push(this.senReqKamSaleContMOdel);
      this.contactService.getUsers(`${this.Config.ApinewContactsUrl}users?personRowId=${this.senReqKamSaleContMOdel}`).subscribe((data: any) => {
        if (data['users'].length > ZERO) {
          for (const element of data['users']) {
            if (perarr.includes(element.personRowId) == ONE) {
              v1Ipn = element.loginId;
            }
          }
        }
        if (v1Ipn == '') {
          v1Ipn = v6Ipn;
          shouldSendMail = true;
        }
        const baseUrl1 = baseUrl
        if (baseUrl1 == opeUrl || baseUrl1 == opewafUrl || baseUrl1 == opeNewwafUrl) {
          globalThis.open(`${share}Request?SupplierName=${SuppName}&AllianceID=${AllianId}&SupplierDetail=${SuppUrl}&V1IPN=${v1Ipn}&V2IPN=${v2Ipn}&V3IPN=${v3Ipn}&V4IPN=${v4Ipn}&V5IPN=${v5Ipn}&V6IPN=${v6Ipn}&V7IPN=${v7Ipn}&V8IPN=${v8Ipn}&V9IPN=${v9Ipn}&V10IPN=${v10Ipn}&RequestType=${reqType}&Description=${desc}`);
        }
        else {
          globalThis.open(`${int}Request?SupplierName=${SuppName}&AllianceID=${AllianId}&SupplierDetail=${SuppUrl}&V1IPN=${v1Ipn}&V2IPN=${v2Ipn}&V3IPN=${v3Ipn}&V4IPN=${v4Ipn}&V5IPN=${v5Ipn}&V6IPN=${v6Ipn}&V7IPN=${v7Ipn}&V8IPN=${v8Ipn}&V9IPN=${v9Ipn}&V10IPN=${v10Ipn}&RequestType=${reqType}&Description=${desc}`);
        }
        if (shouldSendMail) {
          console.info('send Mail');
          const mailSubject = 'ISA access for your referencement in the Renault Group';
          this.mailBodyContent = this.buildSupplierRegistrationMail(sendMailTo, desc);
          this.sendMailFn(sendMailTo, mailSubject, this.mailBodyContent, true);
        }
        console.info('person', this.PersonDetailsCompSent2Req)
        const siteStatusChange = {
          "activeStatus": "PENDING"
        };
        for (const element of this.checkArray) {
          this.siteService.updateSite(`${this.Config.ApiSitesUrl}sites/${element}`, siteStatusChange).subscribe(_data2 => {
            this.loadBvdIdCpy('reload');
            document.getElementById('closesendReqtoSupp1').click();
          });
        }
      });
  }
  private setSupplier2ValidationErrors(): void {
      console.info("false");
      const idAfterSales = document.getElementById('afterSales') as HTMLInputElement;
      const idMassProd = document.getElementById('massProd') as HTMLInputElement;
      const idOutProd = document.getElementById('outProd') as HTMLInputElement;
      const idMassOutProd = document.getElementById('massoutProd') as HTMLInputElement;
      if (this.selectedPayingCmpValue == "failed") {
        this.payingCompanyCodeModelvalerror = true;
      }
      if (this.senReqKamSaleContMOdel == "") {
        this.senReqKamSaleContMOdelError = true;
      }
      if (this.senReqSamMOdel == "") {
        this.senReqSamMOdelError = true;
      } else {
        this.senReqSamMOdelError = false;
      }
      if (this.selectedSendRequest == '') {
        this.sendRequestError = true;
      }
      if (this.checkArray.length > ZERO) {
        this.senReqSiteModelError = false;
      } else {
        this.senReqSiteModelError = true;
      }
  }
  /**START K2 API for send request to supplier */
  sendRequestSupplier() {
    const { id, reqType } = this.getSupplierRequestType();
    if (this.isNewProspectSupplierRequest()) {
      this.sendNewProspectSupplierRequest(id, reqType);
      return;
    }
    if (this.isPayingCompanySupplierRequest()) {
      this.sendPayingCompanySupplierRequest(id, reqType);
      return;
    }
    if (this.isSiteSupplierRequest()) {
      this.sendSiteSupplierRequest(id, reqType);
      return;
    }
    this.setSupplierRequestValidationErrors();
  }
  private getSupplierRequestType(): { id: number; reqType: string } {
    const requestTypes = {
      'New Prospect': { id: ZERO, reqType: '0-New Supplier Prospect' },
      'New Company': { id: ONE, reqType: '1-New Supplier Referencing' },
      'Add site': { id: TWO, reqType: '2-Add Sites' },
      'site update': { id: THREE, reqType: '3-Update Sites' },
      'add paying company': { id: FOUR, reqType: '4-Add Paying Company' },
      'Update bank details': { id: FIVE, reqType: '5-Update bank details' }
    };
    return requestTypes[this.selectedSendRequest] || { id: ZERO, reqType: undefined };
  }
  private isNewProspectSupplierRequest(): boolean {
    const isKamBlank = this.senReqKamSaleContMOdel == "" && this.senReqSamMOdel.trim() != "" && this.selectedSendRequest != '';
    const noRequestErrors = !this.sendRequestError && (!this.accHomoRequestSelected || !this.addPayCmpRequestSelected);
    const payingFailed = this.selectedPayingCmpValue == "failed" && !this.payingCompanyCodeModelvalerror;
    return isKamBlank && noRequestErrors && payingFailed;
  }
  private isPayingCompanySupplierRequest(): boolean {
    const baseConditions = this.senReqKamSaleContMOdel != "" && this.senReqSamMOdel.trim() != "" && this.selectedSendRequest != '' && !this.sendRequestError;
    const payingCompanyCase = (this.accHomoRequestSelected || this.addPayCmpRequestSelected) && this.selectedPayingCmpValue != "failed" && !this.payingCompanyCodeModelvalerror;
    const updatePayingCase = this.RowupArray1.length > ZERO && this.siteUpdatePayingComp;
    return baseConditions && (payingCompanyCase || updatePayingCase);
  }
  private isSiteSupplierRequest(): boolean {
    const baseConditions = this.senReqKamSaleContMOdel != "" && this.senReqSamMOdel.trim() != "" && this.selectedSendRequest != '' && !this.sendRequestError;
    const siteUpdateCase = this.checkArray.length > ZERO && this.siteUpdRequestSelected;
    const siteAddCase = this.siteAddRequestSelected && this.addSiteDataArray.length > ZERO;
    return baseConditions && (siteUpdateCase || siteAddCase);
  }
  private sendNewProspectSupplierRequest(id, reqType): void {
      console.info("true for send request");
      this.senReqSamMOdelError = false;
      this.disableSendReqBtn = true;
      const SuppName = this.companyBasicInfo['legalName'];
      const AllianId = this.companyBasicInfo['allianceIdentifier'];
      const SuppUrl = `'${globalThis.location}'`;
      const temps = this.senReqSamMOdel.trim().split('-');
      const v4Ipn = temps[ZERO].trim();
      const v4Name = `${temps[ONE].trim()} ${temps[TWO].trim()}`;
      const desc = this.senReqNotesMOdel;
      let shouldSendMail = true;
      const perarr: any = [];
      const sendReq = {
        supplierName: SuppName,
        allianceId: AllianId,
        supplierDetail: SuppUrl,
        vsupplierIPN: '',
        vsupplierName: '',
        vbuyerIPN: '',
        vbuyerName: '',
        vbuyerAssistantIPN: '',
        vbuyerAssistantName: '',
        vfinalIPN: v4Ipn,
        vfinalName: v4Name,
        vadminIPN: '',
        vadminName: '',
        vsupplyAdminIPN: '',
        vsupplyAdminName: '',
        requestType: { id },
        strRequestType: reqType,
        comment: desc,
        vBisAdmin1IPN: '',
        vBisAdmin1Name: ''
      };
      const idpToken = localStorage.getItem('IDPAccessToken');
      const sharePointOp = {
        headers: new HttpHeaders({
          Authorization: `Bearer ${idpToken}`,
          apikey: this.Config.apikey
        })
      };
      this.k2Service.createK2Isa(`${this.Config.ApiK2Url}isa`, sendReq).subscribe(data1 => {
        this.k2Service.getK2IsabyId(`${this.Config.ApiK2Url}isa/${data1['requestId']}`).subscribe(data => {
          this.arcaServices.getPerson(`${this.Config.ApiArcaURL}Person('${temps[ZERO].toLowerCase()}')`).subscribe((data7: any) => {
               if (this.selectedSendRequest == 'New Prospect') {
                 const companyWorkflowStatusPayload = {
                   workflowStatus: "WaitingForRenault"
                 };
                   this.supplierService
                     .UpdateCompany(
                       `${this.Config.ApiSupplierUrl}companies/${this.companyID}`,
                       companyWorkflowStatusPayload
                     )
                     .subscribe(_data => {
                       this.companyBasicInfo["workflowStatus"] = companyWorkflowStatusPayload.workflowStatus;
                     });
               }
            document.getElementById('sendReqtoSupp1').click();

            this.workflowDetailsfn()
            const sendMailTo = data7['Mail']
            const desc = this.senReqNotesMOdel;
            const baseUrl1 = baseUrl
            const specificLink = `${baseUrl1}/company-details/${this.companyID}#workflows`;
            const mailSubject = `Approval request for ${this.companyBasicInfo['legalName']}`;
            const onlineHelp = online
            this.mailBodyContent = ` <p>Hello ${temps[ONE]} ${temps[TWO]},</p><p> The request ${data['folio']} (${data['strRequestType']}) is waiting for your Validation as Manager </p> <p>For that, please click on this link to get access to ISA (Interface for Supplier Administration) : <a href=${specificLink}>ISA</a>.</p> </p><p>Notes:</p> <p>${desc}</p> <p>For any help please contact <u>isa@renault.com</u></p><p><a href=${onlineHelp}>Online help</a></p><p>Regards,</p><p>Supplier repository team</p></body>`;
            this.sendMailFn(sendMailTo, mailSubject, this.mailBodyContent);
          })
        })
      }, error => {
        console.info('error', error);
      });
  }
  private sendPayingCompanySupplierRequest(id, reqType): void {
      console.info("true for send request");
      this.senReqSamMOdelError = false;
      this.disableSendReqBtn = true;
      const SuppName = this.companyBasicInfo['legalName'];
      const AllianId = this.companyBasicInfo['allianceIdentifier'];
      const SuppUrl = `'${globalThis.location}'`;
      const v1Ipn = '';
      const v1Name = '';
      const v2Ipn = this.commonService.fromApp_UserIPN;
      const v2Name = this.commonService.fromApp_UserName;
      const tempss = this.senReqBuyerAssiMOdel.trim().split('-');
      const v3Ipn = tempss[ZERO].trim();
      const v3Name = this.buyerNameSelected;
      const temps = this.senReqSamMOdel.trim().split('-');
      const v4Ipn = temps[ZERO].trim();
      const v4Name = `${temps[ONE].trim()} ${temps[TWO].trim()}`;
      const baseUrl1 = baseUrl
      let v5Ipn: string;
      let v5Name: string;
      let v6Ipn: string;
      let v6Name: string;
      let v7Ipn: string;
      let v7Name: string;
      if (baseUrl1 == opeUrl || baseUrl1 == opewafUrl || baseUrl1 == opeNewwafUrl) {
        v5Ipn = 'v033684';
        v5Name = 'Admin MDM';
        v6Ipn = 'v011289';
        v6Name = 'Admin SAER';
        v7Ipn = 'v023231';
        v7Name = 'Admin SUPPLY';
      } else {
        v5Ipn = this.commonService.fromApp_UserIPN;
        v5Name = this.commonService.fromApp_UserName;
        v6Ipn = this.commonService.fromApp_UserIPN;
        v6Name = this.commonService.fromApp_UserName;
        v7Ipn = this.commonService.fromApp_UserIPN;
        v7Name = this.commonService.fromApp_UserName;
      }
      const desc = this.senReqNotesMOdel;
      const shouldSendMail = false;
      const category = this.categoryValues;
      const perarr: any = [];
      perarr.push(this.senReqKamSaleContMOdel);
      this.contactService.getUsers(`${this.Config.ApinewContactsUrl}users?personRowId=${this.senReqKamSaleContMOdel}`).subscribe((data: any) => {
        const contact = this.getRequestContact(data, v1Ipn, v1Name, v5Ipn, v5Name);
        const sendReq = this.createSupplierRequestPayload(id, reqType, desc, SuppName, AllianId, SuppUrl, contact.ipn, contact.name, v2Ipn, v2Name, v3Ipn, v3Name, v4Ipn, v4Name, v5Ipn, v5Name, v6Ipn, v6Name, v7Ipn, v7Name, category.includes('Prototype'));
        this.k2Service.createK2Isa(`${this.Config.ApiK2Url}isa`, sendReq).subscribe(data1 => {
          this.sendRequestSupplier3(contact.shouldSendMail, `ISA ${data1['requestId']} ${this.companyBasicInfo['legalName']} ${reqType}`, reqType);
        }, error => {
          console.info('error', error);
          this.sendRequestSupplier2();
        });
      });
  }
  private getRequestContact(data: any, ipn: string, name: string, fallbackIpn: string, fallbackName: string): any {
    if (data['users'].length > ZERO) {
      for (const element of data['users']) {
        if ([this.senReqKamSaleContMOdel].includes(element.personRowId)) {
          ipn = element.loginId;
        }
      }
      for (const person of this.PersonDetailsCompSent2Req) {
        if (person.personRowId == this.senReqKamSaleContMOdel) {
          name = `${person.personFirstName} ${person.personLastName}`;
        }
      }
    }
    if (ipn == '') {
      ipn = fallbackIpn;
      name = fallbackName;
    }
    return { ipn, name, shouldSendMail: ipn != '' };
  }
  private createSupplierRequestPayload(id: any, reqType: any, description: string, supplierName: string, allianceId: string, supplierUrl: string, supplierIpn: string, supplierContactName: string, buyerIpn: string, buyerName: string, assistantIpn: string, assistantName: string, finalIpn: string, finalName: string, adminIpn: string, adminName: string, otherAdminIpn: string, otherAdminName: string, supplyIpn: string, supplyName: string, isPrototype: boolean): any {
    const isAddPayingCompany = this.selectedSendRequest == 'add paying company';
    const isUpdateBankDetails = this.selectedSendRequest == 'Update bank details';
    const sendReq: any = {
      supplierName,
      allianceId,
      supplierDetail: supplierUrl,
      vsupplierIPN: supplierIpn,
      vsupplierName: supplierContactName,
      vbuyerIPN: buyerIpn,
      vbuyerName: buyerName,
      vbuyerAssistantIPN: assistantIpn,
      vbuyerAssistantName: assistantName,
      vfinalIPN: finalIpn,
      vfinalName: finalName,
      vadminIPN: adminIpn ? adminIpn : '',
      vadminName: adminName ? adminName : '',
      requestType: { id },
      strRequestType: reqType,
      comment: description,
      vBisAdmin1IPN: adminIpn,
      vBisAdmin1Name: adminName
    };
    if (isPrototype) {
      sendReq.vOtherAdmin1IPN = otherAdminIpn;
      sendReq.vOtherAdmin1Name = otherAdminName;
    }
    if (isAddPayingCompany || isUpdateBankDetails) {
      sendReq.vsupplyAdminIPN = '';
      sendReq.vsupplyAdminName = '';
    } else {
      sendReq.vsupplyAdminIPN = supplyIpn ? supplyIpn : '';
      sendReq.vsupplyAdminName = supplyName ? supplyName : '';
    }
    return sendReq;
  }
  private sendSiteSupplierRequest(id, reqType): void {
      this.senReqSamMOdelError = false;
      this.disableSendReqBtn = true;
      const SuppName = this.companyBasicInfo['legalName'];
      const AllianId = this.companyBasicInfo['allianceIdentifier'];
      const SuppUrl = `'${globalThis.location}'`;
      const v1Ipn = '';
      const v1Name = '';
      const v2Ipn = this.commonService.fromApp_UserIPN;
      const v2Name = this.commonService.fromApp_UserName;
      const tempss = this.senReqBuyerAssiMOdel.trim().split('-');
      const v3Ipn = tempss[ZERO].trim();
      const v3Name = this.buyerNameSelected;
      const temps = this.senReqSamMOdel.trim().split('-');
      const v4Ipn = temps[ZERO].trim();
      const v4Name = `${temps[ONE].trim()} ${temps[TWO].trim()}`;
      const baseUrl1 = baseUrl
      let v5Ipn: string;
      let v5Name: string;
      let v6Ipn: string;
      let v6Name: string;
      let v7Ipn: string;
      let v7Name: string;
      if (baseUrl1 == opeUrl || baseUrl1 == opewafUrl || baseUrl1 == opeNewwafUrl) {
        v5Ipn = 'v033684';
        v5Name = 'Admin MDM';
        v6Ipn = 'v011289';
        v6Name = 'Admin SAER';
        v7Ipn = 'v023231';
        v7Name = 'Admin SUPPLY';
      } else {
        v5Ipn = this.commonService.fromApp_UserIPN;
        v5Name = this.commonService.fromApp_UserName;
        v6Ipn = this.commonService.fromApp_UserIPN;
        v6Name = this.commonService.fromApp_UserName;
        v7Ipn = this.commonService.fromApp_UserIPN;
        v7Name = this.commonService.fromApp_UserName;
      }
      const desc = this.senReqNotesMOdel;
      const contactRequest = this.contactService.getUsers(`${this.Config.ApinewContactsUrl}users?personRowId=${this.senReqKamSaleContMOdel}`);
      contactRequest.subscribe((data: any) => {
        const contact = this.getRequestContact(data, v1Ipn, v1Name, v5Ipn, v5Name);
        const sendReq = this.createSupplierRequestPayload(id, reqType, desc, SuppName, AllianId, SuppUrl, contact.ipn, contact.name, v2Ipn, v2Name, v3Ipn, v3Name, v4Ipn, v4Name, v5Ipn, v5Name, v6Ipn, v6Name, v7Ipn, v7Name, false);
        this.k2Service.createK2Isa(`${this.Config.ApiK2Url}isa`, sendReq).subscribe(data1 => {
          this.handleSiteSupplierRequestSuccess(data1, reqType, contact.shouldSendMail);
        }, error => {
          console.info('error', error);
          this.sendRequestSupplier2();
        });
      });
  }
  private handleSiteSupplierRequestSuccess(data: any, reqType: any, shouldSendMail: boolean): void {
    if (shouldSendMail) {
      console.info("send Mail");
      const sendMailTo = this.PersonDetails[`${this.senReqKamSaleContMOdel}_email`];
      const specificLink = baseUrl;
      const mailSubject = `ISA ${data['requestId']} ${this.companyBasicInfo['legalName']} ${reqType}`;
      this.mailBodyContent = `<p>Dear Supplier,</p><p> You have some information to update in Renault database.</p> <p>For that, please click on this link to get access to ISA (Interface for Supplier Administration) : <a href=${specificLink}>ISA</a>.</p> <p>${this.senReqNotesMOdel}</p> <p>For any help please contact <u>isa@renault.com</u></p><p><a href=${online}>Online help</a></p><p>Regards,</p><p>Supplier repository team</p></body>`;
      this.sendMailFn(sendMailTo, mailSubject, this.mailBodyContent, true);
    }
    const siteStatusChange = { "workflowStatus": this.updatedWorkflowStatus };
    for (const element of this.checkArray) {
      this.siteService.updateSite(`${this.Config.ApiSitesUrl}sites/${element}`, siteStatusChange).subscribe(_data2 => {
        this.loadBvdIdCpy('reload');
        document.getElementById('closesendReqtoSupp1')?.click();
      });
    }
    if (this.siteAddRequestSelected) {
      this.importSelectedSites();
    }
  }
  private setSupplierRequestValidationErrors(): void {
      const idAfterSales = document.getElementById('afterSales') as HTMLInputElement;
      const idMassProd = document.getElementById('massProd') as HTMLInputElement;
      const idOutProd = document.getElementById('outProd') as HTMLInputElement;
      const idMassOutProd = document.getElementById('massoutProd') as HTMLInputElement;
      if (this.selectedPayingCmpValue == "failed") {
        this.payingCompanyCodeModelvalerror = true;
      }
      if (this.senReqKamSaleContMOdel == "") {
        this.senReqKamSaleContMOdelError = true;
      }
      if (this.senReqSamMOdel == "") {
        this.senReqSamMOdelError = true;
      } else {
        this.senReqSamMOdelError = false;
      }
      if (this.selectedSendRequest == '') {
        this.sendRequestError = true;
      }
      if (this.checkArray.length > ZERO) {
        this.senReqSiteModelError = false;
      } else {
        this.senReqSiteModelError = true;
      }
      if (this.addSiteDataArray.length > ZERO) {
        this.senReqAddSiteModelError = false;
      } else {
        this.senReqAddSiteModelError = true;
      }
      if (this.RowupArray1.length > ZERO) {
        this.senReqUpdatePayingModelError = false;
      } else {
        this.senReqUpdatePayingModelError = true;
      }
  }
  sendRequestSupplier3(shouldSendMail, folio, reqType = '') {
    if (shouldSendMail) {
      this.sendSupplierCompletionMail(folio);
    }
    this.completeSupplierRequest(reqType);
  }
  private sendSupplierCompletionMail(folio): void {
      if (this.accHomoRequestSelected) {
        console.info("send Mail");
        const sendMailTo = this.PersonDetails[`${this.senReqKamSaleContMOdel}_email`];
        const desc = this.senReqNotesMOdel;
        const baseUrl1 = baseUrl
        let okta
        if(baseUrl1 == opeUrl || baseUrl1 == opewafUrl || baseUrl1 == opeNewwafUrl){
          okta = OktaProd;
        }else{
          okta = OktaUat;
        }
        const specificLink = `${baseUrl1}/view-supplier/${this.viewSupplier}`;
        const mailSubject = "ISA access for your referencement in the Renault Group";
        this.mailBodyContent =
          `<p>Dear Supplier,</p><p>A Renault buyer has identified your company and would like to invite you to register in order to establish a business relationship with the Renault Group.</p><p>To complete your registration, please follow the three steps below.</p><p><strong>Step 1 &#8211; Create your OKTA account</strong></p><p>If you do not yet have an IPN, create your OKTA account using your email address (<em>${sendMailTo}</em>) via this link: <a href='${okta}' target='_blank'>${okta}</a></p><p><strong>Step 2 &#8211; Log into ISA</strong></p><p>Once your account is created, log in to the ISA application (Interface for Supplier Administration): <a href='${baseUrl1}' target='_blank'>${baseUrl1}</a></p><p><strong>Step 3 &#8211; Complete your registration</strong></p><ol><li>In the <strong>Documents</strong> section, upload a blank invoice and your bank account details.</li><li>In the <strong>Sites</strong> section, assign the appropriate qualifiers to each of your locations.</li><li>Once all required information has been completed:<ul><li>Click <strong>&quot;Send to Buyer&quot;</strong> if you do not have an IPN; <strong>or</strong></li><li>Validate the workflow on the <strong>Company</strong> page if you already have an IPN.</li></ul></li></ol><p>This will submit your registration for review.</p><p><em>Buyer comment: ${desc}</em></p><p><strong>Need help?</strong> A user guide is available here: <a href='${guidecompanyLink}' target='_blank'>${guidecompanyLink}</a></p><p>For any question or assistance during this process, please contact: <a href='mailto:isa@renault.com'>isa@renault.com</a></p><p>Thank you in advance for your prompt attention to this request. We look forward to starting our collaboration.</p><p><strong>Best regards,</strong></p><p>Supplier Repository Team</p><p>Renault Group</p>`;
        this.sendMailFn(sendMailTo, mailSubject, this.mailBodyContent);
      } else {
        console.info("send Mail");
        const sendMailTo = this.PersonDetails[`${this.senReqKamSaleContMOdel}_email`];
        const desc = this.senReqNotesMOdel;
        const baseUrl1 = baseUrl
        const specificLink = baseUrl1;
        const mailSubject = folio;
        const onlineHelp = online
        this.mailBodyContent =
          `<p>Dear Supplier,</p><p> You have some information to update in Renault database.</p> <p>For that, please click on this link to get access to ISA (Interface for Supplier Administration) : <a href=${specificLink}>ISA</a>.</p> <p>${desc}</p> <p>For any help please contact <u>isa@renault.com</u></p><p><a href=${onlineHelp}>Online help</a></p><p>Regards,</p><p>Supplier repository team</p></body>`;
        this.sendMailFn(sendMailTo, mailSubject, this.mailBodyContent);
      }
  }
  private completeSupplierRequest(reqType): void {
    document.getElementById("closesendReqtoSupp1").click();
    console.info("person", this.PersonDetailsCompSent2Req);
    const isSiteWorkflowOnlyReqType = reqType === '2-Add Sites' || reqType === '3-Update Sites' || reqType === '1-New Supplier Referencing';
    const isCompanyWorkflowOnlyReqType = reqType === '4-Add Paying Company' || reqType === '5-Update bank details' || reqType === '1-New Supplier Referencing';

    if (isSiteWorkflowOnlyReqType) {
      this.updateSupplierRequestSiteWorkflow();
    }
    if (isCompanyWorkflowOnlyReqType) {
      this.updateSupplierRequestCompanyWorkflow();
    }
    this.updateSupplierRequestApprovals();
    this.createSupplierActivityNames();
    this.saveDatas = "Save";
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigateByUrl(`company-details/${this.companyID}`);
    document.getElementById("closeEditCatAuth").click();
    this.getactivity()
  }
  private updateSupplierRequestCompanyWorkflow(): void {
    const payload = { workflowStatus: this.updatedWorkflowStatus };
    this.supplierService.UpdateCompany(`${this.Config.ApiSupplierUrl}companies/${this.companyID}`, payload).subscribe(_data => { });
  }
  private updateSupplierRequestSiteWorkflow(): void {
    const payload = { workflowStatus: this.updatedWorkflowStatus };
    for (const element of this.SitesInfo) {
      if (element.site) {
        const siteId = element.site.href.split('/')[ONE];
        this.siteService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.Site_City_Country[siteId]['rowId']}`, payload).subscribe(_data => { });
      }
    }
  }
  private updateSupplierRequestPendingSites(): void {
    if (!this.accHomoRequestSelected) { return; }
    const payload = { activeStatus: 'PENDING' };
    for (const element of this.SitesInfo) {
      if (element.site) {
        const siteId = element.site.href.split('/')[ONE];
        this.siteService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.Site_City_Country[siteId]['rowId']}`, payload).subscribe(_data => { });
      }
    }
  }
  private updateSupplierRequestApprovals(): void {
    if (this.siteUpdatePayingComp) {
      const payload = { approvalModificationStatus: 'PENDING_VALIDATION', statusId: this.arrApprovalStatus['To be validated'] };
      for (const element of this.RowupArray1) {
        this.supplierService.updateCompanyApprovals(`${this.Config.ApiSupplierUrl}company-approvals/${element}`, payload).subscribe((_data: any) => { });
      }
      return;
    }
    this.supplierService.getApprovalScopes(`${this.Config.ApiSupplierUrl}approval-scopes`).subscribe((_data: any) => this.checkPayingCompanyStatus());
  }
  private createSupplierActivityNames(): void {
    const activities = [
      ['After Sales only', 'B#AFTER-SALES-ONLY'],
      ['Materials', 'B#MATERIALS'],
      ['Transport', 'B#TRANSPORT'],
      ['Prototype', 'C#PROTOTYPE']
    ];
    for (const [category, value] of activities) {
      if (this.categoryValues.includes(category)) {
      const payload = {
        companyNameTypeName: 'SUPPLIER ACTIVITY',
        startDate: this.commonService.getTodayDate(),
        endDate: '',
        companyId: this.companyID,
        companyNameTypeId: this.cpyShortNameTypes['SUPPLIER ACTIVITY'],
        value,
        companyAllianceIdentifier: this.companyAllianceIdentifier
      };
      this.supplierService.CreateCompanyNames(`${this.Config.ApiSupplierUrl}company-names`, payload).subscribe((_data: any) => this.getactivity());
      }
    }
  }
  /**END K2 api for send request to supplier */
  sendToNewApprover(data, newowner) {
    const destination = newowner.split('  -  ');
    const letters = ['f', 'F']
    let originalWorkflowOwner = data['workflowOwnerWithRole']?.[ZERO] ?? '';
    if (data['workflowOwnerWithRole']?.[ZERO]) {
      const parts = data['workflowOwnerWithRole'][ZERO].split(' - ');
      if (parts.length > ONE) {
        originalWorkflowOwner = parts[parts.length - ONE].trim();
      }
    }
    const originalDomain = letters.some(letter => originalWorkflowOwner.includes(letter)) ? "EXTALLIANCEIT" : "CORP";
    const destinationDomain = letters.some(letter => destination[ZERO].includes(letter)) ? "EXTALLIANCEIT" : "CORP";
    const newData = ''
    console.info('data', newData);
    this.k2Service.createK2Isa(`${this.Config.ApiK2Url}redirect-tasks?taskID=${data['taskID']}&destinationDN=${destination[ZERO]}%20on-behalf-of%20${originalWorkflowOwner}&originalIpn=${originalWorkflowOwner}&destinationIpn=${destination[ZERO]}&originalDomain=${originalDomain}&destinationDomain=${destinationDomain}`, newData).subscribe(_data1 => {
      console.info("send Mail");
      const sendMailTo = this.sendMailToApprover
      const desc = this.senReqNotesMOdel;
      const baseUrl1 = baseUrl
      const specificLink = `${baseUrl1}/company-details/${this.companyID}#workflows`;
      const mailSubject = `Approval request for ${this.companyBasicInfo['legalName']}`;
      const onlineHelp = online
      this.mailBodyContent =
        `<p>Dear ${destination[ONE]} ${destination[TWO]},</p><p> You have been designed as new approver of the request ${data['folio']}</p> <p>For that, please click on this link to get access to ISA (Interface for Supplier Administration) : <a href=${specificLink}>ISA</a>.</p><p>Notes from the Admin Team:</p> <p>${desc}</p> <p>For any help please contact <u>isa@renault.com</u></p><p><a href=${onlineHelp}>Online help</a></p><p>Regards,</p><p>Supplier repository team</p></body>`;
      this.sendMailFn(sendMailTo, mailSubject, this.mailBodyContent, true);
    })
  }
  checkPayingCompanyStatus() {
    const matchingApprovals = this.PayingInfo.filter(e => e.clientCompanyCode == this.selectedPayingCmpValue);
    const occurrence = matchingApprovals.length;
    const activeApproval = matchingApprovals.find(e => ['archived', 'active', 'validated'].includes(e.approvalModificationStatus.toLowerCase()));
    const rowId = activeApproval?.row_id || '';
    console.info('incheck', this.PayingInfo);
    const deleteRowIds = matchingApprovals.map(e => e.row_id);
    console.info('occureneces', occurrence);
    console.info('isActiveOrArchived', Boolean(activeApproval), rowId);
    console.info('deleteRowIds', deleteRowIds);
    this.deleteDuplicateApprovals(occurrence, deleteRowIds);
    if (occurrence == ZERO || occurrence > ONE) {
      this.createPendingApproval();
    }
    if (occurrence == ONE && activeApproval && rowId != '') {
      const datas = { approvalModificationStatus: 'PENDING_VALIDATION', statusId: this.arrApprovalStatus['To be validated'] };
      this.supplierService.updateCompanyApprovals(`${this.Config.ApiSupplierUrl}company-approvals/${rowId}`, datas).subscribe((_data: any) => {
        this.finishPayingCompanyStatus();
      });
    } else if (occurrence == ONE && !activeApproval) {
      this.finishPayingCompanyStatus();
    } else {
    }
  }
  private deleteDuplicateApprovals(occurrence: number, rowIds: any[]): void {
    if (occurrence <= ONE) {
      return;
    }
    for (const rowId of rowIds) {
      this.supplierService.deleteCompanyApprovals(`${this.Config.ApiSupplierUrl}company-approvals/${rowId}`).subscribe((_data: any) => { });
    }
  }
  private createPendingApproval(): void {
    this.supplierService.getApprovalScopes(`${this.Config.ApiSupplierUrl}approval-scopes`).subscribe((data: any) => {
      const scope = data['approval-scopes'].find(element => element.code.toLowerCase() == "in panel");
      const datas = { scopeId: scope?.row_id || "", clientCompanyId: this.payingCompanyCodeids1[this.selectedPayingCmpValue], companiesId: this.companyID, approvalModificationStatus: 'PENDING_VALIDATION', statusId: this.arrApprovalStatus['To be validated'], type: 'COMPANY', validityStartDate: this.commonService.getTodayDate() };
      this.supplierService.createCompanyApprovals(`${this.Config.ApiSupplierUrl}company-approvals`, datas).subscribe((_data: any) => this.finishPayingCompanyStatus());
    });
  }
  private finishPayingCompanyStatus(): void {
    this.getPayingDetails("No");
    document.getElementById("closePCBtn").click();
    this.saveDatas = "Save";
  }
  SuppRoleChange(event: any) {
    this.senReqKamSaleContMOdel = event.value;
    if (this.senReqKamSaleContMOdel != undefined && this.senReqKamSaleContMOdel != "") {
      this["senReqKamSaleContMOdelError"] = false;
    }
  }
  /************************* SEND REQUEST TO SUPPLIER END **********************************/
  /*START DISP BVD ID FUNCTION*/
  loadBvdIdCpy(_d, chk = 'new') {
    this.bvdIdData = [];
    this.bvdIdValExists = false;
    this.SiteDispLoading = true;
    this.inPortfolioLoading = false;
    this.SitesInfo = [];
    this.showDelBtnForNoSite = true;
    this.disableSetAsHQ = false;
    this.getBeFn(chk);
    this.SiteDe_BvdID_Stat = [];
  }
  getBeFn(check, page = ONE, subscribeDataIsHQ = [], subscribeDataNoHq = []) {
    this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=${this.companyID}&_page=${page}`).subscribe(data => {
      if (data['business-entities'].length <= ZERO) { this.SitesFlag = true; this.SiteDispLoading = false; return; }
      for (const e of data['business-entities']) {
        if (e.isHQ == 'Y') { subscribeDataIsHQ.push(e); }
        else if (e.isHQ == 'N') { subscribeDataNoHq.push(e); }
      }
      if (data['maxPage'] > ONE && data['maxPage'] != page) {
        this.getBeFn(check, page + ONE, subscribeDataIsHQ, subscribeDataNoHq);
      } else if (data['maxPage'] == page) {
        setTimeout(function () { if (check == 'new') { this.getSiteDetails(); } }.bind(this), ONE_THOUSAND);
        this.sortGetDataIsHQ(subscribeDataIsHQ);
        this.sortGetDataNoHQ(subscribeDataNoHq, check);
      } else {
      }
    });
  }
  sortGetDataIsHQ(subscribeDataIsHQ) {
    this.BPNLValue = ''
    this.DUNSValue = ''
    if (subscribeDataIsHQ.length == ONE) {
      const archiveBvdId = '';
      const archiveBvdIdval = '';
      const archiveDunsId = '';
      const archiveDunsIdval = '';
      const archiveBpnId = '';
      const archiveBpnIdval = '';
      const notArchivedBvd = false;
      const notArchivedDuns = false;
      const notArchivedBpn = false;
      this.noHqExists = 'one';
      this.noSiteAssn = false;
      this.siteBusinessEntityHQ = subscribeDataIsHQ[ZERO]['row_id'];
      this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=${subscribeDataIsHQ[ZERO]['row_id']}`).subscribe(data1 => this.handleHQIdentifiersResponse(data1));
    } else if (subscribeDataIsHQ.length > ONE) {
      this.bvdFatalError = true;
      this.noHqExists = 'multiple';
      this.requestButton = true
    } else {
      this.bvdFatalError = true;
      this.noHqExists = 'no';
      this.noSiteAssn = true;
      this.requestButton = true
    }
  }
  private handleHQIdentifiersResponse(data: any): void {
    const identifiers = data['business-entity-identifiers'];
    if (identifiers.length == ZERO) {
      this.requestButton = true;
      return;
    }
    const state = { archiveBvdId: '', archiveBvdIdval: '', archiveDunsId: '', archiveDunsIdval: '', archiveBpnId: '', archiveBpnIdval: '', notArchivedBvd: false, notArchivedDuns: false, notArchivedBpn: false };
    identifiers.forEach(identifier => identifier.endDate == '' ? this.processActiveHQIdentifier(identifier, state) : this.processArchivedHQIdentifier(identifier, state));
    this.finishHQIdentifierProcessing(state);
  }
  private processActiveHQIdentifier(identifier: any, state: any): void {
    identifier['showRow'] = false;
    identifier['toggleRow'] = true;
    if (this.SitesInfo.length == ZERO) {
      this.SitesInfo.push(identifier);
      this.bvdIdRowIdForDuplicate = identifier.businessEntityId;
    }
    const type = identifier.businessEntityIdentifierTypeName;
    if (type == 'BVD ID') { this.applyActiveBvdIdentifier(identifier, state); }
    if (type == 'DUNS') { this.applyActiveDunsIdentifier(identifier, state); }
    if (type == 'BPN-L') { this.applyActiveBpnIdentifier(identifier, state); }
    if (type == 'BPN-REQUEST-DATE') { this.applyBpnRequestDate(identifier); }
    if (type == 'ORBIS-STATUS') { this.applyOrbisStatus(identifier); }
  }
  private applyActiveBvdIdentifier(identifier: any, state: any): void {
    this.showArchivedBvdId = false;
    this.SiteDe_BvdID_Stat[identifier.businessEntityId] ||= [];
    this.SiteDe_BvdID_Stat[identifier.businessEntityId]['value'] = identifier.value;
    this.bvdIdValExists = true;
    this.tempBvdId = identifier.row_id;
    state.notArchivedBvd = true;
    this.sitebvidid = identifier.value;
  }
  private applyActiveDunsIdentifier(identifier: any, state: any): void {
    this.showArchivedDUNSId = false;
    this.DUNSValue = identifier.value;
    this.tempDuns = identifier.row_id;
    state.notArchivedDuns = true;
  }
  private applyActiveBpnIdentifier(identifier: any, state: any): void {
    this.showArchivedBPNId = false;
    this.BPNLValue = identifier.value;
    this.tempBpn = identifier.row_id;
    state.notArchivedBpn = true;
  }
  private applyBpnRequestDate(identifier: any): void {
    this.BpnDate = identifier.value;
    this.requested = 'yes';
    if (this.BPNLValue == '') {
      const previous = this.commonService.getTwoDaysAoDate().split('-').map(Number);
      const today = this.commonService.getTodayDate().split('-').map(Number);
      const date = identifier.value.split('-').map(Number);
      const dateTwoDaysAgo = new Date(previous[ZERO], previous[ONE] - ONE, previous[TWO]);
      const dateToday = new Date(today[ZERO], today[ONE] - ONE, today[TWO]);
      const dateSpecific = new Date(date[ZERO], date[ONE] - ONE, date[TWO]);
      this.retriveButton = dateSpecific <= dateTwoDaysAgo;
      this.requestButton = dateSpecific < dateTwoDaysAgo || dateSpecific > dateToday;
    }
  }
  private applyOrbisStatus(identifier: any): void {
    if (!this.latestOrbisStatus || new Date(identifier.startDate) > new Date(this.latestOrbisStatus.startDate)) {
      const value = identifier.value;
      const isNegativeStatus = value.startsWith('In liquidation') || value.startsWith('Dissolved') || value.startsWith('Bankruptcy');
      const color = value === 'Active' ? '#5CBA63' : isNegativeStatus ? '#CB4B32' : '#FFBD69';
      this.latestOrbisStatus = { value, startDate: identifier.startDate, color };
      this.entityId.push(identifier.businessEntityId);
    }
  }
  private processArchivedHQIdentifier(identifier: any, state: any): void {
    if (identifier.businessEntityIdentifierTypeName == 'BVD ID') {
      state.archiveBvdId = identifier.row_id;
      state.archiveBvdIdval = identifier.value;
    } else if (identifier.businessEntityIdentifierTypeName == 'DUNS') {
      state.archiveDunsId = identifier.row_id;
      state.archiveDunsIdval = identifier.value;
    } else if (identifier.businessEntityIdentifierTypeName == 'BPN-L') {
      state.archiveBpnId = identifier.row_id;
      state.archiveBpnIdval = identifier.value;
    } else {
    }
  }
  private finishHQIdentifierProcessing(state: any): void {
    this.requestButton = this.BPNLValue === '' && this.BpnDate === '';
    this.getInPortfolioDetails();
    if (!state.notArchivedBvd) { this.showArchivedBvdId = true; this.tempBvdId = state.archiveBvdId; this.sitebvidid = state.archiveBvdIdval; }
    if (!state.notArchivedDuns) { this.showArchivedDUNSId = true; this.tempDuns = state.archiveDunsId; this.DUNSValue = state.archiveDunsIdval; }
    if (!state.notArchivedBpn) { this.showArchivedBPNId = true; this.tempBpn = state.archiveBpnId; this.BPNLValue = state.archiveBpnIdval; }
  }
  sortGetDataNoHQ(subscribeDataNoHq, check, page = ONE) {
    const forIS = subscribeDataNoHq.map((e: any) => e['row_id']);
    if (forIS.length <= ZERO) { return; }
    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=in(${forIS})&businessEntityIdentifierTypeName=BVD ID&_page=${page}`)
      .subscribe(data3 => {
        if (data3['business-entity-identifiers'].length > ZERO) {
          this.applyNoHqIdentifiers(data3['business-entity-identifiers']);
          if (data3['maxPage'] > ONE && data3['maxPage'] != page) {
            this.sortGetDataNoHQ(subscribeDataNoHq, check, page + ONE);
          } else if (check != 'new') {
            this.SiteDispLoading = false; this.SitesFlag = true; this.setPageForSitesSec(ONE);
          }
        } else if (check != 'new') {
          this.SiteDispLoading = false; this.SitesFlag = true; this.setPageForSitesSec(ONE);
        } else {
        }
      });
  }
  private applyNoHqIdentifiers(identifiers: any[]): void {
    for (const ele of identifiers) {
      if (ele.endDate === '') {
        ele['showRow'] = false;
        ele['toggleRow'] = true;
        this.SitesInfo.push(ele);
        if (this.SiteDe_BvdID_Stat[ele.businessEntityId] == undefined) { this.SiteDe_BvdID_Stat[ele.businessEntityId] = []; }
        this.SiteDe_BvdID_Stat[ele.businessEntityId]['value'] = ele.value;
        this.SiteDe_BvdID_Stat[ele.businessEntityId]['row_id'] = ele.row_id;
      }
    }
  }
  editBvdId(rowId, id) {
    this.EditBvdIdModel = id;
    this.EditBvdIdValueError = false;
    this.saveDatas = 'Save';
    this.bvdIdObj = {};
    this.bvdIdObj = { rowId, id };
  }
  resetBvdId() {
    console.info('resetBvdIdValue')
  }
  saveNewBvdIdValue() {
    if (this.NewCmpAlliasValue != '' && this.NewCmpAlliasValue != undefined && !this.bvdFatalError) {
      this.aliasTextDisp = 'Saving...'
      this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=${this.companyID}&isHQ=Y`).subscribe(data0 => {
        document.getElementById('closeAddCmpAlias').click();
        document.getElementById('closeAliasEditModal').click();
        if (data0['business-entities'].length == ONE) {
          const const1 = {
            businessEntityId: data0['business-entities'][ZERO]['row_id'],
            startDate: this.commonService.getTodayDate(),
            businessEntityIdentifierTypeId: '1',
            value: this.NewCmpAlliasValue
          }
          this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`, const1).subscribe(_data1 => {
            this.loadBvdIdCpy(this.tempBvdId, 'reload');
          });
        }
      });
    } else {
      this.aliasTextDisp = "This data is not exact, impossible to create a BVD ID. Please contact Support team.";
      document.getElementById('closeAddCmpAlias').click();
    }
  }
  EditSaveBvdIdVal(ctrl) {
    this.saveDatas = 'Saving...'
    const tempRow = this.bvdIdObj['rowId'];
    const val = this.EditBvdIdModel;
    if (ctrl == 'edit') {
      if (tempRow != '' && tempRow != undefined && val.trim() != '' && val != undefined) {
        const const2 = { 'value': val }
        this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${tempRow}`, const2).subscribe(_data3 => {
          this.loadBvdIdCpy(this.tempBvdId, 'reload');
          document.getElementById('closeBvdId').click();
          this.saveDatas = 'Save';
        });
      }
    } else if (ctrl == 'archive') {
      if (tempRow != '' && tempRow != undefined) {
        const const8 = { 'endDate': this.commonService.getTodayDate() }
        this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${tempRow}`, const8).subscribe(_data9 => {
          this.loadBvdIdCpy(this.tempBvdId, 'reload');
          document.getElementById('closeBvdId').click();
          document.getElementById('closeCnfArchiveBvdId').click();
          this.saveDatas = 'Save';
        });
      }
    } else {
    }
  }
  /*END DISP BVD ID FUNCTION*/
  /**Set site as HQ start */
  setSiteHQ(page = ONE, businessEntityId = '') {
    if (this.selectedSiteAsHQ == '' || this.selectedSiteAsHQ == undefined) { return; }
    this.disableSetAsHQ = true;
    this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=${this.companyID}&_page=${page}`).subscribe(data => {
      if (data['business-entities'].length <= ZERO) { this.disableSetAsHQ = false; console.info('nothing'); return; }
      this.applyHqAssignment(data, page);
    });
  }
  private applyHqAssignment(data: any, page: number): void {
    for (let h = ZERO; h < data['business-entities'].length; h++) {
      const entity = data['business-entities'][h];
      if (entity['isHQ'] == 'Y' && entity['row_id'] != this.selectedSiteAsHQ) {
        this.supplierService.updateBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities/${entity['row_id']}`, { 'isHQ': 'N' }).subscribe(_data1 => { });
      }
      if (entity['row_id'] == this.selectedSiteAsHQ) {
        this.supplierService.updateBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities/${this.selectedSiteAsHQ}`, { 'isHQ': 'Y' }).subscribe(_data2 => {
          this.SiteDispLoading = true;
          this.SitesFlag = false;
          this.siteBusinessEntityHQ = this.selectedSiteAsHQ;
          this.selectedSiteAsHQ = '';
          if (data['maxPage'] == page) { this.loadBvdIdCpy('reload'); }
        });
      }
    }
    if (data['maxPage'] > ONE && data['maxPage'] != page) { this.setSiteHQ(page + ONE); }
  }
  /**End set site as HQ */
  /**START show paying cpy database */
  archivePayingCpyId(_id) {
    // intentional noop
  }
  /**END show paying cpy database */
  resetInput(id) {
    if (id == this.selectedSiteAsHQ) {
      this.selectedSiteAsHQ = '';
    }
  }
  SwitchToGtop(infoM) {
    const conm = infoM == 'GTOP' ? this.aliasAccToRowId['mdm'] : this.aliasAccToRowId['gtop'];
    const datas9 = {
      'companyIdentifierTypeId': conm
    };
    this.supplierService.updateCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers/${this.EditAliasObj.AliasKey}`, datas9).subscribe(_data => {
      this.CompanyIdnentifiers('', ONE, 'no');
      document.getElementById('closeEditCmpAlias').click();
    })
  }
  hideEnv() {
    const c = this.commonService.getEnvSpecific();
    if (c == 'ope') {
      this.prodHide = true;
    } else { this.prodHide = false };
  }
  PasteSam(ipn, firstName, lastName, mail) {
    this.sendMailToApprover = mail;
    if (this.arcasearchModel == 'sam') {
      this.senReqSamMOdel = `${ipn}  -  ${firstName}  -  ${lastName}`;
      this.senReqSamMOdelError = false;
    }
    if (this.arcasearchModel == 'buyeraasis') {
      this.senReqBuyerAssiMOdel = `${ipn}  -  ${firstName}  -  ${lastName}`;
      this.buyerNameSelected = `${firstName} ${lastName}`;
    }
    document.getElementById("closeGCBtn").click();
  }
  lookupArca(model) {
    this.arcasearchModel = model;
    this.resetArca = false;
    this.ArcIpn = "";
    this.ArcFirstName = "";
    this.ArcLastName = "";
    this.arcaSrchWait = false;
    if (model == 'sam') {
      this.showUidDisable = false;
    } else {
      this.showUidDisable = true;
    }
  }
  lookupCompany(model) {
    this.companysearchModel = model;
    this.senReqPayCompcodeMOdel = '';
    this.senReqPayCompMOdel = '';
    this.resetComp = false;
    this.pComp_Code = "";
    this.pComp_Name = "";
    this.compSrchWait = false;
  }
  companySearch() {
    // intentional noop
  }
  ArcSearch() {
    const filter = this.getArcaSearchFilter();
    const hasBothNames = this.ArcFirstName != '' && this.ArcLastName != '';
    if (filter && hasBothNames) {
      this.searchArcaByBothNames(filter);
    } else if (filter) {
      this.searchArcaByName(filter);
    } else if (this.ArcIpn != '') {
      this.searchArcaByIpn();
    } else {
      console.info("Please fill anyone to search");
    }
  }
  private getArcaSearchFilter(): string {
    if (this.ArcFirstName != '' && this.ArcLastName == '') { return `contains(FirstName,'${this.ArcFirstName}') `; }
    if (this.ArcFirstName == '' && this.ArcLastName != '') { return `contains(LastName,'${this.ArcLastName}') `; }
    if (this.ArcFirstName != '' && this.ArcLastName != '') { return `contains(FirstName,'${this.ArcFirstName}') `; }
    return '';
  }
  private prepareArcaSearch(): void {
    this.arcaSrchnoresults = false;
    this.arcaSrchWait = true;
    this.isaRoleFor_Uid = [];
  }
  private applyArcaRole(uid: string): void {
    if (!this.showUidDisable && !this.isEnvQua && !this.isEnvInt) {
      this.getArcaUserIsaRole(uid);
    } else if (this.isEnvQua || this.isEnvInt) {
      this.isaRoleFor_Uid[uid] = 'manager';
    } else {
    }
  }
  private handleArcaSearchError(): void {
    this.data = [];
    this.resetArca = false;
    this.arcaSrchWait = false;
    this.arcaSrchnoresults = true;
  }
  private searchArcaByName(filter: string): void {
    this.prepareArcaSearch();
    this.arcaServices.getPerson(`${this.Config.ApiArcaURL}Person?$filter=${filter}&$select=Uid,CommonName,FirstName,LastName,Mail,PersonSuperDomainCode&$top=10`).subscribe(
      data => this.handleArcaNameResponse(data),
      () => this.handleArcaSearchError());
  }
  private handleArcaNameResponse(data: any): void {
    const values = data?.['value'] || [];
    if (values.length > ZERO && (this.arcasearchModel == 'sam' || this.arcasearchModel == 'buyeraasis')) {
      const results = values.map(entry => {
        console.info('Adding user to results:', entry.Uid);
        this.applyArcaRole(entry.Uid);
        return entry;
      });
      this.data = results;
    } else if (values.length > ZERO) {
      this.data = values;
    } else {
    }
    this.resetArca = values.length > ZERO;
    this.arcaSrchWait = false;
    this.arcaSrchnoresults = false;
  }
  private searchArcaByBothNames(filter: string): void {
    this.prepareArcaSearch();
    this.arcaServices.getPerson(`${this.Config.ApiArcaURL}Person?$filter=${filter}&$select=Uid,CommonName,FirstName,LastName,Mail,PersonSuperDomainCode`).subscribe(
      data => this.handleArcaBothNamesResponse(data),
      () => this.handleArcaSearchError());
  }
  private handleArcaBothNamesResponse(data: any): void {
    const values = data?.['value'] || [];
    if (values.length <= ZERO) {
      this.resetArca = false;
      return;
    }
    if (this.arcasearchModel != 'sam' && this.arcasearchModel != 'buyeraasis') {
      this.data = values;
      return;
    }
    const results = values.filter(entry => entry.LastName?.toLowerCase().includes(this.ArcLastName.toLowerCase()));
    results.forEach(entry => this.applyArcaRole(entry.Uid));
    if (results.length > ZERO) {
      this.data = results;
      this.resetArca = true;
      this.arcaSrchWait = false;
      this.arcaSrchnoresults = false;
    } else {
      this.seacrhLastname();
    }
  }
  private searchArcaByIpn(): void {
    this.arcaServices.getPerson(`${this.Config.ApiArcaURL}Person('${this.ArcIpn}')`).subscribe((data: any) => this.handleArcaIpnResponse(data));
  }
  private handleArcaIpnResponse(data: any): void {
    if (data == null) {
      this.resetArca = false;
      return;
    }
    if (this.arcasearchModel == 'sam' || this.arcasearchModel == 'buyeraasis') {
      if (data.Uid?.toLowerCase().includes(this.ArcIpn.toLowerCase())) {
        this.applyArcaRole(data.Uid);
        this.data = [data];
        this.resetArca = true;
        this.arcaSrchWait = false;
        this.arcaSrchnoresults = false;
        return;
      }
    }
    this.data.push(data);
  }
  seacrhLastname() {
    this.arcaServices.getPerson(`${this.Config.ApiArcaURL}Person?$filter=contains(LastName,'${this.ArcLastName}') &$select=Uid,CommonName,FirstName,LastName,Mail,PersonSuperDomainCode`).subscribe(data => this.handleLastNameSearchResponse(data),
      _err => {
        this.data = [];
        this.resetArca = false;
        this.arcaSrchWait = false;
        this.arcaSrchnoresults = true;
      });
  }
  private handleLastNameSearchResponse(data: any): void {
    console.info(data);
    const values = data?.['value'];
    if (!values || values.length == ZERO) {
      this.resetArca = false;
      return;
    }
    if (this.arcasearchModel != 'sam' && this.arcasearchModel != 'buyeraasis') {
      this.data = values;
      return;
    }
    const domains = ['renault', 'nna', 'ne', 'nml'];
    const results = values.filter(entry => domains.includes(entry.PersonSuperDomainCode) && (this.ArcFirstName == '' || entry.FirstName?.toLowerCase().includes(this.ArcFirstName.toLowerCase())));
    results.forEach(entry => this.applyArcaRole(entry.Uid));
    console.info("sam_arr", results);
    this.data = results;
    this.resetArca = results.length > ZERO;
    this.arcaSrchnoresults = results.length == ZERO;
    this.arcaSrchWait = false;
  }
  ArcNameModelChange() {
    this.data = [];
    this.resetArca = false;
    this.arcaSrchWait = false;
    this.arcaSrchnoresults = false;
  }
  getArcaUserIsaRole(ipn) {
    if (!ipn) { return; }
    this.arcaServices.getrole(`${this.Config.ApiArcaURL}Role?$filter=(ApplicationDomain eq 'FRA') and (ApplicationId eq 'ISA') and (Uid eq '${ipn}')`).subscribe(data => {
      if (data?.['value']) {
        for (const e of data['value']) { this.isaRoleFor_Uid[ipn] = e.CommonName.toLowerCase(); }
      }
      console.info('roles in isa', this.isaRoleFor_Uid);
    }, error => {
      if (error.status == FOUR_HUNDRED_FOUR) { this.isaRoleFor_Uid[ipn] = 'norole'; }
    });
  }
  onRadioItemChange(value) {
    console.info(value);
  }
  resetArcaSearch(val) {
    if (val == "ArcIpn") {
      this.ArcIpn = '';
    } else if (val == "ArcFirstName") {
      this.ArcFirstName = '';
    } else if (val == "ArcLastName") {
      this.ArcLastName = '';
    } else {
    }
  }
  getSiteIdenTypes(page = ONE, subscribeData = []) {
    this.siteService.getIdentifierTypes(`${this.Config.ApiSitesUrl}identifier-types?_page=${page}`).subscribe(data => {
      if (data['identifier-types'].length <= ZERO) { return; }
      for (const ele of data['identifier-types']) { subscribeData.push(ele); }
      if (data['maxPage'] > ONE && data['maxPage'] != page) { this.getSiteIdenTypes(page + ONE, subscribeData); return; }
      if (data['maxPage'] == page) {
        for (const ele of subscribeData) { this.siteIdenTypeDetails[ele.name] = ele.rowId; }
      }
    });
  }
  getCpyShortNameTypes(page = ONE) {
    this.supplierService.getCompanyNameTypes(`${this.Config.ApiSupplierUrl}company-name-types?_page=${page}`).subscribe(data => {
      for (const ele of data['company-name-types']) {
        this.cpyShortNameTypes[ele.name] = ele.row_id;
      }
      if (data['maxPage'] > ONE && data['maxPage'] != page) {
        this.getCpyShortNameTypes(page + ONE);
      }
    });
  }
  /**START look for sites */
  lookForSites() {
    this.lookForSiteLoading = true;
    this.gotAlcorRealLookData = false;
    this.realEstateAlcorData = [];
    this.selectedInputValLook = [];
    this.lookForSitesLinkIdArr = [];
    this.realEstateNewData = [];
    this.siteAssignmentData = [];
    this.noLookForSiteData = false;
    this.disableBtnInitiateLinkLook = false;
    this.siteRowsOnAlcorVals = [];
    this.alcorValSiteIds = [];
    this.alcorAssignmentAval = [];
    this.showReloadBtnLook = true;
    const alcorValAvaliable = [];
    const siteRowIds = [];
    this.progressForInitiateLink = ZERO;
    this.counterForReloadButton = ZERO;
    this.lookForSitesAssignRows = [];
    if (this.alcorValueWithApos.length > ZERO) {
      this.getRealEstateIdensLookForSites();
    } else {
      this.lookForSiteLoading = false;
    }
    console.info(this.realEstateAlcorData);
    console.info(this.realEstateNewData);
  }
  getRealEstateIdensLookForSites(page = ONE, subscribeData = []) {
    this.siteService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?businessIdentifierValue=in(${this.alcorValueWithApos})&_page=${page}`).subscribe(
      data => this.handleRealEstateIdentifiersResponse(data, page, subscribeData));
  }
  private handleRealEstateIdentifiersResponse(data: any, page: number, subscribeData: any[]): void {
    const identifiers = data['real-estate-asset-identifiers'];
    if (identifiers.length == ZERO) {
      this.noLookForSiteData = true;
      this.lookForSiteLoading = false;
      return;
    }
    subscribeData.push(...identifiers);
    if (data['maxPage'] > ONE && data['maxPage'] != page) {
      this.getRealEstateIdensLookForSites(page + ONE, subscribeData);
    } else if (data['maxPage'] == page) {
      this.prepareRealEstateLookData(subscribeData);
    } else {
    }
  }
  private prepareRealEstateLookData(identifiers: any[]): void {
    const availableValues = [];
    const siteRowIds = [];
    this.gotAlcorRealLookData = true;
    identifiers.forEach((element, index) => this.processRealEstateLookIdentifier(element, index, availableValues, siteRowIds));
    this.getSiteAssignmentsForRealEstate(ONE, siteRowIds, availableValues);
    this.groupRealEstateLookData(availableValues);
  }
  private processRealEstateLookIdentifier(element: any, id: number, availableValues: any[], siteRowIds: any[]): void {
    const value = element.businessIdentifierValue;
    if (availableValues.indexOf(value) == NEGATIVE_ONE) { availableValues.push(value); }
    const siteRow = `'SupSiteService:${element.realEstateAssetId}'`;
    if (siteRowIds.indexOf(siteRow) == NEGATIVE_ONE) { siteRowIds.push(siteRow); }
    this.siteRowsOnAlcorVals[value] ||= [];
    this.siteIdentifierOnAlcor[value] ||= [];
    this.siteIdentifierOnAlcor[element.realEstateAssetId] = element.realEstateAssetIdentifier;
    this.siteRowsOnAlcorVals[value].push(element.realEstateAssetId);
    this.realEstateAlcorData[value] ||= [];
    this.alcorValSiteIds[value] ||= [];
    this.alcorValSiteIds[value].push(element.realEstateAssetId);
    this.assignRealEstateLookLink(element, id);
    this.realEstateAlcorData[value].push(element);
  }
  private assignRealEstateLookLink(element: any, id: number): void {
    const entries = this.realEstateAlcorData[element.businessIdentifierValue];
    if (entries.length == ZERO) {
      entries['inputCount'] = ONE;
      element['linkId'] = id;
      element['showInput'] = true;
      return;
    }
    let unmatched = true;
    entries.forEach(entry => {
      const matches = entry['businessIdentifierName'] == element.businessIdentifierName && entry['effectiveDate'] == element.effectiveDate && entry['endDate'] == element.endDate && unmatched;
      if (matches) {
        element['linkId'] = entry['linkId'];
        element['showInput'] = false;
        unmatched = false;
      } else if (unmatched) {
        element['linkId'] = id;
        element['showInput'] = true;
        entries['inputCount'] = entries['inputCount'] + ONE;
      } else {
      }
    });
  }
  private groupRealEstateLookData(values: any[]): void {
    values.forEach(value => {
      if (this.realEstateAlcorData[value].length == ZERO) { return; }
      this.realEstateAlcorData[value].forEach(element => {
        this.realEstateNewData[value] ||= [];
        this.realEstateNewData[value][element.linkId] ||= [];
        this.realEstateNewData[value][element.linkId].push(element);
        if (this.lookForSitesLinkIdArr.indexOf(element.linkId) == NEGATIVE_ONE) { this.lookForSitesLinkIdArr.push(element.linkId); }
      });
    });
  }
  showUpdateBtnLookForSites(alcorValue, inputValue, objVal, _linkIdVal) {
    const splitVal = inputValue.split('&&');
    this.selectedInputValLook[alcorValue] = objVal;
    for (const element of this.realEstateAlcorData[alcorValue]) {
      if ((element.showInput)
        && (element.businessIdentifierName != splitVal[ONE]
          || element.effectiveDate != splitVal[TWO]
          || element.endDate != splitVal[THREE])) {
        element['showBtnUpdate'] = true;
      } else {
        element['showBtnUpdate'] = false;
      }
    }
  }
  updateAlcorAsRaft(alcorVal, _objValue, _valueSelect, linkIdVal) {
    if (this.selectedInputValLook[alcorVal]) {
      const constRaft = {
        businessIdentifierName: this.selectedInputValLook[alcorVal]['businessIdentifierName'],
        effectiveDate: this.selectedInputValLook[alcorVal]['effectiveDate'],
        endDate: this.selectedInputValLook[alcorVal]['endDate']
      }
      for (const [index, ele] of this.realEstateNewData[alcorVal][linkIdVal].entries()) {
        this.siteService.updateRealEstateAssetIdentifier(this.Config.ApiSitesUrl + REAL_ESTATE_ASSET_IDENTIFIERS_PATH + ele.rowId, constRaft).subscribe(_data => {
          if (index == this.realEstateNewData[alcorVal][linkIdVal].length - ONE) {
            this.lookForSites();
          }
        });
      }
    }
  }
  getSiteAssignmentsForRealEstate(page = ONE, rowIds, alcorVals) {
    if (rowIds.length > ZERO) {
      let splitrowids: any[];
      let morethan20rec = false;
      let remainingRows = [];
      if (rowIds.length > TWENTY) {
        splitrowids = rowIds.slice(ZERO, TWENTY);
        remainingRows = rowIds.slice(TWENTY, rowIds.length);
        morethan20rec = true;
      } else {
        splitrowids = rowIds;
      }
      this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=in(${splitrowids})&_page=${page}`).subscribe(
        data => this.handleSiteAssignmentsResponse(data, page, rowIds, alcorVals, morethan20rec, remainingRows));
    } else {
      this.lookForSiteLoading = false;
    }
  }
  private handleSiteAssignmentsResponse(data: any, page: number, rowIds: any[], alcorVals: any[], morethan20rec: boolean, remainingRows: any[]): void {
    this.indexValidatedSiteAssignments(data['site-assignments']);
    if (data['maxPage'] > ONE && data['maxPage'] != page) {
      this.getSiteAssignmentsForRealEstate(page + ONE, rowIds, alcorVals);
    } else if (data['maxPage'] == page) {
      this.finishSiteAssignmentLookup(alcorVals, morethan20rec, remainingRows);
    } else {
    }
  }
  private indexValidatedSiteAssignments(assignments: any[]): void {
    assignments.forEach(element => {
      if (element.status != 'VALIDATED') { return; }
      const siteId = element.site.href.split('/')[ONE];
      this.siteAssignmentData[siteId] = element;
      if (this.lookForSitesAssignRows.indexOf(siteId) == NEGATIVE_ONE) { this.lookForSitesAssignRows.push(siteId); }
    });
  }
  private finishSiteAssignmentLookup(alcorVals: any[], morethan20rec: boolean, remainingRows: any[]): void {
    if (morethan20rec) {
      this.getSiteAssignmentsForRealEstate(ONE, remainingRows, alcorVals);
      return;
    }
    alcorVals.forEach(value => this.updateAlcorAssignmentAvailability(value));
    this.lookForSiteLoading = false;
  }
  private updateAlcorAssignmentAvailability(value: any): void {
    for (const siteId of this.alcorValSiteIds[value]) {
      if (this.lookForSitesAssignRows.indexOf(siteId) == NEGATIVE_ONE) { this.alcorAssignmentAval[value] = 'noexist'; }
      else if (this.alcorAssignmentAval[value] == '') { this.alcorAssignmentAval[value] = 'exist'; }
    }
  }
  checkForCpyLinks(alcorValue) {
    if (alcorValue == '') { this.disableBtnInitiateLinkLook = true; return; }
    if (this.siteRowsOnAlcorVals[alcorValue].length <= ZERO) { return; }
    const maxLengthArr = this.siteRowsOnAlcorVals[alcorValue].length;
    for (const [index, element] of this.siteRowsOnAlcorVals[alcorValue].entries()) {
      if (this.siteAssignmentData[element]) { this.counterForShowReload(maxLengthArr, index); }
      else { this.createLinkForSite(element, index, maxLengthArr); }
    }
  }
  createLinkForSite(siteRowId, index, maxLength) {
    var tempBusinessRowId;
    const const1 = {
      'companyId': this.companyID,
      'isHQ': 'N'
    }
    this.supplierService.CreateBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities`, const1).subscribe(data => {
      tempBusinessRowId = data['row_id'];
      const const3 = {
        "validityStartDate": this.commonService.getTodayDate(),
        "status": "VALIDATED",
        "businessEntityId": tempBusinessRowId
      }
      this.supplierService.CreateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${siteRowId}`, const3).subscribe(_data3 => {
        this.counterForShowReload(maxLength, index);
      });
    });
  }
  counterForShowReload(maxLength, _index) {
    this.counterForReloadButton = this.counterForReloadButton + ONE;
    console.info(maxLength, this.counterForReloadButton)
    this.progressForInitiateLink = (this.counterForReloadButton / maxLength) * ONE_HUNDRED;
  }
  reloadCurrentPage() {
    document.getElementById('closeRealEstateAlcor').click();
    document.getElementById('closeProgressBarLook').click();
    document.getElementById('closeSentToBuyer').click();
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigateByUrl(`company-details/${this.companyID}`);
  }
  /**END look for sites */
  /**START delete business entity for no site */
  deleteNoSiteEntity(id) {
    this.showDelBtnForNoSite = false;
    this.supplierService.deleteBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities/${id}`).subscribe(_data => {
    });
    this.supplierService.deleteBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.SiteDe_BvdID_Stat[id].row_id}`).subscribe(_data1 => {
      this.loadBvdIdCpy(this.tempBvdId, 'reload');
    });
  }
  /**END delete business entity for no site */
  /**START toggle parentage status on switch */
  toggleSitesDataStatus(event) {
    const toggleEL = event.srcElement.checked;
    for (const element of this.SitesInfo) {
      if (element.status == 'ARCHIVED') {
        element['showRow'] = !toggleEL;
      }
      if (element['toggleRow']) {
        element['showRow'] = !toggleEL;
      }
    }
  }
  /**END toggle parentage status on switch */
  /**START show ALCOR name for alcor values */
  getAlcorNameVals(page = ONE, loop = 'start', subscribeData = []) {
    if (loop == 'start') { this.alcorNameValsOnAlcorVal = ""; this.alcorNameValsOnAlcorVal = []; }
    if (this.alcorValueWithApos.length <= ZERO) { return; }
    this.siteService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?businessIdentifierValue=in(${this.alcorValueWithApos})&_page=${page}`).subscribe(data0 => {
      this.indexAlcorNameValues(data0, page, subscribeData);
    });
  }
  private indexAlcorNameValues(data0: any, page: number, subscribeData: any[]): void {
    if (data0['real-estate-asset-identifiers'].length <= ZERO) { return; }
    for (const element of data0['real-estate-asset-identifiers']) {
      if (this.alcorNameValsOnAlcorVal[element.businessIdentifierValue] == undefined) {
        this.alcorNameValsOnAlcorVal[element.businessIdentifierValue] = [];
      }
      this.alcorNameValsOnAlcorVal[element.businessIdentifierValue].push(element);
    }
    if (data0['maxPage'] > ONE && data0['maxPage'] != page) {
      this.getAlcorNameVals(page + ONE, 'continue', subscribeData);
    }
  }
  /**END show ALCOR name for alcor values */
  /**sTART REGEX check for alcor name */
  checkRegexAlcorName(expression, model) {
    const regEx = new RegExp('^[A-Z0-9\(\)\-\.]*$');
    if (/^\s/.test(expression)) {
      this[model] = expression.trimStart();
      return false;
    }
    if (expression.length > ZERO) {
      this.alcorNameRegExError = !regEx.test(expression);
    }
  }
  /**END REGEX check for alcor name */
  /**START regex check for names */
  checkvalidateCompanyNameField(expression, model, modelerror, regexmodel) {
    if (/^\s/.test(expression)) {
      this[model] = expression.trimStart();
      return false;
    }
    this[model] = expression.replaceAll(/(\r\n|\n|\r)/gm, "");
    if (expression.length > ZERO) {
      this[modelerror] = false;
      this[regexmodel] = !expression.match(/^[a-zA-Z 0-9\.\,\/\-\(\)]*$/gm);
    } else {
      this[regexmodel] = false;
      this[modelerror] = true;
    }
  }
  /**END regex check for name */
  /**START generic sharepoint documents api and token */
  getGenericDocumentDetails() {
    let cpyDetails;
    cpyDetails = `${this.companyID}-${this.companyBasicInfo['allianceIdentifier']}`;
    this.documentService.getServiceCall(`${this.Http_URL}getfiles/${cpyDetails}`, '').subscribe(data => {
      const content = data['rs'].body
      this.loadingForGenericDocuments = false
      this.GenericCompanyDoc  = content['value'].map(docdata => ({
      ...docdata,
      fields:{
        ...docdata.fields,
        DocumentType: decodeURIComponent(docdata.fields.DocumentType || ''),
      }
    }))
      console.info('Documents', this.GenericCompanyDoc);
      this.loadingForCompanyDocuments = false;
    }, _error => {
      this.loadingForCompanyDocuments = false;
    });
  }
  async getgraph(id: any): Promise<string> {
    return new Promise((resolve, reject) => {
      this.documentService
        .getServiceCall(`${this.Http_URL}getDocdownloadfiles/${id}`, '')
        .subscribe({
          next: (response: any) => {
            const file = response['rs'].body;
            this.getBase64File(file['@microsoft.graph.downloadUrl']).then(base64 => {
              resolve(base64);
            });
          },
          error: err => reject(err)
        });
    });
  }
  async getBase64File(downloadUrl: string): Promise<string> {
    const response = await fetch(downloadUrl);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64data = reader.result?.toString().split(',')[ONE];
        resolve(base64data || '');
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }
  downloadGenericFile(id) {
    this.documentService.getServiceCall(`${this.Http_URL}getdownloadfiles/${id}`, '').subscribe((response: any) => {
      const file = response['rs'].body;
      globalThis.location.href = file['@microsoft.graph.downloadUrl']
    });
  }
  openFnAddGenDocumentModal() {
    this.documentTypeModel = '';
    this.fileToUpload = null;
    const inputFile = document.getElementById("file1") as HTMLInputElement;
    inputFile.value = "";
    this.documentNameModel = '';
    this.uploadDocNameError = false;
    this.uploadDocTypeError = false;
    this.uploadDocError = false;
    this.disableUploadBtn = false;
    this.selectFileError = false;
    this.DocTypeError = false;
    this.fileSizeError = false;
    const temp = [];
    this.addDocPayingCpy = '';
    for (const element of this.PayingInfo) {
      if (element.approvalModificationStatus == "PENDING_VALIDATION") {
        temp.push(element.clientCompanyLegalName);
      }
    }
    if (temp.length == ONE) {
      this.boolForPayingCpySelect = true;
      this.addDocPayingCpy = temp[ZERO];
    } else {
      this.boolForPayingCpySelect = false;
      this.addDocPayingCpy = '';
    }
  }
  changeGenListener($event) {
    this.readThisGen($event.target);
    this.uploadDocError = false;
  }
  readThisGen(inputValue: any) {
    this.fileToUpload = inputValue.files[ZERO];
    this.DocTypeError = false;
    const maxFileSizeBytes = 20 * 1024 * 1024;
    if (this.fileToUpload.size > maxFileSizeBytes) {
      this.fileSizeError = true;
      this.fileToUpload = null;
      return;
    }
    this.fileSizeError = false;
    const allowedFileTypes = ['pdf'];
    const splits = this.fileToUpload.name.split('.');
    const maxSplitLen = splits.length;
    const extension = splits[maxSplitLen - ONE].toLowerCase();
    this.DocTypeError = !allowedFileTypes.includes(extension);
  }
  uploadGenDoc() {
    if (this.fileSizeError) {
      return;
    }
    if (this.documentTypeModel != '' && this.fileToUpload != null && !this.DocTypeError) {
      const splits = this.fileToUpload.name.split('.');
      const maxSplitLen = splits.length;
      const extension = splits[maxSplitLen - ONE];
      this.disableUploadBtn = true;
      this.uploadDocNameError = false;
      this.uploadDocTypeError = false;
      this.selectFileError = false;
      console.info(extension);
      const fileReader = new FileReader();
      fileReader.onload = _e => {
        console.info(this.fileToUpload);
        this.fileContent = fileReader.result;
        this.checkForExistingFile(this.fileToUpload, this.fileToUpload.name);
      }
      fileReader.onerror = () => {
        this.disableUploadBtn = false;
        this.uploadDocError = true;
        this.uploadDocMessage = 'Failed to read the file. Please try again.';
      }
      fileReader.readAsArrayBuffer(this.fileToUpload);
    } else {
      if (this.documentNameModel == '') {
        this.uploadDocNameError = true;
      } else {
        this.uploadDocNameError = false;
      }
      if (this.documentTypeModel == '') {
        this.uploadDocTypeError = true;
      } else {
        this.uploadDocTypeError = false;
      }
      if (this.fileToUpload == null) {
        this.selectFileError = true;
      } else {
        this.selectFileError = false;
      }
    }
  }
  checkForExistingFile(fileContent, fileNameToUpload) {
    const actualName = this.fileToUpload.name.split('.').slice(ZERO, NEGATIVE_ONE).join('.');
    this.documentService.getServiceCall(`${this.Http_URL}SearchByFileName/${actualName}`, '').subscribe(data => {
      console.info('data', data);
      const existingValues = data?.['result']?.body?.['value'] ?? [];
      if (existingValues.length == ZERO) {
        this.updateFile(fileContent, fileNameToUpload);
      } else {
        const files = existingValues.map(x => x.fields.FileLeafRef);
        this.renameExistingFileName(files, fileContent)
      }
    }, () => {
      this.disableUploadBtn = false;
      this.uploadDocError = true;
      this.uploadDocMessage = 'Upload failed. Please try again.';
    })
  }
  renameExistingFileName(files, fileContent, indexvalue = ONE) {
    const splits = this.fileToUpload.name.split('.');
    const extension = splits[splits.length - ONE];
    const actualName = this.fileToUpload.name.split('.').slice(ZERO, NEGATIVE_ONE).join('.');
    const renamed_file = `${actualName}-${indexvalue}.${extension}`;
    if (files.indexOf(renamed_file) == NEGATIVE_ONE) {
      this.updateFile(fileContent, renamed_file);
    } else {
      this.renameExistingFileName(files, fileContent, indexvalue + ONE);
    }
  }
  updateFile(filecontent, fileName) {
    let cpyDetails;
    const fileNames = fileName;
    const url = globalThis.location.href;
    const formData = new FormData();
    cpyDetails = `${this.companyID}-${this.companyBasicInfo['allianceIdentifier']}`;
    formData.append('file', filecontent, fileName)
    formData.append('company', cpyDetails)
    formData.append('type', this.documentTypeModel)
    if (this.isKRenaultDocumentType(this.documentTypeModel)) {
      formData.append('status', 'Pending')
    } else if (this.showForSupplier) {
      formData.append('status', 'Active')
    } else {
      formData.append('status', 'Pending')
    }
    this.documentService.postServiceCall(`${this.Http_URL}upload`, formData).subscribe((data: any) => {
      if (this.isKRenaultDocumentType(this.documentTypeModel)) {
        const fileStatus = 'Pending';
        this.callSustainAssessmentsAPI(fileNames, this.documentTypeModel, fileStatus, '');
      }
      console.info('document', data)
      if (this.documentTypeModel === "K-RENAULT GROUP Supplier Code of Conduct") {
        const sendMailTo = this.isEnvOpe ? 'sustainable-procurement@renault.com' : 'isa@renault.com';
        const mailSubject = `New Code of Conduct of ${this.companyBasicInfo['allianceIdentifier']} ${this.companyNameModelval} has been loaded to ISA`;
        this.mailBodyContent =
          `<p>New Code of Conduct for <b>${this.companyBasicInfo['allianceIdentifier']}</b> ${this.companyNameModelval} has been recently uploaded to the ISA platform.</p><p>We kindly request that you validate the file: <b>${fileNames}</b>.</p><p>To access the Code of Conduct, please log in to the ISA platform and navigate to the appropriate section:  <a href='${url}' target='_blank'>${this.companyBasicInfo['allianceIdentifier']}</a></p>`;
        this.sendMailFn(sendMailTo, mailSubject, this.mailBodyContent);
      }
      this.getGenericDocumentDetails();
      document.getElementById('closeAddGenDocModal').click();
      this.inputGenUpload.nativeElement.value = '';
    }, () => {
      this.disableUploadBtn = false;
      this.uploadDocError = true;
      this.uploadDocMessage = 'Upload failed. Please try again.';
    })
  }
  /**END generic sharepoint documents api and token */
  /**START sharepoint documents api and token */
  getCompanyDocumentDetails() {
    let cpyDetails;
    cpyDetails = `${this.companyID}-${this.companyBasicInfo['allianceIdentifier']}`;
    this.documentService.getServiceCall(`${this.Http_URL}getDocfiles/${cpyDetails}`, '').subscribe(data => {
      const content = data['rs'].body
    this.CompanyDoc  = content['value'].map(data => ({
      ...data,
      fields:{
        ...data.fields,
        Document_x0020_Type: decodeURIComponent(data.fields.Document_x0020_Type || ''),
        Paying_x0020_Company: decodeURIComponent(data.fields.Paying_x0020_Company || '')
      }
    }))
      console.info('Documents', this.CompanyDoc);
      this.loadingForCompanyDocuments = false;
      this.clearAllDocumentSelections();
    }, _error => {
      this.loadingForCompanyDocuments = false;
    });
  }
  openDocPreview(index) {
    this.selectedDocPreview = index;
    this.showPreview = true;
  }
  openPreview() {
    const url = this.CompanyDoc[this.selectedDocPreview]['webUrl'];
  }
  downloadFile(id) {
    this.documentService.getServiceCall(`${this.Http_URL}getDocdownloadfiles/${id}`, '').subscribe((response: any) => {
      const file = response['rs'].body;
      globalThis.location.href = file['@microsoft.graph.downloadUrl']
    });
  }
  /**END sharepoint documents api and token */
  /**START clear hq */
  clearSiteHQ() {
    this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=${this.companyID}&isHQ=Y`).subscribe(data => {
      if (data['business-entities'].length > ZERO) {
        console.info("data['business-entities']", data['business-entities'])
        for (const element of data['business-entities']) {
          const clearHQ = { isHQ: 'N' }
          this.supplierService.updateBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities/${element.row_id}`, clearHQ).subscribe(_data1 => {
            this.loadBvdIdCpy('reload');
            this.siteBusinessEntityHQ = '';
          });
        }
      }
    });
  }
  /**END clear hq */
  /**START check HQ */
  checkHQ() {
    this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=${this.companyID}&isHQ=Y`).subscribe(data => {
      this.disableCheckHQ = true;
      console.info(data['business-entities'].length);
      if (data['business-entities'].length == ONE) {
        const businessEntityId = data['business-entities'][ZERO]['row_id'];
        this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?businessEntityId=${businessEntityId}`).subscribe(data1 => {
          if (data1['site-assignments'].length > ZERO) {
            this.checkForFakeOrTruBvd(businessEntityId, 'uno');
          } else {
            this.checkForOrdering_manu_B2b_Invo_ACP(businessEntityId, 'uno');
          }
        });
      } else if (data['business-entities'].length > ONE) {
        this.warningForHQ = 'More than one Business Entity is Headquarters !';
        this.disableCheckHQ = false;
        document.getElementById('btnForMoreHQ').click();
      } else {
        this.checkForOrdering_manu_B2b_Invo_ACP('', 'deux');
      }
    });
  }
  checkForOrdering_manu_B2b_Invo_ACP(businessEntityId, from = '') {
    let oneOrderingExists = false;
    const siteIdens = [];
    const siteRowIdOnSiteIden: any = [];
    const rowIdForDeux: any = [];
    for (const element of this.SitesInfo) {
      if (element.site) {
        const siteId = element.site.href.split('/');
        if (this.site_qualifiers[siteId[ONE]]['P11'] >= ONE || this.site_qualifiers[siteId[ONE]]['P05'] >= ONE || this.site_qualifiers[siteId[ONE]]['B2b'] >= ONE || this.site_qualifiers[siteId[ONE]]['P06'] >= ONE) {
          oneOrderingExists = true;
        }
        siteRowIdOnSiteIden[this.Site_City_Country[siteId[ONE]].identifier] = siteId[ONE];
        siteIdens.push(`'${this.Site_City_Country[siteId[ONE]].identifier}'`);
        rowIdForDeux[siteId[ONE]] = element;
      }
    }
    if (oneOrderingExists) {
      this.checkForLowestRaftCodeSite(siteIdens, siteRowIdOnSiteIden, businessEntityId, from, rowIdForDeux);
    } else {
      this.disableCheckHQ = false;
    }
  }
  checkForLowestRaftCodeSite(siteIdens, siteRowIdOnSiteIden, businessEntityId, from, rowIdForDeux) {
    this.siteService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=RAFT_CODE&siteIdentifier=in(${siteIdens})`).subscribe(data => {
      if (data['access-point-identifiers'].length <= ZERO) { return; }
      let lowestVal: any = '';
      let lowestObj: any;
      for (const element of data['access-point-identifiers']) {
        const splitted = element.identifierValue.slice(-2);
        if (lowestVal != undefined && lowestVal != '' && splitted < lowestVal) {
          lowestVal = splitted; lowestObj = element;
        } else if (lowestVal == undefined || lowestVal == '') {
          lowestObj = element; lowestVal = splitted;
        } else {
        }
      }
      if (from == 'uno') { this.linkSiteToisHQBE(lowestObj, siteRowIdOnSiteIden, businessEntityId); }
      else { this.setBeAsHQ(lowestObj, siteRowIdOnSiteIden, businessEntityId, from, rowIdForDeux); }
    });
  }
  setBeAsHQ(lowestObj, siteRowIdOnSiteIden, _businessEntityId, from, rowIdForDeux) {
    console.info(rowIdForDeux[siteRowIdOnSiteIden[lowestObj['siteIdentifier']]].businessEntityId);
    const beRowId = rowIdForDeux[siteRowIdOnSiteIden[lowestObj['siteIdentifier']]].businessEntityId;
    const setHQ = { isHQ: 'Y' }
    this.supplierService.updateBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities/${beRowId}`, setHQ).subscribe(_data => {
      this.checkForRealBvdIdOnCompany(beRowId, from);
    });
  }
  linkSiteToisHQBE(siteObj, siteRowIdOnSiteIden, businessEntityId) {
    const const3 = {
      "validityStartDate": this.commonService.getTodayDate(),
      "status": "VALIDATED",
      businessEntityId
    }
    this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?businessEntityCompanyId=${this.companyID}`).subscribe(data1 => {
      if (data1['site-assignments'].length > ZERO) {
        for (const element of data1['site-assignments']) {
          const siteId = element.site.href.split('/');
          if (siteId[ONE] == siteRowIdOnSiteIden[siteObj.siteIdentifier]) {
            this.supplierService.deleteSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments/${element.rowId}`).subscribe(_data2 => {
            });
          }
        }
      }
      this.supplierService.CreateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${siteRowIdOnSiteIden[siteObj.siteIdentifier]}`, const3).subscribe(_data3 => {
        this.cleanBE();
      });
    });
  }
  checkForFakeOrTruBvd(businessEntityId, from) {
    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=${businessEntityId}`).subscribe(data => {
      if (data['business-entity-identifiers'].length > ZERO) {
        const bvdid = data['business-entity-identifiers'][ZERO]['value'];
        const beRowid = data['business-entity-identifiers'][ZERO]['row_id'];
        if (bvdid.toLowerCase().startsWith('bvd') || bvdid == '') {
          this.checkForRealBvdIdOnCompany(businessEntityId, from);
        } else {
          this.disableCheckHQ = false;
        }
      } else {
        this.checkForRealBvdIdOnCompany(businessEntityId, from);
      }
    });
  }
  private updateHeadquartersBvdIdentifier(businessEntityId, rowId, onComplete): void {
    const updateBvd = { businessEntityId };
    this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${rowId}`, updateBvd).subscribe(_data => {
      this.warningForHQ = 'BvD ID updated';
      document.getElementById('btnForMoreHQ').click();
      onComplete();
    });
  }

  private hasUsableBvdIdentifier(value): boolean {
    return value != '' && !value.toLowerCase().startsWith('bvd');
  }

  private cleanHeadquartersOnce(cleaned: boolean): boolean {
    if (!cleaned) {
      this.cleanBE();
      return true;
    }
    return cleaned;
  }

  checkForRealBvdIdOnCompany(businessEntityId, from) {
    console.info('bvd id vals>>', this.SiteDe_BvdID_Stat);
    let cleanAlreadyDone = false;
    this.SitesInfo.forEach((element, index) => {
      if (element.businessEntityIdentifierTypeName == 'BVD ID' && this.hasUsableBvdIdentifier(element.value)) {
        this.updateHeadquartersBvdIdentifier(businessEntityId, element.row_id, () => {
          cleanAlreadyDone = this.cleanHeadquartersOnce(cleanAlreadyDone);
        });
        return;
      }

      const siteBvd = this.SiteDe_BvdID_Stat[element.businessEntityId];
      const hasConflictingSiteBvd = element.identifier != '' && siteBvd?.['exist'] &&
        siteBvd['value'] != '' && siteBvd['businessEntityId'] != businessEntityId;
      if (hasConflictingSiteBvd && this.hasUsableBvdIdentifier(siteBvd['value'])) {
        this.updateHeadquartersBvdIdentifier(businessEntityId, siteBvd['row_id'], () => {
          cleanAlreadyDone = this.cleanHeadquartersOnce(cleanAlreadyDone);
        });
        return;
      }

      if (index + ONE == this.SitesInfo.length) {
        cleanAlreadyDone = this.cleanHeadquartersOnce(cleanAlreadyDone);
      }
    });
  }
  cleanBE() {
    this.SiteDe_BvdID_Stat = "";
    this.SiteDe_BvdID_Stat = [];
    this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=${this.companyID}`).subscribe(data => {
      const businessEntityIds = [];
      const businessEntityData: any = [];
      if (data['business-entities'].length > ZERO) {
        for (const element of data['business-entities']) {
          businessEntityData[element.row_id] = element;
          if (businessEntityIds.indexOf(element.row_id) == NEGATIVE_ONE) {
            businessEntityIds.push(element.row_id);
          }
        }
      }
      this.cleanFnGetSiteAssigns(businessEntityIds, businessEntityData);
    });
  }
  cleanFnGetSiteAssigns(businessEntities, businessEntityData) {
    if (businessEntities.length <= ZERO) { this.loadBvdIdCpy(this.tempBvdId, 'reload'); this.disableCheckHQ = false; return; }
    this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?businessEntityCompanyId=${this.companyID}`).subscribe(data => {
      this.removeAssignedBusinessEntities(data['site-assignments'], businessEntities);
      this.cleanGetBvDID(businessEntities, businessEntityData);
    });
  }
  private removeAssignedBusinessEntities(assignments: any[], businessEntities: any[]): void {
    for (const element of assignments) {
      const indexO = businessEntities.indexOf(element.businessEntityId);
      if (indexO != NEGATIVE_ONE) { businessEntities.splice(indexO, ONE); }
    }
    console.info('no siteassns', businessEntities);
  }
  cleanGetBvDID(businessEntities, _businessEntityData) {
    if (businessEntities.length <= ZERO) { this.loadBvdIdCpy(this.tempBvdId, 'reload'); this.disableCheckHQ = false; return; }
    const archiveEntities = [];
    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=in(${businessEntities})`).subscribe(data => {
      if (data['business-entity-identifiers'].length > ZERO) {
        for (const element of data['business-entity-identifiers']) {
          const val = element.value;
          if (val.toLowerCase().startsWith('bvd') || val == '') { archiveEntities.push(element.businessEntityId); }
        }
        this.cleanDelBE(archiveEntities);
      } else { this.cleanDelBE(businessEntities); }
      console.info(archiveEntities);
    });
  }
  cleanDelBE(delBe) {
    if (delBe.length > ZERO) {
      for (const [index, element] of delBe.entries()) {
        this.supplierService.deleteBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities/${element}`).subscribe(_data => {
          if (index + ONE == delBe.length) {
            this.loadBvdIdCpy(this.tempBvdId, 'reload');
            this.disableCheckHQ = false;
          }
        });
      }
    } else {
      this.loadBvdIdCpy(this.tempBvdId, 'reload');
      this.disableCheckHQ = false;
    }
  }
  private deleteOrbisIdentifiers(): void {
    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=ORBIS-STATUS&businessEntityId=in(${this.entityId})`).subscribe(data => {
      const total = data['business-entity-identifiers'].length;
      for (const aa of data['business-entity-identifiers']) {
        this.supplierService.deleteBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${aa['row_id']}`).subscribe(_data1 => {
          if (total == 1) { this.latestOrbisStatus = ''; }
        });
      }
    });
  }
  private applyRaftAccountTracking(data6: any, data1: any, shortName: any, site_id: any, CompanayID: any, BvDidforsite: any, fromCnS: any, mainCount: any, con: any): void {
    if (data6['real-estate-asset-identifiers'].length > ZERO) {
      for (const ele of data6['real-estate-asset-identifiers']) {
        this.cpyAlcorToRaft.push(ele.businessIdentifierValue);
        this.arrBasedOnVal[ele.businessIdentifierValue] = ele.rowId;
        if (con == 'exist') { this.siteService.deleteRealEstateAssetIdentifier(this.Config.ApiSitesUrl + REAL_ESTATE_ASSET_IDENTIFIERS_PATH + ele.rowId).subscribe(_data7 => { }); }
      }
    }
    this.supplierService.getCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers?linkedCompanyId=${CompanayID}&companyIdentifierKeyName=ALCOR`).subscribe(data8 => {
      this.reconcileAlcorRaftIdentifiers(data8, data6, shortName, data1, site_id, CompanayID, BvDidforsite, fromCnS, mainCount, con);
    });
  }
  private reconcileAlcorRaftIdentifiers(data8: any, data6: any, shortName: any, data1: any, site_id: any, CompanayID: any, BvDidforsite: any, fromCnS: any, mainCount: any, con: any): void {
    const alcorValsOfCpy = [];
    const searchAlcorVal = [];
    const idensData: any = [];
    if (shortName == '') { shortName = data1['legalName'].slice(ZERO, TEN); }
    if (data8['company-identifiers'].length > ZERO) {
      for (const elem of data8['company-identifiers']) {
        searchAlcorVal.push(`'${elem.value}'`);
        alcorValsOfCpy.push(elem.value);
        idensData[elem.value] = elem;
      }
    }
    if (searchAlcorVal.length > ZERO) {
      this.siteService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?businessIdentifierValue=in(${searchAlcorVal})&identifierType=RAFT_ACCOUNT`).subscribe(data90 => {
        this.updateAlcorSiteIdentifiers(data90, data6, con, alcorValsOfCpy, idensData, shortName, site_id);
      });
    } else {
      for (const elementA of data6['real-estate-asset-identifiers']) {
        if (con == 'exist' && alcorValsOfCpy.indexOf(elementA.businessIdentifierValue) == NEGATIVE_ONE) {
          this.siteService.deleteRealEstateAssetIdentifier(this.Config.ApiSitesUrl + REAL_ESTATE_ASSET_IDENTIFIERS_PATH + elementA.rowId).subscribe(_data7 => { });
        }
      }
    }
    this.changeAccessPointsToPending(site_id, CompanayID, BvDidforsite);
    console.info("**** Create Site Done ****", fromCnS);
    console.info('calling again', this.selectedBvdId, mainCount);
    this.selectBvdId(this.selectedBvdId, mainCount + ONE);
  }
  /**END check HQ */
  /**START upload doc to SP */
  openFnAddDocumentModal() {
    this.documentTypeModel = 'Blank Invoice';
    const inputFile = document.getElementById("file") as HTMLInputElement;
    inputFile.value = "";
    this.fileToUpload = null;
    this.documentNameModel = '';
    this.uploadDocNameError = false;
    this.uploadDocTypeError = false;
    this.uploadDocError = false;
    this.disableUploadBtn = false;
    this.selectFileError = false;
    this.DocTypeError = false;
    this.fileSizeError = false;
    const temp = [];
    this.addDocPayingCpy = '';
    for (const element of this.PayingInfo) {
      if (element.approvalModificationStatus == "PENDING_VALIDATION") {
        temp.push(element.clientCompanyLegalName);
      }
    }
    if (temp.length == ONE) {
      this.boolForPayingCpySelect = true;
      this.addDocPayingCpy = temp[ZERO];
    } else {
      this.boolForPayingCpySelect = false;
      this.addDocPayingCpy = '';
    }
  }
  resetDocumentName() {
    this.documentNameModel = '';
    this.uploadDocNameError = true;
  }
  changeListener($event) {
    this.readThis($event.target);
    this.uploadDocError = false;
  }
  readThis(inputValue: any) {
    this.fileToUpload = inputValue.files[ZERO];
    const maxFileSizeBytes = 20 * 1024 * 1024;
    if (this.fileToUpload.size > maxFileSizeBytes) {
      this.fileSizeError = true;
      this.fileToUpload = null;
      return;
    }
    this.fileSizeError = false;
    const allowedFileTypes = ['pdf'];
    const splits = this.fileToUpload.name.split('.');
    const maxSplitLen = splits.length;
    const extension = splits[maxSplitLen - ONE].toLowerCase();
    this.DocTypeError = !allowedFileTypes.includes(extension);
  }
  uploadDocToSP() {
    if (this.fileSizeError) {
      return;
    }
    if (this.documentTypeModel != '' && this.fileToUpload != null && !this.DocTypeError) {
      const splits = this.fileToUpload.name.split('.');
      const maxSplitLen = splits.length;
      const extension = splits[maxSplitLen - ONE];
      this.disableUploadBtn = true;
      this.uploadDocNameError = false;
      this.uploadDocTypeError = false;
      this.selectFileError = false;
      console.info(extension);
      const fileReader = new FileReader();
      fileReader.onload = _e => {
        console.info(this.fileToUpload);
        this.fileContent = fileReader.result;
        this.checkForExistingFileAndUpload(this.fileToUpload, this.fileToUpload.name);
      }
      fileReader.onerror = () => {
        this.disableUploadBtn = false;
        this.uploadDocError = true;
        this.uploadDocMessage = 'Failed to read the file. Please try again.';
      }
      fileReader.readAsArrayBuffer(this.fileToUpload);
    } else {
      if (this.documentNameModel == '') {
        this.uploadDocNameError = true;
      } else {
        this.uploadDocNameError = false;
      }
      if (this.documentTypeModel == '') {
        this.uploadDocTypeError = true;
      } else {
        this.uploadDocTypeError = false;
      }
      if (this.fileToUpload == null) {
        this.selectFileError = true;
      } else {
        this.selectFileError = false;
      }
    }
  }
  checkForExistingFileAndUpload(fileContent, fileNameToUpload) {
    const actualName = this.fileToUpload.name.split('.').slice(ZERO, NEGATIVE_ONE).join('.');
    this.documentService.getServiceCall(`${this.Http_URL}searchBySPFileName/${actualName}`, '').subscribe(data => {
      console.info('data', data);
      const existingValues = data?.['result']?.body?.['value'] ?? [];
      if (existingValues.length == ZERO) {
        this.uploadToSharepoint(fileContent, fileNameToUpload);
      } else {
        const files = existingValues.map(x => x.fields.FileLeafRef);
        this.renameExistingFile(files, fileContent)
      }
    }, () => {
      this.disableUploadBtn = false;
      this.uploadDocError = true;
      this.uploadDocMessage = 'Upload failed. Please try again.';
    })
  }
  renameExistingFile(files, fileContent, indexvalue = ONE) {
    const splits = this.fileToUpload.name.split('.');
    const extension = splits[splits.length - ONE];
    const actualName = this.fileToUpload.name.split('.').slice(ZERO, NEGATIVE_ONE).join('.');
    const renamed_file = `${actualName}-${indexvalue}.${extension}`;
    if (files.indexOf(renamed_file) == NEGATIVE_ONE) {
      this.uploadToSharepoint(fileContent, renamed_file);
    } else {
      this.renameExistingFile(files, fileContent, indexvalue + ONE);
    }
  }
  uploadToSharepoint(contentVal, fileName) {
    let cpyDetails;
    const formData = new FormData();
    cpyDetails = `${this.companyID}-${this.companyBasicInfo['allianceIdentifier']}`;
    formData.append('file', contentVal, fileName)
    formData.append('company', cpyDetails)
    formData.append('type', this.documentTypeModel)
    formData.append('payingCompany', this.addDocPayingCpy)
    if (this.showForSupplier) {
      formData.append('status', 'Active')
    } else {
      formData.append('status', 'Pending')
    }
    this.documentService.postServiceCall(`${this.Http_URL}uploadDocs`, formData).subscribe((data: any) => {
      console.info('document', data)
      document.getElementById('closeAddDocModal').click();
      this.inputUpload.nativeElement.value = '';
      this.getCompanyDocumentDetails()
    }, () => {
      this.disableUploadBtn = false;
      this.uploadDocError = true;
      this.uploadDocMessage = 'Upload failed. Please try again.';
    })
  }
  /**END upload doc to SP */
  /**START edit document status */
  openEditDocStatus(status, docsId, fileName = '', gen, docType = '') {
    console.info('=== openEditDocStatus called ===');
    console.info('status:', status);
    console.info('docsId:', docsId);
    console.info('fileName:', fileName);
    console.info('gen:', gen);
    console.info('docType:', docType);
    this.documentStatusModel = status;
    this.documentId = docsId;
    this.documentFileName = fileName;
    this.genDoc = gen;
    this.currentDocumentType = docType;
    console.info('Values set:');
    console.info('this.currentDocumentType:', this.currentDocumentType);
    console.info('this.documentFileName:', this.documentFileName);
    console.info('this.documentStatusModel:', this.documentStatusModel);
  }
  updateDocumentStatus() {
    const isArchived = this.documentStatusModel === 'Archived';
    const endDate = isArchived ? `${new Date().toISOString().split('.')[ZERO]}Z` : '';
    const formData = {
      'status': this.documentStatusModel,
      'itemId': this.documentId,
      endDate
    }
    if (this.genDoc) {
      this.documentService.postServiceCall(`${this.Http_URL}editFileStatus`, formData).subscribe(_data => {
        this.callSustainAssessmentsForStatusUpdate();
        document.getElementById('closeEditDocStatus').click();
        this.getGenericDocumentDetails();
      });
    } else {
      this.documentService.postServiceCall(`${this.Http_URL}editSPFileStatus`, formData).subscribe(_data => {
        this.callSustainAssessmentsForStatusUpdate();
        document.getElementById('closeEditDocStatus').click();
        this.getCompanyDocumentDetails();
      });
    }
  }
  /**END edit document status */
  /**START set paying company status update */
  setPayingCpyOptions(status, info) {
    this.payingCpyStatus = '';
    this.payingCpyOptions = [];
    this.payingCpyStatusError = false;
    this.disablePayingStatusBtn = false;
    if (status.toLowerCase() == 'validated') {
      this.payingCpyOptions.push('ARCHIVED', 'PENDING');
    } else if (status.toLowerCase() == 'pending_validation') {
      this.payingCpyOptions.push('ARCHIVED', 'ACTIVE');
    } else if (status.toLowerCase() == 'archived') {
      this.payingCpyOptions.push('PENDING', 'ACTIVE');
    } else {
    }
    this.activePayingCpyRowId = info.row_id;
  }
  updatePayingCompanyStatus() {
    if (this.payingCpyStatus != '' && this.activePayingCpyRowId != '') {
      this.disablePayingStatusBtn = true;
      let datas1 = {}
      const status = this.payingCpyStatus;
      if (status == 'PENDING') {
        datas1 = {
          approvalModificationStatus: 'PENDING_VALIDATION', statusId: this.arrApprovalStatus['To be validated']
        }
      }
      if (status == 'ACTIVE') {
        datas1 = {
          approvalModificationStatus: 'VALIDATED', statusId: this.arrApprovalStatus['Approved'], validityStartDate: this.commonService.getTodayDate(), validityEndDate: ''
        }
      }
      if (status == 'ARCHIVED') {
        datas1 = {
          approvalModificationStatus: 'ARCHIVED', statusId: this.arrApprovalStatus['Archived'], validityEndDate: this.commonService.getTodayDate()
        }
      }
      this.supplierService.updateCompanyApprovals(`${this.Config.ApiSupplierUrl}company-approvals/${this.activePayingCpyRowId}`, datas1).subscribe(_data => {
        this.getPayingDetails('No');
        document.getElementById('closeshowPayingStatusUpdate').click();
      });
    } else {
      this.payingCpyStatusError = true;
      this.disablePayingStatusBtn = false;
    }
  }
  /**END set paying company status update */
  /* Start paying company delete */
  payingCmpInfo(data) {
    this.payingCmprowId = data['row_id'];
    this.payingCmpName = data['clientCompanyLegalName'];
    this.payingCmpCode = data['clientCompanyCode'];
  }
  deletepayingCmp() {
    this.supplierService.deleteCompanyApprovals(`${this.Config.ApiSupplierUrl}company-approvals/${this.payingCmprowId}`).subscribe(_data => {
      this.getPayingDetails('No');
      document.getElementById('closeconfirmDeletepayingCompany').click()
    });
  }
  /**START show street address for main entrance */
  getMainEntranceIds(rowIds, mainAccessIdOnSiteId, addressIds = [], page = ONE) {
    if (rowIds.length <= ZERO) { return; }
    this.siteService.getAccessPointAddresses(`${this.Config.ApiSitesUrl}access-points-addresses?accessPointId=in(${rowIds})&_page=${page}`).subscribe(data => {
      if (data['access-points-addresses'].length <= ZERO) { return; }
      for (const e of data['access-points-addresses']) {
        if (e.addressType === 'GEOGRAPHICAL') {
          this.accessPointIdOnAddress[mainAccessIdOnSiteId[e.accessPointId]] = e.addressId;
          addressIds.push(e.addressId);
        }
      }
      if (data['maxPage'] > ONE && data['maxPage'] != page) { this.getMainEntranceIds(rowIds, mainAccessIdOnSiteId, addressIds, page + ONE); }
      else if (data['maxPage'] == page) { this.getMainEntrAddresses(addressIds); }
    });
  }
  getMainEntrAddresses(rowIds, page = ONE) {
    if (rowIds.length > ZERO) {
      this.addressService.getGeographicalAddresses(`${this.Config.ApiAddressUrl}geographical-addresses?rowId=in(${rowIds})&_page=${page}`).subscribe(data => {
        if (data['geographical-addresses'].length > ZERO) {
          for (const e of data['geographical-addresses']) {
            this.acpAddressDetOnRows[e.rowId] = e;
          }
          if (data['maxPage'] > ONE && data['maxPage'] != page) {
            this.getMainEntrAddresses(rowIds, page + ONE);
          }
        }
      });
    }
  }
  /**END show street address for main entrance */
  /**SEND mail fn START*/
  sendMailFn(mailTo, mailSubject, mailBody, isload = false, onSuccess?: () => void, onError?: () => void) {
    const mailcontent: any = {};
    mailcontent.toAddress = mailTo,
      mailcontent.mailSubject = this.commonService.mailSub + mailSubject,
      mailcontent.body = mailBody
    const baseUrl1 = baseUrl == localUrl ? intUrl : baseUrl
    console.info('mail sent')
    this.documentService.postServiceCall(`${baseUrl1}/api/sendMail`, mailcontent).subscribe(_data => {
      if (isload) {
        this.workflowDetailsfn();
        this.validatingWorkflow = false;
        document.getElementById('closeWorkflowRejection').click();
        document.getElementById('closeWorkflowInfoRequest').click();
        document.getElementById('closeWorkflowValidation').click();
      }
      document.getElementById("closeCCBtnReminder").click();
      if (onSuccess) {
        onSuccess();
      }
    }, error => {
      console.info('Error while sending email:', error);
      if (onError) {
        onError();
      }
    });
  }
  /**SEND mail function END */
  /**START send request to supplier */
  checkSelectedReuqest() {
    if (this.selectedSendRequest != '' && this.selectedSendRequest != undefined) {
      this.sendRequestError = false;
      document.getElementById('closesendReqtoSupp').click();
      document.getElementById('btnForOpenSendReqToSupp').click();
    } else {
      this.sendRequestError = true;
    }
  }
  selectedRequestType(_event) {
    this.payingCompanyCodeModelvalerror = false;
    this.senReqKamSaleContMOdelError = false;
    this.senReqSamMOdelError = false;
    this.sendRequestError = false;
    this.senReqSiteModelError = false;
    this.senReqAddSiteModelError = false;
    this.senReqUpdatePayingModelError = false;
    this.applyRequestTypeSelection();
  }
  private filterRequestPersons() {
    if (this.personuserId.length === ZERO) {
      return [...this.allKamSaleRoles];
    }
    return this.allKamSaleRoles.filter((person: any) => this.personuserId.some((user: any) => person.personRowId == user.personRowId));
  }
  private applyRequestTypeSelection() {
    switch (this.selectedSendRequest) {
    case 'New Company':
      this.accHomoRequestSelected = true;
      this.prospectSelected = false;
      this.siteUpdRequestSelected = false;
      this.siteAddRequestSelected = false;
      this.addPayCmpRequestSelected = false;
      this.siteUpdatePayingComp = false;
      this.disableSendReqBtn = false;
      this.isPrototypeEnabled = true;
      this.isPrototypeLocked = true;
      break;
    case 'New Prospect':
      this.accHomoRequestSelected = false;
      this.prospectSelected = true;
      this.siteUpdRequestSelected = false;
      this.siteAddRequestSelected = false;
      this.addPayCmpRequestSelected = false;
      this.siteUpdatePayingComp = false;
      this.disableSendReqBtn = false;
      this.isPrototypeEnabled = false;
      this.isPrototypeLocked = false;
      break;
    case 'add paying company':
      this.accHomoRequestSelected = false;
      this.addPayCmpRequestSelected = true;
      this.siteUpdRequestSelected = false;
      this.siteAddRequestSelected = false;
      this.siteUpdatePayingComp = false
      this.disableSendReqBtn = false;
      this.PersonDetailsCompSent2Req = this.filterRequestPersons();
      break;
    case 'site update':
      this.accHomoRequestSelected = false;
      this.addPayCmpRequestSelected = false;
      this.siteUpdRequestSelected = true;
      this.siteAddRequestSelected = false;
      this.siteUpdatePayingComp = false
      this.disableSendReqBtn = false;
      this.PersonDetailsCompSent2Req = this.filterRequestPersons();
      break;
    case 'Add site':
      this.accHomoRequestSelected = false;
      this.addPayCmpRequestSelected = false;
      this.siteUpdRequestSelected = false;
      this.siteAddRequestSelected = true;
      this.disableSendReqBtn = false;
      this.PersonDetailsCompSent2Req = this.filterRequestPersons();
      break;
    case 'Update bank details':
      this.accHomoRequestSelected = false;
      this.siteUpdRequestSelected = false;
      this.addPayCmpRequestSelected = false;
      this.siteUpdatePayingComp = true;
      this.siteAddRequestSelected = false;
      this.disableSendReqBtn = false;
      this.PersonDetailsCompSent2Req = this.filterRequestPersons();
      break;
    default:
      this.accHomoRequestSelected = false;
      this.addPayCmpRequestSelected = false;
      this.siteUpdRequestSelected = false;
      this.siteAddRequestSelected = false;
      this.disableSendReqBtn = true;
      break;
    }
  }
  /**START 3-update sites */
  selectSiteSendReqSup(e, rowid) {
    if (e.target.checked) {
      this.checkArray.push(rowid);
    } else {
      this.checkArray.splice(this.checkArray.indexOf(rowid), ONE);
    }
    if (this.checkArray.length > ZERO) {
      this.senReqSiteModelError = false;
    } else {
      this.senReqSiteModelError = true;
    }
  }
  /**END 3-update sites */
  /**END send request to supplier */
  selectradio(e, rowid) {
    this.RowupArray1 = [];
    if (e.target.checked) {
      this.RowupArray1.push(rowid);
    } else {
      this.RowupArray1.splice(this.RowupArray1.indexOf(rowid), ONE);
    }
    if (this.RowupArray1.length > ZERO) {
      this.senReqUpdatePayingModelError = false;
    } else {
      this.senReqUpdatePayingModelError = true;
    }
  }
  /**START Add site check HQ bvd */
  addSiteChkHQBvd() {
    const datas = { "bvd-id": this.hQBvdIdHolder, "import": "Y" }
    this.showAddSiteLoading = true;
    this.disableImportSite = false;
    this.disableCheckbox = false;
    this.showAddSiteProcessing = false;
    const allBvdIdsArr = [];
    this.supplierService.createBvdInterface(`${this.Config.ApiSupplierUrl}bvd-interface`, datas).subscribe((data: any) => this.handleAddSiteBvdResponse(data, allBvdIdsArr), _error => {
      this.showAddSiteLoading = false;
    });
  }
  private handleAddSiteBvdResponse(data: any, allBvdIdsArr: any[]): void {
    this.addSiteBvdIdData = [];
    const bvdData = JSON.parse(data.result);
    const branchData = bvdData['Data'][ZERO];
    console.info('bvddata>>', branchData);
    if (!branchData || branchData['BRANCH_NAME'] == null) {
      this.showAddSiteLoading = false;
      this.checkAllBvdInDb(allBvdIdsArr);
      return;
    }
    this.addBvdBranches(branchData, allBvdIdsArr);
    this.checkAllBvdInDb(allBvdIdsArr);
  }
  private addBvdBranches(branchData: any, allBvdIdsArr: any[]): void {
    for (let i = ZERO; i < branchData['BRANCH_NAME'].length; i++) {
      const bvdId = branchData['BRANCH_BVD_ID_NUMBER']?.[i] || '';
      if (allBvdIdsArr.indexOf(`'${bvdId}'`) == NEGATIVE_ONE) { allBvdIdsArr.push(`'${bvdId}'`); }
      this.addSiteBvdIdData.push({
        BRANCH_NAME: branchData['BRANCH_NAME']?.[i] || '',
        BRANCH_BVD_ID_NUMBER: bvdId,
        BRANCH_ADDRESS_LINE1: branchData['BRANCH_ADDRESS_LINE1']?.[i] || '',
        BRANCH_POSTCODE: branchData['BRANCH_POSTCODE']?.[i] || '',
        BRANCH_CITY: branchData['BRANCH_CITY']?.[i] || '',
        BRANCH_COUNTRY_ISO_CODE: branchData['BRANCH_COUNTRY_ISO_CODE']?.[i] || ''
      });
    }
  }
  checkAllBvdInDb(bvdIds, page = ONE, subscribeData = []) {
    if (bvdIds.length <= ZERO) { this.showAddSiteLoading = false; return; }
    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?value=in(${bvdIds})&_page=${page}`).subscribe(data => {
      if (data['business-entity-identifiers'].length <= ZERO) { this.showAddSiteLoading = false; return; }
      for (const e of data['business-entity-identifiers']) { subscribeData.push(e); }
      if (data['maxPage'] > ONE && data['maxPage'] != page) {
        this.checkAllBvdInDb(bvdIds, page + ONE, subscribeData);
        return;
      }
      if (data['maxPage'] == page) { this.applyBvdIdDisableFlags(subscribeData); }
    }, _error => { this.showAddSiteLoading = false; });
  }
  private applyBvdIdDisableFlags(subscribeData: any[]): void {
    const existingBvdIds = subscribeData.map(ele => ele.value);
    for (const e of this.addSiteBvdIdData) {
      e['disableCheck'] = existingBvdIds.indexOf(e.BRANCH_BVD_ID_NUMBER) != NEGATIVE_ONE;
    }
    this.showAddSiteLoading = false;
  }
  selectCheckBox(event, bvd) {
    for (const e of this.addSiteBvdIdData) {
      if (e.BRANCH_BVD_ID_NUMBER == bvd) {
        e['isChecked'] = !e.isChecked;
      } else if (!e.isChecked) {
        e['isChecked'] = false;
      } else {
      }
    }
    if (this.siteAddRequestSelected) {
      if (event.target.checked) {
        this.addSiteDataArray.push(bvd);
      } else {
        this.addSiteDataArray.splice(this.selectedBvdId.indexOf(bvd), ONE);
      }
      if (this.addSiteDataArray.length > ZERO) {
        this.senReqAddSiteModelError = false;
      } else {
        this.senReqAddSiteModelError = true;
      }
    }
  }
  importSelectedSites() {
    this.selectedBvdId = [];
    this.disableImportSite = true;
    this.disableCheckbox = true;
    this.showAddSiteProcessing = true;
    if (!this.siteAddRequestSelected) {
      document.getElementById('btnSiteHqStepsLog').click();
    }
    for (const ele of this.addSiteBvdIdData) {
      if (ele.isChecked) {
        this.selectedBvdId.push(ele.BRANCH_BVD_ID_NUMBER);
      }
    }
    console.info('import these>>', this.selectedBvdId);
    this.selectBvdId(this.selectedBvdId);
  }
  selectBvdId(selectedBvdId, count = ZERO) {
    console.info('called', selectedBvdId, count);
    if (selectedBvdId[count] != undefined) {
      this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=${selectedBvdId[count]}`).subscribe((data: any) => {
        if (data['business-entity-identifiers'].length > ZERO) {
          console.info("This Supplier is already available in ISA");
          this.selectBvdId(selectedBvdId[count + ONE]);
        } else {
          this.getBvDIdDetails(selectedBvdId[count], count);
        }
      });
    } else {
      this.disableImportSite = false;
      this.disableCheckbox = false;
      this.showAddSiteProcessing = false;
      document.getElementById('closeshowAddSiteHq').click();
      document.getElementById('closeshowAddSiteHqSteps').click();
      this.loadBvdIdCpy(this.tempBvdId);
      if (this.siteAddRequestSelected) {
        this.workflowDetailsfn();
        document.getElementById('closesendReqtoSupp1').click();
      }
    }
  }
  getBvDIdDetails(bvdId, mainCount) {
    const datas = { "bvd-id": bvdId, 'import': "Y" }
    this.addSiteCurrentStatus = 'Fetching BvD details from BvD interface';
    this.supplierService.createBvdInterface(`${this.Config.ApiSupplierUrl}bvd-interface`, datas).subscribe((data: any) => {
      const bVdDatas = JSON.parse(data.result);
      let tempData = '';
      if (this.SitesInfoBvd && this.SitesInfoBvd.length > 0) {
        tempData = this.SitesInfoBvd['identifier'];
      }
      this.SitesInfoBvd = bVdDatas['Data'][ZERO];
      if (tempData != '') {
        this.SitesInfoBvd['identifier'] = tempData;
      }
      console.info("BvD-SiteLog", this.SitesInfoBvd);
      const city = this.commonService.hasNoSpecialCharacters(this.SitesInfoBvd['CITY_STANDARDIZED'], this.SitesInfoBvd['CITY']);
      this.saveSitesDetails(this.SitesInfoBvd['NAME'], this.SitesInfoBvd['COUNTRY_ISO_CODE'], city === null ? 'UNKNOWN' : city, this.SitesInfoBvd['POSTCODE'], this.companyID, bvdId, "S", this.SitesInfoBvd, mainCount);
    }, _error => {
      this.showAddSiteProcessing = false;
      this.addSiteCurrentStatus = 'BvD interface API error (Timeout)';
    });
  }
  saveSitesDetails(CmpName, counName, CityName, Postal, CompanayID, BvDidforsite, fromCnS = "N", thisBvDdata: any = [], mainCount, times = ONE, counFilter = 'none') {
    console.info("thisBvDdata", thisBvDdata);
    console.info("**** Create Site Processing ****");
    console.info(`Site Name : ${CmpName} ${CityName} Country : ${counName} City Name :${CityName} Postal : ${Postal} Company ID${CompanayID} BvD for Site${BvDidforsite}`);
    console.info('debug>>', this.CountryNameKeyId);
    this.addSiteCurrentStatus = 'Creating Site';
    if (this.isMissingSiteValue(CityName)) {
      CityName = 'UNKNOWN';
      console.info('changing city to unknown');
    }
    const countryMissing = this.CountryNameKeyId[counName] == undefined;
    if (this.handleMissingSiteCountry(countryMissing, times, counName, counFilter, CmpName, CityName, Postal, CompanayID, BvDidforsite, fromCnS, thisBvDdata, mainCount)) { return; }
    const countryId = this.CountryNameKeyId[counName]['countryId'];
    const countryCode = this.CountryNameKeyId[counName]['countryCode'];
    const cntryName = this.CountryNameKeyId[counName]['countryName'];
      if (this.CityNameKeyId[CityName] == undefined || this.CityNameKeyId[CityName] == 'undefined') {
        this.getCityList(CityName, CityName, counName);
        console.info("CityKey", this.CityNameKeyId);
        setTimeout(() => this.completeSiteCityLookup(CityName, CmpName, Postal, CompanayID, BvDidforsite, fromCnS, thisBvDdata, mainCount, countryId, countryCode, cntryName), TWO_THOUSAND);
      } else {
        const cityId = CityName === null ? undefined : this.CityNameKeyId[CityName]["rowId"];
        this.saveSiteInformation(countryId, cityId, `${CmpName} ${CityName}`, Postal, CompanayID, BvDidforsite, fromCnS, thisBvDdata, mainCount);
      }
  }
  private handleMissingSiteCountry(countryMissing: boolean, times: number, counName: any, counFilter: string, CmpName: any, CityName: any, Postal: any, CompanayID: any, BvDidforsite: any, fromCnS: any, thisBvDdata: any, mainCount: any): boolean {
    const validCountryName = counName != null && counName != '' && counFilter != 'yes';
    if (countryMissing && times < TWO && validCountryName) {
      console.info('No country id found, search in list and retry....');
      this.countryService.getCountries(`${this.Config.ApiCountryUrl}countries?countryCode=${counName}&_page=1`).subscribe((data: any) => {
        this.addCountryResults(data);
        this.saveSitesDetails(CmpName, counName, CityName, Postal, CompanayID, BvDidforsite, fromCnS, thisBvDdata, mainCount, times + ONE);
        this.storeTempCountryList(CmpName, counName, CityName, Postal, CompanayID, BvDidforsite, fromCnS, thisBvDdata, mainCount, times);
      });
      return true;
    }
    if (countryMissing && times == TWO && counFilter != 'yes') {
      this.storeTempCountryList(CmpName, counName, CityName, Postal, CompanayID, BvDidforsite, fromCnS, thisBvDdata, mainCount, times);
      console.info('tempVarCounList', this.tempVarCounList);
      console.info('country list', this.countrySelList);
      if (this.countrySelList.length == ONE) {
        this.selectedCustomCountry = this.countrySelList[ZERO];
        this.saveSitesDetails(this.tempVarCounList['CmpName'], this.selectedCustomCountry, this.tempVarCounList['CityName'], this.tempVarCounList['Postal'], this.tempVarCounList['CompanayID'], this.tempVarCounList['BvDidforsite'], this.tempVarCounList['fromCnS'], this.tempVarCounList['thisBvDdata'], this.tempVarCounList['mainCount'], this.tempVarCounList['times'], 'yes');
      } else {
        document.getElementById('btnForSelectCountryId').click();
      }
      return true;
    }
    return false;
  }
  private isMissingSiteValue(value: any): boolean {
    return value == undefined || value == '' || value == null;
  }
  private addCountryResults(data: any): void {
    if (data['count'] <= ZERO) { return; }
    for (const element of data['countries']) {
      if (this.CaptCountry.indexOf(element.countryName) == NEGATIVE_ONE) {
        this.CountryNameKeyId[element.countryCode] = {
          countryCode: element['countryCode'],
          countryName: element['countryName'],
          countryId: element['rowId']
        };
      }
      if (this.countrySelList.indexOf(element.countryName) == NEGATIVE_ONE) {
        this.countrySelList.push(`${element.countryCode} - ${element.countryName}`);
      }
    }
  }
  private storeTempCountryList(CmpName: any, counName: any, CityName: any, Postal: any, CompanayID: any, BvDidforsite: any, fromCnS: any, thisBvDdata: any, mainCount: any, times: any): void {
    this.tempVarCounList['CmpName'] = CmpName;
    this.tempVarCounList['counName'] = counName;
    this.tempVarCounList['CityName'] = CityName;
    this.tempVarCounList['Postal'] = Postal;
    this.tempVarCounList['CompanayID'] = CompanayID;
    this.tempVarCounList['BvDidforsite'] = BvDidforsite;
    this.tempVarCounList['fromCnS'] = fromCnS;
    this.tempVarCounList['thisBvDdata'] = thisBvDdata;
    this.tempVarCounList['mainCount'] = mainCount;
    this.tempVarCounList['times'] = times;
  }
  private completeSiteCityLookup(CityName: any, CmpName: any, Postal: any, CompanayID: any, BvDidforsite: any, fromCnS: any, thisBvDdata: any, mainCount: any, countryId: any, countryCode: any, cntryName: any): void {
    console.info("ltest", this.CityNameKeyId[CityName]);
    const city = this.CityNameKeyId[CityName];
    if (city != undefined && city != 'undefined') {
      this.saveSiteInformation(countryId, city["rowId"], `${CmpName} ${CityName}`, Postal, CompanayID, BvDidforsite, fromCnS, thisBvDdata, mainCount);
      return;
    }
    const cityDatas = { countryCode, name: CityName, active: "1", countryName: cntryName, countryId };
    this.countryService.createCities(`${this.Config.ApiCountryUrl}cities`, cityDatas).subscribe((dataCity: any) => {
      this.saveSiteInformation(countryId, dataCity["rowId"], `${CmpName} ${CityName}`, Postal, CompanayID, BvDidforsite, fromCnS, thisBvDdata, mainCount);
    });
  }
  saveSiteInformation(countryId, cityId, Site_Name, Postal = '', CompanayID, BvDidforsite, fromCnS = "N", thisBvDdata: any = [], mainCount) {
    console.info("thisBvDdata2", thisBvDdata);
    this.SiteRowID = [];
    let siteDatas = {};
    const cityname = Site_Name.split(' ')
    const index = cityname.length - ONE
    if (!this.showForSupplier || this.siteAddRequestSelected) {
      siteDatas = {
        cityId,
        countryId,
        activeStatus: "ACTIVE",
        name: Site_Name,
        usualName: `${this.companyShortName} ${cityname[index]}`,
        effectiveDate: this.commonService.getTodayDate(),
        "irnAuthor": "IRN-71016",
        "siaAuthor": "IAF",
        "isMergingSite": this.varIsMergingSite,
        "workflowStatus": "WaitingForSupplier"
      };
    } else {
      siteDatas = {
        cityId,
        countryId,
        activeStatus: "CREATED",
        name: Site_Name,
        usualName: `${this.companyShortName} ${cityname[index]}`,
        effectiveDate: this.commonService.getTodayDate(),
        "irnAuthor": "IRN-71016",
        "siaAuthor": "IAF",
        "isMergingSite": this.varIsMergingSite,
      };
    }
    this.siteService.createSite(`${this.Config.ApiSitesUrl}sites`, siteDatas).subscribe((dataSite: any) => {
      const site_row_id = dataSite["rowId"];
      console.info(`Created New site ID is : ${dataSite["rowId"]}`);
      this.SiteRowID.push(dataSite["rowId"]);
      const accessPDatas = {
        activeStatus: "ACTIVE",
        activity: "A10",
        realEstateAssetId: site_row_id,
        type: "P14",
        label: Site_Name,
        effectiveDate: this.commonService.getTodayDate(),
        "irnAuthor": "IRN-71016",
        "siaAuthor": "IAF"
      };
      this.addSiteCurrentStatus = 'Creating Access Points';
      this.siteService.createAccessPoint(`${this.Config.ApiSitesUrl}access-points`, accessPDatas).subscribe((dataAccessP: any) => this.handleSiteAccessPointCreated(dataAccessP, thisBvDdata, Postal, cityId, countryId, site_row_id, CompanayID, BvDidforsite, Site_Name, fromCnS, mainCount));
    });
  }
  private handleSiteAccessPointCreated(dataAccessP: any, bvdData: any, postal: string, cityId: any, countryId: any, siteRowId: any, companyId: any, bvdId: any, siteName: string, fromCnS: string, mainCount: any): void {
    const accessPointId = dataAccessP["rowId"];
    const addressData = this.getSiteAddressPayload(bvdData, postal, cityId, countryId);
    this.addSiteCurrentStatus = 'Creating Addresses';
    this.addressService.createGeographicalAddresses(`${this.Config.ApiAddressUrl}geographical-addresses`, addressData).subscribe((dataGeoA: any) => {
      this.createSiteAccessPointAddress(accessPointId, dataGeoA["rowId"]);
      this.createSiteGeolocationAddress(accessPointId, bvdData);
      this.addSiteCategoryToAssignment(siteRowId, companyId, bvdId, siteName, fromCnS, mainCount);
    });
  }
  private getSiteAddressPayload(bvdData: any, postal: string, cityId: any, countryId: any): any {
    if (this.isMissingSiteValue(bvdData['ADDRESS_LINE1'])) { bvdData['ADDRESS_LINE1'] = 'UNKNOWN'; }
    let additionalInformation = '';
    if (bvdData['ADDRESS_LINE2'] != null && bvdData['ADDRESS_LINE2'] != '') { additionalInformation += `${bvdData['ADDRESS_LINE2']} `; }
    if (bvdData['ADDRESS_LINE3'] != null && bvdData['ADDRESS_LINE2'] != '') { additionalInformation += bvdData['ADDRESS_LINE3']; }
    const payload: any = { additionalInformation, streetName: bvdData['ADDRESS_LINE1'], cityId, countryId, "irnAuthor": "IRN-71016", "siaAuthor": "IAF" };
    if (!this.isMissingSiteValue(postal)) { payload.postalCode = postal; }
    return payload;
  }
  private createSiteAccessPointAddress(accessPointId: any, addressId: any): void {
    this.siteService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, { accessPointId, addressId }).subscribe((_dataAccessPoint: any) => { });
  }
  private createSiteGeolocationAddress(accessPointId: any, bvdData: any): void {
    if ((bvdData['LATITUDE'] === '' || bvdData['LATITUDE'] === null) && (bvdData['LONGITUDE'] === '' || bvdData['LONGITUDE'] === null)) { return; }
    const gpsDatas = { accessPointId, latitude: bvdData['LATITUDE']?.toString() ?? '', longitude: bvdData['LONGITUDE']?.toString() ?? '' };
    this.addressService.createGeolocationCoordinatesAddresses(`${this.Config.ApiAddressUrl}geolocation-coordinates-addresses`, gpsDatas).subscribe((dataGeoA: any) => {
      console.info("geolocation-coordinates-addresses : ", dataGeoA);
      this.createSiteAccessPointAddress(accessPointId, dataGeoA['rowId']);
    });
  }
  addSiteCategoryToAssignment(site_row_id, CompanayID, BvDidforsite, Site_Name, fromCnS = "N", mainCount) {
    this.addSiteCurrentStatus = 'Creating Assignments';
    const newCategory = { "realEstateAssetId": site_row_id, "categoryId": this.newCategoryAssignment, "categoryName": this.newCategoryName }
    this.siteService.createRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments`, newCategory).subscribe(_data012 => {
    });
    this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${site_row_id}&_page=1&status=VALIDATED`).subscribe(data => {
      if (data['pageCount'] == ONE) {
        if (data['site-assignments'][ZERO]['status'] == 'VALIDATED') {
          console.info("SRifalse1");
        } else {
          console.info("SRitrue1");
          this.changeCompanySiteAssnNoExist(site_row_id, CompanayID, BvDidforsite, Site_Name, fromCnS, mainCount);
        }
      } else if (data['pageCount'] > ONE) {
        this.bvdidloading = false;
        console.info("SRifalse2");
      } else {
        this.bvdidloading = false;
        console.info("SRitrue2");
        this.changeCompanySiteAssnNoExist(site_row_id, CompanayID, BvDidforsite, Site_Name, fromCnS, mainCount);
      }
    });
  }
  changeCompanySiteAssnNoExist(siteID, CMPiD, BvDidforsite, Site_Name, fromCnS = "N", mainCount) {
    let tempBusinessRowId;
    this.addSiteCurrentStatus = 'Creating BvD for Site';
    if (fromCnS == "S") {
      const datas2 = { modificationStatus: "VALIDATED", isHQ: "N", companyId: CMPiD };
      this.supplierService.CreateBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities`, datas2).subscribe((dataGApprovals: any) => {
        tempBusinessRowId = dataGApprovals['row_id'];
        this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=${tempBusinessRowId}&_page=1`).subscribe(data1 => {
          if (data1['pageCount'] <= ZERO) {
            const const2 = {
              "businessEntityIdentifierTypeId": "1",
              "businessEntityIdentifierTypeName": "BVD ID",
              "startDate": this.commonService.getTodayDate(),
              "businessEntityId": tempBusinessRowId,
              "value": BvDidforsite
            }
            this.supplierService.CreateBusinessEntities(`${this.Config.ApiSupplierUrl}business-entity-identifiers`, const2).subscribe(_data2 => {
            });
          }
          const const3 = {
            "validityStartDate": this.commonService.getTodayDate(),
            "status": "VALIDATED",
            "businessEntityId": tempBusinessRowId
          }
          this.supplierService.CreateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${siteID}`, const3).subscribe(_data3 => {
            this.changeParamsforNewCpy('doesnotexist', siteID, CMPiD, Site_Name, BvDidforsite, fromCnS, mainCount);
          })
        });
      });
    } else {
      this.commonService.get(`${this.Config.ApiSupplierUrl}business-entities?companyId=${CMPiD}&isHQ=Y`).subscribe(data => {
        if (data['business-entities'].length > ZERO) {
          tempBusinessRowId = data['business-entities'][ZERO]['row_id'];
          this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=${tempBusinessRowId}&_page=1`).subscribe(data1 => {
            if (data1['pageCount'] <= ZERO) {
              const const2 = {
                "businessEntityIdentifierTypeId": "1",
                "businessEntityIdentifierTypeName": "BVD ID",
                "startDate": this.commonService.getTodayDate(),
                "businessEntityId": tempBusinessRowId,
                "value": BvDidforsite
              }
              this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`, const2).subscribe(_data2 => {
              });
            }
            const const3 = {
              "validityStartDate": this.commonService.getTodayDate(),
              "status": "VALIDATED",
              "businessEntityId": tempBusinessRowId
            }
            this.addSiteCurrentStatus = 'Creating Site Assignment';
            this.supplierService.CreateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${siteID}`, const3).subscribe(_data3 => {
              this.changeParamsforNewCpy('doesnotexist', siteID, CMPiD, Site_Name, BvDidforsite, fromCnS, mainCount);
            });
          });
        } else {
          const datas = { companyId: CMPiD, isHQ: "Y" };
          this.supplierService.CreateBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities`, datas).subscribe(data2 => {
            tempBusinessRowId = data2['row_id'];
            this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=${tempBusinessRowId}&_page=1`).subscribe(data1 => {
              if (data1['pageCount'] <= ZERO) {
                const const2 = {
                  "businessEntityIdentifierTypeId": "1",
                  "businessEntityIdentifierTypeName": "BVD ID",
                  "startDate": this.commonService.getTodayDate(),
                  "businessEntityId": tempBusinessRowId,
                  "value": BvDidforsite
                }
                this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`, const2).subscribe(_data2 => {
                });
              }
              const const3 = {
                "validityStartDate": this.commonService.getTodayDate(),
                "status": "VALIDATED",
                "businessEntityId": tempBusinessRowId
              }
              this.supplierService.CreateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${siteID}`, const3).subscribe(_data3 => {
                this.changeParamsforNewCpy('doesnotexist', siteID, CMPiD, Site_Name, BvDidforsite, fromCnS, mainCount);
              });
            });
          });
        }
      });
    }
  }
  changeParamsforNewCpy(con, site_id, CompanayID, Site_Name, BvDidforsite, fromCnS = "N", mainCount) {
    this.cpyAlcorToRaft = [];
    this.addSiteCurrentStatus = 'Creating Raft Account';
    if (CompanayID != '' && CompanayID != undefined) {
      this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies/${CompanayID}`).subscribe(data1 => {
        const const1 = { "name": Site_Name }
        this.siteService.updateSite(`${this.Config.ApiSitesUrl}sites/${site_id}`, const1).subscribe(_data0 => {
        });
        let shortName
        this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}company-names?companyNameTypeName=SHORT NAME&companyId=${CompanayID}`).subscribe(data2 => {
          if (data2['company-names'].length > ZERO) {
            shortName = data2['company-names'][ZERO]['value'];
          } else {
            shortName = data1['legalName'].slice(ZERO, TEN);
          }
          this.siteService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?realEstateAssetId=${site_id}&identifierType=RAFT_ACCOUNT`).subscribe(data6 => {
            this.applyRaftAccountTracking(data6, data1, shortName, site_id, CompanayID, BvDidforsite, fromCnS, mainCount, con);
          });
          this.siteService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?realEstateAssetId=${site_id}&identifierType=SHORT_NAME`).subscribe(data3 => {
            if (data3['real-estate-asset-identifiers'].length > ZERO) {
              const tempShtNameRowId = data3['real-estate-asset-identifiers'][ZERO]['rowId'];
              const const11 = { 'endDate': this.commonService.getTodayDate() }
              this.siteService.updateRealEstateAssetIdentifier(this.Config.ApiSitesUrl + REAL_ESTATE_ASSET_IDENTIFIERS_PATH + tempShtNameRowId, const11).subscribe(_data4 => {
              });
            }
          });
        });
        this.changeRealEstateAssignments(site_id, data1['legalName']);
      });
    }
  }
  private updateAlcorSiteIdentifiers(data90: any, data6: any, con: any, alcorValsOfCpy: any[], idensData: any, shortName: string, site_id: any): void {
    const allSitesAlcorVals = [];
    this.createAlcorSiteIdentifiers(data90, alcorValsOfCpy, idensData, shortName, site_id, allSitesAlcorVals);
    this.updateRemovedAlcorSiteIdentifiers(data6, con, alcorValsOfCpy, allSitesAlcorVals);
    this.createRemainingAlcorSiteIdentifiers(alcorValsOfCpy, idensData, shortName, site_id);
  }
  private createAlcorSiteIdentifiers(data90: any, alcorValsOfCpy: any[], idensData: any, shortName: string, site_id: any, allSitesAlcorVals: any[]): void {
    if (data90['real-estate-asset-identifiers'].length <= ZERO) { return; }
    const realEstateAviodDuplicate = [];
    for (const elementAlcor of data90['real-estate-asset-identifiers']) {
      allSitesAlcorVals.push(elementAlcor.businessIdentifierValue);
      const indexTemp = alcorValsOfCpy.indexOf(elementAlcor.businessIdentifierValue);
      alcorValsOfCpy.splice(indexTemp, ONE);
      if (idensData[elementAlcor.businessIdentifierValue] && alcorValsOfCpy.indexOf(elementAlcor.businessIdentifierValue) == NEGATIVE_ONE && elementAlcor.endDate == '' && realEstateAviodDuplicate.indexOf(elementAlcor.businessIdentifierValue) == NEGATIVE_ONE) {
        const constN = { "businessIdentifierId": this.siteIdenTypeDetails['RAFT_ACCOUNT'], "sourceSystemId": "2", "businessIdentifierValue": elementAlcor.businessIdentifierValue, "effectiveDate": elementAlcor.effectiveDate, "businessIdentifierName": elementAlcor.businessIdentifierName, "realEstateAssetId": site_id };
        realEstateAviodDuplicate.push(elementAlcor.businessIdentifierValue);
        this.siteService.createRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers`, constN).subscribe(_data9 => { });
      } else if (idensData[elementAlcor.businessIdentifierValue] && idensData[elementAlcor.businessIdentifierValue].endDate == '' && realEstateAviodDuplicate.indexOf(elementAlcor.businessIdentifierValue) == NEGATIVE_ONE) {
        const constN = { "businessIdentifierId": this.siteIdenTypeDetails['RAFT_ACCOUNT'], "sourceSystemId": "2", "businessIdentifierValue": idensData[elementAlcor.businessIdentifierValue].value, "effectiveDate": this.commonService.getTodayDate(), "businessIdentifierName": shortName, "realEstateAssetId": site_id };
        realEstateAviodDuplicate.push(elementAlcor.businessIdentifierValue);
        this.siteService.createRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers`, constN).subscribe(_data9 => { });
      } else {
      }
    }
  }
  private updateRemovedAlcorSiteIdentifiers(data6: any, con: any, alcorValsOfCpy: any[], allSitesAlcorVals: any[]): void {
    const newEndDate = { "endDate": this.commonService.getTodayDate() };
    for (const elementA of data6['real-estate-asset-identifiers']) {
      if (con == 'exist' && alcorValsOfCpy.indexOf(elementA.businessIdentifierValue) == NEGATIVE_ONE && allSitesAlcorVals.indexOf(elementA.businessIdentifierValue) == NEGATIVE_ONE) {
        this.siteService.updateRealEstateAssetIdentifier(this.Config.ApiSitesUrl + REAL_ESTATE_ASSET_IDENTIFIERS_PATH + elementA.rowId, newEndDate).subscribe(_data7 => { });
      } else if (con == 'exist' && alcorValsOfCpy.indexOf(elementA.businessIdentifierValue) == NEGATIVE_ONE) {
        this.siteService.deleteRealEstateAssetIdentifier(this.Config.ApiSitesUrl + REAL_ESTATE_ASSET_IDENTIFIERS_PATH + elementA.rowId).subscribe(_data7 => { });
      } else {
      }
    }
  }
  private createRemainingAlcorSiteIdentifiers(alcorValsOfCpy: any[], idensData: any, shortName: string, site_id: any): void {
    for (const elementNew of alcorValsOfCpy) {
      if (idensData[elementNew].endDate == '') {
        const constal = { "businessIdentifierId": this.siteIdenTypeDetails['RAFT_ACCOUNT'], "sourceSystemId": "2", "businessIdentifierValue": idensData[elementNew].value, "effectiveDate": this.commonService.getTodayDate(), "businessIdentifierName": shortName, "realEstateAssetId": site_id };
        this.siteService.createRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers`, constal).subscribe(_data9 => { });
      }
    }
  }
  changeRealEstateAssignments(site_id, CompNme) {
    this.siteService.getRealEstateAssetAssignments(`${this.Config.ApiSitesUrl}real-estate-asset-assignments?realEstateAssetId=${site_id}`).subscribe(data => {
      if (data['real-estate-asset-assignments'].length > ZERO) {
        let exist: any = false;
        let rowId = '';
        const const1 = { categoryId: this.newCategoryAssignment, categoryName: this.newCategoryName };
        const constEndDate = { "endDate": this.commonService.getTodayDate() };
        for (const [index, element] of data['real-estate-asset-assignments'].entries()) {
          if ((element.categoryCode != '') && !exist && element.legalEntityIdentifier == '') {
            rowId = element.rowId;
            exist = true;
          }
          if (element.legalEntityIdentifier != '' && element.endDate != '') {
            this.siteService.updateRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments/${element.rowId}`, constEndDate).subscribe(_data1 => {
            });
          }
        }
        if (!exist) {
          this.siteService.updateRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments/${rowId}`, const1).subscribe(_data => {
          });
        }
      }
    });
    const newLegalEntity = { "corporateName": CompNme, "active": '1' }
    this.siteService.getRealEstateAssetAssignments(`${this.Config.ApiSitesUrl}real-estate-asset-assignments?corporateName=${CompNme}&realEstateAssetId=${site_id}`).subscribe(data014 => {
      this.applyLegalEntityToSite(data014, site_id, CompNme, newLegalEntity);
    });
  }
  private applyLegalEntityToSite(data014: any, site_id: any, CompNme: string, newLegalEntity: any): void {
    let runLegal = true;
    if (data014['real-estate-asset-assignments'].length > ZERO) {
      const endDateSet = { endDate: this.commonService.getTodayDate() };
      const noEndD = { endDate: '' };
      for (let i = ZERO; i < data014['real-estate-asset-assignments'].length; i++) {
        const assign = data014['real-estate-asset-assignments'][i];
        if (assign['legalEntityIdentifier'] != '' && assign['endDate'] == '' && assign['legalEntityCorporateName'] != CompNme) {
          this.siteService.updateRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments/${assign['rowId']}`, endDateSet).subscribe(_data0 => { });
        }
        if (assign['legalEntityCorporateName'] == CompNme) { runLegal = false; }
        if (assign['legalEntityCorporateName'] == CompNme && assign['endDate'] != '') {
          this.siteService.updateRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments/${assign['rowId']}`, noEndD).subscribe(_data0 => { });
        }
      }
    }
    if (runLegal) {
      this.siteService.createLegalEntity(`${this.Config.ApiSitesUrl}legal-entities`, newLegalEntity).subscribe(data013 => {
        this.siteService.createRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments`, { 'realEstateAssetId': site_id, 'legalEntityId': data013['rowId'] }).subscribe(_data015 => { });
      });
    }
  }
  changeAccessPointsToPending(site_id, _CompanayID, _BvDidforsite) {
    this.siteService.getAccessPoints(`${this.Config.ApiSitesUrl}access-points?realEstateAssetId=in(${site_id})&_page=1`).subscribe(data => {
      if (data['access-points'].length > ZERO) {
        this.applyAccessPointPendingStatus(data['access-points']);
      }
    });
  }
  private applyAccessPointPendingStatus(accessPoints: any[]): void {
    const constPending = { "activeStatus": "PENDING" };
    const constActive = { "activeStatus": "ACTIVE" };
    const constEndDate = { "endDate": this.commonService.getTodayDate() };
    const OrderManuInvoi = ['P05', 'P06', 'P11'];
    for (const element of accessPoints) {
      if (this.qualifierChangetoPending.indexOf(element.type) !== NEGATIVE_ONE) {
        if (element.activeStatus != 'PENDING') {
          if (element.activeStatus == 'ARCHIVED') {
            this.siteService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${element.rowId}`, constActive).subscribe(_data0 => {
              this.siteService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${element.rowId}`, constPending).subscribe(_data11 => { });
            });
          } else {
            this.siteService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${element.rowId}`, constPending).subscribe(_data1 => { });
          }
        }
        if (OrderManuInvoi.indexOf(element.type) != NEGATIVE_ONE && element.identifier) {
          this.siteService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${element.identifier}`, constEndDate).subscribe(_data12 => { });
        }
      }
    }
  }
  getCityList(event: any, CName = "", countryName = '') {
    console.info('city',CName,countryName)
    if (this.selectedCountry != "failed" && event.length >= TWO) {
      const NCityName = CName == "" ? this.siteCityModel : CName;
      const NcountryName = countryName == '' ? this.siteCountryModel : countryName;
      this.countryService.getCities(`${this.Config.ApiCountryUrl}cities?countryCode=${NcountryName}&name=*${NCityName}*&_page=1&_pagesize=20`).subscribe((data: any) => {
        if (data['count'] > ZERO) {
          this.CityNameKeyId = "";
          this.CityNameKeyId = [];
          this.CaptCity = "";
          this.CaptCity = [];
          for (const element of data['cities']) {
            this.CaptCity.push(element.name);
            this.CityNameKeyId[element.name] = element;
          }
        } else {
          this.CaptCity = [];
        }
      });
    } else {
      this.CaptCity = [];
    }
  }
  /**END Add site check HQ bvd */
  /**START get paying company database */
  loadPayingDatabase(currentPage = ONE, page = ONE, subscribeData = [], loop = 'start', autoSelectGrouping = true) {
    this.loading;
    if (loop == 'start') {
      this.cpyData = [];
      this.uniqueGroupingValues = [];
      this.payingCpyLoading = true;
      this.selectedPayingCpyVal = '';
      this.selectedPayingCpyVals = [];
      this.selectedPayingCompanies = [];
    }
    this.supplierService.get(`${this.Config.ApiSupplierUrl}paying-company?_page=${page}`).subscribe(data => {
      if (data['paying-company'].length > ZERO) {
        for (const e of data['paying-company']) {
          this.cpyData.push(e);
          this.payingCompanyCodeids[this.trimSpaces(e['legalName'])] = e['row_id'];
          this.payingCompanyCodeids1[this.trimSpaces(e['code'])] = e['row_id'];
        }
        if (data['maxPage'] > ONE && data['maxPage'] != page) {
          this.loadPayingDatabase(ONE, page + ONE, subscribeData, 'continue', autoSelectGrouping);

        } else if (data['maxPage'] == page) {
          this.payingCpyLoading = false;
          console.info('paying company data', this.cpyData);
        }
      } else {
        this.payingCpyLoading = false;
      }
      this.uniqueGroupingValues = this.getUniqueGroupingValues();
      if (
        autoSelectGrouping &&
        this.uniqueGroupingValues.length > ZERO &&
        (this.selectedPayingGrouping == '' || this.uniqueGroupingValues.indexOf(this.selectedPayingGrouping) == NEGATIVE_ONE)
      ) {
        this.selectedPayingGrouping = this.uniqueGroupingValues[ZERO];
      }
      this.applyPayingGroupingFilter(currentPage);
    }, _error => {
      this.payingCpyLoading = false;
    });
  }
  getUniqueGroupingValues() {
    return Array.from(
      new Set(
        this.cpyData
          .map((item: any) => item ? item['grouping'] : undefined)
          .filter(value => value !== undefined && value !== null && String(value).trim() !== '')
      )
    ).sort((a, b) => String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' }));
  }
  companyTable(page) {
    this.applyPayingGroupingFilter(page);
  }

  onPayingGroupingChange(grouping: string) {
    this.selectedPayingGrouping = grouping || '';
    this.selectedPayingCpyVals = [];
    this.payingCompanyCodeModelvalerror = false;
    this.applyPayingGroupingFilter(ONE);
  }

  getPayingCompanySelectionKey(cpyPay: any): string {
    return `${cpyPay.code}&&${cpyPay.legalName}`;
  }

  isPayingCompanySelected(cpyPay: any): boolean {
    return this.selectedPayingCpyVals.indexOf(this.getPayingCompanySelectionKey(cpyPay)) != NEGATIVE_ONE;
  }

  onPayingCompanyCheckedChange(cpyPay: any, checked: boolean) {
    const key = this.getPayingCompanySelectionKey(cpyPay);

    if (checked) {
      if (this.selectedPayingCpyVals.indexOf(key) == NEGATIVE_ONE) {
        this.selectedPayingCpyVals.push(key);
      }
      return;
    }

    this.selectedPayingCpyVals = this.selectedPayingCpyVals.filter((value: string) => value != key);
  }

  private getSelectableAvailablePayingCompanies(): any[] {
    if (!this.assignedPayingCmp || !Array.isArray(this.assignedPayingCmp)) {
      return [];
    }

    return this.assignedPayingCmp.filter((cpyPay: any) => !this.disable(cpyPay?.code));
  }

  isAllAvailablePayingSelected(): boolean {
    const selectable = this.getSelectableAvailablePayingCompanies();
    if (selectable.length == ZERO) {
      return false;
    }

    return selectable.every((cpyPay: any) => this.isPayingCompanySelected(cpyPay));
  }

  isAvailablePayingPartiallySelected(): boolean {
    const selectable = this.getSelectableAvailablePayingCompanies();
    if (selectable.length == ZERO) {
      return false;
    }

    const checkedCount = selectable.filter((cpyPay: any) => this.isPayingCompanySelected(cpyPay)).length;
    return checkedCount > ZERO && checkedCount < selectable.length;
  }

  toggleAllAvailablePaying(checked: boolean) {
    const selectable = this.getSelectableAvailablePayingCompanies();
    if (selectable.length == ZERO) {
      return;
    }

    if (checked) {
      for (const cpyPay of selectable) {
        const key = this.getPayingCompanySelectionKey(cpyPay);
        if (this.selectedPayingCpyVals.indexOf(key) == NEGATIVE_ONE) {
          this.selectedPayingCpyVals.push(key);
        }
      }
      return;
    }

    const selectableKeys = new Set(selectable.map((cpyPay: any) => this.getPayingCompanySelectionKey(cpyPay)));
    this.selectedPayingCpyVals = this.selectedPayingCpyVals.filter((value: string) => !selectableKeys.has(value));
  }

  private applyPayingGroupingFilter(page = ONE) {
    const selectedGrouping = (this.selectedPayingGrouping || '').trim();
    const sourceData = selectedGrouping
      ? this.cpyData.filter((item: any) =>
          ((item && item.grouping) ? String(item.grouping).trim() : '') == selectedGrouping &&
          (item.endDate === '' || item.endDate === null || item.endDate === undefined)
        )
      : this.cpyData.filter((item: any) =>
          item.endDate === '' || item.endDate === null || item.endDate === undefined
        );

    this.filteredPayingCpyCount = sourceData.length;

    this.cmpPager = this.pagerService.getPager(sourceData.length, page, TEN);
    const sortedPayingCompanies = [...sourceData].sort((a, b) => a.code.localeCompare(b.code));
    this.assignedPayingCmp=sortedPayingCompanies;
    console.info('assignedPayingCmp',this.assignedPayingCmp)
    this.payingCpyData = sortedPayingCompanies.slice(this.cmpPager.startIndex, this.cmpPager.endIndex + ONE);
    this.loading = sourceData.length > TEN ? false : true;
  }

   wfSelectPayingCompany() {
    if (this.selectedPayingCpyVal === '') {
      this.pComp_Name = '';
      this.selectedPayingCmpValue = 'failed';
      this.payingCompanyCodeModelvalerror = true;
    } else {
      const splits = this.selectedPayingCpyVal.split('&&');
      this.pComp_Name = splits[ZERO] + '-' + splits[ONE];
      this.selectedPayingCmpValue = splits[ZERO];
      this.payingCompanyCodeModelvalerror = false;
    }
  }
  selectPayingCompany() {
    if (this.selectedPayingCpyVals.length > ZERO) {
      const selectedKeys = new Set(this.selectedPayingCpyVals);
      const newlySelectedCompanies = this.cpyData
        .filter((cpy: any) => {
          return cpy && selectedKeys.has(this.getPayingCompanySelectionKey(cpy));
        })
        .map((cpy: any) => ({
          code: cpy.code,
          legalName: cpy.legalName
        }));

      const merged = [...this.selectedPayingCompanies, ...newlySelectedCompanies];
      this.selectedPayingCompanies = merged.filter((company: any, index: number, arr: any[]) => {
        return arr.findIndex((item: any) => item.code == company.code && item.legalName == company.legalName) == index;
      });

      const firstSelection = this.selectedPayingCompanies[ZERO];
      this.selectedPayingCpyVal = firstSelection ? `${firstSelection.code}&&${firstSelection.legalName}` : '';
      this.pComp_Name = firstSelection ? `${firstSelection.code}-${firstSelection.legalName}` : '';
      this.selectedPayingCmpValue = firstSelection?.code ?? 'failed';
      this.payingCompanyCodeModelvalerror = false;
      this.selectedPayingCpyVals = [];
    } else {
      this.payingCompanyCodeModelvalerror = true;
    }
  }
  selectAddPayingCompany() {
    if (this.selectedAddPayingCpyVal === '') {
      this.pComp_Name = '';
      this.selectedAddPayingCpyVal = 'failed';
      this.payingCompanyCodeModelvalerror = true;
    } else {
      const splits = this.selectedAddPayingCpyVal.split('&&');
      this.pComp_Name = `${splits[ZERO]}-${splits[ONE]}`;
      this.selectedAddPayingCpyVal = splits[ONE];
      this.payingCompanyCodeModelvalerror = false;
    }
  }
  /**END get paying company database */
  /**START send to buyer */
  sendToBuyer() {
    document.getElementById('btnForSentToBuyer').click();
    const sendReq = {
      "companyStatusCode": "Waiting for Approval",
      "companyStatusId": "6"
    };
    const siteStatusChange = {
      "activeStatus": "CREATED"
    };
    this.supplierService.UpdateCompany(`${this.Config.ApiSupplierUrl}companies/${this.companyID}`, sendReq).subscribe((_data: any) => { });
    for (const element of this.SitesInfo) {
      if (element.site) {
        const siteIdTemp = element.site.href.split('/');
        if (this.Site_City_Country[siteIdTemp[ONE]]['activeStatus'] == 'PENDING') {
          this.siteService.updateSite(`${this.Config.ApiSitesUrl}sites/${this.Site_City_Country[siteIdTemp[ONE]]['rowId']}`, siteStatusChange).subscribe(_data2 => {
          });
        }
      }
    }
  }
  /**START send to buyer */
  /**add site fn */
  checkSelRunSite() {
    if (this.selectedCustomCountry != '') {
      this.saveSitesDetails(this.tempVarCounList['CmpName'], this.selectedCustomCountry, this.tempVarCounList['CityName'], this.tempVarCounList['Postal'], this.tempVarCounList['CompanayID'], this.tempVarCounList['BvDidforsite'], this.tempVarCounList['fromCnS'], this.tempVarCounList['thisBvDdata'], this.tempVarCounList['mainCount'], this.tempVarCounList['times'], 'yes');
    }
  }
  /**END add site fn */
  /**START delete sharepoint document */
  delSPfile() {
    if (this.genDoc) {
      this.documentService.deleteServiceCall(`${this.Http_URL}deleteGenericfile/${this.documentId}`).subscribe((_data: any) => {
        document.getElementById('closeDelSharepointDoc').click();
        this.getGenericDocumentDetails();
      });
    } else {
      this.documentService.deleteServiceCall(`${this.Http_URL}deletefile/${this.documentId}`).subscribe((_data: any) => {
        document.getElementById('closeDelSharepointDoc').click();
        this.getCompanyDocumentDetails();
      });
    }
  }
  /**END delete sharepoint document */
  delGenSPfile() {
    console.info('generic')
  }
  /**START focus function for sam and buyer */
  focusFunction(field) {
    if (field == 'sam' && this.senReqSamMOdel == '') {
      this.lookupArca('sam');
      document.getElementById('btnForArcaPopup').click();
    } else if (field == 'buyerassistant' && this.senReqBuyerAssiMOdel == '') {
      this.lookupArca('buyeraasis');
      document.getElementById('btnForArcaPopup').click();
    } else if (field == 'payingcompany') {
      this.selectedPayingGrouping = '';
      this.loadPayingDatabase(ONE, ONE, [], 'start', false);
      document.getElementById('btnForPayingCompanyPopUp').click();
    } else {
    }
  }
  /**END focus function for sam and  buyer */
  /**Select paying cpy */
  setPayingCpy(code, name) {
    let data: any[] = [];
    data = this.activeValue.filter(abc => abc.clientCompanyCode === code)
    if (data.length > ZERO) {
      data.filter(abc => {
        abc.clientCompanyCode === code ? this.selectedPayingCpyVal = `${code}&&${name}` : ''
      })
    }
    else {
      this.selectedPayingCpyVal = `${code}&&${name}`
    }
  }
  disable(code): boolean {
    if (!code || !this.PayingInfo || !Array.isArray(this.PayingInfo)) {
      return false;
    }

    return this.PayingInfo.some((assigned: any) => assigned && assigned.clientCompanyCode === code);
  }
  /** */
  /** Shared helper: index access-point-identifier values into a site-keyed map */
  private populateSiteIdentifierMap(data: any, map: any[]): void {
    if (data['access-point-identifiers'].length <= ZERO) { return; }
    for (const e of data['access-point-identifiers']) {
      if (map[e.siteIdentifier] == undefined) { map[e.siteIdentifier] = []; }
      if (map[e.siteIdentifier].indexOf(e.identifierValue) == NEGATIVE_ONE) {
        map[e.siteIdentifier].push(e.identifierValue);
      }
    }
  }
  /**START show site raft code in search */
  getSiteRaftCodes(rowIds, page = ONE, splitrowids = [], morethan20rec = false, remainingRows = []) {
    if (rowIds.length <= ZERO) { return; }
    if (rowIds.length > TWENTY) {
      splitrowids = rowIds.slice(ZERO, TWENTY);
      remainingRows = rowIds.slice(TWENTY, rowIds.length);
      morethan20rec = true;
    } else {
      morethan20rec = false;
      splitrowids = rowIds;
    }
    this.siteService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=RAFT_CODE&siteIdentifier=in(${splitrowids})&_page=${page}`).subscribe(data => {
      this.handleSiteRaftCodesResponse(data, rowIds, page, morethan20rec, remainingRows);
    });
  }
  private handleSiteRaftCodesResponse(data: any, rowIds: any[], page: number, morethan20rec: boolean, remainingRows: any[]): void {
    this.populateSiteIdentifierMap(data, this.siteRaftCodeValOnRowId);
    if (data['maxPage'] > ONE && data['maxPage'] != page) {
      this.getSiteRaftCodes(rowIds, page + ONE);
    } else if (data['maxPage'] == page) {
      console.info('arr', this.siteRaftCodeValOnRowId);
      if (morethan20rec) { this.getSiteRaftCodes(remainingRows, ONE, [], morethan20rec, remainingRows); }
    } else {
    }
  }
  /**END show site raft code in search */
  getSiteSaerCodes(rowIds, page = ONE, splitrowids = [], morethan20rec = false, remainingRows = []) {
    if (rowIds.length <= ZERO) { return; }
    if (rowIds.length > TWENTY) {
      splitrowids = rowIds.slice(ZERO, TWENTY);
      remainingRows = rowIds.slice(TWENTY, rowIds.length);
      morethan20rec = true;
    } else {
      morethan20rec = false;
      splitrowids = rowIds;
    }
    this.siteService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=SAER_CODE&siteIdentifier=in(${splitrowids})&_page=${page}`).subscribe(data => {
      this.handleSiteSaerCodesResponse(data, rowIds, page, morethan20rec, remainingRows);
    });
  }
  private handleSiteSaerCodesResponse(data: any, rowIds: any[], page: number, morethan20rec: boolean, remainingRows: any[]): void {
    this.populateSiteIdentifierMap(data, this.siteSaerCodeValOnRowId);
    if (data['maxPage'] > ONE && data['maxPage'] != page) {
      this.getSiteSaerCodes(rowIds, page + ONE);
    } else if (data['maxPage'] == page) {
      console.info('arr', this.siteSaerCodeValOnRowId);
      if (morethan20rec) { this.getSiteSaerCodes(remainingRows, ONE, [], morethan20rec, remainingRows); }
    } else {
    }
  }
  /**END show site raft code in search */
  getSiteLatamCodes(rowIds, page = ONE, splitrowids = [], morethan20rec = false, remainingRows = []) {
    if (rowIds.length <= ZERO) { return; }
    if (rowIds.length > TWENTY) {
      splitrowids = rowIds.slice(ZERO, TWENTY);
      remainingRows = rowIds.slice(TWENTY, rowIds.length);
      morethan20rec = true;
    } else {
      morethan20rec = false;
      splitrowids = rowIds;
    }
    this.siteService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=AP_LATAM_CODE&siteIdentifier=in(${splitrowids})&_page=${page}`).subscribe(data => {
      this.handleSiteLatamCodesResponse(data, rowIds, page, morethan20rec, remainingRows);
    });
  }
  private handleSiteLatamCodesResponse(data: any, rowIds: any[], page: number, morethan20rec: boolean, remainingRows: any[]): void {
    this.populateSiteIdentifierMap(data, this.siteLatamCodeValOnRowId);
    if (data['maxPage'] > ONE && data['maxPage'] != page) {
      this.getSiteLatamCodes(rowIds, page + ONE);
    } else if (data['maxPage'] == page) {
      console.info("this.siteLatamCodeValOnRowId", this.siteLatamCodeValOnRowId);
      if (morethan20rec) { this.getSiteLatamCodes(remainingRows, ONE, [], morethan20rec, remainingRows); }
    } else {
    }
  }
  getSiteRnaiplCodes(rowIds, page = ONE, splitrowids = [], morethan20rec = false, remainingRows = []) {
    if (rowIds.length <= ZERO) { return; }
    if (rowIds.length > TWENTY) {
      splitrowids = rowIds.slice(ZERO, TWENTY);
      remainingRows = rowIds.slice(TWENTY, rowIds.length);
      morethan20rec = true;
    } else {
      morethan20rec = false;
      splitrowids = rowIds;
    }
    this.siteService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=AP_RNAIPL_CODE&siteIdentifier=in(${splitrowids})&_page=${page}`).subscribe(data => {
      this.handleSiteRnaiplCodesResponse(data, rowIds, page, morethan20rec, remainingRows);
    });
  }
  private handleSiteRnaiplCodesResponse(data: any, rowIds: any[], page: number, morethan20rec: boolean, remainingRows: any[]): void {
    this.populateSiteIdentifierMap(data, this.siteRnaiplCodeValOnRowId);
    if (data['maxPage'] > ONE && data['maxPage'] != page) {
      this.getSiteRnaiplCodes(rowIds, page + ONE);
    } else if (data['maxPage'] == page) {
      if (morethan20rec) { this.getSiteRnaiplCodes(remainingRows, ONE, [], morethan20rec, remainingRows); }
    } else {
    }
  }

  getSiteC2bCodes(rowIds, page = ONE, splitrowids = [], morethan20rec = false, remainingRows = []) {
    if (rowIds.length <= ZERO) { return; }
    if (rowIds.length > TWENTY) {
      splitrowids = rowIds.slice(ZERO, TWENTY);
      remainingRows = rowIds.slice(TWENTY, rowIds.length);
      morethan20rec = true;
    } else {
      morethan20rec = false;
      splitrowids = rowIds;
    }
    this.siteService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=AP_C2B_CODE&siteIdentifier=in(${splitrowids})&_page=${page}`).subscribe(data => {
      this.handleSiteC2bCodesResponse(data, rowIds, page, morethan20rec, remainingRows);
    });
  }
  private handleSiteC2bCodesResponse(data: any, rowIds: any[], page: number, morethan20rec: boolean, remainingRows: any[]): void {
    this.populateSiteIdentifierMap(data, this.siteC2bCodeValOnRowId);
    if (data['maxPage'] > ONE && data['maxPage'] != page) {
      this.getSiteC2bCodes(rowIds, page + ONE);
    } else if (data['maxPage'] == page) {
      console.info('arr', this.siteC2bCodeValOnRowId);
      if (morethan20rec) { this.getSiteC2bCodes(remainingRows, ONE, [], morethan20rec, remainingRows); }
    } else {
    }
  }
  workflowDetailsfn(_page = ONE) {
    this.workFlowDetails = [];
    this.requestForNotesHistory = [];
    this.siteRowIdFilterWorkFlow = [];
    this.loading = true;
    this.tempWorkflow = [];
    this.Uid = this.commonService.fromApp_UserIPN.toLowerCase();
    const idpToken = localStorage.getItem('IDPAccessToken');
    const personCache = new Map();
    const sharePointOp = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
        apikey: this.Config.apikey
      })
    };
    console.info("access token Check", sharePointOp);
    this.commonService.clearAllActiveTask();
    try{
    this.k2Service.getAllActiveTask(`${this.Config.ApiK2SocleUrl}all-active-tasks?processName=ISA%20Workflow%5CISA_Workflow1`).subscribe(data1 => {
      this.commonService.setAllActiveTask(data1);
      this.k2Service.getK2Isa(`${this.Config.ApiK2Url}isa?companyAlianceIdentifier=${this.companyBasicInfo['allianceIdentifier']}`).subscribe(data => {
        this.loading = false;
        this.buildWorkflowOwnerMaps(data, data1, personCache);
        const len = this.workFlowDetails.length;
        if (len <= FIVE) {
          this.pageHeight = data['pageCount'] * THIRTY + WORKFLOW_PAGE_HEIGHT_OFFSET;
        } else {
          this.pageHeight = WORKFLOW_PAGE_HEIGHT_FALLBACK;
        }
        const sorted = this.workFlowDetails.sort((a, b) => (a.requestId > b.requestId ? NEGATIVE_ONE : ONE))
      }, error => {
        this.loading = false;
        console.info('error', error);
      });
    }, error => {
      this.loading = false;
      console.info('error', error);
    });
  } catch(error){
    console.info('error in workflowDetailsfn', error);
  }
  }
  private buildWorkflowOwnerMaps(data: any, data1: any[], personCache: Map<any, any>): void {
    if (data['listRequestDetails'].length <= ZERO) { return; }
    const uniqueIpns = new Set();
    const workflowOwnerIpns = new Map();
    const requestorIpns = new Map();
    for (const element of data['listRequestDetails']) {
      element['workflowOwnerWithRole'] = [];
      if (element['workflowOwner'] == undefined) { element['workflowOwner'] = []; }
      const elementIpns = [];
      for (const ele1 of data1) {
        if (element['folio'] && ele1['folio'].includes(element['folio'])) {
          const workflowOwner = ele1['locatedUser'].split(":");
          const ipn = workflowOwner[ONE].slice(workflowOwner[ONE].length - SEVEN).toLowerCase();
          uniqueIpns.add(ipn);
          elementIpns.push({ ipn, workflowOwner, ele1 });
        }
      }
      workflowOwnerIpns.set(element, elementIpns);
      if (element['requestor']['user'].toLowerCase().length == SEVEN) {
        const requestorIpn = element['requestor']['user'].toLowerCase();
        uniqueIpns.add(requestorIpn);
        requestorIpns.set(element, requestorIpn);
      }
    }
    const fetchPromises = Array.from(uniqueIpns).map(ipn => {
      if (personCache.has(ipn)) { return Promise.resolve({ ipn, data: personCache.get(ipn) }); }
      return firstValueFrom(this.arcaServices.getPerson(`${this.Config.ApiArcaURL}Person('${ipn}')`))
        .then((data7: any) => { personCache.set(ipn, data7); return { ipn, data: data7 }; })
        .catch(_err => { personCache.set(ipn, null); return { ipn, data: null }; });
    });
    Promise.all(fetchPromises).then(() => {
      for (const element of data['listRequestDetails']) {
        this.processWorkflowDetail(element, workflowOwnerIpns, requestorIpns, personCache);
      }
    });
  }
  private processWorkflowDetail(element: any, workflowOwnerIpns: Map<any, any>, requestorIpns: Map<any, any>, personCache: Map<any, any>): void {
    this.processWorkflowOwners(element, workflowOwnerIpns.get(element), personCache);
    this.processWorkflowRequestor(element, requestorIpns.get(element), personCache);
    this.finalizeWorkflowDetail(element);
  }
  private processWorkflowOwners(element: any, ownerDetails: any[], personCache: Map<any, any>): void {
    for (const { ipn, workflowOwner, ele1 } of ownerDetails) {
      element['taskID'] = ele1['serialNumber'];
      element['folio'] = ele1['folio'];
      const cachedData = personCache.get(ipn);
      if (cachedData?.['FirstName'] !== undefined) { element['workflowOwnerWithRole'].push(`${cachedData['FirstName']} ${cachedData['LastName']} - ${ipn.toUpperCase()}`); }
      else { element['workflowOwnerWithRole'].push(ipn); }
      if (element['supplierDetail'].includes('company-details/')) {
        const id = element['supplierDetail'].split("company-details/");
        element['companyId'] = id[ONE].replaceAll("'", '');
      }
      const tem = workflowOwner[ONE].split("\\");
      console.info("tem", tem[ONE]);
      element['supportipn'] = tem[ONE] == 'V033684';
      const tep = element['historys'].length > ZERO ? element['historys'][element['historys'].length - ONE]['date'] : '';
      const date1 = tep != '' && tep != null ? new Date(tep) : new Date(element.lastModificationDate);
      if (date1 && element['lastModificationDate']) {
        const lastModDate = new Date(element['lastModificationDate']);
        const diffMs = Date.now() - lastModDate.getTime();
        const diffDays = Math.floor(diffMs / (ONE_THOUSAND * SIXTY * SIXTY * 24));
        element['difference'] = diffDays;
        console.info('Days since last modification:', diffDays);
        element['date'] = diffDays >= ONE;
      }
      element['workflowOwner'].push(ipn);
    }
  }
  private processWorkflowRequestor(element: any, requestorIpn: any, personCache: Map<any, any>): void {
    if (requestorIpn) {
      const cachedRequestorData = personCache.get(requestorIpn);
      if (cachedRequestorData?.['Mail']) { element['RequestorMailId'] = cachedRequestorData['Mail']; }
    } else if (element['requestor']['user'].toLowerCase().length != SEVEN) { console.info('requestor user is not 7 characters ', element['requestor']['user']); }
  }
  private finalizeWorkflowDetail(element: any): void {
    this.siteRowIdFilterWorkFlow.push(element.requestId);
    if (this.workFlowDetails.length > ZERO) { this.workFlowVisibility = true; }
    this.tempWorkflow.push(element);
    this.workFlowDetails = this.tempWorkflow;
    console.info("workflow", this.workFlowDetails);
    this.handleFragmentScrolling();
    element['filterTrue'] = true;
    if (this.workflowStatus[element.requestId] == undefined) { this.workflowStatus[element.requestId] = []; }
    if (this.workflowStatus[element.requestId]) { this.workflowStatus[element.requestId] = [element.status]; }
  }
  returnNone() {
    return false;
  }
  openWorkflow(id) {
    const baseUrl1 = baseUrl
    if (baseUrl1 == opeUrl || baseUrl1 == opewafUrl || baseUrl1== opeNewwafUrl) {
      globalThis.open(shareLan + id);
    }
    else if (baseUrl1 == localUrl || baseUrl1 == `${localUrl}/` || baseUrl1 == intUrl) {
      globalThis.open(`${dev}Consult/?&language=EN&requestid=${id}`);
    }
    else {
      globalThis.open(intLan + id);
    }
  }
  switchVisible(btnId) {
    this.openData = true;
    this.openRole = false;
    if (btnId === 'btn1') {
      this.openData = true;
      this.openRole = false;
    } else {
      this.openRole = true;
      this.openData = false;
    }
  }
  openLink() {
    globalThis.open(`/view-supplier/${this.viewSupplier}`)
  }
  /**site status filter */
  getColor2(status) {
    const flag = ONE;
    for (let i = ZERO; i < this.colors2.length; i++) {
      if (this.colors2[i].status == status) {
        const flag = TWO
        return this.colors2.filter(item => item.status == status)[ZERO].color;
      }
    }
    if (flag == ONE) {
      return "#FFBD69";
    }
  }
  showDropdownStatus(dos = 'main') {
    if (dos == 'close') {
      for (const ele of this.FiltercheckStatus) {
        this[ele] = false;
        console.info("this", this[ele])
      }
    } else {
      this.showFilterStatus = !this.showFilterStatus;
      if (this.showFilterStatus) {
        this.showFilterSiteWorkflowStatus = false;
      }
    }
    setTimeout(function () {
      for (const ele of this.FiltercheckStatus) {
        const type = ele.split('_');
        if (this[ele]) {
          document.getElementById(type[ZERO]).setAttribute('checked', '');
        } else {
          document.getElementById(type[ZERO]).removeAttribute('checked');
        }
      }
      if (dos == 'close') {
        this.filterStatus();
      }
    }.bind(this), TEN)
  }
  setCheckboxVal(status) {
    this[`${status}_status`] = !this[`${status}_status`];
  }

  showDropdownSiteWorkflowStatus(dos = 'main') {
    if (dos == 'close') {
      for (const ele of this.FiltercheckSiteWorkflowStatus) {
        this[ele] = false;
      }
    } else {
      this.showFilterSiteWorkflowStatus = !this.showFilterSiteWorkflowStatus;
      if (this.showFilterSiteWorkflowStatus) {
        this.showFilterStatus = false;
      }
    }
    setTimeout(function () {
      for (const ele of this.FiltercheckSiteWorkflowStatus) {
        const type = ele.split('_');
        const elem = document.getElementById(`site-workflow-${type[ZERO]}`);
        if (elem) {
          if (this[ele]) {
            elem.setAttribute('checked', '');
          } else {
            elem.removeAttribute('checked');
          }
        }
      }
      if (dos == 'close') {
        this.filterSiteWorkflowStatus();
      }
    }.bind(this), TEN)
  }

  setCheckboxValSiteWorkflow(status) {
    this[`${status}_siteWf`] = !this[`${status}_siteWf`];
  }

  private applySitesFilters() {
    const siteStatusToFilter = this.getSiteFilterValues(this.FiltercheckStatus, true);
    const siteWorkflowStatusToFilter = this.getSiteFilterValues(this.FiltercheckSiteWorkflowStatus, false);
    this.filteredCompanies = [];
    this.statusFilteredSiteStatus = siteStatusToFilter.length > ZERO;
    this.statusFilteredSiteWorkflow = siteWorkflowStatusToFilter.length > ZERO;
    this.statusFiltered = this.statusFilteredSiteStatus || this.statusFilteredSiteWorkflow;

    const workingCopy = [...this.tempCompanySection];
    for (const elements of workingCopy) {
      if (this.siteMatchesFilters(elements, siteStatusToFilter, siteWorkflowStatusToFilter)) {
        elements['filterTrue'] = true;
        this.filteredCompanies.push(elements);
      } else {
        elements['filterTrue'] = false;
      }
    }

    this.applySiteFilterPagination(workingCopy);

    this.showFilterStatus = false;
    this.showFilterSiteWorkflowStatus = false;
  }

  private getSiteFilterValues(filterKeys: string[], uppercase: boolean): string[] {
    return filterKeys
      .filter(filterKey => this[filterKey])
      .map(filterKey => {
        const value = filterKey.split('_')[ZERO];
        return uppercase ? value.toUpperCase() : value;
      });
  }

  private siteMatchesFilters(site, siteStatusToFilter: string[], siteWorkflowStatusToFilter: string[]): boolean {
    const siteId = site.site ? site.site.href.split('/')[ONE] : '';
    const statuses = this.siteStatus[siteId] || [];
    const workflowStatus = this.Site_City_Country[siteId]?.['workflowStatus'] || '';
    const statusMatches = siteStatusToFilter.length == ZERO || statuses.some(status => siteStatusToFilter.includes((status || '').toUpperCase()));
    const workflowMatches = siteWorkflowStatusToFilter.length == ZERO || siteWorkflowStatusToFilter.includes(workflowStatus);
    return statusMatches && workflowMatches;
  }

  private applySiteFilterPagination(workingCopy: any[]): void {
    const source = this.statusFiltered ? this.filteredCompanies : workingCopy;
    this.paginationForStatus = this.statusFiltered;
    this.pagedTotalItem = source.length;
    this.pager = this.pagerService.getPager(source.length, ONE, FIFTY);
    this.SitesInfo = source.slice(this.pager.startIndex, this.pager.endIndex + ONE);
  }

  filterStatus() {
    this.applySitesFilters();
  }

  filterSiteWorkflowStatus() {
    this.applySitesFilters();
  }

  getVisibleSitesCount() {
    if (this.statusFiltered && this.filteredCompanies) {
      return this.filteredCompanies.filter(s => s.showRow && s.filterTrue && this.Site_City_Country[this.Site_hrefTo_Cid[s.businessEntityId]]).length;
    } else if (this.tempCompanySection && this.tempCompanySection.length > ZERO) {
      return this.tempCompanySection.filter(s => s.showRow && s.filterTrue && this.Site_City_Country[this.Site_hrefTo_Cid[s.businessEntityId]]).length;
    } else {
    }
    return ZERO;
  }

  getTotalSitesCount() {
    // Always return the total count of sites (without filter)
    if (this.tempCompanySection && this.tempCompanySection.length > ZERO) {
      return this.tempCompanySection.length;
    }
    return ZERO;
  }
  setPageForSitesSec(page) {
    if (this.paginationForStatus) {
      this.pager = this.pagerService.getPager(this.filteredCompanies.length, page, FIFTY);
      this.SitesInfo = this.filteredCompanies.slice(this.pager.startIndex, this.pager.endIndex + ONE);
    } else {
      this.pager = this.pagerService.getPager(this.tempCompanySection.length, page, FIFTY);
      this.SitesInfo = this.tempCompanySection.slice(this.pager.startIndex, this.pager.endIndex + ONE);
    }
  }
  /**site status filter */
  /**start validate workflow */
  loadWorkflowValidation(type, folio, reqId, reqType, _history, validator) {
    localStorage.setItem('errorReqId', reqId);
    this.validatingWorkflow = false;
    if (type == 'valid') {
      this.wkfValNotesModel = '';
      this.confirmationOption = false;
      this.documentsReviewOption = false;
      this.workflowFolioFromK2Isa = folio;
      this.workflowReqIdFromK2Isa = reqId;
      this.workflowValidationLoading = false;
      this.reqType = reqType;
      this.checkboxSelect = (validator == 'Manager' && reqType == '1-New Supplier Referencing') ? true : false;
    } else if (type == 'reject') {
      this.wkfRejNotesModel = '';
      this.workflowFolioFromK2Isa = folio;
      this.workflowReqIdFromK2Isa = reqId;
      this.workflowValidationLoading = false;
      this.rejectWorkflowNotesError = false;
    } else if (type == 'info') {
      this.wkfInfoNotesModel = '';
      this.workflowFolioFromK2Isa = folio;
      this.workflowReqIdFromK2Isa = reqId;
      this.workflowValidationLoading = false;
    } else {
    }
  }
  resetWkfValNotesModel() {
    this.wkfValNotesModel = '';
    this.confirmationOption = false;
    this.documentsReviewOption = false;
  }
  isValidationFormComplete(): boolean {
    if (this.reqType === '1-New Supplier Referencing' && this.checkboxSelect) {
      return this.confirmationOption && this.documentsReviewOption;
    }
    return true;
  }
  shouldShowCheckboxes(): boolean {
    if (this.reqType === '1-New Supplier Referencing') {
      if (this.requestForNotesHistory && Array.isArray(this.requestForNotesHistory) && this.requestForNotesHistory.length > ZERO) {
        const lastHistoryItem = this.requestForNotesHistory[this.requestForNotesHistory.length - ONE];
        return lastHistoryItem.role === "Buyer" && lastHistoryItem.route === "OK";
      }
      return false;
    }
    return false;
  }
  validateWkfNoteRoute() {
    this.validatingWorkflow = true;
    const idpToken = localStorage.getItem('IDPAccessToken');
    const sharePointOp = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
        apikey: this.Config.apikey
      })
    };
    this.commonService.clearAllActiveTask();
    this.k2Service.getAllActiveTask(`${this.Config.ApiK2SocleUrl}all-active-tasks?processName=ISA%20Workflow%5CISA_Workflow1`).subscribe(data1 => {
      let validateFolio = false;
      this.commonService.setAllActiveTask(data1);
      if (data1.length > ZERO) {
        for (const ele1 of data1) {
          if (this.workflowFolioFromK2Isa && ele1['folio'].includes(this.workflowFolioFromK2Isa)) {
            validateFolio = true;
            const workflowOwner = ele1['locatedUser'].split(":");
            const temp = workflowOwner[ONE].split("\\");
            if (temp[ONE].toLowerCase() === this.Uid) {
              this.submitWkfValidationTask(ele1['serialNumber'], temp[ZERO], this.wkfValNotesModel);
            }
          }
        }
        if (validateFolio) {
          if (this.companyBasicInfo.companyStatusCode == 'Pending' && !this.showForSupplier) {
            this.sendToBuyer();
          }
        } else {
          setTimeout(() => { this.validateWkfNoteRoute(); }, THREE_THOUSAND);
        }
      }
    }, error => {
      console.info('error', error);
    });
  }
  private submitWkfValidationTask(serialNumber: string, domain: string, note: string): void {
    const encoded = encodeURIComponent(note);
    this.k2Service.updateK2Task(`${this.Config.ApiK2Url}tasks/${serialNumber}?comment=${encoded}&actionToExecute=Submit&domain=${domain}`, {}).subscribe(_data => {
      this.workflowValidationLoading = true;
      if (this.shouldUpdateCompanyWorkflowStatusFromPopup()) {
        this.updateCompanyWorkflowStatusFromPopup();
        this.updateSiteWorkflowStatusFromPopup();
      }
      if (this.reqType == '0-New Supplier Prospect') {
        this.supplierService.getCompanySatus(`${this.Config.ApiSupplierUrl}company-status?code=Prospect`).subscribe((data: any) => {
          const datas2 = { "companyStatusCode": 'Prospect', "companyStatusId": data['company-status'][ZERO].row_id, "workflowStatus": "Completed" };
          this.supplierService.UpdateCompany(`${this.Config.ApiSupplierUrl}companies/${this.companyID}`, datas2).subscribe((updData: any) => {
            this.companyBasicInfo.companyStatusCode = updData['companyStatusCode'];
            this.companyBasicInfo.workflowStatus = updData['workflowStatus'];
          });
        });
      }
      setTimeout(() => {
        console.info('workflow mail Log:mail function called');
        this.sendMailToRequestor(this.workflowFolioFromK2Isa, note);
        this.sendRequestForMailToApp(this.workflowFolioFromK2Isa, note);
      }, FOUR_THOUSAND);
    });
  }
  shouldUpdateCompanyWorkflowStatusFromPopup() {
    const isPayingOrBankReqType = this.reqType === '4-Add Paying Company' || this.reqType === '5-Update bank details';
    const isSiteOrRefReqType = this.reqType === '1-New Supplier Referencing' || this.reqType === '2-Add Sites' || this.reqType === '3-Update Sites';
    return this.showForSupplierwithIPN && this.isCompanyWorkflowWaitingForSupplier() && (isPayingOrBankReqType || isSiteOrRefReqType);
  }
  

  private isWorkflowWaitingForSupplier(workflowStatus: unknown): boolean {
    const status = workflowStatus ? String(workflowStatus) : '';
    const normalizedStatus = status.replace(/\s+/g, '').toLowerCase();
    return normalizedStatus === 'waitingforsupplier';
  }

  private isCompanyWorkflowWaitingForSupplier(): boolean {
    const workflowStatus = this.companyBasicInfo?.workflowStatus
      ? String(this.companyBasicInfo.workflowStatus)
      : '';

    return this.isWorkflowWaitingForSupplier(workflowStatus);
  }

  private isSiteWorkflowWaitingForSupplier(siteRowId: string, element: any): boolean {
    const siteCountryStatus = this.Site_City_Country
      && this.Site_City_Country[siteRowId]
      && this.Site_City_Country[siteRowId]['workflowStatus'];
    const elementSiteStatus = element && element.site && element.site.workflowStatus;
    const siteWorkflowStatus = siteCountryStatus
      ? this.Site_City_Country[siteRowId]['workflowStatus']
      : elementSiteStatus ? element.site.workflowStatus : '';

    return this.isWorkflowWaitingForSupplier(siteWorkflowStatus);
  }

  updateCompanyWorkflowStatusFromPopup() {
    if (!this.isCompanyWorkflowWaitingForSupplier()) {
      return;
    }

    const payload = {
      workflowStatus: 'WaitingForRenault'
    };

    this.supplierService
      .UpdateCompany(`${this.Config.ApiSupplierUrl}companies/${this.companyID}`, payload)
      .subscribe((_data: any) => {
        if (this.companyBasicInfo) {
          this.companyBasicInfo.workflowStatus = 'WaitingForRenault';
        }
      });
  }

  updateSiteWorkflowStatusFromPopup() {
    const payload = {
      workflowStatus: 'WaitingForRenault'
    };

    for (const element of this.SitesInfo) {
      if (element.site) {
        const siteIdTemp = element.site.href.split('/');
        const siteRowId = this.Site_City_Country[siteIdTemp[ONE]]['rowId'];

        if (this.isSiteWorkflowWaitingForSupplier(siteRowId, element)) {
          this.siteService
            .updateSite(
              `${this.Config.ApiSitesUrl}sites/${siteRowId}`,
              payload
            )
            .subscribe(_data2 => {
            if (this.Site_City_Country && this.Site_City_Country[siteIdTemp[ONE]]) {
              this.Site_City_Country[siteIdTemp[ONE]]['workflowStatus'] = 'WaitingForRenault';
            }
            if (element.site) {
              element.site.workflowStatus = 'WaitingForRenault';
            }
          });
        }
      }
    }
  }
  /**end validate workflow */
  sendMailToRequestor(folio, notes) {
    const baseUrl1 = baseUrl
    const style = "font-weight-bold text-warning"
    let mailSubject = 'Approval request for ';
    const onlineHelp = online
    this.Uid = this.commonService.fromApp_UserIPN.toLowerCase();
    const idpToken = localStorage.getItem('IDPAccessToken');
    const sharePointOp = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
        apikey: this.Config.apikey
      })
    };
    const specificLink = `${baseUrl1}/company-details/${this.companyID}#workflows`;
    const changed = folio.match(/^(.*_)(\d.*)$/);
    this.k2Service.getK2IsabyId(`${this.Config.ApiK2Url}isa/${this.workflowReqIdFromK2Isa}`).subscribe(data => {
      const current_WrkFlow = data
      const requestedUser = data.requestor;
      if (current_WrkFlow.status.toLowerCase() === 'approved' || current_WrkFlow.status.toLowerCase() === 'refused') {
        this.completedWkf = true
        this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies?allianceIdentifier=*${current_WrkFlow.allianceId}*&_page= 1&_pagesize= 20`).subscribe(companyData => {
          this.arcaServices.getPerson(`${this.Config.ApiArcaURL}Person('${requestedUser.user}')`).subscribe((reqUser: any) => {
            if (current_WrkFlow.status.toLowerCase() === 'approved') {
              mailSubject = `Request approved for ${companyData['companies'][ZERO].legalName}`;;
              this.mailBodyContent =
                `<p>Hello ${requestedUser.displayName},</p><p> The request ${folio} was approved by the all validators! </p> <p>To consult the history of validation, please click on this link to get access to ISA (Interface for Supplier Administration) : <a href=${specificLink}>ISA</a>.</p> <p class=${style}>Notes from last approver : </p><p>${notes}</p> <p>For any help please contact <u>isa@renault.com</u></p><p><a href=${onlineHelp}>Online help</a></p><p>Regards,</p><p>Supplier repository team</p></body>`;
            }
            if (current_WrkFlow.status.toLowerCase() === 'refused') {
              mailSubject = `Request refused for ${companyData['companies'][ZERO].legalName}`;
              this.mailBodyContent =
                `<p>Hello ${requestedUser.displayName},</p><p> The request ${folio} was refused! </p> <p>To consult the history of validation, please click on this link to get access to ISA (Interface for Supplier Administration) : <a href=${specificLink}>ISA</a>.</p> <p class=${style}>Notes from the rejector : </p><p>${notes}</p> <p>For any help please contact <u>isa@renault.com</u></p><p><a href=${onlineHelp}>Online help</a></p><p>Regards,</p><p>Supplier repository team</p></body>`;
            }
            this.sendMailFn(reqUser.Mail, mailSubject, this.mailBodyContent, true);
          })
        })
      }
    })
  }
  /**Start mail to next approver */
  sendRequestForMailToApp(_folio = {}, note = '') {
    console.info('workflow mail Log:get all active tasks')
    this.k2Service.getAllActiveTask(`${this.Config.ApiK2SocleUrl}all-active-tasks?processName=ISA%20Workflow%5CISA_Workflow1`).subscribe(data1 => {
      if (data1.length <= ZERO) {
        console.info('workflow mail Log:get all active tasks doesnt have data', data1);
        setTimeout(() => {
          this.workflowDetailsfn();
          this.validatingWorkflow = false;
          document.getElementById('closeWorkflowValidation').click();
          document.getElementById('closeWorkflowRejection').click();
          document.getElementById('closeWorkflowInfoRequest').click();
        }, THREE_THOUSAND);
        return;
      }
      console.info('workflow mail Log:get workflow by request id');
      this.k2Service.getK2IsabyId(`${this.Config.ApiK2Url}isa/${this.workflowReqIdFromK2Isa}`).subscribe(data => {
        this.processWorkflowMailDispatch(data1, data, note);
      }, error => { console.info('error', error); });
    }, error => { console.info('error', error); });
  }
  private processWorkflowMailDispatch(data1: any[], data: any, note: string): void {
    console.info('workflow mail Log: request id', data);
    if (data1.length <= ZERO) {
      setTimeout(() => {
        console.info('workflow mail Log:workflow by request id doesnt exist', data);
        this.workflowDetailsfn();
        this.validatingWorkflow = false;
        document.getElementById('closeWorkflowValidation').click();
        document.getElementById('closeWorkflowRejection').click();
        document.getElementById('closeWorkflowInfoRequest').click();
      }, THREE_THOUSAND);
      return;
    }
    let mailFolio = false;
    for (const ele1 of data1) {
      if (data['folio'] && ele1['folio'].includes(data['folio'])) {
        mailFolio = true;
        console.info('workflow mail Log:request id has the folio', data['folio']);
        const workflowOwner = ele1['locatedUser'].split(":");
        this.arcaServices.getPerson(`${this.Config.ApiArcaURL}Person('${workflowOwner[ONE].slice(workflowOwner[ONE].length - SEVEN).toLowerCase()}')`).subscribe((data7: any) => {
          this.sendWorkflowApprovalNotification(data, workflowOwner, data7, note);
        });
      } else if (data['folio']) {
        console.info('workflow mail Log:request id  doesnt have the folio', data['folio']);
      }
    }
    if (data['status'] !== 'Refused' && data['status'] !== 'Approved') {
      if (!mailFolio) { setTimeout(() => { console.info('loop Called'); this.sendRequestForMailToApp(); }, THREE_THOUSAND); }
    } else {
      if (!this.completedWkf) { console.info('loop for completed workflow'); this.sendRequestForMailToApp(this.workflowFolioFromK2Isa, note); }
    }
  }
  private sendWorkflowApprovalNotification(data: any, workflowOwner: string[], data7: any, note: string): void {
    const ownerName = data7?.['FirstName'] == null ? workflowOwner[ONE] : `${data7['FirstName']} ${data7['LastName']}`;
    const ownerMail = data7?.['Mail'] ?? '';
    let desc: string;
    if (data['historys'].length == ZERO) {
      desc = data['comment'];
    } else if (data['historys'].length > ZERO) {
      desc = data['historys'][data['historys'].length - ONE]['route'].trim() != "Submitted"
        ? data['historys'][data['historys'].length - ONE]['comment']
        : data['historys'][data['historys'].length - TWO]['comment'];
    } else {
    }
    const roleTemp = data['validatorRole'] ? ` as ${data['validatorRole']}` : '';
    const specificLink = `${baseUrl}/company-details/${this.companyID}#workflows`;
    const onlineHelp = online;
    const style = "font-weight-bold text-warning";
    this.mailBodyContent = `<p>Hello ${ownerName},</p><p> The request ${data['folio']} (${data['strRequestType']}) is waiting for your validation${roleTemp}! </p> <p>For that, please click on this link to get access to ISA (Interface for Supplier Administration) : <a href=${specificLink}>ISA</a>.</p> <p class=${style}>Notes from previous approver : </p><p>${desc}</p> <p>For any help please contact <u>isa@renault.com</u></p><p><a href=${onlineHelp}>Online help</a></p><p>Regards,</p><p>Supplier repository team</p></body>`;
    console.info('workflow mail Log:', 'sendmail triggered');
    this.sendMailFn(ownerMail, `Approval request for ${data['supplierName']}`, this.mailBodyContent, true);
  }
  /**End mail to next approver */
  /**start reject workflow */
  resetWkfRejNotesModel() {
    this.wkfRejNotesModel = '';
  }
  rejectWkfNoteRoute() {
    this.validatingWorkflow = true;
    if (this.wkfRejNotesModel == '') {
      this.rejectWorkflowNotesError = true;
      return;
    }
    let rejectFolio = false;
    this.k2Service.getAllActiveTask(`${this.Config.ApiK2SocleUrl}all-active-tasks?processName=ISA%20Workflow%5CISA_Workflow1`).subscribe(data1 => {
      if (data1.length > ZERO) {
        for (const ele1 of data1) {
          if (this.workflowFolioFromK2Isa && ele1['folio'].includes(this.workflowFolioFromK2Isa)) {
            rejectFolio = true;
            const workflowOwner = ele1['locatedUser'].split(":");
            const temp = workflowOwner[ONE].split("\\");
            if (temp[ONE].toLowerCase() === this.Uid) {
              this.submitWkfRefusalTask(ele1['serialNumber'], temp[ZERO], this.wkfRejNotesModel);
            }
          }
        }
        if (!rejectFolio) { setTimeout(() => { this.rejectWkfNoteRoute(); }, THREE_THOUSAND); }
      }
    }, error => { console.info('error', error); });
  }
  private submitWkfRefusalTask(serialNumber: string, domain: string, note: string): void {
    const encoded = encodeURIComponent(note);
    this.k2Service.updateK2Task(`${this.Config.ApiK2Url}tasks/${serialNumber}?comment=${encoded}&actionToExecute=Refuse&domain=${domain}`, {}).subscribe(_data => {
      this.workflowValidationLoading = true;
      setTimeout(() => {
        console.info('workflow mail Log:mail function called');
        this.sendMailToRequestor(this.workflowFolioFromK2Isa, note);
        this.sendRequestForMailToApp(this.workflowFolioFromK2Isa, note);
      }, EIGHT_THOUSAND);
    });
  }
  checkCommentsField() {
    if (this.wkfRejNotesModel == '') {
      this.rejectWorkflowNotesError = true;
    } else {
      this.rejectWorkflowNotesError = false;
    }
  }
  /**end reject workflow */
  /**start info workflow */
  resetWkfInfoNotesModel() {
    this.wkfInfoNotesModel = '';
  }
  infoWkfNoteRoute() {
    this.validatingWorkflow = true;
    let infoFolio = false;
    this.k2Service.getAllActiveTask(`${this.Config.ApiK2SocleUrl}all-active-tasks?processName=ISA%20Workflow%5CISA_Workflow1`).subscribe(data1 => {
      if (data1.length > ZERO) {
        for (const ele1 of data1) {
          if (this.workflowFolioFromK2Isa && ele1['folio'].includes(this.workflowFolioFromK2Isa)) {
            infoFolio = true;
            const workflowOwner = ele1['locatedUser'].split(":");
            const temp = workflowOwner[ONE].split("\\");
            if (temp[ONE].toLowerCase() === this.Uid) {
              this.submitWkfInfoTask(ele1['serialNumber'], temp[ZERO]);
            }
          }
        }
        if (!infoFolio) { setTimeout(() => { this.infoWkfNoteRoute(); }, THREE_THOUSAND); }
      }
    }, error => { console.info('error', error); });
  }
  private submitWkfInfoTask(serialNumber: string, domain: string): void {
    const encoded = encodeURIComponent(this.wkfInfoNotesModel);
    this.k2Service.updateK2Task(`${this.Config.ApiK2Url}tasks/${serialNumber}?comment=${encoded}&actionToExecute=More info needed&domain=${domain}`, {}).subscribe(_data => {
      this.workflowValidationLoading = true;
      setTimeout(() => {
        console.info('workflow mail Log:mail function called');
        this.sendRequestForMailToApp();
      }, EIGHT_THOUSAND);
    });
  }
  /**end info workflow */
  resetId(val, type = '') {
    this.TypePopup = type
    if (val == 'bvdid' || val == 'DUNS' || val == 'BPN') {
      this.editIdValueModel = '';
      this.editIdModelError = true;
      return;
    }
    if (val == 'modal') {
      switch (type) {
      case 'DUNS':
        this.disableSaveBtn = false;
        this.editIdValueModel = this.DUNSValue
        this.editIdModelError = false;
        this.showArchivedId = this.showArchivedDUNSId
        break;
      case 'BPN':
        this.disableSaveBtn = false;
        this.editIdValueModel = this.BPNLValue
        this.editIdModelError = false;
        this.showArchivedId = this.showArchivedBPNId
        break;
      default:
        this.disableSaveBtn = false;
        this.editIdValueModel = this.sitebvidid;
        this.editIdModelError = false;
        this.showArchivedId = this.showArchivedBvdId
        break;
      }
    }
  }
  checkForIds(expression, model, errorModel) {
    this[model] = expression.replaceAll(/\s/g, "");;
    if (expression.length > ZERO) {
      this[errorModel] = false;
    } else {
      this[errorModel] = true;
    }
  }
  restrictInput(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    if (this.TypePopup === 'DUNS' && input.value.length > NINE) {
      input.value = input.value.slice(ZERO, NINE);
      this.editIdValueModel = input.value;
      this.editIdModelError = false;
    }
  }
  restrictDunsInput(event: any): void {
    const input = event.target.value;
    const filteredInput = input.replaceAll(/[^0-9]/g, '').slice(ZERO, NINE);
    event.target.value = filteredInput;
    this.editIdValueModel = filteredInput;
    if (this.editIdValueModel.length >= NINE) {
      this.disableSaveBtn = false;
    } else {
      this.disableSaveBtn = true;
    }
  }
  validateLength(event, type) {
    if (type == 'DUNS') {
      if (event.length >= NINE) {
        this.disableSaveBtn = false;
      } else {
        this.disableSaveBtn = true;
      }
    } else {
      this.disableSaveBtn = false;
    }
  }
  saveIds() {
    console.info("this.tempBvdId", this.tempBvdId)
    let typeId: string;
    let typeName: string;
    if (this.TypePopup == 'BPN') {
      this.tempBvdId = this.tempBpn
      typeName = "BPN-L"
      typeId = "76"
    } else if (this.TypePopup == 'DUNS') {
      this.tempBvdId = this.tempDuns
      typeName = "DUNS"
      typeId = "2"
    } else {
      typeName = "BVD ID"
      typeId = "1"
    }
    if (this.editIdValueModel != '' && this.editIdValueModel != undefined) {
      this.saveDatas = "Saving...";
      this.disableSaveBtn = true;
      if (this.tempBvdId === '') {
        this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=${typeName}&value=${this.editIdValueModel}`).subscribe(data1 => {
          this.applyNewBeiCreate(data1, typeName, typeId);
        });
      } else {
        const const5 = { value: this.editIdValueModel };
        const setEndDate = { endDate: this.commonService.getTodayDate() };
        this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=${typeName}&value=${this.editIdValueModel}`).subscribe(data1 => {
          this.applyExistingBeiUpdate(data1, typeName, const5, setEndDate);
        });
      }
    }
    else {
      this.disableSaveBtn = false;
      this.editIdModelError = true;
    }
  }
  private applyExistingBeiUpdate(data1: any, typeName: string, const5: any, setEndDate: any): void {
    if (data1['business-entity-identifiers'].length == ZERO || typeName == 'DUNS') {
      this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.tempBvdId}`, const5).subscribe(data => {
        if (data != null) { this.bvdidloading = true; this.saveDatas = "Save"; this.disableSaveBtn = false; this.loadBvdIdCpy(this.tempBvdId, 'reload'); }
        document.getElementById('closemodal').click();
      });
      return;
    }
    if ((data1['business-entity-identifiers'].length > ZERO && data1['business-entity-identifiers'][ZERO]['endDate'] != '') || typeName == 'DUNS') {
      const bvdRowId = data1['business-entity-identifiers'][ZERO]['row_id'];
      this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${bvdRowId}`, { businessEntityId: this.businessIdForBvd, endDate: '' }).subscribe(dataA => {
        this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.tempBvdId}`, setEndDate).subscribe(_dataB => {
          this.bvdidloading = true; this.saveDatas = "Save"; this.disableSaveBtn = false;
          this.tempBvdId = dataA['row_id']; this.loadBvdIdCpy(this.tempBvdId, 'reload');
          document.getElementById('closemodal').click();
        });
      });
      return;
    }
    document.getElementById('btnForStatus').click();
    this.statusText = `${typeName} already attached to a Site`;
    this.saveDatas = "Save"; this.disableSaveBtn = false;
  }
  private applyNewBeiCreate(data1: any, typeName: string, typeId: string): void {
    console.info("data1['business-entity-identifiers']", data1['business-entity-identifiers']);
    console.info("businessIdForBvd", this.businessIdForBvd);
    if (data1['business-entity-identifiers'].length == ZERO || typeName == 'DUNS') {
      const const2 = { "businessEntityIdentifierTypeId": typeId, "businessEntityIdentifierTypeName": typeName, "startDate": this.commonService.getTodayDate(), "businessEntityId": this.businessIdForBvd, "value": this.editIdValueModel };
      this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`, const2).subscribe(data2 => {
        this.bvdidloading = true; this.saveDatas = "Save"; this.disableSaveBtn = false;
        this.tempBvdId = data2['row_id']; this.loadBvdIdCpy(this.tempBvdId, 'reload');
        document.getElementById('closemodal').click();
      });
      return;
    }
    if ((data1['business-entity-identifiers'].length > ZERO && data1['business-entity-identifiers'][ZERO]['endDate'] != '') || typeName == 'DUNS') {
      const BvdRowId = data1['business-entity-identifiers'][ZERO]['row_id'];
      this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${BvdRowId}`, { businessEntityId: this.businessIdForBvd, endDate: '' }).subscribe(data12 => {
        this.tempBvdId = data12['row_id']; this.bvdidloading = true; this.saveDatas = "Save"; this.disableSaveBtn = false;
        this.loadBvdIdCpy(this.tempBvdId, 'reload'); document.getElementById('closemodal').click();
      });
      return;
    }
    document.getElementById('btnForStatus').click();
    this.statusText = `${typeName} already attached to another Site`;
    this.saveDatas = "Save"; this.disableSaveBtn = false;
  }
  openCnfArchiveModal(type) {
    if (this.tempBvdId != '') {
      switch (type) {
      case 'archive':
        document.getElementById('btnForCnfArchive').click();
        break;
      case 'unarchive':
        document.getElementById('btnForCnfUnArchive').click();
        break;
      case 'delete':
        document.getElementById('btnForDeleteBvd').click();
        break;
      default:
        break;
      }
    }
  }
  archiveIds(type) {
    const archiveId = type == 'BVD' ? this.tempBvdId : type == 'DUNS' ? this.tempDuns : this.tempBpn
    console.info("this.businessIdForBvd", this.businessIdForBvd)
    if (archiveId != '') {
      const setEndDate = { endDate: this.commonService.getTodayDate() }
      this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${archiveId}`, setEndDate).subscribe(_data => {
        if (type == 'BVD') {
          this.tempBvdId = '';
        } else if (type == 'DUNS') {
          this.tempDuns = '';
        } else {
          this.tempBpn = '';
        }
        this.loadBvdIdCpy(this.businessIdForBvd, 'reload');
        document.getElementById('closeCnfArchiveBvdId').click();
        document.getElementById('closemodal').click();
      });
    }
  }
  UnarchiveIds(type) {
    const UnarchiveId = type == 'BVD' ? this.tempBvdId : type == 'DUNS' ? this.tempDuns : this.tempBpn
    console.info("this.businessIdForBvd", this.businessIdForBvd)
    if (UnarchiveId != '') {
      const setEndDate = { endDate: '' }
      this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${UnarchiveId}`, setEndDate).subscribe(_data => {
        if (type == 'BVD') {
          this.tempBvdId = '';
        } else if (type == 'DUNS') {
          this.tempDuns = '';
        } else {
          this.tempBpn = '';
        }
        this.loadBvdIdCpy(this.businessIdForBvd, 'reload');
        document.getElementById('closeCnfUnArchiveBvdId').click();
        document.getElementById('closemodal').click();
      });
    }
  }
  DeleteIds(type) {
    const count = ZERO
    const deleteId = type == 'BVD' ? this.tempBvdId : type == 'DUNS' ? this.tempDuns : this.tempBpn
    if (deleteId != '') {
      this.supplierService.deleteBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${deleteId}`).subscribe(_data => {
        this.bvdidloading = true;
        if (type == 'BVD') {
          this.deleteOrbisIdentifiers();
          this.sitebvidid = ''; this.tempBvdId = '';
        } else if (type == 'DUNS') {
          this.editIdValueModel = '';
          this.tempDuns = '';
        } else {
          this.editIdValueModel = '';
          this.tempBpn = '';
        }
        this.loadBvdIdCpy(this.businessIdForBvd, 'reload');
        document.getElementById('closeCnfDeleteBvdId').click();
        document.getElementById('closemodal').click();
      });
    }
  }
  /**START In Portfolio for Group */
  toggleInPortfolioSwitch1(event) {
    const data = { "bvd-id": this.groupbvdIDcpy }
    this.supplierService.createBvdInterface(`${this.Config.ApiSupplierUrl}bvd-interface`, data).subscribe((bvdInterfaceData: any) => {
      const bVdDatas = JSON.parse(bvdInterfaceData.result);
      console.info("bVdDatas", bVdDatas);
      if (bVdDatas['Data'].length > ZERO) {
        const temp = bVdDatas['Data'][ZERO];
        console.info("temp", bVdDatas['Data'].length)
        this.bvdidNumber = temp.BVD_ID_NUMBER;
        if (this.bvdidNumber == this.groupbvdIDcpy) {
          const toggleEL = event.srcElement.checked;
          let urlOperation = 'add'
          if (toggleEL) {
            urlOperation = 'remove';
          }
          this.inPortfolioLoading1 = true;
          const bvdOrbisUrl = `${this.Config.bvdOrbisUrl}store/recordsets/${urlOperation}/${this.commonService.PortfolioRecordSet}`;
          const datas =
          {
            'WHERE':
              [
                {
                  "BvDID": [this.groupbvdIDcpy]
                }
              ]
          }
          this.commonService.putCustomURLOrbis(bvdOrbisUrl, datas).subscribe(_data => {
            this.getInPortfolioDetails1();
          }, _error => {
            this.getInPortfolioDetails1();
            this.inPortfolioLoading1 = false;
          });
        } else {
          document.getElementById('btnForWarningBvdportfolio').click();
        }
      } else {
        document.getElementById("btnForbvdnotpresentinOrbis").click();
      }
    });
  }
  getInPortfolioDetails1() {
    if (this.groupbvdIDcpy === '') {
      this.inPortfolioLoading1 = false;
    } else {
      this.inPortfolioLoading1 = true;
      const bvdOrbisUrl = `${this.Config.bvdOrbisUrl}store/recordsets/${this.commonService.PortfolioRecordSet}`;
      this.commonService.getCustomURLOrbis(bvdOrbisUrl).subscribe(bvdData => {
        this.inPortfolioLoading1 = false;
        this.countValue1 = bvdData['Summary']?.['Count'] ?? ZERO;
        const switches = document.getElementById('sliderCheckBox1');
        let bvdIndex = NEGATIVE_ONE;
        if (bvdData['BvDIDs'].length > ZERO) {
          bvdIndex = bvdData['BvDIDs'].indexOf(this.groupbvdIDcpy);
        }
        if (bvdIndex === NEGATIVE_ONE) {
          this.bvdInPortfolioSet1 = 'off';
        } else {
          if (switches) {
            switches.setAttribute('checked', 'yes');
            this.bvdInPortfolioSet1 = 'on';
          }
        }
      }, _error => {
        this.inPortfolioLoading1 = false;
      });
    }
  }
  /**END In Portfolio for Group */
  /**START In Portfolio fn */
  toggleInPortfolioSwitch(event) {
    const data = { "bvd-id": this.sitebvidid }
    this.supplierService.createBvdInterface(`${this.Config.ApiSupplierUrl}bvd-interface`, data).subscribe((bvdInterfaceData: any) => {
      const bVdDatas = JSON.parse(bvdInterfaceData.result);
      console.info("bVdDatas", bVdDatas);
      if (bVdDatas['Data'].length > ZERO) {
        const temp = bVdDatas['Data'][ZERO];
        console.info("temp", bVdDatas['Data'].length)
        this.bvdidNumber = temp.BVD_ID_NUMBER;
        if (this.bvdidNumber == this.sitebvidid) {
          const toggleEL = event.srcElement.checked;
          let urlOperation = 'add'
          if (this.bvdInPortfolioSet == 'on') {
            urlOperation = 'remove';
          }
          this.inPortfolioLoading = true;
          const bvdOrbisUrl = `${this.Config.bvdOrbisUrl}store/recordsets/${urlOperation}/${this.commonService.PortfolioRecordSet}`;
          const datas =
          {
            'WHERE':
              [
                {
                  "BvDID": [this.sitebvidid]
                }
              ]
          }
          this.commonService.putCustomURLOrbis(bvdOrbisUrl, datas).subscribe(_data => {
            this.getInPortfolioDetails();
          }, _error => {
            this.getInPortfolioDetails();
            this.inPortfolioLoading = false;
          });
        } else {
          document.getElementById('btnForWarningBvdportfolio').click();
        }
      } else {
        document.getElementById("btnForbvdnotpresentinOrbis").click();
      }
    });
  }
  UpdateaddBvDID() {
    console.info("this.bvdidNumber", this.bvdidNumber);
    this.editIdValueModel = this.bvdidNumber;
    console.info("editIdValueModel", this.editIdValueModel)
    let urlOperation = 'add'
    if (this.bvdInPortfolioSet == 'on') {
      urlOperation = 'remove';
    }
    this.inPortfolioLoading = true;
    const bvdOrbisUrl = `${this.Config.bvdOrbisUrl}store/recordsets/${urlOperation}/${this.commonService.PortfolioRecordSet}`;
    const datas =
    {
      'WHERE':
        [
          {
            "BvDID": [this.bvdidNumber]
          }
        ]
    }
    this.commonService.putCustomURLOrbis(bvdOrbisUrl, datas).subscribe(_data => {
      this.getInPortfolioDetails();
    }, _error => {
      this.getInPortfolioDetails();
      this.inPortfolioLoading = false;
    });
    document.getElementById('closeupdateaddbvdid').click();
    this.saveIds();
  }
  getInPortfolioDetails() {
    if (this.sitebvidid === '') {
      this.inPortfolioLoading = false;
    } else {
      this.inPortfolioLoading = true;
      const bvdOrbisUrl = `${this.Config.bvdOrbisUrl}store/recordsets/${this.commonService.PortfolioRecordSet}`;
      this.commonService.getCustomURLOrbis(bvdOrbisUrl).subscribe(bvdData => {
        this.inPortfolioLoading = false;
        if (bvdData) {
          this.countValue = bvdData['Summary']?.['Count'] ?? ZERO;
        } else {
          this.countValue = ZERO
        }
        const switches = document.getElementById('sliderCheckBox');
        let bvdIndex = NEGATIVE_ONE;
        if (bvdData['BvDIDs']?.length > ZERO) {
          bvdIndex = bvdData['BvDIDs'].indexOf(this.sitebvidid);
        }
        if (bvdIndex === NEGATIVE_ONE) {
          if (switches) {
            switches.removeAttribute('checked');
            this.bvdInPortfolioSet = 'off';
          }
        } else {
          if (switches) {
            switches.setAttribute('checked', 'yes');
            this.bvdInPortfolioSet = 'on';
          }
        }
      }, _error => {
        this.inPortfolioLoading = false;
      });
    }
  }
  /**END In Portfolio fn */
  /**Start Workflow filter */
  showDropdownStatusWorkFlow(dos = 'main') {
    if (dos == 'close') {
      for (const ele of this.FiltercheckStatusWorkFlow) {
        this[ele] = false;
      }
    } else {
      this.showFilterStatusWorkFlow = !this.showFilterStatusWorkFlow;
    }
    setTimeout(function () {
      for (const ele of this.FiltercheckStatusWorkFlow) {
        const type = ele.split('_');
        if (this[ele]) {
          document.getElementById(type[ZERO]).setAttribute('checked', '');
        } else {
          document.getElementById(type[ZERO]).removeAttribute('checked');
        }
      }
      if (dos == 'close') {
        this.filterStatusWorkFlow();
      }
    }.bind(this), TEN)
  }
  setCheckboxValWorkFlow(status) {
    this[`${status}_status`] = !this[`${status}_status`];
  }

  private getWorkflowStatusesToFilter(): any[] {
    return this.FiltercheckStatusWorkFlow
      .filter(statusKey => this[statusKey])
      .map(statusKey => {
        const status = statusKey.split('_')[ZERO];
        return status === 'Inprogress' ? 'In progress' : status === 'Needmoreinfo' ? 'Need more info' : status;
      });
  }

  private getMatchingWorkflowRequestIds(statusToFilter: any[]): any[] {
    const validRequestIds: any[] = [];
    for (const requestId of this.siteRowIdFilterWorkFlow) {
      const workflowStatuses = this.workflowStatus[requestId] || [];
      if (workflowStatuses.some(status => statusToFilter.includes(status))) {
        validRequestIds.push(requestId);
      }
    }
    return validRequestIds;
  }

  private markWorkflowFilterResults(validRequestIds: any[]): void {
    for (const workflow of this.workFlowDetails) {
      workflow['filterTrue'] = validRequestIds.includes(workflow.requestId);
      if (workflow['filterTrue']) {
        this.filteredWorkFlow.push(workflow);
      }
    }
  }

  private updateWorkflowPageHeight(workflowCount: number): void {
    this.pageHeight = workflowCount <= TEN ? workflowCount * THIRTY + ONE_HUNDRED_SEVENTY : FIVE_HUNDRED_FIFTY;
  }

  filterStatusWorkFlow() {
    this.workFlowVisibility = true;
    const statusToFilter = this.getWorkflowStatusesToFilter();
    this.filteredWorkFlow = [];
    this.workFlowDetails = [];
    this.statusFilteredWorkFlow = statusToFilter.length > ZERO;
    this.workFlowDetails = this.tempWorkflow;
    if (this.statusFilteredWorkFlow) {
      this.markWorkflowFilterResults(this.getMatchingWorkflowRequestIds(statusToFilter));
      this.workFlowDetails = this.filteredWorkFlow;
      this.workFlowDetails.sort((a, b) => (a.requestId > b.requestId ? NEGATIVE_ONE : ONE));
      this.updateWorkflowPageHeight(this.filteredWorkFlow.length);
    } else {
      for (const e of this.workFlowDetails) {
        e['filterTrue'] = true;
      }
      this.updateWorkflowPageHeight(this.workFlowDetails.length);
      this.workFlowDetails.sort((a, b) => (a.requestId > b.requestId ? NEGATIVE_ONE : ONE));
    }
    this.showFilterStatusWorkFlow = false;
  }
  /**End Workflow filter */
  acc(check) {
    const sections = {
      group: ['openAllBoxgroup', 'showBoxDownGroup'], comp: ['openAllBoxcompany', 'showBoxDowncompany'],
      site: ['openAllBoxcsite', 'showBoxDownSite'], workflow: ['openworkflow', 'showBoxDownworkflow']
    }[check];
    if (sections) {
      this.toggleAccordion(sections[ZERO], sections[ONE]);
    }
    if (this.showBoxDownworkflow && this.showBoxDownSite && this.showBoxDowncompany && this.showBoxDownGroup) {
      this.showBoxDownForAllSec = false;
    }
  }
  private toggleAccordion(elementId: string, stateProperty: string): void {
    const element = document.getElementById(elementId);
    if (element.style.display === "none") {
      element.style.display = "block";
      this[stateProperty] = false;
      this.showBoxDownForAllSec = true;
    } else {
      element.style.display = "none";
      this[stateProperty] = true;
    }
  }
  notesHistoryOpen(request, type = '', page = ONE) {
    this.approverEdit = type == 'edit' ? true : false;
    this.senReqNotesMOdel = ''
    this.senReqSamMOdel = ''
    this.history;
    this.requestForNotesHistory = [];
    const idpToken = localStorage.getItem('IDPAccessToken');
    const sharePointOp = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
        apikey: this.Config.apikey
      })
    };
    this.historyLoading = true;
    this.k2Service.getK2IsabyId(`${this.Config.ApiK2Url}isa/${request['requestId']}`).subscribe(data => {
      let roleTemp;
      data['workflowOwnerWithRole'] = request['workflowOwnerWithRole'];
      data['taskID'] = request['taskID']
      data['companyId'] = request['companyId']
      data['RequestorMailId'] = request['RequestorMailId']
      this.historyLoading = false;
      roleTemp = data['validatorRole'] ?? '';
      if (request['workflowOwnerWithRole'].length > ZERO) {
        data['approver'] = `${request['workflowOwnerWithRole'][ZERO]} (${roleTemp})`;
      } else {
        data['approver'] = '';
      }
      let notsubmitted = false;
      const temp = [];
      for (const element of data['historys']) {
        if (element.route == "Submitted" && !notsubmitted) {
          temp.push(element);
          notsubmitted = true;
        } else if (element.route != "Submitted") {
          temp.push(element);
        } else {
        }
      }
      data['historys'] = temp;
      this.requestForNotesHistory = data;
      console.info("temp", this.requestForNotesHistory)
      this.histPager = this.pagerService.getPager(this.requestForNotesHistory['historys'].length, page, TEN);
      this.requestForNotesHistory['historys'].slice(this.histPager.startIndex, this.histPager.endIndex + ONE);
      this.history = this.requestForNotesHistory['historys'].length > TEN ? false : true
    })
  }
  approverColor(a) {
    if (a[ZERO].length == SEVEN) {
      const mystyle = {
        'color': '#cb4b32'
      }
      return mystyle
    }
  }
  historyTable(page) {
    this.histPager = this.pagerService.getPager(this.requestForNotesHistory['historys'].length, page, TEN);
    this.requestForNotesHistory['historys'].slice(this.histPager.startIndex, this.histPager.endIndex + ONE);
  }
  closeAllSections() {
    const a = document.getElementById('openAllSection');
    if (a.classList.contains('opened_all')) {
      this.showBoxDownForAllSec = false;
    }
    const groupBox = document.getElementById("openAllBoxgroup");
    if (groupBox.style.display !== "none") {
      groupBox.style.display = "none";
      this.showBoxDownGroup = true;
    }
    const companyBox = document.getElementById("openAllBoxcompany");
    if (companyBox.style.display !== "none") {
      companyBox.style.display = "none";
      this.showBoxDowncompany = true;
    }
    const siteBox = document.getElementById("openAllBoxcsite");
    if (siteBox.style.display !== "none") {
      siteBox.style.display = "none";
      this.showBoxDownSite = true;
    }
    const workflowBox = document.getElementById("openworkflow");
    if (workflowBox.style.display !== "none") {
      workflowBox.style.display = "none";
      this.showBoxDownworkflow = true;
    }
  }
  getGroupAliasByRowid(_abs, page = ONE, subscribeData = []) {
    this.groupAlias = [];
    this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?groupId=${this.GroupAssign['groupId']}&_page=${page}`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: any) => {
      if (data['group-identifiers'] && data['group-identifiers'] != null) {
        for (const ele of data['group-identifiers']) {
          if (ele.groupIdentifierKeyName != 'BVD') {
            subscribeData.push(ele);
          }
        }
        this.groupAlias = subscribeData;
        console.info("this.groupAlias[i]===>", this.groupAlias);
      }
    });
  }
  onHeaderKeyDown(event: KeyboardEvent, value:string) {
    if (event.key === 'Enter' || event.key === ' ') {
    this.sort(value);
    }
  }
  bolding(data, id) {
    if (data != undefined && data != "") {
      const data1 = data.split(/(\d+)/).filter(Boolean)
      const data3 = data1[ZERO] === 'Updating...' ? data1[ZERO] : data1[ZERO].bold()
      const data2 = data1[ONE] === undefined ? '' : data1[ONE]
      const result = `${data3}${data2}`
      document.getElementById(id).innerHTML = result
    }
  }
  copyToClipboard(text: string) {
    this.commonService.copyToClipboard(text)
  }
  updatemailModelName(comment, _folio, reqId, days,detail) {
    this.workflowReqIdFromK2Isa = reqId;
    this.differenceinDays = days;
    this.currentModalDetail = detail;
    this.approverEmail = '';
    this.k2Service.getAllActiveTask(`${this.Config.ApiK2SocleUrl}all-active-tasks?processName=ISA%20Workflow%5CISA_Workflow1`).subscribe(data1 => {
      if (data1.length <= ZERO) { return; }
      this.k2Service.getK2Isa(`${this.Config.ApiK2Url}isa/${reqId}`).subscribe(data => {
        for (const ele1 of data1) {
          if (data['folio'] && ele1['folio'].includes(data['folio'])) {
            const workflowOwner = ele1['locatedUser'].split(":");
            this.arcaServices.getPerson(`${this.Config.ApiArcaURL}Person('${workflowOwner[ONE].slice(workflowOwner[ONE].length - SEVEN).toLowerCase()}')`).subscribe((data7: any) => {
              if (data7?.['Mail']) { this.approverEmail = data7['Mail']; }
            });
          }
        }
      });
    });
    console.info("req", reqId);
    console.info("req", comment);
  }
  sendblueRequestForMailToApp() {
    this.k2Service.getAllActiveTask(`${this.Config.ApiK2SocleUrl}all-active-tasks?processName=ISA%20Workflow%5CISA_Workflow1`).subscribe(data1 => {
      if (data1.length <= ZERO) { return; }
      this.k2Service.getK2Isa(`${this.Config.ApiK2Url}isa/${this.workflowReqIdFromK2Isa}`).subscribe(data => {
        for (const ele1 of data1) {
          if (data['folio'] && ele1['folio'].includes(data['folio'])) {
            const workflowOwner = ele1['locatedUser'].split(":");
            this.arcaServices.getPerson(`${this.Config.ApiArcaURL}Person('${workflowOwner[ONE].slice(workflowOwner[ONE].length - SEVEN).toLowerCase()}')`).subscribe((data7: any) => this.sendApprovalReminder(data, workflowOwner, data7));
          }
        }
      }, error => { console.info('error', error); });
    }, error => { console.info('error', error); });
    document.getElementById("closeCCBtn").click();
  }
  private sendApprovalReminder(data: any, workflowOwner: string[], person: any): void {
    const ownerName = person?.['FirstName'] == null ? workflowOwner[ONE] : `${person['FirstName']} ${person['LastName']}`;
    const ownerMail = person?.['Mail'] ?? '';
    const role = data['validatorRole'] ? ` as ${data['validatorRole']}` : '';
    const description = this.getApprovalReminderDescription(data);
    const subject = `Approval request for ${data['supplierName']}`;
    const link = `${baseUrl}/company-details/${this.companyID}#workflows`;
    this.mailBodyContent = `<p>Hello ${ownerName},</p><p> This is a kind reminder as the request ${data['folio']} (${data['strRequestType']}) is waiting for your validation ${role}  from ${this.differenceinDays} days ago! </p> <p>For that, please click on this link to get access to ISA (Interface for Supplier Administration) : <a href=${link}>ISA</a>.</p> <p class="font-weight-bold text-warning">Notes from previous approver : </p><p>${description}<p class="font-weight-bold text-warning">Notes from the reminderer:  </p><p>${this.MailNameModel}</p> <p>For any help please contact <u>isa@renault.com</u></p><p><a href=${online}>Online help</a></p><p>Regards,</p><p>Supplier repository team</p></body>`;
    this.sendMailFn(ownerMail, subject, this.mailBodyContent);
  }
  private getApprovalReminderDescription(data: any): string {
    if (data['historys'].length == ONE) { return data['comment']; }
    if (data['historys'].length <= ONE) { return ''; }
    const history = data['historys'][data['historys'].length - ONE];
    if (history['comment'] == null && history['comment'] == '') { return ''; }
    return history['route'].trim() === "Submitted" ? data['historys'][data['historys'].length - TWO]['comment'] : history['comment'];
  }
  /**End mail to next approver */
  resetCompanyNameFields() {
    this.MailNameModel = '';
  }
  addnewMdm() {
    const data = {
      "linkedCompanyId": this.companyID,
      "companyIdentifierTypeId": "5",
      "value": "",
      "startDate": this.commonService.getTodayDate(),
      "companyIdentifierKeyName": "MDM",
    }
    this.supplierService.createCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers`, data).subscribe(data1 => {
      this.NewCmpAlliasValue = data1['value'];
      document.getElementById("closeAddCmpAlias").click();
      this.CompanyIdnentifiers();
    })
  }
  getbvd() {
    this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?apoStatus=ACTIVE&status=VALIDATED&companyId=${this.companyID}`).subscribe(data1 => {
      if (data1['group-assignments'].length > ZERO) {
        this.groupAssignToCpy = data1['group-assignments'][ZERO]['groupName'];
        this.grpAllianceIdForGR = data1['group-assignments'][ZERO]['groupAllianceIdentifier']
      }
      else {
        this.bvdloading = false
      }
      this.supplierService.getGroups(`${this.Config.ApiSupplierUrl}groups?allianceIdentifier=${this.grpAllianceIdForGR}&_page=1&_pagesize=10`).subscribe((data2: any) => {
        for (const element of data2['groups']) {
          if (element.representingCompanyAllianceIdentifier != '') {
            this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=${element.representingCompanyId}&isHQ=Y`).subscribe(data0 => {
              const businessEntity = data0?.['business-entities']?.[ZERO];
              if (!businessEntity) {
                this.bvdloading = false;
                this.inPortfolioLoading1 = false;
                return;
              }
              this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&businessEntityId=in(${businessEntity['row_id']})&_page=1`).subscribe(
                (data: any) => {
                  if (data['business-entity-identifiers'].length != ZERO) {
                    this.groupbvdIDcpy = data['business-entity-identifiers'][ZERO]['value'];
                    this.bvdloading = false
                    this.getInPortfolioDetails1()
                  } else {
                    this.bvdloading = false
                    this.inPortfolioLoading1 = false
                  }
                })
            })
          }
          this.bvdloading = false
          this.inPortfolioLoading1 = false
        }
      })
    })
  }
  getCompanyGuo() {
    const datas = {}
    this.companyBvdIdNotFound = false;
    this.guoBvdIdNotFound = false;
    this.noGuo = false;
    this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=${this.companyID}&isHQ=Y`).subscribe(data0 => {
      this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&businessEntityId=in(${data0['business-entities'][ZERO]['row_id']})&_page=1`).subscribe(kk => {
        this.GuobvdIDcpy = kk['business-entity-identifiers'][ZERO]['value'];
        this.supplierService.createBvdInterface(`${this.Config.ApiSupplierUrl}bvd-interface?bvd-id=${this.GuobvdIDcpy}`, datas).subscribe((data: any) => {
          this.processGuoBvdResponse(data, datas);
        }, _error => { this.companyBvdIdNotFound = true; this.orbisBvdDataLoading = false; this.dataloading = false; });
      });
    });
  }
  private processGuoBvdResponse(data: any, datas: any): void {
    this.orbisBvdData = null;
    if (!data || !data.result) { this.companyBvdIdNotFound = true; this.orbisBvdDataLoading = false; this.dataloading = false; return; }
    const tempData = JSON.parse(data.result);
    if (tempData['Data'].length == ZERO) { this.companyBvdIdNotFound = true; this.orbisBvdDataLoading = false; this.dataloading = false; return; }
    if (tempData['Data'].length != ZERO ? tempData['Data'][ZERO]['GUO_BVD_ID_NUMBER'] == null : false) { this.noGuo = true; this.guoBvdIdNotFound = true; console.info(this.orbisBvdData); return; }
    this.noGuo = false;
    if (tempData['Data'].length != ZERO ? tempData['Data'][ZERO]['BVD_ID_NUMBER'] != tempData['Data'][ZERO]['GUO_BVD_ID_NUMBER'][ZERO] : false) {
      this.supplierService.createBvdInterface(`${this.Config.ApiSupplierUrl}bvd-interface?bvd-id=${tempData['Data'][ZERO]['GUO_BVD_ID_NUMBER'][ZERO]}`, datas).subscribe((guoData: any) => {
        if (guoData?.result) {
          const guoTempData = JSON.parse(guoData.result);
          this.orbisBvdData = guoTempData['Data'].length == ZERO ? null : guoTempData['Data'][ZERO];
          if (guoTempData['Data'].length == ZERO) { this.guoBvdIdNotFound = true; }
        } else { this.guoBvdIdNotFound = true; }
        this.orbisBvdDataLoading = false; this.dataloading = false;
      }, _error => { this.guoBvdIdNotFound = true; this.orbisBvdDataLoading = false; this.dataloading = false; });
    } else {
      this.orbisBvdData = tempData['Data'][ZERO];
      this.orbisBvdDataLoading = false;
      this.dataloading = false;
    }
    console.info(this.orbisBvdData);
  }
  LoadGuo() {
    if (this.sitebvidid == '') { return; }
    this.groupAssignToCpy = '';
    this.orbisBvdDataLoading = true;
    this.dataloading = true;
    if (this.noGuo) { this.dataloading = false; }
    this.show = false;
    const datas = {};
    this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?apoStatus=ACTIVE&status=VALIDATED&companyId=${this.companyID}`).subscribe(data1 => {
      if (data1['group-assignments'].length <= ZERO) { this.show = true; this.getCompanyGuo(); return; }
      this.groupAssignToCpy = data1['group-assignments'][ZERO]['groupName'];
      this.grpAllianceIdForGR = data1['group-assignments'][ZERO]['groupAllianceIdentifier'];
      this.supplierService.getGroups(`${this.Config.ApiSupplierUrl}groups?allianceIdentifier=${this.grpAllianceIdForGR}&_page=1&_pagesize=10`).subscribe((data2: any) => {
        for (const element of data2['groups']) {
          this.processLoadGuoGroupElement(element, datas);
        }
      });
    });
  }
  private processLoadGuoGroupElement(element: any, datas: any): void {
    if (!element["representingCompanyAllianceIdentifier"]) { this.getCompanyGuo(); return; }
    this.guobvdIDcpy = true;
    this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=${element.representingCompanyId}&isHQ=Y`).subscribe(data0 => {
      this.processLoadGuoBusinessEntity(data0, datas);
      this.loadGuoSiteAssignments(data0);
    });
  }
  private processLoadGuoBusinessEntity(data0: any, datas: any): void {
    console.info("data", data0['business-entities'][ZERO]['row_id']);
    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&businessEntityId=in(${data0['business-entities'][ZERO]['row_id']})&_page=1`).subscribe((data: any) => {
      this.IsaBvD = data['business-entity-identifiers'][ZERO]['value'];
      if (this.groupbvdIDcpy == '' || this.groupbvdIDcpy == undefined) { this.getCompanyGuo(); return; }
      this.GuobvdIDcpy = this.sitebvidid;
      this.companyBvdIdNotFound = false;
      this.guoBvdIdNotFound = false;
      this.noGuo = false;
      this.supplierService.createBvdInterface(`${this.Config.ApiSupplierUrl}bvd-interface?bvd-id=${this.GuobvdIDcpy}`, datas).subscribe((bvdData: any) => {
        this.processGuoBvdResponse(bvdData, datas);
      }, _error => { this.companyBvdIdNotFound = true; this.orbisBvdDataLoading = false; this.dataloading = false; });
    });
  }
  private loadGuoSiteAssignments(data0: any): void {
    this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?businessEntityId=in(${data0['business-entities'][ZERO]['row_id']})&_page=1`).subscribe(data => {
      for (const element of data['site-assignments']) {
        this.siteIdTemp = element.site.href.split('/');
        this.siteService.getAccessPoints(`${this.Config.ApiSitesUrl}access-points?realEstateAssetId=${this.siteIdTemp[ONE]}`).subscribe((apData: any) => {
          this.processLoadGuoAccessPoints(apData);
        });
      }
    });
  }
  private processLoadGuoAccessPoints(data: any): void {
    for (const element of data['access-points']) {
      if (element.type == 'P14' && element.activeStatus == 'ACTIVE') { this.rowID = element.rowId; }
    }
    this.siteService.getAccessPointAddresses(`${this.Config.ApiSitesUrl}access-points-addresses?accessPointId=${this.rowID}`).subscribe(data2 => {
      this.loadGuoGeoAddresses(data2);
    });
  }
  private loadGuoGeoAddresses(data2: any): void {
    for (const element of data2['access-points-addresses']) {
      if (element.addressType === 'GEOGRAPHICAL') {
        this.addressService.getGeographicalAddresses(`${this.Config.ApiAddressUrl}geographical-addresses?rowId=in(${element.addressId})`).subscribe(data => {
          for (const elem of data['geographical-addresses']) { this.ISAdata.push(elem); }
        });
      }
    }
  }
  /**
   * Check if document type is a K-RENAULT type
   */
  private isKRenaultDocumentType(documentType: string): boolean {
    console.info('=== isKRenaultDocumentType called ===');
    console.info('Input documentType:', documentType);
    console.info('Type of documentType:', typeof documentType);
    const kRenaultTypes = [
      "K-RENAULT GROUP Supplier Code of Conduct",
      "K-RENAULT GROUP Global Framework Agreement",
      "K-RENAULT GROUP CSR Guidelines"
    ];
    console.info('Checking against K* types:', kRenaultTypes);
    const result = kRenaultTypes.includes(documentType);
    console.info('Is K* document type?', result);
    return result;
  }
  /**
   * Call sustain assessments API for K* document types
   */
  private callSustainAssessmentsAPI(fileName: string, fileType: string, fileStatus: string, fileEndDate: string): void {
    const currentUrl = globalThis.location.href;
    const datas = {
      companyId: this.companyBasicInfo['allianceIdentifier'],
      companyURL: currentUrl,
      fileName,
      fileType,
      fileStatus,
      fileEndDate,
      lastModification: new Date().toISOString()
    };
    console.info('=== Sustain Assessment API Call ===');
    console.info('Data being sent:', JSON.stringify(datas, null, TWO));
    console.info('API URL:', `${this.Config.ApiSustainUrl}sustain`);
    this.sustainService.createSustain(`${this.Config.ApiSustainUrl}sustain-assessments/companies/c1`, datas).subscribe((data: any) => {
      console.info('Sustain assessment API call successful:', data);
    }, (error: any) => {
      console.info('Error calling sustain assessment API:', error);
    });
  }
  /**
   * Call sustain assessments API when document status is updated for K* types
   */
  private callSustainAssessmentsForStatusUpdate(): void {
    console.info('=== callSustainAssessmentsForStatusUpdate called ===');
    console.info('currentDocumentType:', this.currentDocumentType);
    console.info('documentStatusModel:', this.documentStatusModel);
    console.info('documentFileName:', this.documentFileName);
    if (this.isKRenaultDocumentType(this.currentDocumentType)) {
      const isArchived = this.documentStatusModel === 'Archived';
      const endDate = isArchived ? `${new Date().toISOString().split('.')[ZERO]}Z` : '';
      console.info('=== Document Status Update for K* Document ===');
      console.info('Document Type:', this.currentDocumentType);
      console.info('File Name:', this.documentFileName);
      console.info('Status Updated To:', this.documentStatusModel);
      if (isArchived) {
        console.info('Document Archived - End Date will be set to:', endDate);
      } else {
        console.info('Document not archived - End Date will be empty');
      }
      console.info('Preparing to call Sustain Assessment API...');
      this.callSustainAssessmentsAPI(
        this.documentFileName,
        this.currentDocumentType,
        this.documentStatusModel,
        endDate
      );
    } else {
      console.info('Document type is not K* type, skipping sustain assessment API call');
      console.info('Current document type:', this.currentDocumentType);
      console.info('Available K* types:', ["K-RENAULT GROUP Supplier Code of Conduct", "K-RENAULT GROUP Global Framework Agreement", "K-RENAULT GROUP CSR Guidelines"]);
    }
  }
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }
  handleInitialFragmentScrolling() {
    this.route.fragment.subscribe(fragment => {
      if (fragment) {
        console.info('Fragment detected:', fragment);
        this.scrollToFragment(fragment, ZERO);
      }
    });
  }
  private scrollToFragment(fragment: string, attempt: number) {
    const maxAttempts = TEN;
    const delay = FIVE_HUNDRED + (attempt * FIVE_HUNDRED);
    setTimeout(() => {
      console.info(`Scroll attempt ${attempt + ONE} for fragment: ${fragment}`);
      if (fragment === 'workflows') {
        this.expandWorkflowSection();
      }
      const element = document.getElementById(fragment);
      if (element) {
        const rect = element.getBoundingClientRect();
        const isVisible = rect.width > ZERO && rect.height > ZERO;
        if (isVisible) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          console.info('Successfully scrolled to fragment:', fragment);
          return;
        } else {
          console.info('Element found but not visible yet, continuing...');
        }
      } else {
        console.info('Element not found for fragment:', fragment);
      }
      if (attempt < maxAttempts - ONE) {
        this.scrollToFragment(fragment, attempt + ONE);
      } else {
        console.info('Max scroll attempts reached for fragment:', fragment);
      }
    }, delay);
  }
  private expandWorkflowSection() {
    console.info('Expanding workflow section...');
    this.showBoxDownworkflow = false;
    this.showBoxDownForAllSec = true;
    const workflowElement = document.getElementById("openworkflow");
    if (workflowElement) {
      workflowElement.style.display = "block";
      console.info('Workflow section DOM expanded');
    }
    setTimeout(() => {
      try {
        if (this.cdr) {
          this.cdr.detectChanges();
        }
      } catch (e) {
        console.info('Change detection not available');
      }
    }, ONE_HUNDRED);
  }
  handleFragmentScrolling() {
    this.route.fragment.subscribe(fragment => {
      if (fragment) {
        this.scrollToFragment(fragment, ZERO);
      }
    });
  }
  testScrollToWorkflows() {
    console.info('Testing scroll to workflows...');
    console.info('showBoxDownworkflow:', this.showBoxDownworkflow);
    this.expandWorkflowSection();
    setTimeout(() => {
      const workflowElement = document.getElementById('workflows');
      const openWorkflowElement = document.getElementById('openworkflow');
      console.info('workflows element:', workflowElement);
      console.info('openworkflow element:', openWorkflowElement);
      if (openWorkflowElement) {
        console.info('openworkflow display style:', openWorkflowElement.style.display);
        console.info('openworkflow computed style:', globalThis.getComputedStyle(openWorkflowElement).display);
      }
      if (workflowElement) {
        const rect = workflowElement.getBoundingClientRect();
        console.info('workflows element rect:', rect);
        workflowElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        console.info('Scroll test completed');
      } else {
        console.info('Workflows element not found');
      }
    }, ONE_THOUSAND);
  }
  debugFragment() {
    this.route.fragment.subscribe(fragment => {
      console.info('Current fragment:', fragment);
    });
    console.info('Current URL:', globalThis.location.href);
    console.info('Current hash:', globalThis.location.hash);
  }
  togglePayingCompany() {
    this.showPayingCompanyBlock = !this.showPayingCompanyBlock;
  }
  toggleActivityCollapsed() {
    this.showActivityBlock = !this.showActivityBlock;
  }
  toggleCompanyIdentifierCollapsed() {
    this.showACompanyIdentifier = !this.showACompanyIdentifier;
  }
  toggleTaxIdentifierCollapsed() {
    this.showTaxIdentifier = !this.showTaxIdentifier;
  }
  toggleCompanyContactsCollapsed() {
    this.showCompanyContacts = !this.showCompanyContacts;
  }
  toggleDocumentsForAccounting() {
    this.showDocumentsForAccounting = !this.showDocumentsForAccounting;
  }
  toggleGenericDocuments() {
    this.showGenericDocuments = !this.showGenericDocuments;
  }
  getTaxIdentifierCount(): number {
    if (!this.companyAliasAll || !this.TaxIdentifierKeys) { return ZERO; }
    return this.TaxIdentifierKeys.reduce((sum, key) => {
      return sum + (this.companyAliasAll[key]?.length || ZERO);
    }, ZERO);
  }
  getCompanyIdentifierCount(): number {
    if (!this.companyAliasAll || !this.CompanyIdentiTypes) { return ZERO; }
    return this.CompanyIdentiTypes.reduce((sum, key) => {
      return sum + (this.companyAliasAll[key]?.length || ZERO);
    }, ZERO);
  }
  toggleApproverEdit(): void {
    this.approverEdit = !this.approverEdit;
  }
  getAlcorRequestCompanyNames() {
    if (!this.companyAllianceIdentifier) { return; }
    this.supplierService.getCompanyNames(
      `${this.Config.ApiSupplierUrl}company-names?companyNameTypeName=ALCOR-REQUEST&companyAllianceIdentifier=${this.companyAllianceIdentifier}`
    ).subscribe((data: any) => {
      if (data?.['company-names']?.length > ZERO) {
        this.alcorRequestCompanyNames = data['company-names'];
        if (this.companyAliasAll['ALCOR-REQUEST']) {
          this.companyAliasAll['ALCOR-REQUEST'] = [];
        } else {
          this.companyAliasAll['ALCOR-REQUEST'] = [];
          if (this.CompanyIdentiTypes.indexOf('ALCOR-REQUEST') === NEGATIVE_ONE) {
            this.CompanyIdentiTypes.push('ALCOR-REQUEST');
          }
        }
        for (const item of this.alcorRequestCompanyNames) {
          const temps = {
            'val': item.value,
            'key': item.row_id,
            'startDate': item.startDate,
            'endDate': item.endDate,
            'archived': item.endDate ? true : false,
            'disableInput': false,
            'showSwitch': false
          };
          this.companyAliasAll['ALCOR-REQUEST'].push(temps);
          if (item.value) {
            this.getAlcorStatusReport(item.value);
          }
        }
      }
    }, error => {
      console.info('Error fetching ALCOR-REQUEST company names:', error);
    });
  }
  getAlcorStatusReport(requestId: string) {
    if (!requestId) { return; }
    this.supplierService.getVendorInfo(
      `${this.Config.ApiVendorUrl}status-reports?requestId=${requestId}`
    ).subscribe((data: any) => {
      if (data && Array.isArray(data) && data.length > ZERO) {
        this.alcorRequestStatusReports[requestId] = data[ZERO];
      }
    }, error => {
      console.info(`Error fetching ALCOR status report for ${requestId}:`, error);
    });
  }
  getAlcorRequestStatusLabel(statusCode: string): string {
    return this.alcorRequestStatusMapping[statusCode] || statusCode;
  }
  stripLeadingZeros(value: string): string {
    if (!value) { return ''; }
    return value.replace(/^0+/, '') || '0';
  }
  copySupplierCodeToClipboard(text: string) {
    const strippedValue = this.stripLeadingZeros(text);
    this.copyToClipboard(strippedValue);
  }
  openAlcorRequestPopup(alcorRequest: any) {
    if (alcorRequest.key) {
      this.selectedAlcorRequest = {
        value: alcorRequest.val,
        row_id: alcorRequest.key,
        startDate: alcorRequest.startDate,
        endDate: alcorRequest.endDate
      };
    } else {
      this.selectedAlcorRequest = alcorRequest;
    }
    this.showAlcorRequestPopup = true;
  }
  closeAlcorRequestPopup() {
    this.showAlcorRequestPopup = false;
    this.selectedAlcorRequest = null;
  }
  archiveAlcorRequest() {
    if (!this.selectedAlcorRequest) { return; }
    const today = new Date().toISOString().split('T')[ZERO];
    const updateData = {
      endDate: today
    };
    this.supplierService.updateCompanyNames(
      `${this.Config.ApiSupplierUrl}company-names/${this.selectedAlcorRequest.row_id}`,
      updateData
    ).subscribe((_data: any) => {
      this.closeAlcorRequestPopup();
      this.getAlcorRequestCompanyNames();
    }, error => {
      console.info('Error archiving ALCOR-REQUEST:', error);
    });
  }
  unarchiveAlcorRequest() {
    if (!this.selectedAlcorRequest) { return; }
    const updateData = {
      endDate: ''
    };
    this.supplierService.updateCompanyNames(
      `${this.Config.ApiSupplierUrl}company-names/${this.selectedAlcorRequest.row_id}`,
      updateData
    ).subscribe((_data: any) => {
      this.closeAlcorRequestPopup();
      this.getAlcorRequestCompanyNames();
    }, error => {
      console.info('Error unarchiving ALCOR-REQUEST:', error);
    });
  }
  deleteAlcorRequest() {
    if (!this.selectedAlcorRequest) { return; }
    if (!confirm('Are you sure you want to delete this ALCOR-REQUEST?')) {
      return;
    }
    this.supplierService.deleteCompanyName(
      `${this.Config.ApiSupplierUrl}company-names/${this.selectedAlcorRequest.row_id}`
    ).subscribe((_data: any) => {
      this.closeAlcorRequestPopup();
      this.getAlcorRequestCompanyNames();
    }, error => {
      console.info('Error deleting ALCOR-REQUEST:', error);
      alert('Failed to delete ALCOR-REQUEST');
    });
  }
  saveAlcorRequest() {
    const updateAlcorReq = {
      value: this.selectedAlcorRequest.value,
    };
    this.supplierService.updateCompanyNames(
      `${this.Config.ApiSupplierUrl}company-names/${this.selectedAlcorRequest.row_id}`,
      updateAlcorReq
    ).subscribe((_data: any) => {
      const closeBtn = document.getElementById('closeAlcorRequestPopup');
      if (closeBtn) {
        closeBtn.click();
      } else {
        this.closeAlcorRequestPopup();
      }
      this.getAlcorRequestCompanyNames();
    }, error => {
      console.info('Error saving ALCOR-REQUEST:', error);
      alert('Failed to save ALCOR-REQUEST');
    });
  }
  openAddAlcorCodePopup() {
    this.alcorTaxValue = []
    this.alcorTaxName = []
    this.sirenValue = ''
    this.siretValue = ''
    this.vatValur = ''
    this.alcorRequestType = '';
    this.selectedPayingCompanyForAlcor = '';
    this.isStep2 = false;
    this.selectedPayingCompanyDetails = null;
    this.alcorBlindTasksResponse = [];
    this.selectedDocuments = [];
    if (!this.CompanyDoc || this.CompanyDoc.length === ZERO) {
      console.info('CompanyDoc is empty, loading documents...');
      this.getCompanyDocumentDetails();
    }
    this.pendingPayingCompanies = this.PayingInfo.filter((pc: any) => {
      const status = pc.approvalModificationStatus?.toUpperCase();
      return status === 'PENDING_VALIDATION' || status === 'PENDING';
    }).sort((a: any, b: any) => {
      const codeA = a.clientCompanyCode || '';
      const codeB = b.clientCompanyCode || '';
      return codeA.localeCompare(codeB);
    });
    console.info('Total PayingInfo:', this.PayingInfo.length);
    console.info('Pending Paying Companies:', this.pendingPayingCompanies.length);
    console.info('ALCOR codes count:', this.alcorValueCpy?.length);
    console.info('Pending companies:', this.pendingPayingCompanies);
  }
  closeAddAlcorCodePopup() {
    this.alcorRequestType = '';
    this.selectedPayingCompanyForAlcor = '';
    this.selectedPayingCompaniesForAlcor = [];
    this.clearAllDocumentSelections();
    this.selectedPayingCompanyDetails = null;
    this.isAlcorRequestLoading = false;
    document.getElementById('addAlcorCodePopup').click();
  }
  canRequestNewAlcorCode(): boolean {
    const hasAlcorCode = this.companyAliasAll &&
      this.companyAliasAll['ALCOR'] &&
      this.companyAliasAll['ALCOR'].length > ZERO;
    const hasActiveAlcorRequest = this.companyAliasAll &&
      this.companyAliasAll['ALCOR-REQUEST'] &&
      this.companyAliasAll['ALCOR-REQUEST'].some((req: any) => !req.endDate);
    return !hasAlcorCode && !hasActiveAlcorRequest;
  }
  onAlcorRequestTypeChange() {
    if (this.alcorRequestType !== 'new') {
      this.selectedPayingCompanyForAlcor = '';
    }
    if (this.alcorRequestType !== 'addPaying') {
      this.selectedPayingCompaniesForAlcor = [];
    }
    if (this.alcorRequestType === 'update') {
      this.requestedType = '2'
    } else {
      this.requestedType = '1'
    }
  }
  isNextButtonEnabled(): boolean {
    if (this.alcorRequestType === 'new') {
      return true
    }
    if (this.alcorRequestType === 'update') {
      return true;
    }
    if (this.alcorRequestType === 'addPaying') {
      return this.selectedPayingCompaniesForAlcor && this.selectedPayingCompaniesForAlcor.length > ZERO;
    }
    return false;
  }
  goToStep2() {
    let EvatExsist = false;
    let vatExsist = false;
    console.info('Moving to step 2');
    console.info('Request Type:', this.alcorRequestType);
    console.info('Selected Paying Company:', this.selectedPayingCompanyForAlcor);
    if (this.alcorRequestType === 'new' && this.selectedPayingCompanyForAlcor) {
      this.selectedPayingCompanyDetails = this.pendingPayingCompanies.find(
        pc => pc.clientCompanyCode === this.selectedPayingCompanyForAlcor
      );
    } else if (this.alcorRequestType === 'update') {
      if (this.pendingPayingCompanies && this.pendingPayingCompanies.length > ZERO) {
        this.selectedPayingCompanyDetails = this.pendingPayingCompanies[ZERO];
      }
    } else if (this.alcorRequestType === 'addPaying' && this.selectedPayingCompaniesForAlcor && this.selectedPayingCompaniesForAlcor.length > ZERO) {
      this.selectedPayingCompanyDetails = this.pendingPayingCompanies.find(
        pc => pc.clientCompanyCode === this.selectedPayingCompaniesForAlcor[ZERO]
      );
    } else {
    }
    this.getCompanyDocumentDetails();
    this.isStep2 = true;
    for (const payingCompanyCode of this.selectedPayingCompaniesForAlcor) {
      this.selectedDocumentsByCompanyDetails[payingCompanyCode] = []
    }
    this.alcorAddress = this.acpAddressDetOnRows[this.accessPointIdOnAddress[this.Site_City_Country[this.Site_hrefTo_Cid[this.businessentity]]['rowId']]]
    console.info('alcorAddress', this.acpAddressDetOnRows[this.accessPointIdOnAddress[this.Site_City_Country[this.Site_hrefTo_Cid[this.businessentity]]['rowId']]])
    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierType=TAXATION&businessEntityId=${this.businessentity}`).subscribe(data => {
      for (const element of data['business-entity-identifiers']) {
        this.alcorTaxValue.push(element.value)
        this.alcorTaxName.push(element.businessEntityIdentifierTypeName)
        if (element['businessEntityIdentifierTypeName'] == 'SIREN NUMBER') {
          this.sirenValue = element.value
        } if (element['businessEntityIdentifierTypeName'] == 'SIRET NUMBER') {
          this.siretValue = element.value;
        } if (element['businessEntityIdentifierTypeName'] == 'EUROPEAN VAT NUMBER') {
          EvatExsist = true;
          this.vatValur = element.value;
        }
        if (element['businessEntityIdentifierTypeName'] == 'VAT NUMBER' && !EvatExsist) {
          vatExsist = true;
          this.vatValur = element.value;
        }
        if (element['businessEntityIdentifierTypeName'] == 'TAX NUMBER' && !EvatExsist && !vatExsist) {
          this.vatValur = element.value;
        }
      }
    })
  }
  sendapi() {
    const LanguageFR = ['AQ', 'BE', 'BF', 'BI', 'BJ', 'BL', 'CA', 'CD', 'CF', 'CG', 'CH', 'CI', 'CM', 'DJ', 'FR', 'GA', 'GF', 'GG', 'GN', 'GP', 'GQ', 'HT', 'JE', 'KM', 'LU', 'MC', 'MF', 'MG', 'ML', 'MQ', 'MU', 'NC', 'NE', 'PF', 'PM', 'RE', 'RW', 'SC', 'SN', 'TD', 'TF', 'TG', 'TN', 'VU', 'WF', 'YT']
    this.isAlcorRequestLoading = true;
    this.isAlcorRequestComplete = false;
    this.alcorBlindTasksResponse = [];
    if (this.alcorRequestType === 'addPaying' && this.selectedPayingCompaniesForAlcor.length > ZERO) {
      this.generateMultipleIds(this.selectedPayingCompaniesForAlcor.length).subscribe(idArray => {
        const allRequestsData = [];
        for (const [index, payingCompanyCode] of this.selectedPayingCompaniesForAlcor.entries()) {
          const documentsForThisCompany = this.selectedDocumentsByCompanyDetails[payingCompanyCode] || [];
          const commentsForThisCompany = this.alcorRequestCommentsByCompany[payingCompanyCode] || '';
          const requestData = {
            "mdmAskForRequestId": idArray[index],
            "alcorCode": this.alcorValueCpy?.length === ONE ? this.alcorValueCpy[ZERO] : '',
            payingCompanyCode,
            "country": this.alcorAddress['countryCode'],
            "reason": commentsForThisCompany,
            "documents": documentsForThisCompany,
            "requestType": this.requestedType
          };
          allRequestsData.push(requestData);
        }
        this.AlcorRequestdata = allRequestsData;
        console.info('Single API call with all data and unique IDs:', this.AlcorRequestdata);
        this.supplierService.CreateVender(
          `${this.Config.ApiVendorUrl}demand-table-updates`, this.AlcorRequestdata).subscribe((data: any) => {
            console.info('API Response for all companies:', data);
            for (const alcor of data) {
              if (alcor.status == 'Accepted') {
                const datas3 = {
                  companyId: this.companyID,
                  companyNameTypeId: this.cpyShortNameTypes['ALCOR-REQUEST'],
                  value: alcor.alcorDde,
                  startDate: this.commonService.getTodayDate(),
                }
                this.supplierService.CreateCompanyNames(`${this.Config.ApiSupplierUrl}company-names`, datas3).subscribe((_data: any) => { })
              }
            }
            this.getAlcorRequestCompanyNames();
            if (data && Array.isArray(data)) {
              this.alcorBlindTasksResponse = data.map((item: any, index: number) => ({
                alcorCode: item.alcorCode || '',
                requestId: item.mdmAskForRequestId || idArray[index],
                status: item.status || '',
                reason: item.reason || '',
                filename: item.fileStatus || '',
                payingCompanyCode: item.payingCompanyCode || ''
              }));
              this.isAlcorRequestComplete = true;
            }
          }, error => {
            console.info('Error in demand-table-updates for all companies:', error);
            this.isAlcorRequestLoading = false;
          });
      });
    } else {
      this.newIdGeneration().subscribe(id => {
        const documentsForThisCompany = this.selectedDocumentsByCompanyDetails[this.selectedPayingCompanyForAlcor] || [];
        const requestData = {
          "mdmAskForRequestId": id,
          "requestType": this.requestedType,
          "alcorCode": this.alcorValueCpy?.length === ONE ? this.alcorValueCpy[ZERO] : '',
          "payingCompanyCode": this.selectedPayingCompanyForAlcor,
          "companyIdentifier": this.companyBasicInfo['allianceIdentifier'],
          "siteIdentifier": this.Alcordata,
          "name": this.companyBasicInfo['legalName'],
          "shortName": this.companyShortName,
          "street": this.alcorAddress?.['wayNumber'] ? `${this.alcorAddress['wayNumber']}, ${(this.alcorAddress?.['streetName'] || '')}` : (this.alcorAddress?.['streetName'] || ''),
          "street2": this.alcorAddress?.['additionalInformation'] ? this.alcorAddress['additionalInformation'] : '',
          "postalBox": "",
          "city": this.alcorAddress?.['cityName'],
          "region": "",
          "country": this.alcorAddress?.['countryCode'],
          "telephone": "",
          "businessLanguage": LanguageFR.includes(this.alcorAddress?.['countryCode']) ? "FR" : "EN",
          "duns": this.DUNSValue,
          "vatId": this.vatValur.replaceAll(/\s+/g, ''),
          "headQuarterLanguage": LanguageFR.includes(this.alcorAddress?.['countryCode']) ? "FR" : "EN",
          "effectiveDate": this.alcorStartDate.replaceAll(/-/g, ''),
          "expiration Date": this.alcorEndDate.replaceAll(/-/g, ''),
          "sirenNumber": this.sirenValue,
          "siretNumber": this.siretValue,
          "taxationType": this.alcorTaxName.join(", "),
          "taxationValue": this.alcorTaxValue.join(", "),
          "reason": this.alcorRequestComments,
          "documents": documentsForThisCompany,
          "zipCode": this.alcorAddress?.['postalCode']
        };
        this.AlcorRequestdata = [requestData];
        console.info('Alcordata', this.AlcorRequestdata)
        this.supplierService.CreateVender(
          `${this.Config.ApiVendorUrl}demand-table-updates`, this.AlcorRequestdata).subscribe((data: any) => {
            console.info('API Response:', data);
            for (const alcor of data) {
              if (alcor.status == 'Accepted') {
                const datas3 = {
                  companyId: this.companyID,
                  companyNameTypeId: this.cpyShortNameTypes['ALCOR-REQUEST'],
                  value: alcor.alcorDde,
                  startDate: this.commonService.getTodayDate(),
                }
                this.supplierService.CreateCompanyNames(`${this.Config.ApiSupplierUrl}company-names`, datas3).subscribe((_data: any) => { })
              }
            }
            this.getAlcorRequestCompanyNames();
            if (data && Array.isArray(data)) {
              this.alcorBlindTasksResponse = data.map((item: any) => ({
                alcorCode: item.alcorCode || '',
                requestId: item.mdmAskForRequestId || id,
                status: item.status || '',
                reason: item.reason || '',
                filename: item.fileStatus || '',
                payingCompanyCode: this.selectedPayingCompanyForAlcor
              }));
              this.isAlcorRequestComplete = true;
            }
          }, error => {
            console.info('Error in demand-table-updates:', error);
            this.isAlcorRequestLoading = false;
          })
      });
    }
  }
  newIdGeneration(): Observable<string> {
    const range1 = `${this.yesterDay},${this.AlcorReqStart}`;
    const oneWeeksAgo = this.commonService.getOneWeekAgoDate();
    const range2 = `${oneWeeksAgo},${this.AlcorReqStart}`
    return this.supplierService.getVendorInfo(
      `${this.Config.ApiVendorUrl}status-reports?creationdate=${range1}`
    ).pipe(
      switchMap((data: any) => {
        if (Array.isArray(data) && data.length > ZERO) {
          return of(this.computeNextRequestId(data));
        }
        return this.supplierService.getVendorInfo(
          `${this.Config.ApiVendorUrl}status-reports?creationdate=${range2}`
        ).pipe(
          map((data2: any) => {
            if (Array.isArray(data2) && data2.length > ZERO) {
              return this.computeNextRequestId(data2);
            }
            return this.newId;
          })
        );
      })
    );
  }
  getDateSequence(startDate: string, endDate: string): string {
    const dates: string[] = [];
    const current = new Date(startDate);
    const end = new Date(endDate);
    while (current <= end) {
      const formatted = current.toISOString().split("T")[ZERO].replaceAll(/-/g, '');
      dates.push(formatted);
      current.setDate(current.getDate() + ONE);
    }
    return dates.join(",");
  }
  private computeNextRequestId(rows: any[]): string {
    const requestIds = rows.map((x: any) => x.REQUESTID).filter((id: any) => typeof id === 'string');
    const highestNum = requestIds.reduce((max: number, id: string) => {
      const n = parseInt(id.slice(ONE), TEN);
      return Number.isFinite(n) && n > max ? n : max;
    }, ZERO);
    const highestIdFormatted = `M${highestNum.toString().padStart(EIGHT, '0')}`;
    const prefix = highestIdFormatted.charAt(ZERO);
    const numberPart = highestIdFormatted.substring(ONE);
    const nextNumber = parseInt(numberPart, TEN) + ONE;
    const padded = nextNumber.toString().padStart(numberPart.length, '0');
    this.newId = prefix + padded;
    return this.newId;
  }
  clearAllDocumentSelections() {
    this.selectedDocuments = [];
    this.selectedDocumentsIds = [];
    this.selectedDocumentsByCompany = {};
    this.selectedDocumentsByCompanyDetails = {};
    this.selectedDocumentsDetails = [];
    this.alcorRequestComments = '';
    this.alcorRequestCommentsByCompany = {};
  }
  
  /**
   * Limits filename to 110 characters including extension for ALCOR requests
   * @param fileName Original filename
   * @returns Truncated filename if needed
   */
  limitFileNameForAlcor(fileName: string): string {
    if (!fileName || fileName.length <= ONE_HUNDRED_TEN) { return fileName; }
    
    const dotIndex = fileName.lastIndexOf('.');
    if (dotIndex === NEGATIVE_ONE) { return fileName.substring(ZERO, ONE_HUNDRED_TEN); }
    
    const extension = fileName.substring(dotIndex);
    const maxNameLength = ONE_HUNDRED_TEN - extension.length;
    
    return maxNameLength <= ZERO 
      ? fileName.substring(ZERO, ONE_HUNDRED_TEN)
      : fileName.substring(ZERO, maxNameLength) + extension;
  }
  onDocumentSelectionChange(docs: any, event: any) {
    const isSelected = (event.target as HTMLInputElement).checked;
    const docId = docs.id || docs.name || JSON.stringify(docs);
    if (isSelected) {
      if (!this.selectedDocuments.some(d => (d.id || d.name || JSON.stringify(d)) === docId)) {
        this.selectedDocuments.push(docs);
      }
    } else {
      this.selectedDocuments = this.selectedDocuments.filter(d => (d.id || d.name || JSON.stringify(d)) !== docId);
    }
    this.selectedDocuments = this.selectedDocuments.filter((doc, index, self) => {
      const currentDocId = doc.id || doc.name || JSON.stringify(doc);
      return index === self.findIndex(d => (d.id || d.name || JSON.stringify(d)) === currentDocId);
    });
  }
  isDocumentSelected(docs: any): boolean {
    const docId = docs.id || docs.name || JSON.stringify(docs);
    return this.selectedDocuments.some(d => (d.id || d.name || JSON.stringify(d)) === docId);
  }
  sendAlcorRequest() {
    console.info("selectedDocumentsByCompany : ", this.selectedDocumentsByCompany)
    this.sendapi()
    this.isAlcorRequestLoading = true;
  }
  get activeDocumentsForAlcor() {
    if (!this.CompanyDoc || this.CompanyDoc.length === ZERO) {
      return [];
    }
    return this.CompanyDoc.filter(docs => {
      const status = docs?.fields?.Status || docs?.fields?.status || docs?.fields?.Document_x0020_Status;
      return status && status.toLowerCase() === 'active';
    });
  }
  selectedDocumentsIds: any[] = [];
  selectedDocumentsByCompany: { [key: string]: any[] } = {};
  alcorRequestComments: string = '';
  alcorRequestCommentsByCompany: { [key: string]: string } = {};
  async onDocumentMultiSelectChange(event: any) {
    this.selectedDocumentsByCompanyDetails[this.selectedPayingCompanyForAlcor] = [];
    this.selectedDocumentsDetails = [];
    console.info('Dropdown event value:', event.value);
    if (event.value && event.value.length > ZERO) {
      await this.loadSelectedDocuments(event.value);
      this.selectedDocumentsByCompanyDetails[this.selectedPayingCompanyForAlcor] = [...this.selectedDocumentsDetails];
    }
    this.selectedDocuments = event.value || [];
    console.info('Selected documents from dropdown:', this.selectedDocumentsByCompanyDetails);
  }
  private async loadSelectedDocuments(documents: any[]): Promise<void> {
    for (const docs of documents) {
      try {
        const document = {
          "fileName": this.limitFileNameForAlcor(docs['fields']['LinkFilename']),
          "fileType": docs['fields']['Document_x0020_Type'] ? docs['fields']['Document_x0020_Type'] : '-',
          "documentPayingCompany": this.selectedPayingCompanyForAlcor === '' ? '' : this.selectedPayingCompanyForAlcor,
          fileBinary: await this.getgraph(docs['fields']['id'])
        };
        const isDuplicate = this.selectedDocumentsDetails.some(existingDoc =>
          existingDoc.fileName === document.fileName && existingDoc.fileType === document.fileType &&
          existingDoc.documentPayingCompany === document.documentPayingCompany);
        if (!isDuplicate) {
          this.selectedDocumentsDetails.push(document);
        }
      } catch (error) {
        console.info('Error processing document:', docs, error);
      }
    }
  }
  async onDocumentMultiSelectChangeByCompany(event: any, payingCompanyCode: string) {
    this.selectedDocumentsByCompany[payingCompanyCode] = event.value || [];
    this.selectedDocumentsByCompanyDetails[payingCompanyCode] = [];
    console.info('Dropdown event value:', event.value);
    if (event.value && event.value.length > ZERO) {
      const documentsForCompany = [];
      for (const d of event.value) {
        const doc = await this.buildDocumentEntry(d, payingCompanyCode);
        if (doc) { documentsForCompany.push(doc); }
      }
      this.selectedDocumentsByCompanyDetails[payingCompanyCode] = documentsForCompany;
    }
    console.info('Selected documents for', payingCompanyCode, ':', this.selectedDocumentsByCompany[payingCompanyCode]);
    console.info('All selected documents:', this.selectedDocumentsByCompanyDetails);
  }
  private async buildDocumentEntry(d: any, payingCompanyCode: string): Promise<any> {
    try {
      const doc = {
        fileName: this.limitFileNameForAlcor(d['fields']['LinkFilename']),
        fileType: d['fields']['Document_x0020_Type'] ? d['fields']['Document_x0020_Type'] : '-',
        documentPayingCompany: payingCompanyCode,
        fileBinary: await this.getgraph(d['fields']['id'])
      };
      return doc;
    } catch (error) {
      console.info('Error processing document for company:', payingCompanyCode, d, error);
      return null;
    }
  }
  getPayingCompanyDetails(payingCompanyCode: string) {
    return this.pendingPayingCompanies?.find(pc => pc.clientCompanyCode === payingCompanyCode);
  }
  getDocumentsForPayingCompany(_payingCompanyCode: string) {
    if (!this.CompanyDoc || this.CompanyDoc.length === ZERO) {
      return [];
    }
    return this.CompanyDoc.filter(docs => {
      const status = docs?.fields?.Status || docs?.fields?.status || docs?.fields?.Document_x0020_Status;
      return status && status.toLowerCase() === 'active';
    });
  }
  generateMultipleIds(count: number): Observable<string[]> {
    return this.newIdGeneration().pipe(
      map(firstId => {
        const idArray = [firstId];
        const numericPart = parseInt(firstId.slice(ONE), TEN);
        for (let i = ONE; i < count; i++) {
          const nextNumber = numericPart + i;
          const nextId = `M${nextNumber.toString().padStart(EIGHT, '0')}`;
          idArray.push(nextId);
        }
        return idArray;
      })
    );
  }

  isSendToBuyerInProgress = false;

  async sendToBuyers() {
    if (this.isSendToBuyerInProgress) {
      return;
    }

    this.isSendToBuyerInProgress = true;
    console.info('Send to Buyer functionality for company:', this.companyID);
    
    try {
      const hasDocuments = await this.validateCompanyDocuments(this.companyID, this.companyBasicInfo?.allianceIdentifier);
      if (!hasDocuments) {
        console.info('Document validation failed for company:', this.companyID);
        this.showDocumentValidationPopup();
        this.isSendToBuyerInProgress = false;
        return;
      }
      const hasQualifiers = await this.validateCompanyQualifiers(this.companyID);
      if (!hasQualifiers) {
        console.info('Qualifier validation failed for company:', this.companyID);
        this.showQualifierValidationPopup();
        this.isSendToBuyerInProgress = false;
        return;
      }
      console.info('All validations passed - sending to buyer for company:', this.companyID);
      this.proceedWithSendToBuyer();
      
    } catch (error) {
      this.isSendToBuyerInProgress = false;
      console.info('Error during send to buyer for company:', this.companyID, error);
      alert('An error occurred during validation. Please try again.');
    }
  }
  async validateCompanyDocuments(companyId: string, allianceIdentifier: string): Promise<boolean> {
    try {
      console.info('Validating documents for company:', companyId);
      if (!this.Http_URL) {
        console.info('Document service URL not available');
        return false;
      }
      
      const cpyDetails = `${companyId}-${(allianceIdentifier || 'UNKNOWN')}`;
      const sharePointUrl = `${this.Http_URL}getDocfiles/${cpyDetails}`;
      
      console.info('Fetching documents from:', sharePointUrl);
      
      const response = await this.documentService.getServiceCall(sharePointUrl, '').toPromise();
    
      console.info('Document API response for company', companyId, ':', response);    
      if (response?.rs?.body?.value) {
        const documents = response.rs.body.value;
        console.info('Found documents for company', companyId, ':', documents.length, documents);

        const hasNonArchivedDoc = documents.some(doc => {
          const status = doc.fields?.Status || doc.fields?.Document_x0020_Status || doc.fields?.status;
          const isNotArchived = !status || (
            status.toUpperCase() !== 'ARCHIVED' && 
            status.toUpperCase() !== 'ARCHIVE'
          );
          console.info('Company', companyId, 'Document:', doc.name, 'Status:', status, 'IsNotArchived:', isNotArchived);
          return isNotArchived;
        });
        
        console.info('Company', companyId, 'has non-archived documents:', hasNonArchivedDoc);
        return hasNonArchivedDoc;
      }
      
      console.info('No documents found for company', companyId);
      return false;
      
    } catch (error) {
      console.info('Error validating documents for company:', companyId, error);
      return false;
    }
  }

  async validateCompanyQualifiers(_companyId: string): Promise<boolean> {
    for (const siteId in this.site_qualifiers) {
      const qualifiers = this.site_qualifiers[siteId];
      const keys = Object.keys(qualifiers).filter(k => qualifiers[k] > ZERO);
      const hasNonP14 = keys.some(k => k !== 'P14');
      if (hasNonP14) {
        return true;
      }
    }
    return false;
  }

  showDocumentValidationPopup() {
    document.getElementById('btnForDocumentValidation').click();
  }

  showQualifierValidationPopup() {
    document.getElementById('btnForQualifierValidation').click();
  }

  proceedWithSendToBuyer() {
    const updateData = {
      workflowStatus: "WaitingForRenault"
    };
    this.supplierService.UpdateCompany(
      `${this.Config.ApiSupplierUrl}companies/${this.companyID}`, 
      updateData
    ).subscribe(
      _response => {
        console.info('Company status updated for:', this.companyID);
        this.sendEmailToBuyer();
      },
      error => {
        this.isSendToBuyerInProgress = false;
        console.info('Error updating company status for:', this.companyID, error);
        alert('Error updating company status. Please try again.');
      }
    );
    this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?businessEntityCompanyId=${this.companyID}`).subscribe((data1: any) => {
      const assignments = data1['site-assignments'].filter((el: any) => el.site.href);
      let pending = assignments.length;
      if (pending === 0) { return; }
      assignments.forEach((element: any) => {
        const siteIdTemp = element.site.href.split('/');
        const siteId = siteIdTemp[siteIdTemp.length - 1];
        this.siteService.updateSite(`${this.Config.ApiSitesUrl}sites/${siteId}`, { workflowStatus: 'WaitingForRenault' }).subscribe(() => {
          pending--;
          if (pending === 0) { globalThis.location.reload(); }
        });
      });
    });
  }

  sendEmailToBuyer() {
    const companyAllianceId = this.companyBasicInfo?.allianceIdentifier || this.companyID;
    const companyName = this.companyBasicInfo?.name || 'Company';
    const directLink = `${globalThis.location.origin}/company-details/${this.companyID}`;
    const sendMailTo = 'isa@renault.com';
    const subject = `Supplier has Filled in the Data for company ${companyAllianceId} - ${companyName}`;
    const body = `<p>Hello,</p><p>Please check the supplier data for company ${companyAllianceId} - ${companyName} and validate the workflow for the supplier.</p><p>For that, please click on this link to get access to ISA (Interface for Supplier Administration) : <a href="${directLink}">ISA</a></p><p>Regards,</p><p>Supplier</p>`;
    this.sendMailFn(
      sendMailTo,
      subject,
      body,
      false,
      () => {
        this.getCompanyDetails();
        // globalThis.location.reload();
      },
      () => {
        this.isSendToBuyerInProgress = false;
        alert('Error sending email to buyer. Please try again.');
      }
    );
  }

  shouldShowSendToBuyerButton() {
    if (!this.commonService.noIpnSupplier) {
      return false;
    }
    
    if (this.companyBasicInfo?.workflowStatus) {
      return this.companyBasicInfo.workflowStatus === 'WaitingForSupplier';
    }
    
    return false;
  }

  openCompanyWorkflowStatusModal() {
    this.companyWorkflowStatusModel = this.companyBasicInfo?.['workflowStatus'] ?? '';
    this.disableCompanyWorkflowStatusBtn = false;
  }

  updateCompanyWorkflowStatus() {
    if (this.companyWorkflowStatusModel !== '') {
      this.disableCompanyWorkflowStatusBtn = true;
      const payload = { workflowStatus: this.companyWorkflowStatusModel };
      this.supplierService.UpdateCompany(`${this.Config.ApiSupplierUrl}companies/${this.companyID}`, payload).subscribe((_data: any) => {
        if (this.companyBasicInfo) {
          this.companyBasicInfo['workflowStatus'] = this.companyWorkflowStatusModel;
        }
        this.disableCompanyWorkflowStatusBtn = false;
        document.getElementById('closeCompanyWorkflowStatusModal').click();
      }, () => {
        this.disableCompanyWorkflowStatusBtn = false;
      });
    }
  }
}
